/* tslint:disable */
/* eslint-disable */
/**
 * Procurtal API
 * API documentation for Procurtal application
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@yourdomain.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddClaimMessageDto
 */
export interface AddClaimMessageDto {
    /**
     * 
     * @type {string}
     * @memberof AddClaimMessageDto
     */
    'content': string;
    /**
     * 
     * @type {Array<AttachmentInputDto>}
     * @memberof AddClaimMessageDto
     */
    'attachments'?: Array<AttachmentInputDto>;
}
/**
 * 
 * @export
 * @interface AddDisputeMessageDto
 */
export interface AddDisputeMessageDto {
    /**
     * 
     * @type {string}
     * @memberof AddDisputeMessageDto
     */
    'content': string;
    /**
     * 
     * @type {Array<AttachmentInputDto>}
     * @memberof AddDisputeMessageDto
     */
    'attachments'?: Array<AttachmentInputDto>;
}
/**
 * 
 * @export
 * @interface AdminAiChatConversationDetailDto
 */
export interface AdminAiChatConversationDetailDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationDetailDto
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationDetailDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {AdminAiChatUserDto}
     * @memberof AdminAiChatConversationDetailDto
     */
    'user': AdminAiChatUserDto;
    /**
     * SUM(costUSD) across all assistant messages.
     * @type {number}
     * @memberof AdminAiChatConversationDetailDto
     */
    'totalCostUSD': number;
    /**
     * SUM(totalTokens) across all assistant messages.
     * @type {number}
     * @memberof AdminAiChatConversationDetailDto
     */
    'totalTokens': number;
    /**
     * 
     * @type {Array<AdminAiChatConversationMessageDto>}
     * @memberof AdminAiChatConversationDetailDto
     */
    'messages': Array<AdminAiChatConversationMessageDto>;
}
/**
 * 
 * @export
 * @interface AdminAiChatConversationDto
 */
export interface AdminAiChatConversationDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationDto
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationDto
     */
    'title'?: string | null;
    /**
     * Total messages (user + assistant) in this conversation.
     * @type {number}
     * @memberof AdminAiChatConversationDto
     */
    'messageCount': number;
    /**
     * Number of assistant messages with cost data.
     * @type {number}
     * @memberof AdminAiChatConversationDto
     */
    'assistantCount': number;
    /**
     * SUM(costUSD) across assistant messages in this conversation.
     * @type {number}
     * @memberof AdminAiChatConversationDto
     */
    'totalCostUSD': number;
    /**
     * SUM(totalTokens) across assistant messages.
     * @type {number}
     * @memberof AdminAiChatConversationDto
     */
    'totalTokens': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationDto
     */
    'firstMessageAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationDto
     */
    'lastMessageAt': string;
    /**
     * Preview of the most recent message.
     * @type {string}
     * @memberof AdminAiChatConversationDto
     */
    'lastMessagePreview'?: string | null;
    /**
     * 
     * @type {AdminAiChatUserDto}
     * @memberof AdminAiChatConversationDto
     */
    'user': AdminAiChatUserDto;
}
/**
 * 
 * @export
 * @interface AdminAiChatConversationMessageDto
 */
export interface AdminAiChatConversationMessageDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationMessageDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationMessageDto
     */
    'role': AdminAiChatConversationMessageDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationMessageDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationMessageDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationMessageDto
     */
    'provider'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatConversationMessageDto
     */
    'promptTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatConversationMessageDto
     */
    'completionTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatConversationMessageDto
     */
    'totalTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatConversationMessageDto
     */
    'costUSD'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatConversationMessageDto
     */
    'durationMs'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatConversationMessageDto
     */
    'createdAt': string;
}

export const AdminAiChatConversationMessageDtoRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type AdminAiChatConversationMessageDtoRoleEnum = typeof AdminAiChatConversationMessageDtoRoleEnum[keyof typeof AdminAiChatConversationMessageDtoRoleEnum];

/**
 * 
 * @export
 * @interface AdminAiChatListItemDto
 */
export interface AdminAiChatListItemDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatListItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatListItemDto
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatListItemDto
     */
    'provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatListItemDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatListItemDto
     */
    'promptTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatListItemDto
     */
    'completionTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatListItemDto
     */
    'totalTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatListItemDto
     */
    'costUSD'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiChatListItemDto
     */
    'durationMs'?: number | null;
    /**
     * First 100 characters of the assistant reply.
     * @type {string}
     * @memberof AdminAiChatListItemDto
     */
    'textPreview'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatListItemDto
     */
    'createdAt': string;
    /**
     * 
     * @type {AdminAiChatUserDto}
     * @memberof AdminAiChatListItemDto
     */
    'user': AdminAiChatUserDto;
}
/**
 * 
 * @export
 * @interface AdminAiChatPartnerCostDto
 */
export interface AdminAiChatPartnerCostDto {
    /**
     * Odoo partner ID.
     * @type {number}
     * @memberof AdminAiChatPartnerCostDto
     */
    'partnerId': number;
    /**
     * Linked Prisma user ID, null if no user linked.
     * @type {string}
     * @memberof AdminAiChatPartnerCostDto
     */
    'userId'?: string | null;
    /**
     * All-time SUM(costUSD).
     * @type {number}
     * @memberof AdminAiChatPartnerCostDto
     */
    'totalCostUSD': number;
    /**
     * SUM(costUSD) in the last 30 days.
     * @type {number}
     * @memberof AdminAiChatPartnerCostDto
     */
    'last30DaysCostUSD': number;
    /**
     * SUM(costUSD) in the last 7 days.
     * @type {number}
     * @memberof AdminAiChatPartnerCostDto
     */
    'last7DaysCostUSD': number;
    /**
     * Total assistant messages with cost data (all-time).
     * @type {number}
     * @memberof AdminAiChatPartnerCostDto
     */
    'totalCalls': number;
    /**
     * SUM(totalTokens) all-time.
     * @type {number}
     * @memberof AdminAiChatPartnerCostDto
     */
    'totalTokens': number;
}
/**
 * 
 * @export
 * @interface AdminAiChatStatsDto
 */
export interface AdminAiChatStatsDto {
    /**
     * 
     * @type {AiChatTotalsDto}
     * @memberof AdminAiChatStatsDto
     */
    'last7Days': AiChatTotalsDto;
    /**
     * 
     * @type {AiChatTotalsDto}
     * @memberof AdminAiChatStatsDto
     */
    'last30Days': AiChatTotalsDto;
    /**
     * 
     * @type {AiChatTotalsDto}
     * @memberof AdminAiChatStatsDto
     */
    'allTime': AiChatTotalsDto;
    /**
     * Top 10 users by chat spend (last 30 days).
     * @type {Array<AiChatByUserDto>}
     * @memberof AdminAiChatStatsDto
     */
    'topUsers': Array<AiChatByUserDto>;
    /**
     * Weekly cost + call totals for the last 12 weeks.
     * @type {Array<AiChatByWeekDto>}
     * @memberof AdminAiChatStatsDto
     */
    'byWeek': Array<AiChatByWeekDto>;
}
/**
 * 
 * @export
 * @interface AdminAiChatUserDto
 */
export interface AdminAiChatUserDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatUserDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatUserDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiChatUserDto
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminAiExtractionListItemDto
 */
export interface AdminAiExtractionListItemDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'status': AdminAiExtractionListItemDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'resourceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'resourceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'sourceFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'model': string;
    /**
     * 
     * @type {number}
     * @memberof AdminAiExtractionListItemDto
     */
    'promptTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiExtractionListItemDto
     */
    'completionTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiExtractionListItemDto
     */
    'totalTokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiExtractionListItemDto
     */
    'costUSD'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAiExtractionListItemDto
     */
    'durationMs'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionListItemDto
     */
    'createdAt': string;
    /**
     * 
     * @type {AdminAiExtractionUserDto}
     * @memberof AdminAiExtractionListItemDto
     */
    'user': AdminAiExtractionUserDto;
}

export const AdminAiExtractionListItemDtoStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Failed: 'failed'
} as const;

export type AdminAiExtractionListItemDtoStatusEnum = typeof AdminAiExtractionListItemDtoStatusEnum[keyof typeof AdminAiExtractionListItemDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminAiExtractionStatsDto
 */
export interface AdminAiExtractionStatsDto {
    /**
     * 
     * @type {AiExtractionTotalsDto}
     * @memberof AdminAiExtractionStatsDto
     */
    'last7Days': AiExtractionTotalsDto;
    /**
     * 
     * @type {AiExtractionTotalsDto}
     * @memberof AdminAiExtractionStatsDto
     */
    'last30Days': AiExtractionTotalsDto;
    /**
     * 
     * @type {AiExtractionTotalsDto}
     * @memberof AdminAiExtractionStatsDto
     */
    'allTime': AiExtractionTotalsDto;
    /**
     * 
     * @type {Array<AiExtractionByKindDto>}
     * @memberof AdminAiExtractionStatsDto
     */
    'byKind': Array<AiExtractionByKindDto>;
    /**
     * Top 10 users by AI spend (last 30 days).
     * @type {Array<AiExtractionByUserDto>}
     * @memberof AdminAiExtractionStatsDto
     */
    'topUsers': Array<AiExtractionByUserDto>;
    /**
     * Weekly cost + call totals for the last 12 weeks.
     * @type {Array<AiExtractionByWeekDto>}
     * @memberof AdminAiExtractionStatsDto
     */
    'byWeek': Array<AiExtractionByWeekDto>;
}
/**
 * 
 * @export
 * @interface AdminAiExtractionUserDto
 */
export interface AdminAiExtractionUserDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionUserDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionUserDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAiExtractionUserDto
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminCreateUserDto
 */
export interface AdminCreateUserDto {
    /**
     * Full name
     * @type {string}
     * @memberof AdminCreateUserDto
     */
    'name': string;
    /**
     * Email address
     * @type {string}
     * @memberof AdminCreateUserDto
     */
    'email'?: string;
    /**
     * Phone number in E.164 format
     * @type {string}
     * @memberof AdminCreateUserDto
     */
    'phoneNumber'?: string;
    /**
     * Password (optional - if not provided, user will use OTP login)
     * @type {string}
     * @memberof AdminCreateUserDto
     */
    'password'?: string;
    /**
     * Partner data to create in Odoo for this user
     * @type {CreatePartnerDto}
     * @memberof AdminCreateUserDto
     */
    'partner': CreatePartnerDto;
    /**
     * Array of documents to create for the user (will be auto-approved)
     * @type {Array<CreateDocumentDto>}
     * @memberof AdminCreateUserDto
     */
    'documents'?: Array<CreateDocumentDto>;
}
/**
 * 
 * @export
 * @interface AdminDatasheetExtractionDto
 */
export interface AdminDatasheetExtractionDto {
    /**
     * Lifecycle of the latest extraction for this product request. \"none\" means no PDF was ever uploaded (e.g. legacy datasheetUrl-only request).
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'status': AdminDatasheetExtractionDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'extractionId'?: string | null;
    /**
     * Short-lived (≈5 min) signed GCS read URL for the uploaded PDF. Null when no PDF was uploaded.
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'fileName'?: string | null;
    /**
     * Structured AI summary as JSON string. Same shape as the seller-facing extraction DTO.
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'aiSummary'?: string | null;
    /**
     * Raw text dump from the PDF (capped at 40k chars).
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'extractedText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminDatasheetExtractionDto
     */
    'costUSD'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDatasheetExtractionDto
     */
    'createdAt'?: string | null;
}

export const AdminDatasheetExtractionDtoStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Failed: 'failed',
    None: 'none'
} as const;

export type AdminDatasheetExtractionDtoStatusEnum = typeof AdminDatasheetExtractionDtoStatusEnum[keyof typeof AdminDatasheetExtractionDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminLoyaltyTransactionDto
 */
export interface AdminLoyaltyTransactionDto {
    /**
     * Transaction ID
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'id': string;
    /**
     * User ID
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'userId': string;
    /**
     * Partner/company name
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'partnerName'?: string | null;
    /**
     * User full name
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'userName'?: string | null;
    /**
     * User email
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'email'?: string | null;
    /**
     * User phone number
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'phoneNumber'?: string | null;
    /**
     * Points awarded
     * @type {number}
     * @memberof AdminLoyaltyTransactionDto
     */
    'points': number;
    /**
     * Payment amount
     * @type {number}
     * @memberof AdminLoyaltyTransactionDto
     */
    'amount': number;
    /**
     * Payment currency
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'currency': string;
    /**
     * Expiration date
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'expiresAt': string;
    /**
     * Whether points are expired
     * @type {boolean}
     * @memberof AdminLoyaltyTransactionDto
     */
    'isExpired': boolean;
    /**
     * Whether points have been redeemed
     * @type {boolean}
     * @memberof AdminLoyaltyTransactionDto
     */
    'isRedeemed': boolean;
    /**
     * Transaction date
     * @type {string}
     * @memberof AdminLoyaltyTransactionDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface AdminLoyaltyTransactionsResponseDto
 */
export interface AdminLoyaltyTransactionsResponseDto {
    /**
     * Transactions
     * @type {Array<AdminLoyaltyTransactionDto>}
     * @memberof AdminLoyaltyTransactionsResponseDto
     */
    'data': Array<AdminLoyaltyTransactionDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof AdminLoyaltyTransactionsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface AdminResolveClaimDto
 */
export interface AdminResolveClaimDto {
    /**
     * Target status. Admin state machine: non-terminal → MEDIATING; MEDIATING → RESOLVED | REJECTED | ESCALATED.
     * @type {string}
     * @memberof AdminResolveClaimDto
     */
    'status': AdminResolveClaimDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminResolveClaimDto
     */
    'resolutionAction'?: AdminResolveClaimDtoResolutionActionEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminResolveClaimDto
     */
    'resolutionNote'?: string;
}

export const AdminResolveClaimDtoStatusEnum = {
    New: 'NEW',
    Acknowledged: 'ACKNOWLEDGED',
    Investigating: 'INVESTIGATING',
    Resolved: 'RESOLVED',
    Rejected: 'REJECTED',
    Mediating: 'MEDIATING',
    Escalated: 'ESCALATED'
} as const;

export type AdminResolveClaimDtoStatusEnum = typeof AdminResolveClaimDtoStatusEnum[keyof typeof AdminResolveClaimDtoStatusEnum];
export const AdminResolveClaimDtoResolutionActionEnum = {
    Refund: 'REFUND',
    Replacement: 'REPLACEMENT',
    StoreCredit: 'STORE_CREDIT',
    None: 'NONE'
} as const;

export type AdminResolveClaimDtoResolutionActionEnum = typeof AdminResolveClaimDtoResolutionActionEnum[keyof typeof AdminResolveClaimDtoResolutionActionEnum];

/**
 * 
 * @export
 * @interface AdminStatsDto
 */
export interface AdminStatsDto {
    /**
     * Sum of all inbound PAID payments
     * @type {number}
     * @memberof AdminStatsDto
     */
    'totalRevenue': number;
    /**
     * Procurtal profit: total revenue minus released supplier payouts
     * @type {number}
     * @memberof AdminStatsDto
     */
    'procurtalMargin': number | null;
    /**
     * Sum of outbound payments in DRAFT or POSTED state (pending supplier payout)
     * @type {number}
     * @memberof AdminStatsDto
     */
    'payoutsOutstanding': number;
    /**
     * Profit: total revenue minus released supplier payouts
     * @type {number}
     * @memberof AdminStatsDto
     */
    'profit': number;
}
/**
 * 
 * @export
 * @interface AdminUpdateUserDto
 */
export interface AdminUpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateUserDto
     */
    'role'?: AdminUpdateUserDtoRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateUserDto
     */
    'isActive'?: boolean;
}

export const AdminUpdateUserDtoRoleEnum = {
    Admin: 'admin',
    User: 'user'
} as const;

export type AdminUpdateUserDtoRoleEnum = typeof AdminUpdateUserDtoRoleEnum[keyof typeof AdminUpdateUserDtoRoleEnum];

/**
 * 
 * @export
 * @interface AdminUserQueryDto
 */
export interface AdminUserQueryDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserQueryDto
     */
    'role'?: AdminUserQueryDtoRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserQueryDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminUserQueryDto
     */
    'search'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUserQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserQueryDto
     */
    'pageSize'?: number;
}

export const AdminUserQueryDtoRoleEnum = {
    Admin: 'admin',
    User: 'user'
} as const;

export type AdminUserQueryDtoRoleEnum = typeof AdminUserQueryDtoRoleEnum[keyof typeof AdminUserQueryDtoRoleEnum];

/**
 * 
 * @export
 * @interface AdminWarrantyClaimQueryDto
 */
export interface AdminWarrantyClaimQueryDto {
    /**
     * 
     * @type {string}
     * @memberof AdminWarrantyClaimQueryDto
     */
    'status'?: AdminWarrantyClaimQueryDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminWarrantyClaimQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminWarrantyClaimQueryDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminWarrantyClaimQueryDto
     */
    'supplierId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminWarrantyClaimQueryDto
     */
    'unassigned'?: boolean;
}

export const AdminWarrantyClaimQueryDtoStatusEnum = {
    New: 'NEW',
    Acknowledged: 'ACKNOWLEDGED',
    Investigating: 'INVESTIGATING',
    Resolved: 'RESOLVED',
    Rejected: 'REJECTED',
    Mediating: 'MEDIATING',
    Escalated: 'ESCALATED'
} as const;

export type AdminWarrantyClaimQueryDtoStatusEnum = typeof AdminWarrantyClaimQueryDtoStatusEnum[keyof typeof AdminWarrantyClaimQueryDtoStatusEnum];

/**
 * 
 * @export
 * @interface AiChatByUserDto
 */
export interface AiChatByUserDto {
    /**
     * 
     * @type {string}
     * @memberof AiChatByUserDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AiChatByUserDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AiChatByUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AiChatByUserDto
     */
    'calls': number;
    /**
     * 
     * @type {number}
     * @memberof AiChatByUserDto
     */
    'costUSD': number;
}
/**
 * 
 * @export
 * @interface AiChatByWeekDto
 */
export interface AiChatByWeekDto {
    /**
     * ISO date of the week start (Monday).
     * @type {string}
     * @memberof AiChatByWeekDto
     */
    'weekStart': string;
    /**
     * 
     * @type {number}
     * @memberof AiChatByWeekDto
     */
    'calls': number;
    /**
     * 
     * @type {number}
     * @memberof AiChatByWeekDto
     */
    'costUSD': number;
}
/**
 * 
 * @export
 * @interface AiChatTotalsDto
 */
export interface AiChatTotalsDto {
    /**
     * Number of assistant messages in the window.
     * @type {number}
     * @memberof AiChatTotalsDto
     */
    'totalCalls': number;
    /**
     * SUM(costUSD) across the window.
     * @type {number}
     * @memberof AiChatTotalsDto
     */
    'totalCostUSD': number;
    /**
     * SUM(totalTokens) across the window.
     * @type {number}
     * @memberof AiChatTotalsDto
     */
    'totalTokens': number;
    /**
     * Average streaming duration in ms.
     * @type {number}
     * @memberof AiChatTotalsDto
     */
    'avgDurationMs'?: number | null;
}
/**
 * 
 * @export
 * @interface AiExtractionByKindDto
 */
export interface AiExtractionByKindDto {
    /**
     * 
     * @type {string}
     * @memberof AiExtractionByKindDto
     */
    'kind': string;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionByKindDto
     */
    'calls': number;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionByKindDto
     */
    'costUSD': number;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionByKindDto
     */
    'totalTokens': number;
}
/**
 * 
 * @export
 * @interface AiExtractionByUserDto
 */
export interface AiExtractionByUserDto {
    /**
     * 
     * @type {string}
     * @memberof AiExtractionByUserDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AiExtractionByUserDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AiExtractionByUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionByUserDto
     */
    'calls': number;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionByUserDto
     */
    'costUSD': number;
}
/**
 * 
 * @export
 * @interface AiExtractionByWeekDto
 */
export interface AiExtractionByWeekDto {
    /**
     * ISO date of the week start (Monday).
     * @type {string}
     * @memberof AiExtractionByWeekDto
     */
    'weekStart': string;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionByWeekDto
     */
    'calls': number;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionByWeekDto
     */
    'costUSD': number;
}
/**
 * 
 * @export
 * @interface AiExtractionTotalsDto
 */
export interface AiExtractionTotalsDto {
    /**
     * Number of extraction calls in the window.
     * @type {number}
     * @memberof AiExtractionTotalsDto
     */
    'totalCalls': number;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionTotalsDto
     */
    'successCalls': number;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionTotalsDto
     */
    'failedCalls': number;
    /**
     * 
     * @type {number}
     * @memberof AiExtractionTotalsDto
     */
    'pendingCalls': number;
    /**
     * Success rate as a fraction (0–1).
     * @type {number}
     * @memberof AiExtractionTotalsDto
     */
    'successRate': number;
    /**
     * SUM(costUSD) across the window.
     * @type {number}
     * @memberof AiExtractionTotalsDto
     */
    'totalCostUSD': number;
    /**
     * SUM(totalTokens) across the window.
     * @type {number}
     * @memberof AiExtractionTotalsDto
     */
    'totalTokens': number;
    /**
     * Average call duration in ms across SUCCESS rows.
     * @type {number}
     * @memberof AiExtractionTotalsDto
     */
    'avgDurationMs'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApprovalStatus = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type ApprovalStatus = typeof ApprovalStatus[keyof typeof ApprovalStatus];


/**
 * 
 * @export
 * @interface ApproveDocumentDto
 */
export interface ApproveDocumentDto {
    /**
     * Optional approval note
     * @type {string}
     * @memberof ApproveDocumentDto
     */
    'note'?: string;
    /**
     * Document expiration date entered by the admin. The frontend will warn the seller as the date approaches.
     * @type {string}
     * @memberof ApproveDocumentDto
     */
    'expiresAt'?: string;
}
/**
 * 
 * @export
 * @interface AttachmentInputDto
 */
export interface AttachmentInputDto {
    /**
     * 
     * @type {string}
     * @memberof AttachmentInputDto
     */
    'objectKey': string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentInputDto
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentInputDto
     */
    'contentType': string;
    /**
     * 
     * @type {number}
     * @memberof AttachmentInputDto
     */
    'fileSize'?: number | null;
}
/**
 * 
 * @export
 * @interface AttributeValueEntryDto
 */
export interface AttributeValueEntryDto {
    /**
     * product.attribute.value ID
     * @type {number}
     * @memberof AttributeValueEntryDto
     */
    'id': number;
    /**
     * Value name (e.g. \"1 TB\", \"Black\")
     * @type {string}
     * @memberof AttributeValueEntryDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AuditLogQueryDto
 */
export interface AuditLogQueryDto {
    /**
     * 
     * @type {string}
     * @memberof AuditLogQueryDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogQueryDto
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogQueryDto
     */
    'resource'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogQueryDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogQueryDto
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuditLogQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditLogQueryDto
     */
    'pageSize'?: number;
}
/**
 * 
 * @export
 * @interface AuthResponseDto
 */
export interface AuthResponseDto {
    /**
     * JWT access token for API authentication
     * @type {string}
     * @memberof AuthResponseDto
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface BankAccountDto
 */
export interface BankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    'accountHolder': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    'swift'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountDto
     */
    'isDefault': boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface BankingChangeRequestSummaryDto
 */
export interface BankingChangeRequestSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof BankingChangeRequestSummaryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankingChangeRequestSummaryDto
     */
    'status': BankingChangeRequestSummaryDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BankingChangeRequestSummaryDto
     */
    'submittedAt'?: string | null;
}

export const BankingChangeRequestSummaryDtoStatusEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    ChangesRequested: 'CHANGES_REQUESTED',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type BankingChangeRequestSummaryDtoStatusEnum = typeof BankingChangeRequestSummaryDtoStatusEnum[keyof typeof BankingChangeRequestSummaryDtoStatusEnum];

/**
 * 
 * @export
 * @interface BestDealItemDto
 */
export interface BestDealItemDto {
    /**
     * 
     * @type {ProductVariantDto}
     * @memberof BestDealItemDto
     */
    'product': ProductVariantDto;
    /**
     * Supplier display name
     * @type {string}
     * @memberof BestDealItemDto
     */
    'supplierName': string;
    /**
     * Whether the supplier is verified
     * @type {boolean}
     * @memberof BestDealItemDto
     */
    'supplierVerified': boolean;
    /**
     * Human-readable warranty label shown in the checkout card
     * @type {string}
     * @memberof BestDealItemDto
     */
    'warrantyLabel'?: string | null;
    /**
     * Discount percentage used for ranking and display
     * @type {number}
     * @memberof BestDealItemDto
     */
    'discountPercent'?: number | null;
    /**
     * 1-based deal rank within the feed
     * @type {number}
     * @memberof BestDealItemDto
     */
    'rank': number;
}
/**
 * 
 * @export
 * @interface BestDealsResponseDto
 */
export interface BestDealsResponseDto {
    /**
     * Timestamp when the feed was generated
     * @type {string}
     * @memberof BestDealsResponseDto
     */
    'updatedAt': string;
    /**
     * Feed currency code
     * @type {string}
     * @memberof BestDealsResponseDto
     */
    'currency': string;
    /**
     * Best deal items
     * @type {Array<BestDealItemDto>}
     * @memberof BestDealsResponseDto
     */
    'items': Array<BestDealItemDto>;
}
/**
 * 
 * @export
 * @interface BrandDto
 */
export interface BrandDto {
    /**
     * Brand ID
     * @type {number}
     * @memberof BrandDto
     */
    'id': number;
    /**
     * Brand name
     * @type {string}
     * @memberof BrandDto
     */
    'name': string;
    /**
     * Whether the brand is active
     * @type {boolean}
     * @memberof BrandDto
     */
    'active': boolean;
    /**
     * Brand logo (base64 encoded)
     * @type {string}
     * @memberof BrandDto
     */
    'logo'?: string | null;
}
/**
 * 
 * @export
 * @interface BulkApproveProductRequestsDto
 */
export interface BulkApproveProductRequestsDto {
    /**
     * Margin percentage to apply to seller pricing (e.g., 10 for 10% markup)
     * @type {number}
     * @memberof BulkApproveProductRequestsDto
     */
    'marginPercentage': number;
    /**
     * Round up prices to nearest 10 minus 0.01 (e.g. 1234 → 1239.99)
     * @type {boolean}
     * @memberof BulkApproveProductRequestsDto
     */
    'roundUp'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkApproveResponseDto
 */
export interface BulkApproveResponseDto {
    /**
     * Number of requests successfully approved
     * @type {number}
     * @memberof BulkApproveResponseDto
     */
    'approved': number;
    /**
     * Number of requests that failed to approve
     * @type {number}
     * @memberof BulkApproveResponseDto
     */
    'failed': number;
    /**
     * Total number of pending requests processed
     * @type {number}
     * @memberof BulkApproveResponseDto
     */
    'total': number;
    /**
     * Detailed results for each request
     * @type {Array<BulkApproveResultDto>}
     * @memberof BulkApproveResponseDto
     */
    'results': Array<BulkApproveResultDto>;
}
/**
 * 
 * @export
 * @interface BulkApproveResultDto
 */
export interface BulkApproveResultDto {
    /**
     * Product request ID
     * @type {string}
     * @memberof BulkApproveResultDto
     */
    'requestId': string;
    /**
     * Whether the approval was successful
     * @type {boolean}
     * @memberof BulkApproveResultDto
     */
    'success': boolean;
    /**
     * Error message if approval failed
     * @type {string}
     * @memberof BulkApproveResultDto
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface BuyerAddressDto
 */
export interface BuyerAddressDto {
    /**
     * Odoo res.partner id
     * @type {number}
     * @memberof BuyerAddressDto
     */
    'id': number;
    /**
     * Address book entry type (delivery / invoice / other).
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'type': BuyerAddressDtoTypeEnum;
    /**
     * Display name (typically contact name).
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'street2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'notes'?: string | null;
    /**
     * Odoo state id.
     * @type {number}
     * @memberof BuyerAddressDto
     */
    'stateId'?: number | null;
    /**
     * Odoo state name.
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'stateName'?: string | null;
    /**
     * Odoo country id.
     * @type {number}
     * @memberof BuyerAddressDto
     */
    'countryId'?: number | null;
    /**
     * Odoo country name.
     * @type {string}
     * @memberof BuyerAddressDto
     */
    'countryName'?: string | null;
    /**
     * Whether this is the buyer\'s default delivery address. At most one entry is the default; it is listed first.
     * @type {boolean}
     * @memberof BuyerAddressDto
     */
    'isDefault': boolean;
}

export const BuyerAddressDtoTypeEnum = {
    Delivery: 'delivery',
    Invoice: 'invoice',
    Other: 'other'
} as const;

export type BuyerAddressDtoTypeEnum = typeof BuyerAddressDtoTypeEnum[keyof typeof BuyerAddressDtoTypeEnum];

/**
 * 
 * @export
 * @interface BuyerStatsDto
 */
export interface BuyerStatsDto {
    /**
     * Total number of sale orders
     * @type {number}
     * @memberof BuyerStatsDto
     */
    'orderCount': number;
    /**
     * Total lifetime spend across all orders
     * @type {number}
     * @memberof BuyerStatsDto
     */
    'lifetimeSpend': number;
    /**
     * Average order value
     * @type {number}
     * @memberof BuyerStatsDto
     */
    'avgOrderValue': number;
    /**
     * Date of most recent order (ISO 8601)
     * @type {string}
     * @memberof BuyerStatsDto
     */
    'lastOrderAt'?: string | null;
}
/**
 * 
 * @export
 * @interface CatalogFacetsDto
 */
export interface CatalogFacetsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFacetsDto
     */
    'ramOptions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFacetsDto
     */
    'storageOptions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFacetsDto
     */
    'cpuOptions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFacetsDto
     */
    'brands': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFacetsDto
     */
    'categories': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFacetsDto
     */
    'conditions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFacetsDto
     */
    'screenSizes': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFacetsDto
     */
    'colors': Array<string>;
}
/**
 * 
 * @export
 * @interface CategoryDto
 */
export interface CategoryDto {
    /**
     * Category ID
     * @type {number}
     * @memberof CategoryDto
     */
    'id': number;
    /**
     * Category name
     * @type {string}
     * @memberof CategoryDto
     */
    'name': string;
    /**
     * Parent category
     * @type {ParentCategoryDto}
     * @memberof CategoryDto
     */
    'parent'?: ParentCategoryDto | null;
    /**
     * Complete category path
     * @type {string}
     * @memberof CategoryDto
     */
    'completeName': string;
    /**
     * Display name
     * @type {string}
     * @memberof CategoryDto
     */
    'displayName': string;
}
/**
 * 
 * @export
 * @interface CategoryFieldConfigDto
 */
export interface CategoryFieldConfigDto {
    /**
     * 
     * @type {number}
     * @memberof CategoryFieldConfigDto
     */
    'categoryId': number;
    /**
     * Overrides set directly on this category (excludes inherited values).
     * @type {{ [key: string]: FieldPolicyDto; }}
     * @memberof CategoryFieldConfigDto
     */
    'ownConfig': { [key: string]: FieldPolicyDto; };
    /**
     * Fully-resolved policy after parent-chain inheritance and defaults.
     * @type {{ [key: string]: FieldPolicyDto; }}
     * @memberof CategoryFieldConfigDto
     */
    'effectiveConfig': { [key: string]: FieldPolicyDto; };
    /**
     * For each field, the ancestor category id the effective value was inherited from, or null when it came from this category or the default.
     * @type {{ [key: string]: number | null; }}
     * @memberof CategoryFieldConfigDto
     */
    'inheritedFrom': { [key: string]: number | null; };
}
/**
 * 
 * @export
 * @interface ChangePasswordDto
 */
export interface ChangePasswordDto {
    /**
     * Current password
     * @type {string}
     * @memberof ChangePasswordDto
     */
    'currentPassword': string;
    /**
     * New password
     * @type {string}
     * @memberof ChangePasswordDto
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ChangeRequestDto
 */
export interface ChangeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'userId': string;
    /**
     * Submitter\'s display name.
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'userName'?: string | null;
    /**
     * Submitter\'s email.
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'userEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'type': ChangeRequestDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'status': ChangeRequestDtoStatusEnum;
    /**
     * Field-level diff of proposed changes.
     * @type {{ [key: string]: any; }}
     * @memberof ChangeRequestDto
     */
    'proposedChanges': { [key: string]: any; };
    /**
     * Snapshot of the user\'s field values for the same keys present in `proposedChanges`, frozen at submit time. Lets the FE render a stable before/after diff that doesn\'t drift as the underlying data evolves. Null for DRAFTs and request types without a meaningful \"current\".
     * @type {{ [key: string]: any; }}
     * @memberof ChangeRequestDto
     */
    'currentSnapshot'?: { [key: string]: any; } | null;
    /**
     * Odoo product.template ID (PRODUCT_UPDATE only).
     * @type {number}
     * @memberof ChangeRequestDto
     */
    'targetProductId'?: number | null;
    /**
     * BankAccount id (BANK_ACCOUNT_UPDATE/DELETE only).
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'targetBankAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'submittedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'reviewedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'reviewedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'reviewNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'rejectionReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDto
     */
    'updatedAt': string;
}

export const ChangeRequestDtoTypeEnum = {
    SellerProfileUpdate: 'SELLER_PROFILE_UPDATE',
    BuyerProfileUpdate: 'BUYER_PROFILE_UPDATE',
    ProductUpdate: 'PRODUCT_UPDATE',
    BankAccountCreate: 'BANK_ACCOUNT_CREATE',
    BankAccountUpdate: 'BANK_ACCOUNT_UPDATE',
    BankAccountDelete: 'BANK_ACCOUNT_DELETE'
} as const;

export type ChangeRequestDtoTypeEnum = typeof ChangeRequestDtoTypeEnum[keyof typeof ChangeRequestDtoTypeEnum];
export const ChangeRequestDtoStatusEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    ChangesRequested: 'CHANGES_REQUESTED',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type ChangeRequestDtoStatusEnum = typeof ChangeRequestDtoStatusEnum[keyof typeof ChangeRequestDtoStatusEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ChangeRequestType = {
    SellerProfileUpdate: 'SELLER_PROFILE_UPDATE',
    BuyerProfileUpdate: 'BUYER_PROFILE_UPDATE',
    ProductUpdate: 'PRODUCT_UPDATE',
    BankAccountCreate: 'BANK_ACCOUNT_CREATE',
    BankAccountUpdate: 'BANK_ACCOUNT_UPDATE',
    BankAccountDelete: 'BANK_ACCOUNT_DELETE'
} as const;

export type ChangeRequestType = typeof ChangeRequestType[keyof typeof ChangeRequestType];


/**
 * 
 * @export
 * @interface ChangeRequestsResponseDto
 */
export interface ChangeRequestsResponseDto {
    /**
     * List of change requests
     * @type {Array<ChangeRequestDto>}
     * @memberof ChangeRequestsResponseDto
     */
    'data': Array<ChangeRequestDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof ChangeRequestsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface ChatAttachmentInputDto
 */
export interface ChatAttachmentInputDto {
    /**
     * Raw base64-encoded file body (no data URI prefix).
     * @type {string}
     * @memberof ChatAttachmentInputDto
     */
    'base64': string;
    /**
     * MIME type
     * @type {string}
     * @memberof ChatAttachmentInputDto
     */
    'mimeType': string;
    /**
     * 
     * @type {string}
     * @memberof ChatAttachmentInputDto
     */
    'fileName'?: string;
}
/**
 * 
 * @export
 * @interface ChatHistoryTurnDto
 */
export interface ChatHistoryTurnDto {
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryTurnDto
     */
    'role': ChatHistoryTurnDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryTurnDto
     */
    'text': string;
}

export const ChatHistoryTurnDtoRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type ChatHistoryTurnDtoRoleEnum = typeof ChatHistoryTurnDtoRoleEnum[keyof typeof ChatHistoryTurnDtoRoleEnum];

/**
 * 
 * @export
 * @interface CheckAvailabilityDto
 */
export interface CheckAvailabilityDto {
    /**
     * Email address to check
     * @type {string}
     * @memberof CheckAvailabilityDto
     */
    'email'?: string;
    /**
     * Phone number to check
     * @type {string}
     * @memberof CheckAvailabilityDto
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface CheckAvailabilityResponseDto
 */
export interface CheckAvailabilityResponseDto {
    /**
     * True when no account exists with this email. Omitted when email was not supplied.
     * @type {boolean}
     * @memberof CheckAvailabilityResponseDto
     */
    'emailAvailable'?: boolean;
    /**
     * True when no account exists with this phone number. Omitted when phoneNumber was not supplied.
     * @type {boolean}
     * @memberof CheckAvailabilityResponseDto
     */
    'phoneNumberAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ClaimAttachmentDto
 */
export interface ClaimAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimAttachmentDto
     */
    'objectKey': string;
    /**
     * 
     * @type {string}
     * @memberof ClaimAttachmentDto
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof ClaimAttachmentDto
     */
    'contentType': string;
    /**
     * 
     * @type {number}
     * @memberof ClaimAttachmentDto
     */
    'fileSize'?: number | null;
    /**
     * Signed download URL; detail endpoints only.
     * @type {string}
     * @memberof ClaimAttachmentDto
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface CompareVariantsDto
 */
export interface CompareVariantsDto {
    /**
     * Product variant IDs to compare. Between 2 and 3 IDs, duplicates are ignored.
     * @type {Array<number>}
     * @memberof CompareVariantsDto
     */
    'variantIds': Array<number>;
    /**
     * Optional focus hint for the comparison (e.g. \"best for gaming\", \"value for money\", \"most portable\").
     * @type {string}
     * @memberof CompareVariantsDto
     */
    'focus'?: string;
}
/**
 * 
 * @export
 * @interface ComparisonDto
 */
export interface ComparisonDto {
    /**
     * 
     * @type {string}
     * @memberof ComparisonDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonDto
     */
    'name': string;
    /**
     * Thumbnail URL for the comparison card.
     * @type {string}
     * @memberof ComparisonDto
     */
    'thumbnailUrl'?: string | null;
    /**
     * Odoo product.product IDs included in the comparison.
     * @type {Array<number>}
     * @memberof ComparisonDto
     */
    'variantIds': Array<number>;
    /**
     * Cached AI comparison result captured at save time. Shape mirrors the FE VariantComparison type (summary, perProduct, winnerByCategory, recommendation).
     * @type {{ [key: string]: any; }}
     * @memberof ComparisonDto
     */
    'aiComparison'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof ComparisonDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ComparisonLookupDto
 */
export interface ComparisonLookupDto {
    /**
     * The current user\'s saved comparison for the requested variant set, or null when they have not saved it yet.
     * @type {ComparisonDto}
     * @memberof ComparisonLookupDto
     */
    'saved'?: ComparisonDto | null;
}
/**
 * 
 * @export
 * @interface ComparisonsResponseDto
 */
export interface ComparisonsResponseDto {
    /**
     * 
     * @type {Array<ComparisonDto>}
     * @memberof ComparisonsResponseDto
     */
    'data': Array<ComparisonDto>;
    /**
     * 
     * @type {PaginationMeta}
     * @memberof ComparisonsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface ConfirmPurchaseOrderDto
 */
export interface ConfirmPurchaseOrderDto {
    /**
     * Ship date in format: YYYY-MM-DD HH:mm:ss
     * @type {string}
     * @memberof ConfirmPurchaseOrderDto
     */
    'date_planned': string;
    /**
     * Estimated delivery date in format: YYYY-MM-DD HH:mm:ss
     * @type {string}
     * @memberof ConfirmPurchaseOrderDto
     */
    'estimatedDelivery'?: string;
    /**
     * Tracking URL for the shipment
     * @type {string}
     * @memberof ConfirmPurchaseOrderDto
     */
    'deliveryUrl'?: string;
    /**
     * Carrier / courier name (e.g. DHL, Aramex, FedEx)
     * @type {string}
     * @memberof ConfirmPurchaseOrderDto
     */
    'carrier'?: string;
    /**
     * Carrier tracking number / reference
     * @type {string}
     * @memberof ConfirmPurchaseOrderDto
     */
    'trackingNumber'?: string;
    /**
     * Note to the buyer about the shipment
     * @type {string}
     * @memberof ConfirmPurchaseOrderDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface CountryDto
 */
export interface CountryDto {
    /**
     * Country ID
     * @type {number}
     * @memberof CountryDto
     */
    'id': number;
    /**
     * Country name
     * @type {string}
     * @memberof CountryDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateBrandDto
 */
export interface CreateBrandDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBrandDto
     */
    'name': string;
    /**
     * Base64 logo (PNG/JPEG)
     * @type {string}
     * @memberof CreateBrandDto
     */
    'logo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBrandDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateBuyerAddressDto
 */
export interface CreateBuyerAddressDto {
    /**
     * Address book entry type. Defaults to `delivery` when omitted, preserving the original checkout behavior.
     * @type {string}
     * @memberof CreateBuyerAddressDto
     */
    'type'?: CreateBuyerAddressDtoTypeEnum;
    /**
     * Display / contact name.
     * @type {string}
     * @memberof CreateBuyerAddressDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBuyerAddressDto
     */
    'street'?: string;
    /**
     * Building number, apartment, zone, etc.
     * @type {string}
     * @memberof CreateBuyerAddressDto
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBuyerAddressDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBuyerAddressDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBuyerAddressDto
     */
    'phone'?: string;
    /**
     * Free-form delivery instructions.
     * @type {string}
     * @memberof CreateBuyerAddressDto
     */
    'notes'?: string;
    /**
     * Odoo state id.
     * @type {number}
     * @memberof CreateBuyerAddressDto
     */
    'stateId'?: number;
    /**
     * Odoo country id.
     * @type {number}
     * @memberof CreateBuyerAddressDto
     */
    'countryId'?: number;
}

export const CreateBuyerAddressDtoTypeEnum = {
    Delivery: 'delivery',
    Invoice: 'invoice',
    Other: 'other'
} as const;

export type CreateBuyerAddressDtoTypeEnum = typeof CreateBuyerAddressDtoTypeEnum[keyof typeof CreateBuyerAddressDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateCategoryDto
 */
export interface CreateCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryDto
     */
    'name': string;
    /**
     * Parent category ID
     * @type {number}
     * @memberof CreateCategoryDto
     */
    'parentId'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateChangeRequestDto
 */
export interface CreateChangeRequestDto {
    /**
     * Kind of change being requested. Determines which entity will be mutated on approval.
     * @type {string}
     * @memberof CreateChangeRequestDto
     */
    'type': CreateChangeRequestDtoTypeEnum;
    /**
     * Field-level diff of proposed changes. Only changed fields should be included. The service validates allowed keys per type.
     * @type {{ [key: string]: any; }}
     * @memberof CreateChangeRequestDto
     */
    'proposedChanges': { [key: string]: any; };
    /**
     * Target Odoo product.template ID (required when type is PRODUCT_UPDATE).
     * @type {number}
     * @memberof CreateChangeRequestDto
     */
    'targetProductId'?: number;
    /**
     * Target BankAccount.id (required for BANK_ACCOUNT_UPDATE / BANK_ACCOUNT_DELETE).
     * @type {string}
     * @memberof CreateChangeRequestDto
     */
    'targetBankAccountId'?: string;
    /**
     * Optional note from the submitter explaining the change.
     * @type {string}
     * @memberof CreateChangeRequestDto
     */
    'note'?: string;
}

export const CreateChangeRequestDtoTypeEnum = {
    SellerProfileUpdate: 'SELLER_PROFILE_UPDATE',
    BuyerProfileUpdate: 'BUYER_PROFILE_UPDATE',
    ProductUpdate: 'PRODUCT_UPDATE',
    BankAccountCreate: 'BANK_ACCOUNT_CREATE',
    BankAccountUpdate: 'BANK_ACCOUNT_UPDATE',
    BankAccountDelete: 'BANK_ACCOUNT_DELETE'
} as const;

export type CreateChangeRequestDtoTypeEnum = typeof CreateChangeRequestDtoTypeEnum[keyof typeof CreateChangeRequestDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateComparisonDto
 */
export interface CreateComparisonDto {
    /**
     * 
     * @type {string}
     * @memberof CreateComparisonDto
     */
    'name': string;
    /**
     * Odoo product.product IDs (2 or 3).
     * @type {Array<number>}
     * @memberof CreateComparisonDto
     */
    'variantIds': Array<number>;
    /**
     * Thumbnail URL for the card.
     * @type {string}
     * @memberof CreateComparisonDto
     */
    'thumbnailUrl'?: string;
    /**
     * Cached AI comparison result (summary, perProduct, winnerByCategory, recommendation). Stored verbatim so reopening the comparison reuses the same recommendation.
     * @type {{ [key: string]: any; }}
     * @memberof CreateComparisonDto
     */
    'aiComparison'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface CreateDocumentDto
 */
export interface CreateDocumentDto {
    /**
     * Document type
     * @type {string}
     * @memberof CreateDocumentDto
     */
    'type': CreateDocumentDtoTypeEnum;
    /**
     * Object key from upload URL response
     * @type {string}
     * @memberof CreateDocumentDto
     */
    'objectKey': string;
    /**
     * Original file name
     * @type {string}
     * @memberof CreateDocumentDto
     */
    'fileName': string;
    /**
     * Content type
     * @type {string}
     * @memberof CreateDocumentDto
     */
    'contentType': string;
    /**
     * File size in bytes
     * @type {number}
     * @memberof CreateDocumentDto
     */
    'fileSize'?: number;
    /**
     * User ID to create document for (admin only). If not provided, uses the authenticated user\'s ID.
     * @type {string}
     * @memberof CreateDocumentDto
     */
    'userId'?: string;
}

export const CreateDocumentDtoTypeEnum = {
    Cr: 'CR',
    TaxCard: 'TAX_CARD'
} as const;

export type CreateDocumentDtoTypeEnum = typeof CreateDocumentDtoTypeEnum[keyof typeof CreateDocumentDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateFeaturedDealDto
 */
export interface CreateFeaturedDealDto {
    /**
     * Product template ID to feature
     * @type {number}
     * @memberof CreateFeaturedDealDto
     */
    'productTemplateId': number;
    /**
     * Optional initial sequence. Defaults to the end of the list.
     * @type {number}
     * @memberof CreateFeaturedDealDto
     */
    'sequence'?: number;
}
/**
 * 
 * @export
 * @interface CreateIntentDto
 */
export interface CreateIntentDto {
    /**
     * Amount in cents (e.g., 1999 = $19.99). Minimum is 50 cents.
     * @type {number}
     * @memberof CreateIntentDto
     */
    'amountCents': number;
    /**
     * Currency code (ISO 4217 format)
     * @type {string}
     * @memberof CreateIntentDto
     */
    'currency'?: CreateIntentDtoCurrencyEnum;
    /**
     * Odoo sale order id (must already exist as a draft quotation). The webhook reads this from PaymentIntent metadata on `payment_intent.succeeded` and confirms the SO. Required: every PaymentIntent must correlate to exactly one draft SO created up-front, so money taken always maps to a known order.
     * @type {number}
     * @memberof CreateIntentDto
     */
    'orderId': number;
}

export const CreateIntentDtoCurrencyEnum = {
    Usd: 'usd',
    Eur: 'eur',
    Gbp: 'gbp',
    Cad: 'cad',
    Aud: 'aud',
    Jpy: 'jpy',
    Sar: 'sar',
    Qar: 'qar'
} as const;

export type CreateIntentDtoCurrencyEnum = typeof CreateIntentDtoCurrencyEnum[keyof typeof CreateIntentDtoCurrencyEnum];

/**
 * 
 * @export
 * @interface CreateInvoiceDto
 */
export interface CreateInvoiceDto {
    /**
     * Sale order ID to create invoice for
     * @type {number}
     * @memberof CreateInvoiceDto
     */
    'saleOrderId': number;
}
/**
 * 
 * @export
 * @interface CreateLoyaltyPromotionDto
 */
export interface CreateLoyaltyPromotionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLoyaltyPromotionDto
     */
    'name': string;
    /**
     * Points multiplier (≥ 1)
     * @type {number}
     * @memberof CreateLoyaltyPromotionDto
     */
    'multiplier': number;
    /**
     * 
     * @type {string}
     * @memberof CreateLoyaltyPromotionDto
     */
    'scope': CreateLoyaltyPromotionDtoScopeEnum;
    /**
     * Odoo product.template ids. Required & non-empty when scope = PRODUCTS; omit/empty when ALL.
     * @type {Array<number>}
     * @memberof CreateLoyaltyPromotionDto
     */
    'productIds'?: Array<number>;
    /**
     * Manual on/off toggle. Defaults to true.
     * @type {boolean}
     * @memberof CreateLoyaltyPromotionDto
     */
    'enabled'?: boolean;
    /**
     * Start date (ISO). Null = open-ended.
     * @type {string}
     * @memberof CreateLoyaltyPromotionDto
     */
    'startsAt'?: string | null;
    /**
     * End date (ISO). Null = open-ended.
     * @type {string}
     * @memberof CreateLoyaltyPromotionDto
     */
    'endsAt'?: string | null;
}

export const CreateLoyaltyPromotionDtoScopeEnum = {
    All: 'ALL',
    Products: 'PRODUCTS'
} as const;

export type CreateLoyaltyPromotionDtoScopeEnum = typeof CreateLoyaltyPromotionDtoScopeEnum[keyof typeof CreateLoyaltyPromotionDtoScopeEnum];

/**
 * 
 * @export
 * @interface CreateOrderDisputeDto
 */
export interface CreateOrderDisputeDto {
    /**
     * Odoo sale.order id
     * @type {number}
     * @memberof CreateOrderDisputeDto
     */
    'saleOrderId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDisputeDto
     */
    'reason': CreateOrderDisputeDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDisputeDto
     */
    'description': string;
    /**
     * 
     * @type {Array<AttachmentInputDto>}
     * @memberof CreateOrderDisputeDto
     */
    'attachments'?: Array<AttachmentInputDto>;
}

export const CreateOrderDisputeDtoReasonEnum = {
    WrongItem: 'WRONG_ITEM',
    DamagedInTransit: 'DAMAGED_IN_TRANSIT',
    NotDelivered: 'NOT_DELIVERED',
    PartialDelivery: 'PARTIAL_DELIVERY',
    LateDelivery: 'LATE_DELIVERY',
    BillingIssue: 'BILLING_ISSUE',
    Other: 'OTHER'
} as const;

export type CreateOrderDisputeDtoReasonEnum = typeof CreateOrderDisputeDtoReasonEnum[keyof typeof CreateOrderDisputeDtoReasonEnum];

/**
 * 
 * @export
 * @interface CreatePartnerDto
 */
export interface CreatePartnerDto {
    /**
     * Full name
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'name': string;
    /**
     * Email address
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'email'?: string;
    /**
     * Phone number
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'phone'?: string;
    /**
     * Company type
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'companyType'?: CreatePartnerDtoCompanyTypeEnum;
    /**
     * Company name
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'companyName'?: string;
    /**
     * Commercial Registration number
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'crNumber'?: string;
    /**
     * Tax number
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'taxNumber'?: string;
    /**
     * Contact name
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'contactName'?: string;
    /**
     * Country ID from Odoo (res.country)
     * @type {number}
     * @memberof CreatePartnerDto
     */
    'countryId'?: number;
    /**
     * State / province ID from Odoo (res.country.state)
     * @type {number}
     * @memberof CreatePartnerDto
     */
    'stateId'?: number;
    /**
     * ZIP/Postal code
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'zip'?: string;
    /**
     * City
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'city'?: string;
    /**
     * Street
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'street'?: string;
    /**
     * Street line 2
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'street2'?: string;
    /**
     * Partner type: buyer (sets customer_rank) or seller (sets supplier_rank)
     * @type {string}
     * @memberof CreatePartnerDto
     */
    'partnerType'?: CreatePartnerDtoPartnerTypeEnum;
}

export const CreatePartnerDtoCompanyTypeEnum = {
    Person: 'person',
    Company: 'company'
} as const;

export type CreatePartnerDtoCompanyTypeEnum = typeof CreatePartnerDtoCompanyTypeEnum[keyof typeof CreatePartnerDtoCompanyTypeEnum];
export const CreatePartnerDtoPartnerTypeEnum = {
    Buyer: 'buyer',
    Seller: 'seller'
} as const;

export type CreatePartnerDtoPartnerTypeEnum = typeof CreatePartnerDtoPartnerTypeEnum[keyof typeof CreatePartnerDtoPartnerTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductAttributeDto
 */
export interface CreateProductAttributeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductAttributeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductAttributeDto
     */
    'displayType'?: CreateProductAttributeDtoDisplayTypeEnum;
}

export const CreateProductAttributeDtoDisplayTypeEnum = {
    Radio: 'radio',
    Select: 'select',
    Color: 'color'
} as const;

export type CreateProductAttributeDtoDisplayTypeEnum = typeof CreateProductAttributeDtoDisplayTypeEnum[keyof typeof CreateProductAttributeDtoDisplayTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductAttributeValueDto
 */
export interface CreateProductAttributeValueDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductAttributeValueDto
     */
    'name': string;
    /**
     * Attribute this value belongs to
     * @type {number}
     * @memberof CreateProductAttributeValueDto
     */
    'attributeId': number;
}
/**
 * 
 * @export
 * @interface CreateProductConditionDto
 */
export interface CreateProductConditionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductConditionDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductConditionDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateProductDatasheetUploadUrlDto
 */
export interface CreateProductDatasheetUploadUrlDto {
    /**
     * MIME type of the datasheet to be uploaded. Only PDF is accepted.
     * @type {string}
     * @memberof CreateProductDatasheetUploadUrlDto
     */
    'contentType': CreateProductDatasheetUploadUrlDtoContentTypeEnum;
    /**
     * File size in bytes (for client-side bookkeeping only; enforcement happens via signed URL + backend ingest).
     * @type {number}
     * @memberof CreateProductDatasheetUploadUrlDto
     */
    'fileSize'?: number;
    /**
     * Optional suffix to scope the object key (e.g. a product-request draft ID).
     * @type {string}
     * @memberof CreateProductDatasheetUploadUrlDto
     */
    'scope'?: string;
}

export const CreateProductDatasheetUploadUrlDtoContentTypeEnum = {
    ApplicationPdf: 'application/pdf'
} as const;

export type CreateProductDatasheetUploadUrlDtoContentTypeEnum = typeof CreateProductDatasheetUploadUrlDtoContentTypeEnum[keyof typeof CreateProductDatasheetUploadUrlDtoContentTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductDealTypeDto
 */
export interface CreateProductDealTypeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductDealTypeDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductDealTypeDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateProductImageUploadUrlDto
 */
export interface CreateProductImageUploadUrlDto {
    /**
     * MIME type of the image to be uploaded.
     * @type {string}
     * @memberof CreateProductImageUploadUrlDto
     */
    'contentType': CreateProductImageUploadUrlDtoContentTypeEnum;
    /**
     * File size in bytes (for client-side bookkeeping only; enforcement happens via signed URL).
     * @type {number}
     * @memberof CreateProductImageUploadUrlDto
     */
    'fileSize'?: number;
    /**
     * Optional suffix to scope the object key (e.g. a product-request draft ID).
     * @type {string}
     * @memberof CreateProductImageUploadUrlDto
     */
    'scope'?: string;
}

export const CreateProductImageUploadUrlDtoContentTypeEnum = {
    ImageJpeg: 'image/jpeg',
    ImagePng: 'image/png',
    ImageWebp: 'image/webp'
} as const;

export type CreateProductImageUploadUrlDtoContentTypeEnum = typeof CreateProductImageUploadUrlDtoContentTypeEnum[keyof typeof CreateProductImageUploadUrlDtoContentTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductRequestByNameDto
 */
export interface CreateProductRequestByNameDto {
    /**
     * Product template name
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'name': string;
    /**
     * Brand name from Odoo
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'brand'?: string;
    /**
     * Category name from Odoo
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'category'?: string;
    /**
     * Product description
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'description'?: string;
    /**
     * Product type
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'productType'?: CreateProductRequestByNameDtoProductTypeEnum;
    /**
     * Warranty name from Odoo (e.g. Standard 1Y). If provided, will be resolved via getOrCreate.
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'warranty'?: string;
    /**
     * Warranty type name from Odoo (optional)
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'warrantyType'?: string;
    /**
     * Warranty provider name from Odoo (optional)
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'warrantyProvider'?: string;
    /**
     * Country of origin name from Odoo (optional)
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'countryOfOrigin'?: string;
    /**
     * Screen size name (e.g. 14\"). Template-level — same for every variant.
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'screenSize'?: string;
    /**
     * Resolution name (e.g. 1920x1080). Template-level — same for every variant.
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'resolution'?: string;
    /**
     * Datasheet URL (optional)
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'datasheetUrl'?: string;
    /**
     * Internal notes (optional)
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'notes'?: string;
    /**
     * Deal type name from Odoo (optional)
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'dealType'?: string;
    /**
     * Template-level main image URL. Displayed in the \"General Product images\" section.
     * @type {string}
     * @memberof CreateProductRequestByNameDto
     */
    'image'?: string;
    /**
     * Additional template-level gallery image URLs (semicolon-separated in Excel).
     * @type {Array<string>}
     * @memberof CreateProductRequestByNameDto
     */
    'images'?: Array<string>;
    /**
     * Product variants with storage, color, SKUs, images, and quantities
     * @type {Array<CreateProductVariantByNameDto>}
     * @memberof CreateProductRequestByNameDto
     */
    'variants': Array<CreateProductVariantByNameDto>;
    /**
     * When true, the request is saved as a seller-only draft and does not enter the admin review queue.
     * @type {boolean}
     * @memberof CreateProductRequestByNameDto
     */
    'isDraft'?: boolean;
}

export const CreateProductRequestByNameDtoProductTypeEnum = {
    Consu: 'consu'
} as const;

export type CreateProductRequestByNameDtoProductTypeEnum = typeof CreateProductRequestByNameDtoProductTypeEnum[keyof typeof CreateProductRequestByNameDtoProductTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductRequestDto
 */
export interface CreateProductRequestDto {
    /**
     * Product template name
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'name': string;
    /**
     * Brand ID from Odoo
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'brandId'?: number;
    /**
     * Category ID from Odoo
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'categoryId'?: number;
    /**
     * Product description
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'description'?: string;
    /**
     * Product type
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'productType'?: CreateProductRequestDtoProductTypeEnum;
    /**
     * Warranty record ID from Odoo. Optional — required for non-draft submissions in product UX, but the API accepts drafts without it.
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'warrantyId'?: number;
    /**
     * Warranty type ID from Odoo (optional)
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'warrantyTypeId'?: number;
    /**
     * Warranty provider ID from Odoo (product.warranty.provider). Optional.
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'warrantyProviderId'?: number;
    /**
     * Country of origin ID from Odoo (optional)
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'countryOfOriginId'?: number;
    /**
     * Screen size ID (product.screen.size). Template-level — same for every variant.
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'screenSizeId'?: number;
    /**
     * Resolution ID (product.resolution). Template-level — same for every variant.
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'resolutionId'?: number;
    /**
     * Template-level \"main\" image. Accepts a GCS object key (prefix \"product-images/\"), a public URL (https://), or a base64-encoded image. When the request is non-draft, the server requires `image` or a non-empty `images[]` — every submitted product needs at least one image.
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'image'?: string;
    /**
     * Additional template-level gallery images. Each entry is a GCS object key (prefix \"product-images/\") or a base64-encoded image. On approval each image becomes a product.image row linked via product_tmpl_id.
     * @type {Array<string>}
     * @memberof CreateProductRequestDto
     */
    'images'?: Array<string>;
    /**
     * External datasheet URL (legacy / bulk-import). When provided alongside a PDF that ends in .pdf, the backend will fetch+rehost it as a real PDF attachment. For the single-product UI, prefer uploading via /product-datasheets/upload-url and sending datasheetObjectKey instead.
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'datasheetUrl'?: string;
    /**
     * GCS object key for an uploaded datasheet PDF (prefix \"product-datasheets/\"). Obtained via POST /product-datasheets/upload-url. Backend copies the bytes into an ir.attachment on the new product template and runs AI extraction.
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'datasheetObjectKey'?: string;
    /**
     * Original filename of the uploaded datasheet PDF, used for the ir.attachment name and download attribution.
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'datasheetFileName'?: string;
    /**
     * AiExtraction row id returned by POST /product-datasheets/extract on the FE. When present, the backend loads that row, mirrors its outputJson + outputText onto the new product template in Odoo, and links the extraction to the template — all without re-running Gemini. The bulk-import path leaves this undefined and the backend extracts in the background instead.
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'datasheetExtractionId'?: string;
    /**
     * Internal notes (optional)
     * @type {string}
     * @memberof CreateProductRequestDto
     */
    'notes'?: string;
    /**
     * Deal type ID from Odoo (optional)
     * @type {number}
     * @memberof CreateProductRequestDto
     */
    'dealTypeId'?: number;
    /**
     * Product variants with storage, color, SKUs, images, and quantities
     * @type {Array<CreateProductVariantDto>}
     * @memberof CreateProductRequestDto
     */
    'variants': Array<CreateProductVariantDto>;
    /**
     * Warranty product template ids (product.template where is_warranty=true) the buyer can pick from at checkout. Maps to product.template.compatible_warranty_ids on the created template.
     * @type {Array<number>}
     * @memberof CreateProductRequestDto
     */
    'compatibleWarrantyIds'?: Array<number>;
    /**
     * When true, the request is saved as a seller-only draft and does not enter the admin review queue.
     * @type {boolean}
     * @memberof CreateProductRequestDto
     */
    'isDraft'?: boolean;
}

export const CreateProductRequestDtoProductTypeEnum = {
    Consu: 'consu'
} as const;

export type CreateProductRequestDtoProductTypeEnum = typeof CreateProductRequestDtoProductTypeEnum[keyof typeof CreateProductRequestDtoProductTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductResolutionDto
 */
export interface CreateProductResolutionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductResolutionDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductResolutionDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateProductScreenSizeDto
 */
export interface CreateProductScreenSizeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductScreenSizeDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductScreenSizeDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateProductVariantByNameDto
 */
export interface CreateProductVariantByNameDto {
    /**
     * Storage specification (e.g. 256GB SSD)
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'storage'?: string;
    /**
     * Color name
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'color'?: string;
    /**
     * SKU/Product code for this variant
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'sku'?: string;
    /**
     * Variant image. Accepts a GCS object key returned by POST /product-images/upload-url (prefix \"product-images/\") or a base64-encoded image string. Max image size: 10MB.
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'image'?: string;
    /**
     * Initial supplier stock quantity for this variant
     * @type {number}
     * @memberof CreateProductVariantByNameDto
     */
    'quantity'?: number;
    /**
     * Model name for this variant
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'model'?: string;
    /**
     * Condition name from Odoo (e.g. New, Refurbished)
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'condition'?: string;
    /**
     * CPU name from Odoo (e.g. Intel Core i7-1360P). If provided, will be resolved via getOrCreate.
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'cpu'?: string;
    /**
     * RAM name from Odoo (e.g. 16GB DDR5). If provided, will be resolved via getOrCreate.
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'ram'?: string;
    /**
     * Variant-level datasheet URL (overrides template-level if provided)
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'datasheetUrl'?: string;
    /**
     * Variant-level notes (overrides template-level if provided)
     * @type {string}
     * @memberof CreateProductVariantByNameDto
     */
    'notes'?: string;
    /**
     * Volume pricing tiers for this variant — seller wholesale prices at different quantity breaks
     * @type {Array<PricingTierDto>}
     * @memberof CreateProductVariantByNameDto
     */
    'pricingTiers': Array<PricingTierDto>;
}
/**
 * 
 * @export
 * @interface CreateProductVariantDto
 */
export interface CreateProductVariantDto {
    /**
     * Storage attribute value ID from Odoo (product.attribute.value)
     * @type {number}
     * @memberof CreateProductVariantDto
     */
    'storageValueId'?: number;
    /**
     * Color attribute value ID from Odoo (product.attribute.value)
     * @type {number}
     * @memberof CreateProductVariantDto
     */
    'colorValueId'?: number;
    /**
     * SKU/Product code for this variant
     * @type {string}
     * @memberof CreateProductVariantDto
     */
    'sku'?: string;
    /**
     * Variant image. Accepts one of: (a) a GCS objectKey returned by POST /product-images/upload-url (recommended — preserves auditability); (b) a public https URL; (c) a base64 string. Max 10MB. On approval the backend resolves to base64 and writes it to Odoo image_1920.
     * @type {string}
     * @memberof CreateProductVariantDto
     */
    'image'?: string;
    /**
     * Initial supplier stock quantity for this variant
     * @type {number}
     * @memberof CreateProductVariantDto
     */
    'quantity'?: number;
    /**
     * Model name for this variant
     * @type {string}
     * @memberof CreateProductVariantDto
     */
    'model'?: string;
    /**
     * Condition ID from Odoo (e.g. New, Refurbished)
     * @type {number}
     * @memberof CreateProductVariantDto
     */
    'conditionId'?: number;
    /**
     * CPU attribute value ID from Odoo (product.attribute.value)
     * @type {number}
     * @memberof CreateProductVariantDto
     */
    'cpuValueId'?: number;
    /**
     * RAM attribute value ID from Odoo (product.attribute.value)
     * @type {number}
     * @memberof CreateProductVariantDto
     */
    'ramValueId'?: number;
    /**
     * Variant-level datasheet URL (overrides template-level if provided)
     * @type {string}
     * @memberof CreateProductVariantDto
     */
    'datasheetUrl'?: string;
    /**
     * Variant-level notes (overrides template-level if provided)
     * @type {string}
     * @memberof CreateProductVariantDto
     */
    'notes'?: string;
    /**
     * Volume pricing tiers for this variant — seller wholesale prices at different quantity breaks
     * @type {Array<PricingTierDto>}
     * @memberof CreateProductVariantDto
     */
    'pricingTiers': Array<PricingTierDto>;
}
/**
 * 
 * @export
 * @interface CreateProductWarrantyDto
 */
export interface CreateProductWarrantyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductWarrantyDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductWarrantyDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateProductWarrantyProviderDto
 */
export interface CreateProductWarrantyProviderDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductWarrantyProviderDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductWarrantyProviderDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateProductWarrantyTypeDto
 */
export interface CreateProductWarrantyTypeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProductWarrantyTypeDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductWarrantyTypeDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateQuotationDto
 */
export interface CreateQuotationDto {
    /**
     * Validity date
     * @type {string}
     * @memberof CreateQuotationDto
     */
    'validityDate'?: string;
    /**
     * Order lines
     * @type {Array<QuotationOrderLineDto>}
     * @memberof CreateQuotationDto
     */
    'orderLines': Array<QuotationOrderLineDto>;
    /**
     * Odoo res.partner id of a saved buyer delivery address (type=delivery). When set we validate ownership and pass it as `partner_shipping_id` on the sale order so Odoo ships to that contact instead of the company partner.
     * @type {number}
     * @memberof CreateQuotationDto
     */
    'shippingAddressId'?: number;
    /**
     * Odoo res.partner id of a saved buyer billing address (type=invoice or type=other). When set we pass it as `partner_invoice_id` so accounting bills that contact instead of the company partner. Omit to bill the company partner (default).
     * @type {number}
     * @memberof CreateQuotationDto
     */
    'billingAddressId'?: number;
    /**
     * Loyalty points to apply as a discount on this order. The buyer must have at least this many active points. Discount value is computed from LoyaltyConfig.redemptionValuePer100Points and added as a negative-priced \"Loyalty discount\" line on the Odoo SO. Actual point deduction is deferred until payment_intent.succeeded so abandoned drafts don\'t burn the balance.
     * @type {number}
     * @memberof CreateQuotationDto
     */
    'loyaltyPointsToRedeem'?: number;
}
/**
 * 
 * @export
 * @interface CreateUploadUrlDto
 */
export interface CreateUploadUrlDto {
    /**
     * Document type
     * @type {string}
     * @memberof CreateUploadUrlDto
     */
    'type': CreateUploadUrlDtoTypeEnum;
    /**
     * Content types for file uploads
     * @type {Array<string>}
     * @memberof CreateUploadUrlDto
     */
    'contentTypes': Array<string>;
}

export const CreateUploadUrlDtoTypeEnum = {
    Cr: 'CR',
    TaxCard: 'TAX_CARD'
} as const;

export type CreateUploadUrlDtoTypeEnum = typeof CreateUploadUrlDtoTypeEnum[keyof typeof CreateUploadUrlDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateWarrantyClaimDto
 */
export interface CreateWarrantyClaimDto {
    /**
     * Odoo sale.order id
     * @type {number}
     * @memberof CreateWarrantyClaimDto
     */
    'saleOrderId': number;
    /**
     * Odoo sale.order.line id
     * @type {number}
     * @memberof CreateWarrantyClaimDto
     */
    'saleOrderLineId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateWarrantyClaimDto
     */
    'claimType': CreateWarrantyClaimDtoClaimTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateWarrantyClaimDto
     */
    'description': string;
    /**
     * 
     * @type {Array<AttachmentInputDto>}
     * @memberof CreateWarrantyClaimDto
     */
    'attachments'?: Array<AttachmentInputDto>;
}

export const CreateWarrantyClaimDtoClaimTypeEnum = {
    Damage: 'DAMAGE',
    Defect: 'DEFECT',
    MissingPart: 'MISSING_PART',
    DoesNotMatchDescription: 'DOES_NOT_MATCH_DESCRIPTION',
    Other: 'OTHER'
} as const;

export type CreateWarrantyClaimDtoClaimTypeEnum = typeof CreateWarrantyClaimDtoClaimTypeEnum[keyof typeof CreateWarrantyClaimDtoClaimTypeEnum];

/**
 * 
 * @export
 * @interface CreateWarrantyProductDto
 */
export interface CreateWarrantyProductDto {
    /**
     * 
     * @type {string}
     * @memberof CreateWarrantyProductDto
     */
    'name': string;
    /**
     * Price per unit in the platform currency (QAR).
     * @type {number}
     * @memberof CreateWarrantyProductDto
     */
    'price': number;
    /**
     * product.warranty (period) row id.
     * @type {number}
     * @memberof CreateWarrantyProductDto
     */
    'warrantyId': number;
    /**
     * product.warranty.type row id.
     * @type {number}
     * @memberof CreateWarrantyProductDto
     */
    'warrantyTypeId': number;
    /**
     * product.warranty.provider row id.
     * @type {number}
     * @memberof CreateWarrantyProductDto
     */
    'warrantyProviderId': number;
    /**
     * Buyer-facing description / terms summary.
     * @type {string}
     * @memberof CreateWarrantyProductDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWarrantyProductDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CurrencyDto
 */
export interface CurrencyDto {
    /**
     * Currency ID
     * @type {number}
     * @memberof CurrencyDto
     */
    'id': number;
    /**
     * Currency name (ISO code)
     * @type {string}
     * @memberof CurrencyDto
     */
    'name': string;
    /**
     * Currency symbol
     * @type {string}
     * @memberof CurrencyDto
     */
    'symbol': string;
    /**
     * Whether currency is active
     * @type {boolean}
     * @memberof CurrencyDto
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface DeliveryAlertQueryDto
 */
export interface DeliveryAlertQueryDto {
    /**
     * 
     * @type {string}
     * @memberof DeliveryAlertQueryDto
     */
    'status'?: DeliveryAlertQueryDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof DeliveryAlertQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryAlertQueryDto
     */
    'pageSize'?: number;
}

export const DeliveryAlertQueryDtoStatusEnum = {
    AtRisk: 'AT_RISK',
    Breached: 'BREACHED'
} as const;

export type DeliveryAlertQueryDtoStatusEnum = typeof DeliveryAlertQueryDtoStatusEnum[keyof typeof DeliveryAlertQueryDtoStatusEnum];

/**
 * 
 * @export
 * @interface DeliveryAlertStatsDto
 */
export interface DeliveryAlertStatsDto {
    /**
     * 
     * @type {number}
     * @memberof DeliveryAlertStatsDto
     */
    'atRisk': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryAlertStatsDto
     */
    'breached': number;
}
/**
 * 
 * @export
 * @interface DocumentDto
 */
export interface DocumentDto {
    /**
     * Document ID
     * @type {string}
     * @memberof DocumentDto
     */
    'id': string;
    /**
     * User ID
     * @type {string}
     * @memberof DocumentDto
     */
    'userId': string;
    /**
     * Document type
     * @type {string}
     * @memberof DocumentDto
     */
    'type': DocumentDtoTypeEnum;
    /**
     * Document status
     * @type {string}
     * @memberof DocumentDto
     */
    'status': DocumentDtoStatusEnum;
    /**
     * Object key in storage
     * @type {string}
     * @memberof DocumentDto
     */
    'objectKey': string;
    /**
     * Original file name
     * @type {string}
     * @memberof DocumentDto
     */
    'fileName': string;
    /**
     * Content type
     * @type {string}
     * @memberof DocumentDto
     */
    'contentType': string;
    /**
     * File size in bytes
     * @type {number}
     * @memberof DocumentDto
     */
    'fileSize'?: number | null;
    /**
     * Document expiration date set by the admin (or AI later). Used by the frontend to warn the seller as the date approaches. Null for non-expiring docs or pending/rejected ones.
     * @type {string}
     * @memberof DocumentDto
     */
    'expiresAt'?: string | null;
    /**
     * Admin user ID who reviewed
     * @type {string}
     * @memberof DocumentDto
     */
    'reviewedBy'?: string | null;
    /**
     * Review timestamp
     * @type {string}
     * @memberof DocumentDto
     */
    'reviewedAt'?: string | null;
    /**
     * Rejection reason
     * @type {string}
     * @memberof DocumentDto
     */
    'rejectionReason'?: string | null;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof DocumentDto
     */
    'createdAt': string;
    /**
     * Last update timestamp
     * @type {string}
     * @memberof DocumentDto
     */
    'updatedAt': string;
}

export const DocumentDtoTypeEnum = {
    Cr: 'CR',
    TaxCard: 'TAX_CARD'
} as const;

export type DocumentDtoTypeEnum = typeof DocumentDtoTypeEnum[keyof typeof DocumentDtoTypeEnum];
export const DocumentDtoStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type DocumentDtoStatusEnum = typeof DocumentDtoStatusEnum[keyof typeof DocumentDtoStatusEnum];

/**
 * 
 * @export
 * @interface DocumentsQueryDto
 */
export interface DocumentsQueryDto {
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof DocumentsQueryDto
     */
    'page'?: number;
    /**
     * Page size
     * @type {number}
     * @memberof DocumentsQueryDto
     */
    'pageSize'?: number;
    /**
     * Search term for text search
     * @type {string}
     * @memberof DocumentsQueryDto
     */
    'search'?: string;
    /**
     * Field to sort by
     * @type {string}
     * @memberof DocumentsQueryDto
     */
    'sortBy'?: string;
    /**
     * Sort order
     * @type {string}
     * @memberof DocumentsQueryDto
     */
    'sortOrder'?: DocumentsQueryDtoSortOrderEnum;
    /**
     * Filter by document type
     * @type {string}
     * @memberof DocumentsQueryDto
     */
    'type'?: DocumentsQueryDtoTypeEnum;
    /**
     * Filter by document status
     * @type {string}
     * @memberof DocumentsQueryDto
     */
    'status'?: DocumentsQueryDtoStatusEnum;
    /**
     * Filter by user ID (admin only)
     * @type {string}
     * @memberof DocumentsQueryDto
     */
    'userId'?: string;
    /**
     * Filter by partner type (admin only)
     * @type {string}
     * @memberof DocumentsQueryDto
     */
    'partnerType'?: DocumentsQueryDtoPartnerTypeEnum;
}

export const DocumentsQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type DocumentsQueryDtoSortOrderEnum = typeof DocumentsQueryDtoSortOrderEnum[keyof typeof DocumentsQueryDtoSortOrderEnum];
export const DocumentsQueryDtoTypeEnum = {
    Cr: 'CR',
    TaxCard: 'TAX_CARD'
} as const;

export type DocumentsQueryDtoTypeEnum = typeof DocumentsQueryDtoTypeEnum[keyof typeof DocumentsQueryDtoTypeEnum];
export const DocumentsQueryDtoStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type DocumentsQueryDtoStatusEnum = typeof DocumentsQueryDtoStatusEnum[keyof typeof DocumentsQueryDtoStatusEnum];
export const DocumentsQueryDtoPartnerTypeEnum = {
    Buyer: 'buyer',
    Seller: 'seller'
} as const;

export type DocumentsQueryDtoPartnerTypeEnum = typeof DocumentsQueryDtoPartnerTypeEnum[keyof typeof DocumentsQueryDtoPartnerTypeEnum];

/**
 * 
 * @export
 * @interface DocumentsResponseDto
 */
export interface DocumentsResponseDto {
    /**
     * List of documents
     * @type {Array<DocumentDto>}
     * @memberof DocumentsResponseDto
     */
    'data': Array<DocumentDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof DocumentsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface DropshippingAttachmentDto
 */
export interface DropshippingAttachmentDto {
    /**
     * Attachment ID
     * @type {number}
     * @memberof DropshippingAttachmentDto
     */
    'id': number;
    /**
     * File name
     * @type {string}
     * @memberof DropshippingAttachmentDto
     */
    'name': string;
    /**
     * MIME type
     * @type {string}
     * @memberof DropshippingAttachmentDto
     */
    'mimetype': string;
    /**
     * Creation timestamp (Odoo UTC string)
     * @type {string}
     * @memberof DropshippingAttachmentDto
     */
    'createDate'?: string | null;
    /**
     * URL on this backend that streams the attachment bytes
     * @type {string}
     * @memberof DropshippingAttachmentDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface DropshippingDto
 */
export interface DropshippingDto {
    /**
     * Dropshipping ID
     * @type {number}
     * @memberof DropshippingDto
     */
    'id': number;
    /**
     * Dropshipping name
     * @type {string}
     * @memberof DropshippingDto
     */
    'name': string;
    /**
     * State
     * @type {string}
     * @memberof DropshippingDto
     */
    'state': string;
    /**
     * Picking type
     * @type {OdooObjectDto}
     * @memberof DropshippingDto
     */
    'pickingType'?: OdooObjectDto | null;
    /**
     * Source location
     * @type {OdooObjectDto}
     * @memberof DropshippingDto
     */
    'location'?: OdooObjectDto | null;
    /**
     * Destination location
     * @type {OdooObjectDto}
     * @memberof DropshippingDto
     */
    'locationDest'?: OdooObjectDto | null;
    /**
     * Origin (e.g., purchase order name)
     * @type {string}
     * @memberof DropshippingDto
     */
    'origin'?: string | null;
    /**
     * Scheduled date
     * @type {string}
     * @memberof DropshippingDto
     */
    'scheduledDate'?: string | null;
    /**
     * Deadline date
     * @type {string}
     * @memberof DropshippingDto
     */
    'dateDeadline'?: string | null;
    /**
     * Partner (customer/vendor)
     * @type {OdooObjectDto}
     * @memberof DropshippingDto
     */
    'partner'?: OdooObjectDto | null;
    /**
     * Note to buyer
     * @type {string}
     * @memberof DropshippingDto
     */
    'note'?: string | null;
    /**
     * Delivery tracking URL
     * @type {string}
     * @memberof DropshippingDto
     */
    'deliveryTrackingUrl'?: string | null;
    /**
     * Carrier name (e.g. DHL)
     * @type {string}
     * @memberof DropshippingDto
     */
    'carrierName'?: string | null;
    /**
     * Carrier tracking reference number
     * @type {string}
     * @memberof DropshippingDto
     */
    'carrierTrackingRef'?: string | null;
    /**
     * Is signed
     * @type {boolean}
     * @memberof DropshippingDto
     */
    'isSigned'?: boolean | null;
    /**
     * Whether the buyer has confirmed receipt of this delivery. Source of truth for the post-delivery \"Validated\" status — written by the buyer\'s Mark-as-Received action and read by both buyer and seller views.
     * @type {boolean}
     * @memberof DropshippingDto
     */
    'confirmedByBuyer'?: boolean | null;
    /**
     * Preview URL for the delivery-slip PDF report (Odoo Procurtal portal route)
     * @type {string}
     * @memberof DropshippingDto
     */
    'previewUrl'?: string | null;
    /**
     * Internal estimated delivery cost for this shipment (Procurtal-owned rate card)
     * @type {number}
     * @memberof DropshippingDto
     */
    'internalDeliveryCostEstimate'?: number | null;
    /**
     * Currency for internal delivery cost tracking
     * @type {string}
     * @memberof DropshippingDto
     */
    'internalDeliveryCostCurrency'?: string | null;
    /**
     * Internal actual delivery cost recorded by admin after reconciliation
     * @type {number}
     * @memberof DropshippingDto
     */
    'internalDeliveryActualCost'?: number | null;
    /**
     * Currency for the actual internal delivery cost
     * @type {string}
     * @memberof DropshippingDto
     */
    'internalDeliveryActualCostCurrency'?: string | null;
    /**
     * Source of the recorded internal delivery cost
     * @type {string}
     * @memberof DropshippingDto
     */
    'internalDeliveryCostSource'?: string | null;
    /**
     * When the internal delivery cost was recorded
     * @type {string}
     * @memberof DropshippingDto
     */
    'internalDeliveryCostRecordedAt'?: string | null;
    /**
     * Attachments uploaded against this picking (e.g. delivery proof photos)
     * @type {Array<DropshippingAttachmentDto>}
     * @memberof DropshippingDto
     */
    'attachments'?: Array<DropshippingAttachmentDto> | null;
}
/**
 * 
 * @export
 * @interface EffectiveFieldConfigDto
 */
export interface EffectiveFieldConfigDto {
    /**
     * Resolved policy per configurable field for this category.
     * @type {{ [key: string]: FieldPolicyDto; }}
     * @memberof EffectiveFieldConfigDto
     */
    'config': { [key: string]: FieldPolicyDto; };
}
/**
 * 
 * @export
 * @interface ExtractProductDatasheetDto
 */
export interface ExtractProductDatasheetDto {
    /**
     * GCS object key returned by POST /product-datasheets/upload-url after the seller PUT the PDF.
     * @type {string}
     * @memberof ExtractProductDatasheetDto
     */
    'objectKey': string;
    /**
     * Original PDF filename, persisted with the AiExtraction audit row for display/audit.
     * @type {string}
     * @memberof ExtractProductDatasheetDto
     */
    'fileName'?: string;
}
/**
 * 
 * @export
 * @interface ExtractedDocumentMetadataDto
 */
export interface ExtractedDocumentMetadataDto {
    /**
     * Suggested expiration date extracted from the document. Null when the model could not find one.
     * @type {string}
     * @memberof ExtractedDocumentMetadataDto
     */
    'expiresAt'?: string | null;
    /**
     * Confidence in the extracted expiresAt, 0..1. Below ~0.6 the admin should manually verify.
     * @type {number}
     * @memberof ExtractedDocumentMetadataDto
     */
    'confidence': number;
    /**
     * Free-form additional fields (issuer, document number, owner) returned by the extractor. Useful for cross-checking the seller profile.
     * @type {{ [key: string]: any; }}
     * @memberof ExtractedDocumentMetadataDto
     */
    'rawFields': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ExtractedDocumentMetadataDto
     */
    'modelVersion': string;
    /**
     * 
     * @type {string}
     * @memberof ExtractedDocumentMetadataDto
     */
    'extractedAt': string;
    /**
     * True when the result came from the placeholder pipeline rather than a real model call. Frontend should clearly label suggestions in this case.
     * @type {boolean}
     * @memberof ExtractedDocumentMetadataDto
     */
    'isStub': boolean;
}
/**
 * 
 * @export
 * @interface FeaturedDealDto
 */
export interface FeaturedDealDto {
    /**
     * Featured deal record ID
     * @type {number}
     * @memberof FeaturedDealDto
     */
    'id': number;
    /**
     * Linked product template ID
     * @type {number}
     * @memberof FeaturedDealDto
     */
    'productTemplateId': number;
    /**
     * Ordering sequence (lower = earlier)
     * @type {number}
     * @memberof FeaturedDealDto
     */
    'sequence': number;
    /**
     * Whether the deal is active
     * @type {boolean}
     * @memberof FeaturedDealDto
     */
    'active': boolean;
    /**
     * Resolved product
     * @type {ProductDto}
     * @memberof FeaturedDealDto
     */
    'product'?: ProductDto | null;
}
/**
 * 
 * @export
 * @interface FieldPolicyDto
 */
export interface FieldPolicyDto {
    /**
     * Whether the field is shown in the product form
     * @type {boolean}
     * @memberof FieldPolicyDto
     */
    'visible': boolean;
    /**
     * Whether the field must be filled in
     * @type {boolean}
     * @memberof FieldPolicyDto
     */
    'required': boolean;
}
/**
 * 
 * @export
 * @interface ForgotPasswordDto
 */
export interface ForgotPasswordDto {
    /**
     * User email address to send password reset instructions
     * @type {string}
     * @memberof ForgotPasswordDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface GetDocumentDownloadUrl200Response
 */
export interface GetDocumentDownloadUrl200Response {
    /**
     * 
     * @type {string}
     * @memberof GetDocumentDownloadUrl200Response
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface GetOrCreateAttributeDto
 */
export interface GetOrCreateAttributeDto {
    /**
     * Attribute name
     * @type {string}
     * @memberof GetOrCreateAttributeDto
     */
    'name': GetOrCreateAttributeDtoNameEnum;
    /**
     * Display type for the attribute
     * @type {string}
     * @memberof GetOrCreateAttributeDto
     */
    'displayType'?: GetOrCreateAttributeDtoDisplayTypeEnum;
}

export const GetOrCreateAttributeDtoNameEnum = {
    Storage: 'Storage',
    Color: 'Color'
} as const;

export type GetOrCreateAttributeDtoNameEnum = typeof GetOrCreateAttributeDtoNameEnum[keyof typeof GetOrCreateAttributeDtoNameEnum];
export const GetOrCreateAttributeDtoDisplayTypeEnum = {
    Radio: 'radio',
    Select: 'select',
    Color: 'color'
} as const;

export type GetOrCreateAttributeDtoDisplayTypeEnum = typeof GetOrCreateAttributeDtoDisplayTypeEnum[keyof typeof GetOrCreateAttributeDtoDisplayTypeEnum];

/**
 * 
 * @export
 * @interface GetOrCreateAttributeResponseDto
 */
export interface GetOrCreateAttributeResponseDto {
    /**
     * Attribute ID (existing or newly created)
     * @type {number}
     * @memberof GetOrCreateAttributeResponseDto
     */
    'id': number;
    /**
     * Attribute name
     * @type {string}
     * @memberof GetOrCreateAttributeResponseDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface InternalDeliveryCostRecordDto
 */
export interface InternalDeliveryCostRecordDto {
    /**
     * Picking ID
     * @type {number}
     * @memberof InternalDeliveryCostRecordDto
     */
    'pickingId': number;
    /**
     * Order type
     * @type {string}
     * @memberof InternalDeliveryCostRecordDto
     */
    'orderType': string;
    /**
     * Order ID
     * @type {number}
     * @memberof InternalDeliveryCostRecordDto
     */
    'orderId': number;
    /**
     * Actual internal delivery cost
     * @type {number}
     * @memberof InternalDeliveryCostRecordDto
     */
    'actualCost': number;
    /**
     * Currency for actual cost
     * @type {string}
     * @memberof InternalDeliveryCostRecordDto
     */
    'currency': string;
    /**
     * Cost source
     * @type {string}
     * @memberof InternalDeliveryCostRecordDto
     */
    'costSource': string;
    /**
     * Optional notes
     * @type {string}
     * @memberof InternalDeliveryCostRecordDto
     */
    'notes'?: string | null;
    /**
     * Admin user ID
     * @type {string}
     * @memberof InternalDeliveryCostRecordDto
     */
    'recordedBy'?: string | null;
    /**
     * Recorded at
     * @type {string}
     * @memberof InternalDeliveryCostRecordDto
     */
    'recordedAt': string;
}
/**
 * 
 * @export
 * @interface InternalDeliveryRateCardDto
 */
export interface InternalDeliveryRateCardDto {
    /**
     * Currency used for internal delivery cost tracking
     * @type {string}
     * @memberof InternalDeliveryRateCardDto
     */
    'currency': string;
    /**
     * Internal cost per shipment
     * @type {number}
     * @memberof InternalDeliveryRateCardDto
     */
    'costPerShipment': number;
    /**
     * Last updated by user ID
     * @type {string}
     * @memberof InternalDeliveryRateCardDto
     */
    'updatedBy'?: string | null;
    /**
     * Last update date
     * @type {string}
     * @memberof InternalDeliveryRateCardDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * Invoice ID
     * @type {number}
     * @memberof InvoiceDto
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface LinkedPurchaseOrderDto
 */
export interface LinkedPurchaseOrderDto {
    /**
     * Purchase order ID
     * @type {number}
     * @memberof LinkedPurchaseOrderDto
     */
    'id': number;
    /**
     * Purchase order name
     * @type {string}
     * @memberof LinkedPurchaseOrderDto
     */
    'name': string;
    /**
     * Purchase order state
     * @type {string}
     * @memberof LinkedPurchaseOrderDto
     */
    'state': string;
    /**
     * Total amount
     * @type {number}
     * @memberof LinkedPurchaseOrderDto
     */
    'amountTotal': number;
    /**
     * Seller partner ID
     * @type {number}
     * @memberof LinkedPurchaseOrderDto
     */
    'partnerId'?: number | null;
    /**
     * Seller partner name
     * @type {string}
     * @memberof LinkedPurchaseOrderDto
     */
    'partnerName'?: string | null;
}
/**
 * 
 * @export
 * @interface LinkedSaleOrderDto
 */
export interface LinkedSaleOrderDto {
    /**
     * Sale order ID
     * @type {number}
     * @memberof LinkedSaleOrderDto
     */
    'id': number;
    /**
     * Sale order name
     * @type {string}
     * @memberof LinkedSaleOrderDto
     */
    'name': string;
    /**
     * Sale order state
     * @type {string}
     * @memberof LinkedSaleOrderDto
     */
    'state': string;
    /**
     * Total amount
     * @type {number}
     * @memberof LinkedSaleOrderDto
     */
    'amountTotal': number;
    /**
     * Buyer partner ID
     * @type {number}
     * @memberof LinkedSaleOrderDto
     */
    'partnerId'?: number | null;
    /**
     * Buyer partner name
     * @type {string}
     * @memberof LinkedSaleOrderDto
     */
    'partnerName'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginOtpRequestDto
 */
export interface LoginOtpRequestDto {
    /**
     * Email address
     * @type {string}
     * @memberof LoginOtpRequestDto
     */
    'email'?: string;
    /**
     * Phone number in E.164 format
     * @type {string}
     * @memberof LoginOtpRequestDto
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface LoginPasswordDto
 */
export interface LoginPasswordDto {
    /**
     * User email address
     * @type {string}
     * @memberof LoginPasswordDto
     */
    'email': string;
    /**
     * User password
     * @type {string}
     * @memberof LoginPasswordDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LoyaltyAnalyticsDto
 */
export interface LoyaltyAnalyticsDto {
    /**
     * 
     * @type {LoyaltyAnalyticsSummaryDto}
     * @memberof LoyaltyAnalyticsDto
     */
    'summary': LoyaltyAnalyticsSummaryDto;
    /**
     * 
     * @type {Array<TimeSeriesBucketDto>}
     * @memberof LoyaltyAnalyticsDto
     */
    'timeSeries': Array<TimeSeriesBucketDto>;
}
/**
 * 
 * @export
 * @interface LoyaltyAnalyticsSummaryDto
 */
export interface LoyaltyAnalyticsSummaryDto {
    /**
     * Total points issued in the date range
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'totalPointsIssued': number;
    /**
     * Total points redeemed in the date range
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'totalPointsRedeemed': number;
    /**
     * Total points expired in the date range
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'totalPointsExpired': number;
    /**
     * Redemption rate percentage (redeemed / issued * 100)
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'redemptionRate': number;
    /**
     * Expiry rate percentage (expired / issued * 100)
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'expiryRate': number;
    /**
     * Outstanding active points (not expired, not redeemed)
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'outstandingPoints': number;
    /**
     * Outstanding liability in currency
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'outstandingValue': number;
    /**
     * Currency code for outstandingValue
     * @type {string}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'currency': string;
    /**
     * Points expiring within the next 30 days
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'expiringSoon': number;
    /**
     * Count of users with active points
     * @type {number}
     * @memberof LoyaltyAnalyticsSummaryDto
     */
    'activeMembers': number;
}
/**
 * 
 * @export
 * @interface LoyaltyConfigDto
 */
export interface LoyaltyConfigDto {
    /**
     * Points awarded per 100 units of currency
     * @type {number}
     * @memberof LoyaltyConfigDto
     */
    'pointsPer100': number;
    /**
     * Currency value granted per 100 redeemed points (e.g. 1.0 = QAR 1 per 100 points)
     * @type {number}
     * @memberof LoyaltyConfigDto
     */
    'redemptionValuePer100Points': number;
    /**
     * Days until points expire
     * @type {number}
     * @memberof LoyaltyConfigDto
     */
    'validityDays': number;
    /**
     * Last updated by user ID
     * @type {string}
     * @memberof LoyaltyConfigDto
     */
    'updatedBy'?: string | null;
    /**
     * Last update date
     * @type {string}
     * @memberof LoyaltyConfigDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface LoyaltyPointTransactionDto
 */
export interface LoyaltyPointTransactionDto {
    /**
     * Transaction ID
     * @type {string}
     * @memberof LoyaltyPointTransactionDto
     */
    'id': string;
    /**
     * Points awarded
     * @type {number}
     * @memberof LoyaltyPointTransactionDto
     */
    'points': number;
    /**
     * Payment amount
     * @type {number}
     * @memberof LoyaltyPointTransactionDto
     */
    'amount': number;
    /**
     * Payment currency
     * @type {string}
     * @memberof LoyaltyPointTransactionDto
     */
    'currency': string;
    /**
     * Expiration date
     * @type {string}
     * @memberof LoyaltyPointTransactionDto
     */
    'expiresAt': string;
    /**
     * Whether points are expired
     * @type {boolean}
     * @memberof LoyaltyPointTransactionDto
     */
    'isExpired': boolean;
    /**
     * Whether points have been redeemed
     * @type {boolean}
     * @memberof LoyaltyPointTransactionDto
     */
    'isRedeemed': boolean;
    /**
     * Transaction date
     * @type {string}
     * @memberof LoyaltyPointTransactionDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface LoyaltyPointsMeta
 */
export interface LoyaltyPointsMeta {
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'currentPage': number;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyPointsMeta
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyPointsMeta
     */
    'isLastPage': boolean;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'previousPage': number | null;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'nextPage': number | null;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'totalCount': number;
    /**
     * 
     * @type {PaginationLinks}
     * @memberof LoyaltyPointsMeta
     */
    'links'?: PaginationLinks;
    /**
     * Total loyalty points across all transactions
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'totalPoints': number;
    /**
     * Active (non-expired, non-redeemed) points
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'activePoints': number;
    /**
     * Expired points
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'expiredPoints': number;
    /**
     * Redeemed points
     * @type {number}
     * @memberof LoyaltyPointsMeta
     */
    'redeemedPoints': number;
}
/**
 * 
 * @export
 * @interface LoyaltyPointsQueryDto
 */
export interface LoyaltyPointsQueryDto {
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsQueryDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsQueryDto
     */
    'search'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsQueryDto
     */
    'sortBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsQueryDto
     */
    'sortOrder'?: LoyaltyPointsQueryDtoSortOrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyPointsQueryDto
     */
    'isExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyPointsQueryDto
     */
    'isRedeemed'?: boolean;
}

export const LoyaltyPointsQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type LoyaltyPointsQueryDtoSortOrderEnum = typeof LoyaltyPointsQueryDtoSortOrderEnum[keyof typeof LoyaltyPointsQueryDtoSortOrderEnum];

/**
 * 
 * @export
 * @interface LoyaltyPointsResponseDto
 */
export interface LoyaltyPointsResponseDto {
    /**
     * Loyalty point transactions
     * @type {Array<LoyaltyPointTransactionDto>}
     * @memberof LoyaltyPointsResponseDto
     */
    'data': Array<LoyaltyPointTransactionDto>;
    /**
     * Pagination metadata with summary totals
     * @type {LoyaltyPointsMeta}
     * @memberof LoyaltyPointsResponseDto
     */
    'meta': LoyaltyPointsMeta;
}
/**
 * 
 * @export
 * @interface LoyaltyPromotionDto
 */
export interface LoyaltyPromotionDto {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPromotionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPromotionDto
     */
    'name': string;
    /**
     * Points multiplier (e.g. 2.0 = double)
     * @type {number}
     * @memberof LoyaltyPromotionDto
     */
    'multiplier': number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPromotionDto
     */
    'scope': LoyaltyPromotionDtoScopeEnum;
    /**
     * Odoo product.template ids the promotion targets. Empty when scope = ALL.
     * @type {Array<number>}
     * @memberof LoyaltyPromotionDto
     */
    'productIds': Array<number>;
    /**
     * Manual on/off toggle. Active = enabled AND within window.
     * @type {boolean}
     * @memberof LoyaltyPromotionDto
     */
    'enabled': boolean;
    /**
     * First day the promotion applies (inclusive). Null = open-ended.
     * @type {string}
     * @memberof LoyaltyPromotionDto
     */
    'startsAt'?: string | null;
    /**
     * Last day the promotion applies (inclusive). Null = open-ended.
     * @type {string}
     * @memberof LoyaltyPromotionDto
     */
    'endsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPromotionDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPromotionDto
     */
    'updatedAt': string;
    /**
     * Admin user ID who last created/updated
     * @type {string}
     * @memberof LoyaltyPromotionDto
     */
    'updatedBy'?: string | null;
}

export const LoyaltyPromotionDtoScopeEnum = {
    All: 'ALL',
    Products: 'PRODUCTS'
} as const;

export type LoyaltyPromotionDtoScopeEnum = typeof LoyaltyPromotionDtoScopeEnum[keyof typeof LoyaltyPromotionDtoScopeEnum];

/**
 * 
 * @export
 * @interface LoyaltyRedemptionDto
 */
export interface LoyaltyRedemptionDto {
    /**
     * Redemption id
     * @type {string}
     * @memberof LoyaltyRedemptionDto
     */
    'id': string;
    /**
     * Points redeemed
     * @type {number}
     * @memberof LoyaltyRedemptionDto
     */
    'points': number;
    /**
     * Reason or note
     * @type {string}
     * @memberof LoyaltyRedemptionDto
     */
    'reason'?: string | null;
    /**
     * Linked order id (string)
     * @type {string}
     * @memberof LoyaltyRedemptionDto
     */
    'orderId'?: string | null;
    /**
     * Linked Odoo sale.order id
     * @type {number}
     * @memberof LoyaltyRedemptionDto
     */
    'saleOrderId'?: number | null;
    /**
     * Whether this redemption was reversed (e.g. refund)
     * @type {boolean}
     * @memberof LoyaltyRedemptionDto
     */
    'isReversed': boolean;
    /**
     * Reversed at
     * @type {string}
     * @memberof LoyaltyRedemptionDto
     */
    'reversedAt'?: string | null;
    /**
     * Created at
     * @type {string}
     * @memberof LoyaltyRedemptionDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface LoyaltyStatsDto
 */
export interface LoyaltyStatsDto {
    /**
     * Total points issued across all transactions
     * @type {number}
     * @memberof LoyaltyStatsDto
     */
    'totalPointsIssued': number;
    /**
     * Count of users with active (non-expired, non-redeemed) points
     * @type {number}
     * @memberof LoyaltyStatsDto
     */
    'activeMembers': number;
    /**
     * Total points redeemed
     * @type {number}
     * @memberof LoyaltyStatsDto
     */
    'pointsRedeemed': number;
}
/**
 * 
 * @export
 * @interface MessageResponseDto
 */
export interface MessageResponseDto {
    /**
     * Response message
     * @type {string}
     * @memberof MessageResponseDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface MyPaymentsResponseDto
 */
export interface MyPaymentsResponseDto {
    /**
     * Payments paid to the seller
     * @type {Array<PaymentDto>}
     * @memberof MyPaymentsResponseDto
     */
    'data': Array<PaymentDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof MyPaymentsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface MyUnpaidBillsResponseDto
 */
export interface MyUnpaidBillsResponseDto {
    /**
     * Unpaid vendor bills owed to the seller
     * @type {Array<VendorBillDto>}
     * @memberof MyUnpaidBillsResponseDto
     */
    'data': Array<VendorBillDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof MyUnpaidBillsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface NewVariantAttributeValueDto
 */
export interface NewVariantAttributeValueDto {
    /**
     * product.attribute ID for this axis. Must match an attribute line already on the product template.
     * @type {number}
     * @memberof NewVariantAttributeValueDto
     */
    'attributeId'?: number;
    /**
     * Existing product.attribute.value ID. Provide either this OR `newValueName` (not both).
     * @type {number}
     * @memberof NewVariantAttributeValueDto
     */
    'valueId'?: number;
    /**
     * Name of a brand-new attribute value to create and add to this attribute line. Use when the seller introduces a value not yet on the product (e.g. a new \"Green\" color). Provide either this OR `valueId`.
     * @type {string}
     * @memberof NewVariantAttributeValueDto
     */
    'newValueName'?: string;
}
/**
 * 
 * @export
 * @interface NewVariantDto
 */
export interface NewVariantDto {
    /**
     * One entry per attribute axis (Storage, Color, …). Every attribute line on the product MUST be covered exactly once so the resulting variant is fully specified.
     * @type {Array<NewVariantAttributeValueDto>}
     * @memberof NewVariantDto
     */
    'attributeValues'?: Array<NewVariantAttributeValueDto>;
    /**
     * SKU (default_code) for the new variant
     * @type {string}
     * @memberof NewVariantDto
     */
    'sku'?: string;
    /**
     * Seller\'s list price for the new variant (writes a product.supplierinfo row at min_qty=1).
     * @type {number}
     * @memberof NewVariantDto
     */
    'sellerPrice'?: number;
    /**
     * Initial supplier_stock for the new variant
     * @type {number}
     * @memberof NewVariantDto
     */
    'quantity'?: number;
    /**
     * Image for the new variant (GCS object key or base64).
     * @type {string}
     * @memberof NewVariantDto
     */
    'image'?: string;
    /**
     * Seller discount percentage to apply on the new variant. 0 = no discount.
     * @type {number}
     * @memberof NewVariantDto
     */
    'discountPercentage'?: number;
}
/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'kind': NotificationDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'link'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NotificationDto
     */
    'payload'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'readAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'createdAt': string;
}

export const NotificationDtoKindEnum = {
    OrderConfirmed: 'orderConfirmed',
    OrderShipped: 'orderShipped',
    OrderDelivered: 'orderDelivered',
    OrderCancelled: 'orderCancelled',
    DocumentApproved: 'documentApproved',
    DocumentRejected: 'documentRejected',
    PartnerApproved: 'partnerApproved',
    LoyaltyPointsExpiring: 'loyaltyPointsExpiring',
    SystemAnnouncement: 'systemAnnouncement',
    Welcome: 'welcome',
    UserSignedUp: 'userSignedUp',
    WarrantyClaimed: 'warrantyClaimed',
    WarrantyStatusUpdated: 'warrantyStatusUpdated',
    DisputeOpened: 'disputeOpened',
    DisputeStatusUpdated: 'disputeStatusUpdated',
    DeliveryAtRisk: 'deliveryAtRisk',
    DeliveryBreached: 'deliveryBreached'
} as const;

export type NotificationDtoKindEnum = typeof NotificationDtoKindEnum[keyof typeof NotificationDtoKindEnum];

/**
 * 
 * @export
 * @interface NotificationPrefsDto
 */
export interface NotificationPrefsDto {
    /**
     * Order lifecycle emails
     * @type {boolean}
     * @memberof NotificationPrefsDto
     */
    'emailOrders': boolean;
    /**
     * KYC, partner approval, and change/product request outcomes
     * @type {boolean}
     * @memberof NotificationPrefsDto
     */
    'emailAccount': boolean;
    /**
     * Promotions and newsletters
     * @type {boolean}
     * @memberof NotificationPrefsDto
     */
    'emailMarketing': boolean;
}
/**
 * 
 * @export
 * @interface NotificationsResponseDto
 */
export interface NotificationsResponseDto {
    /**
     * 
     * @type {Array<NotificationDto>}
     * @memberof NotificationsResponseDto
     */
    'data': Array<NotificationDto>;
    /**
     * 
     * @type {PaginationMeta}
     * @memberof NotificationsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface OdooObjectDto
 */
export interface OdooObjectDto {
    /**
     * Object ID
     * @type {number}
     * @memberof OdooObjectDto
     */
    'id': number;
    /**
     * Object name
     * @type {string}
     * @memberof OdooObjectDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrderDisputeDto
 */
export interface OrderDisputeDto {
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof OrderDisputeDto
     */
    'saleOrderId': number;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'buyerId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'reason': OrderDisputeDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'status': OrderDisputeDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'resolutionAction'?: OrderDisputeDtoResolutionActionEnum | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'resolutionNote'?: string | null;
    /**
     * Attachment metadata array
     * @type {Array<AttachmentInputDto>}
     * @memberof OrderDisputeDto
     */
    'attachments': Array<AttachmentInputDto>;
    /**
     * 
     * @type {Array<OrderDisputeMessageDto>}
     * @memberof OrderDisputeDto
     */
    'messages'?: Array<OrderDisputeMessageDto>;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeDto
     */
    'updatedAt': string;
}

export const OrderDisputeDtoReasonEnum = {
    WrongItem: 'WRONG_ITEM',
    DamagedInTransit: 'DAMAGED_IN_TRANSIT',
    NotDelivered: 'NOT_DELIVERED',
    PartialDelivery: 'PARTIAL_DELIVERY',
    LateDelivery: 'LATE_DELIVERY',
    BillingIssue: 'BILLING_ISSUE',
    Other: 'OTHER'
} as const;

export type OrderDisputeDtoReasonEnum = typeof OrderDisputeDtoReasonEnum[keyof typeof OrderDisputeDtoReasonEnum];
export const OrderDisputeDtoStatusEnum = {
    Open: 'OPEN',
    UnderReview: 'UNDER_REVIEW',
    ResolvedRefund: 'RESOLVED_REFUND',
    ResolvedReplacement: 'RESOLVED_REPLACEMENT',
    ResolvedOther: 'RESOLVED_OTHER',
    Rejected: 'REJECTED'
} as const;

export type OrderDisputeDtoStatusEnum = typeof OrderDisputeDtoStatusEnum[keyof typeof OrderDisputeDtoStatusEnum];
export const OrderDisputeDtoResolutionActionEnum = {
    Refund: 'REFUND',
    Replacement: 'REPLACEMENT',
    Credit: 'CREDIT',
    None: 'NONE'
} as const;

export type OrderDisputeDtoResolutionActionEnum = typeof OrderDisputeDtoResolutionActionEnum[keyof typeof OrderDisputeDtoResolutionActionEnum];

/**
 * 
 * @export
 * @interface OrderDisputeMessageDto
 */
export interface OrderDisputeMessageDto {
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeMessageDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeMessageDto
     */
    'disputeId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeMessageDto
     */
    'authorId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeMessageDto
     */
    'authorRole': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeMessageDto
     */
    'content': string;
    /**
     * Attachment metadata array
     * @type {Array<AttachmentInputDto>}
     * @memberof OrderDisputeMessageDto
     */
    'attachments': Array<AttachmentInputDto>;
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeMessageDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface OrderDisputeQueryDto
 */
export interface OrderDisputeQueryDto {
    /**
     * 
     * @type {string}
     * @memberof OrderDisputeQueryDto
     */
    'status'?: OrderDisputeQueryDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderDisputeQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDisputeQueryDto
     */
    'pageSize'?: number;
}

export const OrderDisputeQueryDtoStatusEnum = {
    Open: 'OPEN',
    UnderReview: 'UNDER_REVIEW',
    ResolvedRefund: 'RESOLVED_REFUND',
    ResolvedReplacement: 'RESOLVED_REPLACEMENT',
    ResolvedOther: 'RESOLVED_OTHER',
    Rejected: 'REJECTED'
} as const;

export type OrderDisputeQueryDtoStatusEnum = typeof OrderDisputeQueryDtoStatusEnum[keyof typeof OrderDisputeQueryDtoStatusEnum];

/**
 * 
 * @export
 * @interface OrderDisputeStatsDto
 */
export interface OrderDisputeStatsDto {
    /**
     * 
     * @type {number}
     * @memberof OrderDisputeStatsDto
     */
    'total': number;
    /**
     * Count per DisputeStatus value
     * @type {object}
     * @memberof OrderDisputeStatsDto
     */
    'byStatus': object;
    /**
     * Count per DisputeReason value
     * @type {object}
     * @memberof OrderDisputeStatsDto
     */
    'byReason': object;
    /**
     * Average days from OPEN to a resolved/rejected state
     * @type {number}
     * @memberof OrderDisputeStatsDto
     */
    'avgResolutionDays': number | null;
}
/**
 * 
 * @export
 * @interface PageLink
 */
export interface PageLink {
    /**
     * Page number (null if ellipsis)
     * @type {number}
     * @memberof PageLink
     */
    'page': number | null;
    /**
     * URL for this page (null if ellipsis)
     * @type {string}
     * @memberof PageLink
     */
    'url': string | null;
    /**
     * Whether this is the current page
     * @type {boolean}
     * @memberof PageLink
     */
    'isActive': boolean;
    /**
     * Whether this is an ellipsis placeholder
     * @type {boolean}
     * @memberof PageLink
     */
    'isEllipsis'?: boolean;
}
/**
 * 
 * @export
 * @interface PaginationLinks
 */
export interface PaginationLinks {
    /**
     * Link to current page
     * @type {string}
     * @memberof PaginationLinks
     */
    'self': string;
    /**
     * Link to first page
     * @type {string}
     * @memberof PaginationLinks
     */
    'first': string;
    /**
     * Link to previous page
     * @type {string}
     * @memberof PaginationLinks
     */
    'prev': string | null;
    /**
     * Link to next page
     * @type {string}
     * @memberof PaginationLinks
     */
    'next': string | null;
    /**
     * Link to last page
     * @type {string}
     * @memberof PaginationLinks
     */
    'last': string;
    /**
     * Array of page links with ellipses for gaps (e.g., [1, 2, ..., 5, ..., 10, 11])
     * @type {Array<PageLink>}
     * @memberof PaginationLinks
     */
    'pages': Array<PageLink>;
}
/**
 * 
 * @export
 * @interface PaginationMeta
 */
export interface PaginationMeta {
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'currentPage': number;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationMeta
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationMeta
     */
    'isLastPage': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'previousPage': number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'nextPage': number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'totalCount': number;
    /**
     * 
     * @type {PaginationLinks}
     * @memberof PaginationMeta
     */
    'links'?: PaginationLinks;
}
/**
 * 
 * @export
 * @interface ParentCategoryDto
 */
export interface ParentCategoryDto {
    /**
     * Parent category ID
     * @type {number}
     * @memberof ParentCategoryDto
     */
    'id': number;
    /**
     * Parent category name
     * @type {string}
     * @memberof ParentCategoryDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PartialFieldPolicyDto
 */
export interface PartialFieldPolicyDto {
    /**
     * 
     * @type {boolean}
     * @memberof PartialFieldPolicyDto
     */
    'visible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartialFieldPolicyDto
     */
    'required'?: boolean;
}
/**
 * 
 * @export
 * @interface PartnerChildDto
 */
export interface PartnerChildDto {
    /**
     * Odoo res.partner id
     * @type {number}
     * @memberof PartnerChildDto
     */
    'id': number;
    /**
     * Child kind. `contact` is a person; the rest are address book entries.
     * @type {string}
     * @memberof PartnerChildDto
     */
    'type': PartnerChildDtoTypeEnum;
    /**
     * Display name
     * @type {string}
     * @memberof PartnerChildDto
     */
    'name'?: string | null;
    /**
     * Email
     * @type {string}
     * @memberof PartnerChildDto
     */
    'email'?: string | null;
    /**
     * Phone
     * @type {string}
     * @memberof PartnerChildDto
     */
    'phone'?: string | null;
    /**
     * Street
     * @type {string}
     * @memberof PartnerChildDto
     */
    'street'?: string | null;
    /**
     * Street line 2
     * @type {string}
     * @memberof PartnerChildDto
     */
    'street2'?: string | null;
    /**
     * City
     * @type {string}
     * @memberof PartnerChildDto
     */
    'city'?: string | null;
    /**
     * ZIP / postal code
     * @type {string}
     * @memberof PartnerChildDto
     */
    'zip'?: string | null;
    /**
     * Country
     * @type {CountryDto}
     * @memberof PartnerChildDto
     */
    'country'?: CountryDto | null;
}

export const PartnerChildDtoTypeEnum = {
    Contact: 'contact',
    Delivery: 'delivery',
    Invoice: 'invoice',
    Other: 'other',
    Private: 'private'
} as const;

export type PartnerChildDtoTypeEnum = typeof PartnerChildDtoTypeEnum[keyof typeof PartnerChildDtoTypeEnum];

/**
 * 
 * @export
 * @interface PartnerDto
 */
export interface PartnerDto {
    /**
     * Partner ID
     * @type {number}
     * @memberof PartnerDto
     */
    'id': number;
    /**
     * Partner name
     * @type {string}
     * @memberof PartnerDto
     */
    'name'?: string | null;
    /**
     * Email address
     * @type {string}
     * @memberof PartnerDto
     */
    'email'?: string | null;
    /**
     * Phone number
     * @type {string}
     * @memberof PartnerDto
     */
    'phone'?: string | null;
    /**
     * Customer rank
     * @type {number}
     * @memberof PartnerDto
     */
    'customerRank'?: number | null;
    /**
     * Supplier rank
     * @type {number}
     * @memberof PartnerDto
     */
    'supplierRank'?: number | null;
    /**
     * Company type
     * @type {string}
     * @memberof PartnerDto
     */
    'companyType'?: string | null;
    /**
     * Country
     * @type {CountryDto}
     * @memberof PartnerDto
     */
    'country'?: CountryDto | null;
    /**
     * VAT number
     * @type {string}
     * @memberof PartnerDto
     */
    'vat'?: string | null;
    /**
     * Commercial registration number
     * @type {string}
     * @memberof PartnerDto
     */
    'companyRegistry'?: string | null;
    /**
     * Street address
     * @type {string}
     * @memberof PartnerDto
     */
    'street'?: string | null;
    /**
     * Street address line 2
     * @type {string}
     * @memberof PartnerDto
     */
    'street2'?: string | null;
    /**
     * City
     * @type {string}
     * @memberof PartnerDto
     */
    'city'?: string | null;
    /**
     * ZIP/Postal code
     * @type {string}
     * @memberof PartnerDto
     */
    'zip'?: string | null;
    /**
     * State / province
     * @type {OdooObjectDto}
     * @memberof PartnerDto
     */
    'state'?: OdooObjectDto | null;
    /**
     * Whether the partner is active
     * @type {boolean}
     * @memberof PartnerDto
     */
    'active': boolean;
    /**
     * Product pricelist
     * @type {PartnerPricelistDto}
     * @memberof PartnerDto
     */
    'pricelist'?: PartnerPricelistDto | null;
}
/**
 * 
 * @export
 * @interface PartnerOverviewStatsDto
 */
export interface PartnerOverviewStatsDto {
    /**
     * Total number of partners
     * @type {number}
     * @memberof PartnerOverviewStatsDto
     */
    'totalPartners': number;
    /**
     * Number of supplier/seller partners (supplier_rank > 0)
     * @type {number}
     * @memberof PartnerOverviewStatsDto
     */
    'sellers': number;
    /**
     * Number of buyer/customer partners (customer_rank > 0)
     * @type {number}
     * @memberof PartnerOverviewStatsDto
     */
    'buyers': number;
}
/**
 * 
 * @export
 * @interface PartnerPricelistDto
 */
export interface PartnerPricelistDto {
    /**
     * Pricelist ID
     * @type {number}
     * @memberof PartnerPricelistDto
     */
    'id': number;
    /**
     * Pricelist name
     * @type {string}
     * @memberof PartnerPricelistDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PartnerStatsDto
 */
export interface PartnerStatsDto {
    /**
     * Buyer-side stats (present when customer_rank > 0)
     * @type {BuyerStatsDto}
     * @memberof PartnerStatsDto
     */
    'buyer'?: BuyerStatsDto | null;
    /**
     * Seller-side stats (present when supplier_rank > 0)
     * @type {SellerStatsDto}
     * @memberof PartnerStatsDto
     */
    'seller'?: SellerStatsDto | null;
}
/**
 * 
 * @export
 * @interface PartnersQueryDto
 */
export interface PartnersQueryDto {
    /**
     * 
     * @type {number}
     * @memberof PartnersQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnersQueryDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnersQueryDto
     */
    'search'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnersQueryDto
     */
    'sortBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnersQueryDto
     */
    'sortOrder'?: PartnersQueryDtoSortOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnersQueryDto
     */
    'type'?: PartnersQueryDtoTypeEnum;
}

export const PartnersQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type PartnersQueryDtoSortOrderEnum = typeof PartnersQueryDtoSortOrderEnum[keyof typeof PartnersQueryDtoSortOrderEnum];
export const PartnersQueryDtoTypeEnum = {
    Buyer: 'buyer',
    Supplier: 'supplier'
} as const;

export type PartnersQueryDtoTypeEnum = typeof PartnersQueryDtoTypeEnum[keyof typeof PartnersQueryDtoTypeEnum];

/**
 * 
 * @export
 * @interface PartnersResponseDto
 */
export interface PartnersResponseDto {
    /**
     * Array of partners
     * @type {Array<PartnerDto>}
     * @memberof PartnersResponseDto
     */
    'data': Array<PartnerDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof PartnersResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface PayVendorBillDto
 */
export interface PayVendorBillDto {
    /**
     * Odoo vendor bill (account.move) ID
     * @type {number}
     * @memberof PayVendorBillDto
     */
    'billId': number;
    /**
     * Amount to pay. Defaults to full outstanding balance if omitted.
     * @type {number}
     * @memberof PayVendorBillDto
     */
    'amount'?: number;
    /**
     * Payment date in YYYY-MM-DD format
     * @type {string}
     * @memberof PayVendorBillDto
     */
    'paymentDate'?: string;
    /**
     * Odoo account.journal ID to use
     * @type {number}
     * @memberof PayVendorBillDto
     */
    'journalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PayVendorBillDto
     */
    'memo'?: string;
}
/**
 * 
 * @export
 * @interface PaymentDto
 */
export interface PaymentDto {
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'direction': PaymentDtoDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'partnerType': PaymentDtoPartnerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    'partnerId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'partnerName': string | null;
    /**
     * Payment amount in the payment currency
     * @type {number}
     * @memberof PaymentDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'currency': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'state': PaymentDtoStateEnum;
    /**
     * Accounting journal name, e.g. \"Stripe\"
     * @type {string}
     * @memberof PaymentDto
     */
    'journalName': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'reference': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'memo': string | null;
    /**
     * Payment date (YYYY-MM-DD)
     * @type {string}
     * @memberof PaymentDto
     */
    'date': string | null;
    /**
     * IDs of invoices/bills reconciled against this payment
     * @type {Array<number>}
     * @memberof PaymentDto
     */
    'reconciledInvoiceIds': Array<number>;
    /**
     * Reconciled bills/invoices with name and preview URL
     * @type {Array<object>}
     * @memberof PaymentDto
     */
    'reconciledBills': Array<object>;
    /**
     * Source document of the reconciled bill (e.g. \"P00013\"). Null if no source ref is set.
     * @type {string}
     * @memberof PaymentDto
     */
    'originRef': string | null;
    /**
     * Sale order linked to this payment via the PO origin (e.g. \"S00013\"). Null if not resolved.
     * @type {string}
     * @memberof PaymentDto
     */
    'saleOrderRef': string | null;
}

export const PaymentDtoDirectionEnum = {
    Incoming: 'INCOMING',
    Outgoing: 'OUTGOING'
} as const;

export type PaymentDtoDirectionEnum = typeof PaymentDtoDirectionEnum[keyof typeof PaymentDtoDirectionEnum];
export const PaymentDtoPartnerTypeEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Other: 'OTHER'
} as const;

export type PaymentDtoPartnerTypeEnum = typeof PaymentDtoPartnerTypeEnum[keyof typeof PaymentDtoPartnerTypeEnum];
export const PaymentDtoStateEnum = {
    Draft: 'DRAFT',
    Posted: 'POSTED',
    InProcess: 'IN_PROCESS',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Rejected: 'REJECTED',
    Unknown: 'UNKNOWN'
} as const;

export type PaymentDtoStateEnum = typeof PaymentDtoStateEnum[keyof typeof PaymentDtoStateEnum];

/**
 * 
 * @export
 * @interface PaymentMethodDto
 */
export interface PaymentMethodDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    'brand'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    'last4'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodDto
     */
    'expMonth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodDto
     */
    'expYear'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodDto
     */
    'isDefault': boolean;
}
/**
 * 
 * @export
 * @interface PendingChangeRequestSummaryDto
 */
export interface PendingChangeRequestSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof PendingChangeRequestSummaryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PendingChangeRequestSummaryDto
     */
    'type': PendingChangeRequestSummaryDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PendingChangeRequestSummaryDto
     */
    'status': PendingChangeRequestSummaryDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PendingChangeRequestSummaryDto
     */
    'targetBankAccountId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PendingChangeRequestSummaryDto
     */
    'targetProductId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PendingChangeRequestSummaryDto
     */
    'submittedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PendingChangeRequestSummaryDto
     */
    'createdAt': string;
}

export const PendingChangeRequestSummaryDtoTypeEnum = {
    SellerProfileUpdate: 'SELLER_PROFILE_UPDATE',
    BuyerProfileUpdate: 'BUYER_PROFILE_UPDATE',
    ProductUpdate: 'PRODUCT_UPDATE',
    BankAccountCreate: 'BANK_ACCOUNT_CREATE',
    BankAccountUpdate: 'BANK_ACCOUNT_UPDATE',
    BankAccountDelete: 'BANK_ACCOUNT_DELETE'
} as const;

export type PendingChangeRequestSummaryDtoTypeEnum = typeof PendingChangeRequestSummaryDtoTypeEnum[keyof typeof PendingChangeRequestSummaryDtoTypeEnum];
export const PendingChangeRequestSummaryDtoStatusEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    ChangesRequested: 'CHANGES_REQUESTED',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type PendingChangeRequestSummaryDtoStatusEnum = typeof PendingChangeRequestSummaryDtoStatusEnum[keyof typeof PendingChangeRequestSummaryDtoStatusEnum];

/**
 * 
 * @export
 * @interface PendingReleaseSummaryDto
 */
export interface PendingReleaseSummaryDto {
    /**
     * Number of unpaid vendor bills (posted, not fully paid).
     * @type {number}
     * @memberof PendingReleaseSummaryDto
     */
    'unpaidBillCount': number;
    /**
     * Sum of outstanding amounts across unpaid bills.
     * @type {number}
     * @memberof PendingReleaseSummaryDto
     */
    'totalAmount': number;
    /**
     * ISO currency code for `totalAmount`. May be null when no unpaid bills exist or currencies are mixed.
     * @type {string}
     * @memberof PendingReleaseSummaryDto
     */
    'currency': string | null;
}
/**
 * 
 * @export
 * @interface PricelistDto
 */
export interface PricelistDto {
    /**
     * Pricelist ID
     * @type {number}
     * @memberof PricelistDto
     */
    'id': number;
    /**
     * Pricelist name
     * @type {string}
     * @memberof PricelistDto
     */
    'name': string;
    /**
     * Currency ID
     * @type {number}
     * @memberof PricelistDto
     */
    'currencyId': number;
}
/**
 * 
 * @export
 * @interface PricelistItemDto
 */
export interface PricelistItemDto {
    /**
     * Pricelist item ID
     * @type {number}
     * @memberof PricelistItemDto
     */
    'id': number;
    /**
     * Pricelist ID
     * @type {number}
     * @memberof PricelistItemDto
     */
    'pricelistId': number;
    /**
     * Product template ID
     * @type {number}
     * @memberof PricelistItemDto
     */
    'productTemplateId': number;
    /**
     * Minimum quantity for this price
     * @type {number}
     * @memberof PricelistItemDto
     */
    'minQuantity': number;
    /**
     * Price computation method
     * @type {string}
     * @memberof PricelistItemDto
     */
    'computePrice': string;
    /**
     * Fixed price
     * @type {number}
     * @memberof PricelistItemDto
     */
    'fixedPrice': number;
}
/**
 * 
 * @export
 * @interface PricingTierDto
 */
export interface PricingTierDto {
    /**
     * Minimum quantity for this price tier
     * @type {number}
     * @memberof PricingTierDto
     */
    'minQty': number;
    /**
     * Price for this quantity tier
     * @type {number}
     * @memberof PricingTierDto
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface PricingTierResponseDto
 */
export interface PricingTierResponseDto {
    /**
     * Minimum quantity for this price tier
     * @type {number}
     * @memberof PricingTierResponseDto
     */
    'minQty': number;
    /**
     * Price for this quantity tier
     * @type {number}
     * @memberof PricingTierResponseDto
     */
    'price': number;
    /**
     * Approved Procurtal price for this tier
     * @type {number}
     * @memberof PricingTierResponseDto
     */
    'adminPrice'?: number | null;
    /**
     * Approved margin percentage versus seller price
     * @type {number}
     * @memberof PricingTierResponseDto
     */
    'marginPercentage'?: number | null;
    /**
     * Currency code
     * @type {string}
     * @memberof PricingTierResponseDto
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface ProductAttributeDto
 */
export interface ProductAttributeDto {
    /**
     * Attribute ID
     * @type {number}
     * @memberof ProductAttributeDto
     */
    'id': number;
    /**
     * Attribute name
     * @type {string}
     * @memberof ProductAttributeDto
     */
    'name': string;
    /**
     * Display type
     * @type {string}
     * @memberof ProductAttributeDto
     */
    'displayType': ProductAttributeDtoDisplayTypeEnum;
    /**
     * Array of attribute value IDs
     * @type {Array<number>}
     * @memberof ProductAttributeDto
     */
    'valueIds': Array<number>;
}

export const ProductAttributeDtoDisplayTypeEnum = {
    Radio: 'radio',
    Select: 'select',
    Color: 'color'
} as const;

export type ProductAttributeDtoDisplayTypeEnum = typeof ProductAttributeDtoDisplayTypeEnum[keyof typeof ProductAttributeDtoDisplayTypeEnum];

/**
 * 
 * @export
 * @interface ProductAttributeLineDto
 */
export interface ProductAttributeLineDto {
    /**
     * product.attribute ID for this axis
     * @type {number}
     * @memberof ProductAttributeLineDto
     */
    'attributeId': number;
    /**
     * Attribute axis name (e.g. \"Storage\")
     * @type {string}
     * @memberof ProductAttributeLineDto
     */
    'attributeName': string;
    /**
     * Existing values configured on this attribute line for the product.
     * @type {Array<AttributeValueEntryDto>}
     * @memberof ProductAttributeLineDto
     */
    'values': Array<AttributeValueEntryDto>;
}
/**
 * 
 * @export
 * @interface ProductAttributeValueDto
 */
export interface ProductAttributeValueDto {
    /**
     * Attribute value ID
     * @type {number}
     * @memberof ProductAttributeValueDto
     */
    'id': number;
    /**
     * Attribute value name
     * @type {string}
     * @memberof ProductAttributeValueDto
     */
    'name': string;
    /**
     * Attribute ID this value belongs to
     * @type {number}
     * @memberof ProductAttributeValueDto
     */
    'attributeId': number;
}
/**
 * 
 * @export
 * @interface ProductConditionDto
 */
export interface ProductConditionDto {
    /**
     * Condition ID
     * @type {number}
     * @memberof ProductConditionDto
     */
    'id': number;
    /**
     * Condition name
     * @type {string}
     * @memberof ProductConditionDto
     */
    'name': string;
    /**
     * Whether the condition is active
     * @type {boolean}
     * @memberof ProductConditionDto
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface ProductDatasheetDownloadUrlResponseDto
 */
export interface ProductDatasheetDownloadUrlResponseDto {
    /**
     * Short-lived signed GCS read URL for the datasheet PDF. Safe to feed into an <iframe> or <a download>.
     * @type {string}
     * @memberof ProductDatasheetDownloadUrlResponseDto
     */
    'url': string;
    /**
     * ISO timestamp when the URL expires.
     * @type {string}
     * @memberof ProductDatasheetDownloadUrlResponseDto
     */
    'expiresAt': string;
    /**
     * Display file name to use for download attribution.
     * @type {string}
     * @memberof ProductDatasheetDownloadUrlResponseDto
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface ProductDatasheetExtractionDto
 */
export interface ProductDatasheetExtractionDto {
    /**
     * AiExtraction row id. Send this back as CreateProductRequestDto.datasheetExtractionId on submit; the backend looks up the row, mirrors content to Odoo, and links the row to the new product template.
     * @type {string}
     * @memberof ProductDatasheetExtractionDto
     */
    'extractionId': string;
    /**
     * Lifecycle status of this extraction. \"failed\" means Gemini could not return anything; the seller can still submit and the bulk fallback will retry server-side.
     * @type {string}
     * @memberof ProductDatasheetExtractionDto
     */
    'status': ProductDatasheetExtractionDtoStatusEnum;
    /**
     * Structured AI summary of the datasheet as a JSON string. The schema includes title, manufacturer, summary, key_features, specifications, dimensions, certifications, connectivity, power, operating_conditions, warranty, in_the_box, revision. Fields the AI could not find are omitted. Null when extraction failed.
     * @type {string}
     * @memberof ProductDatasheetExtractionDto
     */
    'aiSummary'?: string | null;
    /**
     * Raw text dump from the PDF in reading order, capped at 40k characters. Null when extraction failed.
     * @type {string}
     * @memberof ProductDatasheetExtractionDto
     */
    'extractedText'?: string | null;
    /**
     * Original object key — surfaced so the FE can keep the dropzone state in sync.
     * @type {string}
     * @memberof ProductDatasheetExtractionDto
     */
    'objectKey': string;
    /**
     * USD cost of this Gemini call, computed at write-time from token usage. Useful for ops dashboards.
     * @type {number}
     * @memberof ProductDatasheetExtractionDto
     */
    'costUSD'?: number | null;
}

export const ProductDatasheetExtractionDtoStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Failed: 'failed'
} as const;

export type ProductDatasheetExtractionDtoStatusEnum = typeof ProductDatasheetExtractionDtoStatusEnum[keyof typeof ProductDatasheetExtractionDtoStatusEnum];

/**
 * 
 * @export
 * @interface ProductDatasheetUploadUrlResponseDto
 */
export interface ProductDatasheetUploadUrlResponseDto {
    /**
     * Signed upload URL (PUT).
     * @type {string}
     * @memberof ProductDatasheetUploadUrlResponseDto
     */
    'uploadUrl': string;
    /**
     * ISO timestamp when the signed URL expires.
     * @type {string}
     * @memberof ProductDatasheetUploadUrlResponseDto
     */
    'expiresAt': string;
    /**
     * Headers the client must include in the PUT.
     * @type {object}
     * @memberof ProductDatasheetUploadUrlResponseDto
     */
    'headers': object;
    /**
     * Object key to send back in CreateProductRequestDto.datasheetObjectKey after the upload succeeds.
     * @type {string}
     * @memberof ProductDatasheetUploadUrlResponseDto
     */
    'objectKey': string;
    /**
     * Maximum allowed file size in bytes.
     * @type {number}
     * @memberof ProductDatasheetUploadUrlResponseDto
     */
    'maxBytes': number;
}
/**
 * 
 * @export
 * @interface ProductDealTypeDto
 */
export interface ProductDealTypeDto {
    /**
     * Deal type ID
     * @type {number}
     * @memberof ProductDealTypeDto
     */
    'id': number;
    /**
     * Deal type name
     * @type {string}
     * @memberof ProductDealTypeDto
     */
    'name': string;
    /**
     * Whether the deal type is active
     * @type {boolean}
     * @memberof ProductDealTypeDto
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface ProductDetailsDto
 */
export interface ProductDetailsDto {
    /**
     * Product template
     * @type {ProductDto}
     * @memberof ProductDetailsDto
     */
    'product': ProductDto;
    /**
     * Product variants for this template
     * @type {Array<ProductVariantDto>}
     * @memberof ProductDetailsDto
     */
    'variants': Array<ProductVariantDto>;
}
/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * Product ID
     * @type {number}
     * @memberof ProductDto
     */
    'id': number;
    /**
     * Product name
     * @type {string}
     * @memberof ProductDto
     */
    'name': string;
    /**
     * Display name
     * @type {string}
     * @memberof ProductDto
     */
    'displayName'?: string | null;
    /**
     * Sale price
     * @type {number}
     * @memberof ProductDto
     */
    'listPrice'?: number | null;
    /**
     * Product description
     * @type {string}
     * @memberof ProductDto
     */
    'description'?: string | null;
    /**
     * Cost price
     * @type {number}
     * @memberof ProductDto
     */
    'standardPrice'?: number | null;
    /**
     * The authenticated seller\'s own list price for this product, sourced from product.supplierinfo.price. Populated only on seller-facing endpoints (GET /products/my) when the caller is the supplier — null otherwise. Use this instead of listPrice on seller-facing screens; listPrice reflects the admin-approved buyer-facing price.
     * @type {number}
     * @memberof ProductDto
     */
    'sellerPrice'?: number | null;
    /**
     * Product type
     * @type {string}
     * @memberof ProductDto
     */
    'type': string;
    /**
     * SKU/Product code
     * @type {string}
     * @memberof ProductDto
     */
    'defaultCode'?: string | null;
    /**
     * Price extra
     * @type {number}
     * @memberof ProductDto
     */
    'priceExtra'?: number | null;
    /**
     * Variant ID (first product template attribute value ID)
     * @type {number}
     * @memberof ProductDto
     */
    'variantId'?: number | null;
    /**
     * First product variant ID (product.product). Used for wishlist/likes matching.
     * @type {number}
     * @memberof ProductDto
     */
    'firstVariantId'?: number | null;
    /**
     * Product category
     * @type {OdooObjectDto}
     * @memberof ProductDto
     */
    'category'?: OdooObjectDto | null;
    /**
     * Seller ID (first seller from seller_ids)
     * @type {number}
     * @memberof ProductDto
     */
    'sellerId'?: number | null;
    /**
     * Unit of Measure
     * @type {OdooObjectDto}
     * @memberof ProductDto
     */
    'unitOfMeasure'?: OdooObjectDto | null;
    /**
     * Whether the product is active
     * @type {boolean}
     * @memberof ProductDto
     */
    'active': boolean;
    /**
     * Derived product lifecycle status. Active products are \"live\"; inactive products can be either \"inactive\" or \"discontinued\" depending on the internal lifecycle marker.
     * @type {string}
     * @memberof ProductDto
     */
    'lifecycleStatus'?: ProductDtoLifecycleStatusEnum;
    /**
     * URL of the product main image. Backed by Odoo image_1920 and proxied through /product-images/template/:id with write_date as cache-busting token.
     * @type {string}
     * @memberof ProductDto
     */
    'image'?: string | null;
    /**
     * URLs for template gallery images, ordered by sequence. Each entry proxies a product.image row through /product-images/gallery/:id. Only populated by single-product fetches.
     * @type {Array<string>}
     * @memberof ProductDto
     */
    'galleryImages'?: Array<string>;
    /**
     * IDs of the product.image rows behind galleryImages, same order. Used by the edit endpoint to identify which gallery rows to keep when reconciling.
     * @type {Array<number>}
     * @memberof ProductDto
     */
    'galleryImageIds'?: Array<number>;
    /**
     * Product brand
     * @type {OdooObjectDto}
     * @memberof ProductDto
     */
    'brand'?: OdooObjectDto | null;
    /**
     * Warranty
     * @type {OdooObjectDto}
     * @memberof ProductDto
     */
    'warranty'?: OdooObjectDto | null;
    /**
     * Warranty type
     * @type {OdooObjectDto}
     * @memberof ProductDto
     */
    'warrantyType'?: OdooObjectDto | null;
    /**
     * Warranty product template ids the buyer can choose from at checkout (product.template.compatible_warranty_ids).
     * @type {Array<number>}
     * @memberof ProductDto
     */
    'compatibleWarrantyIds'?: Array<number>;
    /**
     * Country of origin
     * @type {OdooObjectDto}
     * @memberof ProductDto
     */
    'countryOfOrigin'?: OdooObjectDto | null;
    /**
     * External datasheet URL (legacy / bulk import).
     * @type {string}
     * @memberof ProductDto
     */
    'datasheetUrl'?: string | null;
    /**
     * True when the product has an uploaded PDF datasheet that can be previewed via /product-datasheets/template/:id/download-url.
     * @type {boolean}
     * @memberof ProductDto
     */
    'hasDatasheetPdf'?: boolean;
    /**
     * Internal notes
     * @type {string}
     * @memberof ProductDto
     */
    'notes'?: string | null;
    /**
     * Deal type
     * @type {OdooObjectDto}
     * @memberof ProductDto
     */
    'dealType'?: OdooObjectDto | null;
    /**
     * Distinct conditions (e.g. New, Refurbished) across this product\'s variants, so a catalog card can disclose them before the buyer opens the product. Populated on the catalog, similar-products and Deal of the Week lists; empty elsewhere.
     * @type {Array<OdooObjectDto>}
     * @memberof ProductDto
     */
    'conditions'?: Array<OdooObjectDto>;
    /**
     * Delivery lead time promised to the buyer, in days from order confirmation (Odoo\'s Customer Lead Time, product.template.sale_delay). Null when the seller hasn\'t set one.
     * @type {number}
     * @memberof ProductDto
     */
    'leadTimeDays'?: number | null;
}

export const ProductDtoLifecycleStatusEnum = {
    Live: 'live',
    Inactive: 'inactive',
    Discontinued: 'discontinued'
} as const;

export type ProductDtoLifecycleStatusEnum = typeof ProductDtoLifecycleStatusEnum[keyof typeof ProductDtoLifecycleStatusEnum];

/**
 * 
 * @export
 * @interface ProductImageUploadUrlResponseDto
 */
export interface ProductImageUploadUrlResponseDto {
    /**
     * Signed upload URL (PUT).
     * @type {string}
     * @memberof ProductImageUploadUrlResponseDto
     */
    'uploadUrl': string;
    /**
     * ISO timestamp when the signed URL expires.
     * @type {string}
     * @memberof ProductImageUploadUrlResponseDto
     */
    'expiresAt': string;
    /**
     * Headers the client must include in the PUT.
     * @type {object}
     * @memberof ProductImageUploadUrlResponseDto
     */
    'headers': object;
    /**
     * Object key to send back in CreateProductVariantDto.image after the upload succeeds.
     * @type {string}
     * @memberof ProductImageUploadUrlResponseDto
     */
    'objectKey': string;
    /**
     * Maximum allowed file size in bytes.
     * @type {number}
     * @memberof ProductImageUploadUrlResponseDto
     */
    'maxBytes': number;
}
/**
 * 
 * @export
 * @interface ProductRequestDto
 */
export interface ProductRequestDto {
    /**
     * Product request ID
     * @type {string}
     * @memberof ProductRequestDto
     */
    'id': string;
    /**
     * User ID
     * @type {string}
     * @memberof ProductRequestDto
     */
    'userId': string;
    /**
     * Odoo supplier partner ID
     * @type {number}
     * @memberof ProductRequestDto
     */
    'supplierId': number;
    /**
     * Product template name
     * @type {string}
     * @memberof ProductRequestDto
     */
    'name': string;
    /**
     * Brand ID from Odoo
     * @type {number}
     * @memberof ProductRequestDto
     */
    'brandId'?: number | null;
    /**
     * Category ID from Odoo
     * @type {number}
     * @memberof ProductRequestDto
     */
    'categoryId'?: number | null;
    /**
     * Product description
     * @type {string}
     * @memberof ProductRequestDto
     */
    'description'?: string | null;
    /**
     * Warranty ID from Odoo
     * @type {number}
     * @memberof ProductRequestDto
     */
    'warrantyId': number;
    /**
     * Warranty type ID from Odoo
     * @type {number}
     * @memberof ProductRequestDto
     */
    'warrantyTypeId'?: number | null;
    /**
     * Warranty provider ID from Odoo (product.warranty.provider)
     * @type {number}
     * @memberof ProductRequestDto
     */
    'warrantyProviderId'?: number | null;
    /**
     * Warranty product template ids buyers can pick from at checkout.
     * @type {Array<number>}
     * @memberof ProductRequestDto
     */
    'compatibleWarrantyIds'?: Array<number>;
    /**
     * Country of origin ID from Odoo
     * @type {number}
     * @memberof ProductRequestDto
     */
    'countryOfOriginId'?: number | null;
    /**
     * Screen size ID from Odoo (product.screen.size)
     * @type {number}
     * @memberof ProductRequestDto
     */
    'screenSizeId'?: number | null;
    /**
     * Resolution ID from Odoo (product.resolution)
     * @type {number}
     * @memberof ProductRequestDto
     */
    'resolutionId'?: number | null;
    /**
     * Template-level main image URL for display. The backend stores the GCS object key internally, but GET responses return a signed download URL when the image is stored in GCS.
     * @type {string}
     * @memberof ProductRequestDto
     */
    'image'?: string | null;
    /**
     * Template-level gallery images for display. Each entry is a signed download URL when the underlying value was a GCS object key, or the original public URL / data-URI otherwise.
     * @type {Array<string>}
     * @memberof ProductRequestDto
     */
    'galleryImages'?: Array<string>;
    /**
     * External datasheet URL (legacy / bulk-import).
     * @type {string}
     * @memberof ProductRequestDto
     */
    'datasheetUrl'?: string | null;
    /**
     * GCS object key for the uploaded datasheet PDF.
     * @type {string}
     * @memberof ProductRequestDto
     */
    'datasheetObjectKey'?: string | null;
    /**
     * Original filename of the uploaded datasheet PDF.
     * @type {string}
     * @memberof ProductRequestDto
     */
    'datasheetFileName'?: string | null;
    /**
     * AiExtraction id linked to this request (set when the seller extracted the PDF on the FE upload step).
     * @type {string}
     * @memberof ProductRequestDto
     */
    'datasheetExtractionId'?: string | null;
    /**
     * Internal notes
     * @type {string}
     * @memberof ProductRequestDto
     */
    'notes'?: string | null;
    /**
     * Deal type ID from Odoo
     * @type {number}
     * @memberof ProductRequestDto
     */
    'dealTypeId'?: number | null;
    /**
     * Product type
     * @type {string}
     * @memberof ProductRequestDto
     */
    'productType': ProductRequestDtoProductTypeEnum;
    /**
     * Product variants with storage, color, SKUs, images, quantities, and pricing tiers
     * @type {Array<ProductVariantResponseDto>}
     * @memberof ProductRequestDto
     */
    'variants': Array<ProductVariantResponseDto>;
    /**
     * Request status
     * @type {string}
     * @memberof ProductRequestDto
     */
    'status': ProductRequestDtoStatusEnum;
    /**
     * True when the request is a seller-only draft (not yet submitted for admin review)
     * @type {boolean}
     * @memberof ProductRequestDto
     */
    'isDraft': boolean;
    /**
     * Reviewed by user ID
     * @type {string}
     * @memberof ProductRequestDto
     */
    'reviewedBy'?: string | null;
    /**
     * Review date
     * @type {string}
     * @memberof ProductRequestDto
     */
    'reviewedAt'?: string | null;
    /**
     * Rejection reason
     * @type {string}
     * @memberof ProductRequestDto
     */
    'rejectionReason'?: string | null;
    /**
     * Odoo product template ID (after creation)
     * @type {number}
     * @memberof ProductRequestDto
     */
    'odooProductTemplateId'?: number | null;
    /**
     * Creation date
     * @type {string}
     * @memberof ProductRequestDto
     */
    'createdAt': string;
    /**
     * Last update date
     * @type {string}
     * @memberof ProductRequestDto
     */
    'updatedAt': string;
}

export const ProductRequestDtoProductTypeEnum = {
    Consu: 'consu'
} as const;

export type ProductRequestDtoProductTypeEnum = typeof ProductRequestDtoProductTypeEnum[keyof typeof ProductRequestDtoProductTypeEnum];
export const ProductRequestDtoStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type ProductRequestDtoStatusEnum = typeof ProductRequestDtoStatusEnum[keyof typeof ProductRequestDtoStatusEnum];

/**
 * 
 * @export
 * @interface ProductRequestQueryDto
 */
export interface ProductRequestQueryDto {
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof ProductRequestQueryDto
     */
    'page'?: number;
    /**
     * Page size
     * @type {number}
     * @memberof ProductRequestQueryDto
     */
    'pageSize'?: number;
    /**
     * Search term for text search
     * @type {string}
     * @memberof ProductRequestQueryDto
     */
    'search'?: string;
    /**
     * Field to sort by
     * @type {string}
     * @memberof ProductRequestQueryDto
     */
    'sortBy'?: string;
    /**
     * Sort order
     * @type {string}
     * @memberof ProductRequestQueryDto
     */
    'sortOrder'?: ProductRequestQueryDtoSortOrderEnum;
    /**
     * Filter by request status
     * @type {string}
     * @memberof ProductRequestQueryDto
     */
    'requestStatus'?: ProductRequestQueryDtoRequestStatusEnum;
    /**
     * Filter by user ID (admin only)
     * @type {string}
     * @memberof ProductRequestQueryDto
     */
    'userId'?: string;
}

export const ProductRequestQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type ProductRequestQueryDtoSortOrderEnum = typeof ProductRequestQueryDtoSortOrderEnum[keyof typeof ProductRequestQueryDtoSortOrderEnum];
export const ProductRequestQueryDtoRequestStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type ProductRequestQueryDtoRequestStatusEnum = typeof ProductRequestQueryDtoRequestStatusEnum[keyof typeof ProductRequestQueryDtoRequestStatusEnum];

/**
 * 
 * @export
 * @interface ProductRequestResponseDto
 */
export interface ProductRequestResponseDto {
    /**
     * List of product requests
     * @type {Array<ProductRequestDto>}
     * @memberof ProductRequestResponseDto
     */
    'data': Array<ProductRequestDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof ProductRequestResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface ProductResolutionDto
 */
export interface ProductResolutionDto {
    /**
     * Resolution ID
     * @type {number}
     * @memberof ProductResolutionDto
     */
    'id': number;
    /**
     * Resolution name
     * @type {string}
     * @memberof ProductResolutionDto
     */
    'name': string;
    /**
     * Whether the resolution is active
     * @type {boolean}
     * @memberof ProductResolutionDto
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface ProductScreenSizeDto
 */
export interface ProductScreenSizeDto {
    /**
     * Screen Size ID
     * @type {number}
     * @memberof ProductScreenSizeDto
     */
    'id': number;
    /**
     * Screen Size name
     * @type {string}
     * @memberof ProductScreenSizeDto
     */
    'name': string;
    /**
     * Whether the screen size is active
     * @type {boolean}
     * @memberof ProductScreenSizeDto
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface ProductVariantDto
 */
export interface ProductVariantDto {
    /**
     * Product variant ID
     * @type {number}
     * @memberof ProductVariantDto
     */
    'id': number;
    /**
     * Product name
     * @type {string}
     * @memberof ProductVariantDto
     */
    'name': string;
    /**
     * Display name
     * @type {string}
     * @memberof ProductVariantDto
     */
    'displayName'?: string | null;
    /**
     * Sale price
     * @type {number}
     * @memberof ProductVariantDto
     */
    'listPrice'?: number | null;
    /**
     * Cost price
     * @type {number}
     * @memberof ProductVariantDto
     */
    'standardPrice'?: number | null;
    /**
     * Price extra
     * @type {number}
     * @memberof ProductVariantDto
     */
    'priceExtra'?: number | null;
    /**
     * The authenticated seller\'s own list price for this variant, sourced from product.supplierinfo.price. Populated only when the caller is the supplier on the template (GET /products/:id for the seller) — null otherwise. Use this on seller-facing screens; listPrice reflects the admin-approved buyer-facing price.
     * @type {number}
     * @memberof ProductVariantDto
     */
    'sellerPrice'?: number | null;
    /**
     * Product type
     * @type {string}
     * @memberof ProductVariantDto
     */
    'type': string;
    /**
     * SKU/Product code
     * @type {string}
     * @memberof ProductVariantDto
     */
    'defaultCode'?: string | null;
    /**
     * Product description
     * @type {string}
     * @memberof ProductVariantDto
     */
    'description'?: string | null;
    /**
     * Product category
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'category'?: OdooObjectDto | null;
    /**
     * Whether the product is active
     * @type {boolean}
     * @memberof ProductVariantDto
     */
    'active': boolean;
    /**
     * Unit of Measure
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'unitOfMeasure'?: OdooObjectDto | null;
    /**
     * Product variant ID (first variant)
     * @type {number}
     * @memberof ProductVariantDto
     */
    'productVariantId'?: number | null;
    /**
     * Product variant IDs
     * @type {Array<number>}
     * @memberof ProductVariantDto
     */
    'productVariantIds'?: Array<number> | null;
    /**
     * Product template ID (links this variant to its template)
     * @type {number}
     * @memberof ProductVariantDto
     */
    'productTemplateId'?: number | null;
    /**
     * Product brand
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'brand'?: OdooObjectDto | null;
    /**
     * Warranty
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'warranty'?: OdooObjectDto | null;
    /**
     * Warranty type
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'warrantyType'?: OdooObjectDto | null;
    /**
     * Country of origin
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'countryOfOrigin'?: OdooObjectDto | null;
    /**
     * Deal type
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'dealType'?: OdooObjectDto | null;
    /**
     * Seller IDs
     * @type {Array<number>}
     * @memberof ProductVariantDto
     */
    'sellerIds'?: Array<number> | null;
    /**
     * Supplier stock
     * @type {number}
     * @memberof ProductVariantDto
     */
    'supplierStock'?: number | null;
    /**
     * URL of the variant image. Proxies Odoo product.product.image_1920 via /product-images/variant/:id with write_date as cache-busting token.
     * @type {string}
     * @memberof ProductVariantDto
     */
    'image'?: string | null;
    /**
     * Pricelist items (volume pricing tiers) for this product template
     * @type {Array<PricelistItemDto>}
     * @memberof ProductVariantDto
     */
    'pricelistItems'?: Array<PricelistItemDto>;
    /**
     * Seller-set discount percentage (0 = no discount)
     * @type {number}
     * @memberof ProductVariantDto
     */
    'discountPercentage'?: number | null;
    /**
     * Model name for this variant
     * @type {string}
     * @memberof ProductVariantDto
     */
    'model'?: string | null;
    /**
     * Condition of this variant
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'condition'?: OdooObjectDto | null;
    /**
     * Screen size
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'screenSize'?: OdooObjectDto | null;
    /**
     * Screen resolution
     * @type {OdooObjectDto}
     * @memberof ProductVariantDto
     */
    'resolution'?: OdooObjectDto | null;
    /**
     * Variant-level datasheet URL (legacy / external link).
     * @type {string}
     * @memberof ProductVariantDto
     */
    'datasheetUrl'?: string | null;
    /**
     * True when the parent product template has an uploaded PDF datasheet (related field from product.template).
     * @type {boolean}
     * @memberof ProductVariantDto
     */
    'hasDatasheetPdf'?: boolean;
    /**
     * Variant-level notes
     * @type {string}
     * @memberof ProductVariantDto
     */
    'notes'?: string | null;
    /**
     * Whether the authenticated user has liked this variant. Always false for unauthenticated requests.
     * @type {boolean}
     * @memberof ProductVariantDto
     */
    'liked': boolean;
}
/**
 * 
 * @export
 * @interface ProductVariantQueryDto
 */
export interface ProductVariantQueryDto {
    /**
     * 
     * @type {number}
     * @memberof ProductVariantQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantQueryDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantQueryDto
     */
    'search'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantQueryDto
     */
    'sortBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantQueryDto
     */
    'sortOrder'?: ProductVariantQueryDtoSortOrderEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantQueryDto
     */
    'minPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantQueryDto
     */
    'maxPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantQueryDto
     */
    'minStock'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantQueryDto
     */
    'maxStock'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'categoryIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'brandIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'warrantyIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'warrantyTypeIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'countryOfOriginIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'dealTypeIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'conditionIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'sellerIds'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantQueryDto
     */
    'minScreenSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantQueryDto
     */
    'maxScreenSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantQueryDto
     */
    'model'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'attributeValueIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'screenSizeIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductVariantQueryDto
     */
    'resolutionIds'?: Array<number>;
}

export const ProductVariantQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type ProductVariantQueryDtoSortOrderEnum = typeof ProductVariantQueryDtoSortOrderEnum[keyof typeof ProductVariantQueryDtoSortOrderEnum];

/**
 * 
 * @export
 * @interface ProductVariantResponseDto
 */
export interface ProductVariantResponseDto {
    /**
     * Variant ID
     * @type {string}
     * @memberof ProductVariantResponseDto
     */
    'id': string;
    /**
     * Storage attribute ID from Odoo (product.attribute)
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'storageId'?: number | null;
    /**
     * Storage attribute value ID from Odoo (product.attribute.value)
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'storageValueId'?: number | null;
    /**
     * Color attribute ID from Odoo (product.attribute)
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'colorId'?: number | null;
    /**
     * Color attribute value ID from Odoo (product.attribute.value)
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'colorValueId'?: number | null;
    /**
     * SKU/Product code for this variant
     * @type {string}
     * @memberof ProductVariantResponseDto
     */
    'sku'?: string | null;
    /**
     * Variant image URL for display. The backend stores the GCS object key internally, but GET responses return a signed download URL when the image is stored in GCS.
     * @type {string}
     * @memberof ProductVariantResponseDto
     */
    'image'?: string | null;
    /**
     * Initial supplier stock quantity for this variant
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'quantity'?: number | null;
    /**
     * Model name for this variant
     * @type {string}
     * @memberof ProductVariantResponseDto
     */
    'model'?: string | null;
    /**
     * Condition ID from Odoo (e.g. New, Refurbished)
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'conditionId'?: number | null;
    /**
     * CPU attribute ID (product.attribute, \"CPU\")
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'cpuId'?: number | null;
    /**
     * CPU attribute value ID (product.attribute.value)
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'cpuValueId'?: number | null;
    /**
     * RAM attribute ID (product.attribute, \"RAM\")
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'ramId'?: number | null;
    /**
     * RAM attribute value ID (product.attribute.value)
     * @type {number}
     * @memberof ProductVariantResponseDto
     */
    'ramValueId'?: number | null;
    /**
     * Variant-level datasheet URL (overrides template-level if provided)
     * @type {string}
     * @memberof ProductVariantResponseDto
     */
    'datasheetUrl'?: string | null;
    /**
     * Variant-level notes (overrides template-level if provided)
     * @type {string}
     * @memberof ProductVariantResponseDto
     */
    'notes'?: string | null;
    /**
     * Volume pricing tiers for this variant
     * @type {Array<PricingTierResponseDto>}
     * @memberof ProductVariantResponseDto
     */
    'pricingTiers': Array<PricingTierResponseDto>;
    /**
     * Creation date
     * @type {string}
     * @memberof ProductVariantResponseDto
     */
    'createdAt': string;
    /**
     * Last update date
     * @type {string}
     * @memberof ProductVariantResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ProductWarrantyDto
 */
export interface ProductWarrantyDto {
    /**
     * Warranty ID
     * @type {number}
     * @memberof ProductWarrantyDto
     */
    'id': number;
    /**
     * Warranty name
     * @type {string}
     * @memberof ProductWarrantyDto
     */
    'name': string;
    /**
     * Whether the warranty is active
     * @type {boolean}
     * @memberof ProductWarrantyDto
     */
    'active': boolean;
    /**
     * Coverage in months from purchase date; 0 = no expiry check
     * @type {number}
     * @memberof ProductWarrantyDto
     */
    'durationMonths': number;
}
/**
 * 
 * @export
 * @interface ProductWarrantyProviderDto
 */
export interface ProductWarrantyProviderDto {
    /**
     * Warranty provider ID
     * @type {number}
     * @memberof ProductWarrantyProviderDto
     */
    'id': number;
    /**
     * Warranty provider name
     * @type {string}
     * @memberof ProductWarrantyProviderDto
     */
    'name': string;
    /**
     * Whether the warranty provider is active
     * @type {boolean}
     * @memberof ProductWarrantyProviderDto
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface ProductWarrantyTypeDto
 */
export interface ProductWarrantyTypeDto {
    /**
     * Warranty type ID
     * @type {number}
     * @memberof ProductWarrantyTypeDto
     */
    'id': number;
    /**
     * Warranty type name
     * @type {string}
     * @memberof ProductWarrantyTypeDto
     */
    'name': string;
    /**
     * Whether the warranty type is active
     * @type {boolean}
     * @memberof ProductWarrantyTypeDto
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface ProductsQueryDto
 */
export interface ProductsQueryDto {
    /**
     * 
     * @type {number}
     * @memberof ProductsQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsQueryDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductsQueryDto
     */
    'search'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsQueryDto
     */
    'sortBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsQueryDto
     */
    'sortOrder'?: ProductsQueryDtoSortOrderEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductsQueryDto
     */
    'categoryIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductsQueryDto
     */
    'brandIds'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ProductsQueryDto
     */
    'minWarrantyMonths'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsQueryDto
     */
    'maxWarrantyMonths'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsQueryDto
     */
    'minQty'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsQueryDto
     */
    'maxQty'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsQueryDto
     */
    'minPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsQueryDto
     */
    'maxPrice'?: number;
}

export const ProductsQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type ProductsQueryDtoSortOrderEnum = typeof ProductsQueryDtoSortOrderEnum[keyof typeof ProductsQueryDtoSortOrderEnum];

/**
 * 
 * @export
 * @interface ProductsResponseDto
 */
export interface ProductsResponseDto {
    /**
     * Array of products
     * @type {Array<ProductDto>}
     * @memberof ProductsResponseDto
     */
    'data': Array<ProductDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof ProductsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface PurchaseOrderDetailsDto
 */
export interface PurchaseOrderDetailsDto {
    /**
     * Purchase order ID
     * @type {number}
     * @memberof PurchaseOrderDetailsDto
     */
    'id': number;
    /**
     * Purchase order name
     * @type {string}
     * @memberof PurchaseOrderDetailsDto
     */
    'name': string;
    /**
     * Purchase order state
     * @type {string}
     * @memberof PurchaseOrderDetailsDto
     */
    'state': string;
    /**
     * Whether the seller has marked the order as shipped
     * @type {boolean}
     * @memberof PurchaseOrderDetailsDto
     */
    'sellerShipped': boolean;
    /**
     * Partner
     * @type {PartnerDto}
     * @memberof PurchaseOrderDetailsDto
     */
    'partner'?: PartnerDto | null;
    /**
     * Destination address partner
     * @type {PartnerDto}
     * @memberof PurchaseOrderDetailsDto
     */
    'destAddress'?: PartnerDto | null;
    /**
     * Origin (e.g., sale order name)
     * @type {string}
     * @memberof PurchaseOrderDetailsDto
     */
    'origin'?: string | null;
    /**
     * Amount untaxed
     * @type {number}
     * @memberof PurchaseOrderDetailsDto
     */
    'amountUntaxed': number;
    /**
     * Amount tax
     * @type {number}
     * @memberof PurchaseOrderDetailsDto
     */
    'amountTax': number;
    /**
     * Amount total
     * @type {number}
     * @memberof PurchaseOrderDetailsDto
     */
    'amountTotal': number;
    /**
     * Order date
     * @type {string}
     * @memberof PurchaseOrderDetailsDto
     */
    'dateOrder': string;
    /**
     * Planned date
     * @type {string}
     * @memberof PurchaseOrderDetailsDto
     */
    'datePlanned'?: string | null;
    /**
     * Effective date
     * @type {string}
     * @memberof PurchaseOrderDetailsDto
     */
    'deliveredAt'?: string | null;
    /**
     * Order lines
     * @type {Array<PurchaseOrderLineDto>}
     * @memberof PurchaseOrderDetailsDto
     */
    'orderLines': Array<PurchaseOrderLineDto>;
    /**
     * Dropshipping records
     * @type {Array<DropshippingDto>}
     * @memberof PurchaseOrderDetailsDto
     */
    'dropshipping': Array<DropshippingDto>;
    /**
     * Preview URL for PDF report
     * @type {string}
     * @memberof PurchaseOrderDetailsDto
     */
    'previewUrl'?: string | null;
    /**
     * 
     * @type {PurchaseOrderDetailsDtoSellerInvoice}
     * @memberof PurchaseOrderDetailsDto
     */
    'sellerInvoice'?: PurchaseOrderDetailsDtoSellerInvoice;
    /**
     * 
     * @type {PurchaseOrderDetailsDtoVendorBill}
     * @memberof PurchaseOrderDetailsDto
     */
    'vendorBill'?: PurchaseOrderDetailsDtoVendorBill;
    /**
     * Linked sale order that created this purchase order
     * @type {LinkedSaleOrderDto}
     * @memberof PurchaseOrderDetailsDto
     */
    'linkedSaleOrder'?: LinkedSaleOrderDto | null;
}
/**
 * 
 * @export
 * @interface PurchaseOrderDetailsDtoSellerInvoice
 */
export interface PurchaseOrderDetailsDtoSellerInvoice {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsDtoSellerInvoice
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderDetailsDtoSellerInvoice
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderDetailsDtoSellerInvoice
     */
    'mimetype': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderDetailsDtoSellerInvoice
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface PurchaseOrderDetailsDtoVendorBill
 */
export interface PurchaseOrderDetailsDtoVendorBill {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsDtoVendorBill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderDetailsDtoVendorBill
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderDetailsDtoVendorBill
     */
    'previewUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderDetailsDtoVendorBill
     */
    'paymentState': string | null;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsDtoVendorBill
     */
    'amountResidual': number | null;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsDtoVendorBill
     */
    'amountTotal': number | null;
}
/**
 * 
 * @export
 * @interface PurchaseOrderDto
 */
export interface PurchaseOrderDto {
    /**
     * Purchase order ID
     * @type {number}
     * @memberof PurchaseOrderDto
     */
    'id': number;
    /**
     * Purchase order name
     * @type {string}
     * @memberof PurchaseOrderDto
     */
    'name': string;
    /**
     * Purchase order state
     * @type {string}
     * @memberof PurchaseOrderDto
     */
    'state': string;
    /**
     * Partner
     * @type {OdooObjectDto}
     * @memberof PurchaseOrderDto
     */
    'partner'?: OdooObjectDto | null;
    /**
     * Origin (e.g., sale order name)
     * @type {string}
     * @memberof PurchaseOrderDto
     */
    'origin'?: string | null;
    /**
     * Order date
     * @type {string}
     * @memberof PurchaseOrderDto
     */
    'dateOrder': string;
    /**
     * Planned date
     * @type {string}
     * @memberof PurchaseOrderDto
     */
    'datePlanned'?: string | null;
    /**
     * Effective date
     * @type {string}
     * @memberof PurchaseOrderDto
     */
    'deliveredAt'?: string | null;
    /**
     * Amount untaxed
     * @type {number}
     * @memberof PurchaseOrderDto
     */
    'amountUntaxed': number;
    /**
     * Amount tax
     * @type {number}
     * @memberof PurchaseOrderDto
     */
    'amountTax': number;
    /**
     * Amount total
     * @type {number}
     * @memberof PurchaseOrderDto
     */
    'amountTotal': number;
    /**
     * Order line IDs
     * @type {Array<number>}
     * @memberof PurchaseOrderDto
     */
    'orderLineIds': Array<number>;
    /**
     * Picking IDs
     * @type {Array<number>}
     * @memberof PurchaseOrderDto
     */
    'pickingId': Array<number> | null;
    /**
     * Creation date
     * @type {string}
     * @memberof PurchaseOrderDto
     */
    'createDate': string;
    /**
     * Last update date
     * @type {string}
     * @memberof PurchaseOrderDto
     */
    'writeDate': string;
}
/**
 * 
 * @export
 * @interface PurchaseOrderLineDto
 */
export interface PurchaseOrderLineDto {
    /**
     * Order line ID
     * @type {number}
     * @memberof PurchaseOrderLineDto
     */
    'id': number;
    /**
     * Product name
     * @type {string}
     * @memberof PurchaseOrderLineDto
     */
    'name': string;
    /**
     * Product
     * @type {OdooObjectDto}
     * @memberof PurchaseOrderLineDto
     */
    'product'?: OdooObjectDto | null;
    /**
     * Quantity
     * @type {number}
     * @memberof PurchaseOrderLineDto
     */
    'quantity': number;
    /**
     * Unit price
     * @type {number}
     * @memberof PurchaseOrderLineDto
     */
    'priceUnit': number;
    /**
     * Subtotal
     * @type {number}
     * @memberof PurchaseOrderLineDto
     */
    'priceSubtotal': number;
    /**
     * Total
     * @type {number}
     * @memberof PurchaseOrderLineDto
     */
    'priceTotal': number;
    /**
     * Product image URL. Proxied through /product-images/variant/:id by ProductsService.joinProductImagesToOrderLines.
     * @type {string}
     * @memberof PurchaseOrderLineDto
     */
    'image'?: string | null;
}
/**
 * 
 * @export
 * @interface PurchaseOrderStatsDto
 */
export interface PurchaseOrderStatsDto {
    /**
     * Confirmed purchase orders visible in the admin list
     * @type {number}
     * @memberof PurchaseOrderStatsDto
     */
    'totalPurchaseOrders': number;
    /**
     * Confirmed purchase orders still waiting for shipment
     * @type {number}
     * @memberof PurchaseOrderStatsDto
     */
    'processingPurchaseOrders': number;
    /**
     * Confirmed purchase orders currently in transit
     * @type {number}
     * @memberof PurchaseOrderStatsDto
     */
    'inTransitPurchaseOrders': number;
    /**
     * Confirmed purchase orders that are delivered
     * @type {number}
     * @memberof PurchaseOrderStatsDto
     */
    'deliveredPurchaseOrders': number;
}
/**
 * 
 * @export
 * @interface PurchaseOrdersResponseDto
 */
export interface PurchaseOrdersResponseDto {
    /**
     * List of purchase orders
     * @type {Array<PurchaseOrderDto>}
     * @memberof PurchaseOrdersResponseDto
     */
    'data': Array<PurchaseOrderDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof PurchaseOrdersResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface QuotationDto
 */
export interface QuotationDto {
    /**
     * Quotation ID
     * @type {number}
     * @memberof QuotationDto
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface QuotationOrderLineDto
 */
export interface QuotationOrderLineDto {
    /**
     * Product variant ID
     * @type {number}
     * @memberof QuotationOrderLineDto
     */
    'productId': number;
    /**
     * Quantity
     * @type {number}
     * @memberof QuotationOrderLineDto
     */
    'quantity': number;
    /**
     * Buyer-facing line label captured from the selected variant snapshot.
     * @type {string}
     * @memberof QuotationOrderLineDto
     */
    'displayName'?: string;
    /**
     * Explicit unit price captured from the buyer snapshot.
     * @type {number}
     * @memberof QuotationOrderLineDto
     */
    'unitPrice'?: number;
    /**
     * Optional warranty product variant id (default product.product of a `is_warranty=true` template). Emitted as a separate sale.order.line linked to the parent line via `linked_line_id`.
     * @type {number}
     * @memberof QuotationOrderLineDto
     */
    'warrantyProductId'?: number;
}
/**
 * 
 * @export
 * @interface RedeemPointsDto
 */
export interface RedeemPointsDto {
    /**
     * Points to redeem
     * @type {number}
     * @memberof RedeemPointsDto
     */
    'points': number;
    /**
     * Optional reason or note
     * @type {string}
     * @memberof RedeemPointsDto
     */
    'reason'?: string;
    /**
     * Optional order id this redemption is tied to
     * @type {string}
     * @memberof RedeemPointsDto
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface RegisterOtpDto
 */
export interface RegisterOtpDto {
    /**
     * Full name
     * @type {string}
     * @memberof RegisterOtpDto
     */
    'name': string;
    /**
     * User role
     * @type {Role}
     * @memberof RegisterOtpDto
     */
    'role': Role;
    /**
     * Email address
     * @type {string}
     * @memberof RegisterOtpDto
     */
    'email'?: string;
    /**
     * Phone number in E.164 format
     * @type {string}
     * @memberof RegisterOtpDto
     */
    'phoneNumber'?: string;
    /**
     * Password to set on the account. When provided, the user can also log in with email+password after OTP verification.
     * @type {string}
     * @memberof RegisterOtpDto
     */
    'password'?: string;
    /**
     * Partner data to create in Odoo for this user
     * @type {CreatePartnerDto}
     * @memberof RegisterOtpDto
     */
    'partner'?: CreatePartnerDto;
}


/**
 * 
 * @export
 * @interface RegisterPasswordDto
 */
export interface RegisterPasswordDto {
    /**
     * Full name
     * @type {string}
     * @memberof RegisterPasswordDto
     */
    'name': string;
    /**
     * User role
     * @type {Role}
     * @memberof RegisterPasswordDto
     */
    'role': Role;
    /**
     * Email address
     * @type {string}
     * @memberof RegisterPasswordDto
     */
    'email': string;
    /**
     * Password
     * @type {string}
     * @memberof RegisterPasswordDto
     */
    'password': string;
    /**
     * Partner data to create in Odoo for this user
     * @type {CreatePartnerDto}
     * @memberof RegisterPasswordDto
     */
    'partner'?: CreatePartnerDto;
}


/**
 * 
 * @export
 * @interface RegisterResponseDto
 */
export interface RegisterResponseDto {
    /**
     * User ID of the newly created user
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'id': string;
    /**
     * User email address (if registered with email)
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'email'?: string | null;
    /**
     * User phone number in E.164 format (if registered with phone)
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'phoneNumber'?: string | null;
    /**
     * User full name
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'name': string;
    /**
     * User role
     * @type {Role}
     * @memberof RegisterResponseDto
     */
    'role': Role;
    /**
     * Company name
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'companyName'?: string | null;
    /**
     * Commercial Registration number
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'crNumber'?: string | null;
    /**
     * Tax number (VAT)
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'taxNumber'?: string | null;
    /**
     * Contact name
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'contactName'?: string | null;
    /**
     * Street
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'street'?: string | null;
    /**
     * Odoo user ID
     * @type {number}
     * @memberof RegisterResponseDto
     */
    'partnerId'?: number | null;
}


/**
 * 
 * @export
 * @interface RejectDocumentDto
 */
export interface RejectDocumentDto {
    /**
     * Reason for rejection
     * @type {string}
     * @memberof RejectDocumentDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface ReorderFeaturedDealsDto
 */
export interface ReorderFeaturedDealsDto {
    /**
     * Featured-deal IDs in the desired display order
     * @type {Array<number>}
     * @memberof ReorderFeaturedDealsDto
     */
    'orderedIds': Array<number>;
}
/**
 * 
 * @export
 * @interface ReportQueryDto
 */
export interface ReportQueryDto {
    /**
     * 
     * @type {string}
     * @memberof ReportQueryDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportQueryDto
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportQueryDto
     */
    'pageSize'?: number;
}
/**
 * 
 * @export
 * @interface RequestContactChangeDto
 */
export interface RequestContactChangeDto {
    /**
     * New email address
     * @type {string}
     * @memberof RequestContactChangeDto
     */
    'email'?: string;
    /**
     * New phone number in E.164 format
     * @type {string}
     * @memberof RequestContactChangeDto
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface ResendVerificationDto
 */
export interface ResendVerificationDto {
    /**
     * Email address
     * @type {string}
     * @memberof ResendVerificationDto
     */
    'email'?: string;
    /**
     * Phone number in E.164 format
     * @type {string}
     * @memberof ResendVerificationDto
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * Password reset token received via email
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'token': string;
    /**
     * New password
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ResolveDisputeDto
 */
export interface ResolveDisputeDto {
    /**
     * 
     * @type {string}
     * @memberof ResolveDisputeDto
     */
    'status': ResolveDisputeDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ResolveDisputeDto
     */
    'resolutionAction'?: ResolveDisputeDtoResolutionActionEnum;
    /**
     * 
     * @type {string}
     * @memberof ResolveDisputeDto
     */
    'resolutionNote'?: string;
}

export const ResolveDisputeDtoStatusEnum = {
    Open: 'OPEN',
    UnderReview: 'UNDER_REVIEW',
    ResolvedRefund: 'RESOLVED_REFUND',
    ResolvedReplacement: 'RESOLVED_REPLACEMENT',
    ResolvedOther: 'RESOLVED_OTHER',
    Rejected: 'REJECTED'
} as const;

export type ResolveDisputeDtoStatusEnum = typeof ResolveDisputeDtoStatusEnum[keyof typeof ResolveDisputeDtoStatusEnum];
export const ResolveDisputeDtoResolutionActionEnum = {
    Refund: 'REFUND',
    Replacement: 'REPLACEMENT',
    Credit: 'CREDIT',
    None: 'NONE'
} as const;

export type ResolveDisputeDtoResolutionActionEnum = typeof ResolveDisputeDtoResolutionActionEnum[keyof typeof ResolveDisputeDtoResolutionActionEnum];

/**
 * 
 * @export
 * @interface ReviewChangeRequestDto
 */
export interface ReviewChangeRequestDto {
    /**
     * Review decision.
     * @type {string}
     * @memberof ReviewChangeRequestDto
     */
    'status': ReviewChangeRequestDtoStatusEnum;
    /**
     * Required when requesting changes (so the submitter knows what to fix) or when rejecting (explains the terminal decision).
     * @type {string}
     * @memberof ReviewChangeRequestDto
     */
    'reviewNote'?: string;
}

export const ReviewChangeRequestDtoStatusEnum = {
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    ChangesRequested: 'CHANGES_REQUESTED'
} as const;

export type ReviewChangeRequestDtoStatusEnum = typeof ReviewChangeRequestDtoStatusEnum[keyof typeof ReviewChangeRequestDtoStatusEnum];

/**
 * 
 * @export
 * @interface ReviewProductRequestDto
 */
export interface ReviewProductRequestDto {
    /**
     * New status for the product request
     * @type {string}
     * @memberof ReviewProductRequestDto
     */
    'status': ReviewProductRequestDtoStatusEnum;
    /**
     * Rejection reason (required if status is REJECTED)
     * @type {string}
     * @memberof ReviewProductRequestDto
     */
    'rejectionReason'?: string;
    /**
     * Per-variant admin pricing tiers (required if status is APPROVED). Each entry maps a variant to its buyer-facing prices.
     * @type {Array<VariantPricingTiersDto>}
     * @memberof ReviewProductRequestDto
     */
    'variantPricingTiers'?: Array<VariantPricingTiersDto>;
}

export const ReviewProductRequestDtoStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type ReviewProductRequestDtoStatusEnum = typeof ReviewProductRequestDtoStatusEnum[keyof typeof ReviewProductRequestDtoStatusEnum];

/**
 * User role
 * @export
 * @enum {string}
 */

export const Role = {
    Admin: 'admin',
    User: 'user'
} as const;

export type Role = typeof Role[keyof typeof Role];


/**
 * 
 * @export
 * @interface SaleDetailsDto
 */
export interface SaleDetailsDto {
    /**
     * Sale order ID
     * @type {number}
     * @memberof SaleDetailsDto
     */
    'id': number;
    /**
     * Sale order name
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'name': string;
    /**
     * Sale order state
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'state': string;
    /**
     * Invoice status
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'invoiceStatus': string;
    /**
     * Invoice ID
     * @type {number}
     * @memberof SaleDetailsDto
     */
    'invoiceId'?: number | null;
    /**
     * Partner
     * @type {PartnerDto}
     * @memberof SaleDetailsDto
     */
    'partner'?: PartnerDto | null;
    /**
     * Invoice partner
     * @type {PartnerDto}
     * @memberof SaleDetailsDto
     */
    'invoicePartner'?: PartnerDto | null;
    /**
     * Shipping partner
     * @type {PartnerDto}
     * @memberof SaleDetailsDto
     */
    'shippingPartner'?: PartnerDto | null;
    /**
     * Amount untaxed
     * @type {number}
     * @memberof SaleDetailsDto
     */
    'amountUntaxed': number;
    /**
     * Amount tax
     * @type {number}
     * @memberof SaleDetailsDto
     */
    'amountTax': number;
    /**
     * Amount total
     * @type {number}
     * @memberof SaleDetailsDto
     */
    'amountTotal': number;
    /**
     * Order date
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'dateOrder': string;
    /**
     * Validity date
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'validityDate'?: string | null;
    /**
     * Currency
     * @type {OdooObjectDto}
     * @memberof SaleDetailsDto
     */
    'currency'?: OdooObjectDto | null;
    /**
     * Order lines
     * @type {Array<SaleOrderLineDto>}
     * @memberof SaleDetailsDto
     */
    'orderLines': Array<SaleOrderLineDto>;
    /**
     * Access token
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'accessToken': string;
    /**
     * Preview URL for PDF report
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'previewUrl'?: string | null;
    /**
     * Invoice preview URL for PDF report
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'invoicePreviewUrl'?: string | null;
    /**
     * Dropshipping records
     * @type {Array<DropshippingDto>}
     * @memberof SaleDetailsDto
     */
    'dropshipping'?: Array<DropshippingDto>;
    /**
     * Buyer received
     * @type {boolean}
     * @memberof SaleDetailsDto
     */
    'buyerReceived'?: boolean | null;
    /**
     * Seller confirmed shipping
     * @type {boolean}
     * @memberof SaleDetailsDto
     */
    'sellerShipped'?: boolean | null;
    /**
     * Delivery status from Odoo: no, pending, partial, full
     * @type {string}
     * @memberof SaleDetailsDto
     */
    'deliveryStatus'?: string | null;
    /**
     * Linked purchase orders created from this sale order
     * @type {Array<LinkedPurchaseOrderDto>}
     * @memberof SaleDetailsDto
     */
    'linkedPurchaseOrders'?: Array<LinkedPurchaseOrderDto>;
    /**
     * Whether this confirmed order has been routed to at least one supplier (has linked purchase orders)
     * @type {boolean}
     * @memberof SaleDetailsDto
     */
    'routed'?: boolean;
    /**
     * Number of purchase orders linked to this sale order
     * @type {number}
     * @memberof SaleDetailsDto
     */
    'purchaseOrderCount'?: number;
}
/**
 * 
 * @export
 * @interface SaleDto
 */
export interface SaleDto {
    /**
     * Sale order ID
     * @type {number}
     * @memberof SaleDto
     */
    'id': number;
    /**
     * Sale order name
     * @type {string}
     * @memberof SaleDto
     */
    'name': string;
    /**
     * Sale order state
     * @type {string}
     * @memberof SaleDto
     */
    'state': string;
    /**
     * Partner
     * @type {OdooObjectDto}
     * @memberof SaleDto
     */
    'partner'?: OdooObjectDto | null;
    /**
     * Invoice partner
     * @type {OdooObjectDto}
     * @memberof SaleDto
     */
    'invoicePartner'?: OdooObjectDto | null;
    /**
     * Shipping partner
     * @type {OdooObjectDto}
     * @memberof SaleDto
     */
    'shippingPartner'?: OdooObjectDto | null;
    /**
     * Salesperson
     * @type {OdooObjectDto}
     * @memberof SaleDto
     */
    'salesperson'?: OdooObjectDto | null;
    /**
     * Sales team
     * @type {OdooObjectDto}
     * @memberof SaleDto
     */
    'team'?: OdooObjectDto | null;
    /**
     * Company
     * @type {OdooObjectDto}
     * @memberof SaleDto
     */
    'company'?: OdooObjectDto | null;
    /**
     * Currency
     * @type {OdooObjectDto}
     * @memberof SaleDto
     */
    'currency'?: OdooObjectDto | null;
    /**
     * Order date
     * @type {string}
     * @memberof SaleDto
     */
    'dateOrder': string;
    /**
     * Validity date
     * @type {string}
     * @memberof SaleDto
     */
    'validityDate'?: string | null;
    /**
     * Amount untaxed
     * @type {number}
     * @memberof SaleDto
     */
    'amountUntaxed': number;
    /**
     * Amount tax
     * @type {number}
     * @memberof SaleDto
     */
    'amountTax': number;
    /**
     * Amount total
     * @type {number}
     * @memberof SaleDto
     */
    'amountTotal': number;
    /**
     * Invoice status
     * @type {string}
     * @memberof SaleDto
     */
    'invoiceStatus': string;
    /**
     * Order line IDs
     * @type {Array<number>}
     * @memberof SaleDto
     */
    'orderLineIds': Array<number>;
    /**
     * First picking ID
     * @type {number}
     * @memberof SaleDto
     */
    'pickingId'?: number | null;
    /**
     * Delivery status from Odoo: no, pending, partial, full
     * @type {string}
     * @memberof SaleDto
     */
    'deliveryStatus'?: string | null;
    /**
     * Creation date
     * @type {string}
     * @memberof SaleDto
     */
    'createDate': string;
    /**
     * Last update date
     * @type {string}
     * @memberof SaleDto
     */
    'writeDate': string;
    /**
     * Buyer received
     * @type {boolean}
     * @memberof SaleDto
     */
    'buyerReceived'?: boolean | null;
    /**
     * Seller confirmed shipping
     * @type {boolean}
     * @memberof SaleDto
     */
    'sellerShipped'?: boolean | null;
    /**
     * Whether this confirmed order has been routed to at least one supplier (has linked purchase orders)
     * @type {boolean}
     * @memberof SaleDto
     */
    'routed'?: boolean;
    /**
     * Number of purchase orders linked to this sale order
     * @type {number}
     * @memberof SaleDto
     */
    'purchaseOrderCount'?: number;
}
/**
 * 
 * @export
 * @interface SaleOrderLineDto
 */
export interface SaleOrderLineDto {
    /**
     * Order line ID
     * @type {number}
     * @memberof SaleOrderLineDto
     */
    'id': number;
    /**
     * Order line name
     * @type {string}
     * @memberof SaleOrderLineDto
     */
    'name': string;
    /**
     * Product
     * @type {OdooObjectDto}
     * @memberof SaleOrderLineDto
     */
    'product'?: OdooObjectDto | null;
    /**
     * Quantity
     * @type {number}
     * @memberof SaleOrderLineDto
     */
    'quantity': number;
    /**
     * Unit price
     * @type {number}
     * @memberof SaleOrderLineDto
     */
    'unitPrice': number;
    /**
     * Subtotal (without tax)
     * @type {number}
     * @memberof SaleOrderLineDto
     */
    'subtotal': number;
    /**
     * Total (with tax)
     * @type {number}
     * @memberof SaleOrderLineDto
     */
    'total': number;
    /**
     * Product image URL. Proxied through /product-images/variant/:id by ProductsService.joinProductImagesToOrderLines.
     * @type {string}
     * @memberof SaleOrderLineDto
     */
    'image'?: string | null;
}
/**
 * 
 * @export
 * @interface SaleStatsDto
 */
export interface SaleStatsDto {
    /**
     * Confirmed sale orders in the caller\'s orders list (every order for admins)
     * @type {number}
     * @memberof SaleStatsDto
     */
    'totalOrders': number;
    /**
     * Confirmed orders currently in transit
     * @type {number}
     * @memberof SaleStatsDto
     */
    'inTransitOrders': number;
    /**
     * Confirmed orders that are delivered
     * @type {number}
     * @memberof SaleStatsDto
     */
    'deliveredOrders': number;
    /**
     * Delivered orders awaiting buyer validation
     * @type {number}
     * @memberof SaleStatsDto
     */
    'pendingApprovalOrders': number;
    /**
     * Confirmed orders with no linked purchase orders (not yet routed to a supplier)
     * @type {number}
     * @memberof SaleStatsDto
     */
    'unroutedOrders': number;
}
/**
 * 
 * @export
 * @interface SalesQueryDto
 */
export interface SalesQueryDto {
    /**
     * 
     * @type {number}
     * @memberof SalesQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesQueryDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesQueryDto
     */
    'search'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesQueryDto
     */
    'sortBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesQueryDto
     */
    'sortOrder'?: SalesQueryDtoSortOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof SalesQueryDto
     */
    'state'?: SalesQueryDtoStateEnum;
    /**
     * 
     * @type {number}
     * @memberof SalesQueryDto
     */
    'partnerId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SalesQueryDto
     */
    'inDelivery'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesQueryDto
     */
    'buyerReceived'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesQueryDto
     */
    'notExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesQueryDto
     */
    'unrouted'?: boolean;
}

export const SalesQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SalesQueryDtoSortOrderEnum = typeof SalesQueryDtoSortOrderEnum[keyof typeof SalesQueryDtoSortOrderEnum];
export const SalesQueryDtoStateEnum = {
    Draft: 'draft',
    Sent: 'sent',
    Sale: 'sale',
    Done: 'done',
    Cancel: 'cancel',
    Confirmed: 'confirmed'
} as const;

export type SalesQueryDtoStateEnum = typeof SalesQueryDtoStateEnum[keyof typeof SalesQueryDtoStateEnum];

/**
 * 
 * @export
 * @interface SalesReportBuyerDto
 */
export interface SalesReportBuyerDto {
    /**
     * 
     * @type {number}
     * @memberof SalesReportBuyerDto
     */
    'partnerId': number;
    /**
     * 
     * @type {string}
     * @memberof SalesReportBuyerDto
     */
    'partnerName': string;
    /**
     * 
     * @type {number}
     * @memberof SalesReportBuyerDto
     */
    'revenue': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportBuyerDto
     */
    'orderCount': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportBuyerDto
     */
    'avgOrderValue': number;
}
/**
 * 
 * @export
 * @interface SalesReportDto
 */
export interface SalesReportDto {
    /**
     * 
     * @type {SalesReportSummaryDto}
     * @memberof SalesReportDto
     */
    'summary': SalesReportSummaryDto;
    /**
     * 
     * @type {Array<SalesReportPeriodDto>}
     * @memberof SalesReportDto
     */
    'byPeriod': Array<SalesReportPeriodDto>;
    /**
     * Top 20 products by revenue
     * @type {Array<SalesReportProductDto>}
     * @memberof SalesReportDto
     */
    'topProducts': Array<SalesReportProductDto>;
    /**
     * Top 20 buyers by revenue
     * @type {Array<SalesReportBuyerDto>}
     * @memberof SalesReportDto
     */
    'topBuyers': Array<SalesReportBuyerDto>;
}
/**
 * 
 * @export
 * @interface SalesReportPeriodDto
 */
export interface SalesReportPeriodDto {
    /**
     * 
     * @type {string}
     * @memberof SalesReportPeriodDto
     */
    'month': string;
    /**
     * 
     * @type {number}
     * @memberof SalesReportPeriodDto
     */
    'revenue': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportPeriodDto
     */
    'orderCount': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportPeriodDto
     */
    'estimatedMargin': number;
}
/**
 * 
 * @export
 * @interface SalesReportProductDto
 */
export interface SalesReportProductDto {
    /**
     * 
     * @type {number}
     * @memberof SalesReportProductDto
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof SalesReportProductDto
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof SalesReportProductDto
     */
    'revenue': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportProductDto
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportProductDto
     */
    'estimatedMargin': number;
}
/**
 * 
 * @export
 * @interface SalesReportSummaryDto
 */
export interface SalesReportSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof SalesReportSummaryDto
     */
    'totalOrders': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportSummaryDto
     */
    'totalRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportSummaryDto
     */
    'totalTax': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportSummaryDto
     */
    'avgOrderValue': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportSummaryDto
     */
    'estimatedMargin': number;
    /**
     * 
     * @type {number}
     * @memberof SalesReportSummaryDto
     */
    'marginPct'?: number | null;
}
/**
 * 
 * @export
 * @interface SalesResponseDto
 */
export interface SalesResponseDto {
    /**
     * List of sales
     * @type {Array<SaleDto>}
     * @memberof SalesResponseDto
     */
    'data': Array<SaleDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof SalesResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface SellerStatsDto
 */
export interface SellerStatsDto {
    /**
     * Number of active products listed by this seller
     * @type {number}
     * @memberof SellerStatsDto
     */
    'activeProductCount': number;
    /**
     * Total confirmed purchase orders placed with this seller
     * @type {number}
     * @memberof SellerStatsDto
     */
    'totalSales': number;
    /**
     * Number of open (draft/sent/confirmed) purchase orders
     * @type {number}
     * @memberof SellerStatsDto
     */
    'openPoCount': number;
    /**
     * Average days between PO confirmation and delivery
     * @type {number}
     * @memberof SellerStatsDto
     */
    'avgFulfillmentDays'?: number | null;
}
/**
 * 
 * @export
 * @interface SendMessageDto
 */
export interface SendMessageDto {
    /**
     * User message text. Required unless attachments are provided.
     * @type {string}
     * @memberof SendMessageDto
     */
    'message'?: string;
    /**
     * Existing chat id. Omit to start a new chat.
     * @type {string}
     * @memberof SendMessageDto
     */
    'chatId'?: string;
    /**
     * Optional attachments (≤5 items, ≤10 MB each).
     * @type {Array<ChatAttachmentInputDto>}
     * @memberof SendMessageDto
     */
    'attachments'?: Array<ChatAttachmentInputDto>;
    /**
     * Client-side conversation history for guest (unauthenticated) sessions.
     * @type {Array<ChatHistoryTurnDto>}
     * @memberof SendMessageDto
     */
    'history'?: Array<ChatHistoryTurnDto>;
    /**
     * Odoo product.template id of the product the user is currently viewing. When provided, the BE pins this product (and its datasheet_ai_summary) to the catalog context so the model always has it available even if the broader catalog query misses it.
     * @type {number}
     * @memberof SendMessageDto
     */
    'productId'?: number;
    /**
     * Odoo product.product id of the specific variant the user has selected on the product page. Stock is per-variant (product.product.supplier_stock), so without this the assistant reports the template-wide total rather than the availability the page is showing.
     * @type {number}
     * @memberof SendMessageDto
     */
    'variantId'?: number;
}
/**
 * 
 * @export
 * @interface SimilarProductsQueryDto
 */
export interface SimilarProductsQueryDto {
    /**
     * 
     * @type {number}
     * @memberof SimilarProductsQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof SimilarProductsQueryDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof SimilarProductsQueryDto
     */
    'search'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarProductsQueryDto
     */
    'sortBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarProductsQueryDto
     */
    'sortOrder'?: SimilarProductsQueryDtoSortOrderEnum;
    /**
     * 
     * @type {number}
     * @memberof SimilarProductsQueryDto
     */
    'productId': number;
}

export const SimilarProductsQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SimilarProductsQueryDtoSortOrderEnum = typeof SimilarProductsQueryDtoSortOrderEnum[keyof typeof SimilarProductsQueryDtoSortOrderEnum];

/**
 * 
 * @export
 * @interface StateDto
 */
export interface StateDto {
    /**
     * State ID
     * @type {number}
     * @memberof StateDto
     */
    'id': number;
    /**
     * State name
     * @type {string}
     * @memberof StateDto
     */
    'name': string;
    /**
     * Country
     * @type {CountryDto}
     * @memberof StateDto
     */
    'country'?: CountryDto | null;
}
/**
 * 
 * @export
 * @interface StripeCustomerSheetResponseDto
 */
export interface StripeCustomerSheetResponseDto {
    /**
     * Stripe customer ID
     * @type {string}
     * @memberof StripeCustomerSheetResponseDto
     */
    'customerId': string;
    /**
     * Ephemeral key secret for Stripe mobile SDK (for customer-based flows)
     * @type {string}
     * @memberof StripeCustomerSheetResponseDto
     */
    'ephemeralKeySecret': string;
    /**
     * Payment intent client secret
     * @type {string}
     * @memberof StripeCustomerSheetResponseDto
     */
    'paymentIntentClientSecret': string;
}
/**
 * 
 * @export
 * @interface StripeGuestIntentResponseDto
 */
export interface StripeGuestIntentResponseDto {
    /**
     * Stripe payment intent client secret
     * @type {string}
     * @memberof StripeGuestIntentResponseDto
     */
    'clientSecret': string;
}
/**
 * 
 * @export
 * @interface SupplierWarrantyStatDto
 */
export interface SupplierWarrantyStatDto {
    /**
     * 
     * @type {number}
     * @memberof SupplierWarrantyStatDto
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierWarrantyStatDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierWarrantyStatDto
     */
    'resolved': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierWarrantyStatDto
     */
    'rejected': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierWarrantyStatDto
     */
    'mediating': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierWarrantyStatDto
     */
    'escalated': number;
}
/**
 * 
 * @export
 * @interface TimeSeriesBucketDto
 */
export interface TimeSeriesBucketDto {
    /**
     * Bucket start date (ISO)
     * @type {string}
     * @memberof TimeSeriesBucketDto
     */
    'period': string;
    /**
     * Points issued in this period
     * @type {number}
     * @memberof TimeSeriesBucketDto
     */
    'pointsIssued': number;
    /**
     * Points redeemed in this period
     * @type {number}
     * @memberof TimeSeriesBucketDto
     */
    'pointsRedeemed': number;
    /**
     * Points expired in this period
     * @type {number}
     * @memberof TimeSeriesBucketDto
     */
    'pointsExpired': number;
}
/**
 * 
 * @export
 * @interface TopProductDto
 */
export interface TopProductDto {
    /**
     * Odoo product (variant) ID
     * @type {number}
     * @memberof TopProductDto
     */
    'productId': number;
    /**
     * Display name of the product (Odoo display_name).
     * @type {string}
     * @memberof TopProductDto
     */
    'productName': string;
    /**
     * Sum of confirmed PO line quantities for the period.
     * @type {number}
     * @memberof TopProductDto
     */
    'units': number;
    /**
     * Distinct purchase orders that included this product.
     * @type {number}
     * @memberof TopProductDto
     */
    'orders': number;
}
/**
 * 
 * @export
 * @interface TopProductsQueryDto
 */
export interface TopProductsQueryDto {
    /**
     * Lookback window for ranking. Rolling rather than calendar-aligned so the ranking is always meaningful.
     * @type {string}
     * @memberof TopProductsQueryDto
     */
    'period'?: TopProductsQueryDtoPeriodEnum;
    /**
     * How many products to return.
     * @type {number}
     * @memberof TopProductsQueryDto
     */
    'take'?: number;
}

export const TopProductsQueryDtoPeriodEnum = {
    _7d: '7d',
    _30d: '30d',
    _90d: '90d',
    Year: 'year'
} as const;

export type TopProductsQueryDtoPeriodEnum = typeof TopProductsQueryDtoPeriodEnum[keyof typeof TopProductsQueryDtoPeriodEnum];

/**
 * 
 * @export
 * @interface TwoFactorStatusDto
 */
export interface TwoFactorStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof TwoFactorStatusDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface UnpaidBillsQueryDto
 */
export interface UnpaidBillsQueryDto {
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof UnpaidBillsQueryDto
     */
    'page'?: number;
    /**
     * Page size
     * @type {number}
     * @memberof UnpaidBillsQueryDto
     */
    'pageSize'?: number;
    /**
     * Search term for text search
     * @type {string}
     * @memberof UnpaidBillsQueryDto
     */
    'search'?: string;
    /**
     * Field to sort by
     * @type {string}
     * @memberof UnpaidBillsQueryDto
     */
    'sortBy'?: string;
    /**
     * Sort order
     * @type {string}
     * @memberof UnpaidBillsQueryDto
     */
    'sortOrder'?: UnpaidBillsQueryDtoSortOrderEnum;
    /**
     * Filter by source document ref (e.g. \"PO00123\")
     * @type {string}
     * @memberof UnpaidBillsQueryDto
     */
    'originRef'?: string;
}

export const UnpaidBillsQueryDtoSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type UnpaidBillsQueryDtoSortOrderEnum = typeof UnpaidBillsQueryDtoSortOrderEnum[keyof typeof UnpaidBillsQueryDtoSortOrderEnum];

/**
 * 
 * @export
 * @interface UnreadCountDto
 */
export interface UnreadCountDto {
    /**
     * 
     * @type {number}
     * @memberof UnreadCountDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface UpdateBrandDto
 */
export interface UpdateBrandDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandDto
     */
    'name'?: string;
    /**
     * Base64 logo (PNG/JPEG)
     * @type {string}
     * @memberof UpdateBrandDto
     */
    'logo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBrandDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateBuyerPricingDto
 */
export interface UpdateBuyerPricingDto {
    /**
     * Per-variant buyer-facing pricing tiers
     * @type {Array<UpdateVariantPricingDto>}
     * @memberof UpdateBuyerPricingDto
     */
    'variants': Array<UpdateVariantPricingDto>;
}
/**
 * 
 * @export
 * @interface UpdateCategoryDto
 */
export interface UpdateCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryDto
     */
    'name'?: string;
    /**
     * Parent category ID
     * @type {number}
     * @memberof UpdateCategoryDto
     */
    'parentId'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateCategoryFieldConfigDto
 */
export interface UpdateCategoryFieldConfigDto {
    /**
     * Sparse map of fieldKey -> partial policy. Only changed keys need to be sent. Unknown keys are ignored.
     * @type {{ [key: string]: PartialFieldPolicyDto; }}
     * @memberof UpdateCategoryFieldConfigDto
     */
    'config': { [key: string]: PartialFieldPolicyDto; };
}
/**
 * 
 * @export
 * @interface UpdateChangeRequestDto
 */
export interface UpdateChangeRequestDto {
    /**
     * Replacement proposed changes diff. Overwrites the existing proposedChanges.
     * @type {{ [key: string]: any; }}
     * @memberof UpdateChangeRequestDto
     */
    'proposedChanges'?: { [key: string]: any; };
    /**
     * Updated submitter note.
     * @type {string}
     * @memberof UpdateChangeRequestDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface UpdateClaimStatusDto
 */
export interface UpdateClaimStatusDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimStatusDto
     */
    'status': UpdateClaimStatusDtoStatusEnum;
}

export const UpdateClaimStatusDtoStatusEnum = {
    New: 'NEW',
    Acknowledged: 'ACKNOWLEDGED',
    Investigating: 'INVESTIGATING',
    Resolved: 'RESOLVED',
    Rejected: 'REJECTED',
    Mediating: 'MEDIATING',
    Escalated: 'ESCALATED'
} as const;

export type UpdateClaimStatusDtoStatusEnum = typeof UpdateClaimStatusDtoStatusEnum[keyof typeof UpdateClaimStatusDtoStatusEnum];

/**
 * 
 * @export
 * @interface UpdateInternalDeliveryRateCardDto
 */
export interface UpdateInternalDeliveryRateCardDto {
    /**
     * Currency used for internal delivery cost tracking
     * @type {string}
     * @memberof UpdateInternalDeliveryRateCardDto
     */
    'currency': string;
    /**
     * Internal cost per shipment
     * @type {number}
     * @memberof UpdateInternalDeliveryRateCardDto
     */
    'costPerShipment': number;
}
/**
 * 
 * @export
 * @interface UpdateLoyaltyConfigDto
 */
export interface UpdateLoyaltyConfigDto {
    /**
     * Points awarded per 100 units of currency
     * @type {number}
     * @memberof UpdateLoyaltyConfigDto
     */
    'pointsPer100': number;
    /**
     * Currency value granted per 100 redeemed points
     * @type {number}
     * @memberof UpdateLoyaltyConfigDto
     */
    'redemptionValuePer100Points': number;
    /**
     * Days until points expire
     * @type {number}
     * @memberof UpdateLoyaltyConfigDto
     */
    'validityDays': number;
}
/**
 * 
 * @export
 * @interface UpdateLoyaltyPromotionDto
 */
export interface UpdateLoyaltyPromotionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPromotionDto
     */
    'name'?: string;
    /**
     * Points multiplier (≥ 1)
     * @type {number}
     * @memberof UpdateLoyaltyPromotionDto
     */
    'multiplier'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPromotionDto
     */
    'scope'?: UpdateLoyaltyPromotionDtoScopeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateLoyaltyPromotionDto
     */
    'productIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLoyaltyPromotionDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPromotionDto
     */
    'startsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPromotionDto
     */
    'endsAt'?: string | null;
}

export const UpdateLoyaltyPromotionDtoScopeEnum = {
    All: 'ALL',
    Products: 'PRODUCTS'
} as const;

export type UpdateLoyaltyPromotionDtoScopeEnum = typeof UpdateLoyaltyPromotionDtoScopeEnum[keyof typeof UpdateLoyaltyPromotionDtoScopeEnum];

/**
 * 
 * @export
 * @interface UpdateNotificationPrefsDto
 */
export interface UpdateNotificationPrefsDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPrefsDto
     */
    'emailOrders'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPrefsDto
     */
    'emailAccount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPrefsDto
     */
    'emailMarketing'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdatePlatformSettingsDto
 */
export interface UpdatePlatformSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof UpdatePlatformSettingsDto
     */
    'platformFeePercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePlatformSettingsDto
     */
    'defaultMarginPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePlatformSettingsDto
     */
    'orderValidityDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePlatformSettingsDto
     */
    'maxLoyaltyDiscountPct'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePlatformSettingsDto
     */
    'maintenanceMode'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePlatformSettingsDto
     */
    'allowGuestCheckout'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlatformSettingsDto
     */
    'defaultCurrency'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductAttributeDto
 */
export interface UpdateProductAttributeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductAttributeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductAttributeDto
     */
    'displayType'?: UpdateProductAttributeDtoDisplayTypeEnum;
}

export const UpdateProductAttributeDtoDisplayTypeEnum = {
    Radio: 'radio',
    Select: 'select',
    Color: 'color'
} as const;

export type UpdateProductAttributeDtoDisplayTypeEnum = typeof UpdateProductAttributeDtoDisplayTypeEnum[keyof typeof UpdateProductAttributeDtoDisplayTypeEnum];

/**
 * 
 * @export
 * @interface UpdateProductAttributeValueDto
 */
export interface UpdateProductAttributeValueDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductAttributeValueDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductConditionDto
 */
export interface UpdateProductConditionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductConditionDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductConditionDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateProductDealTypeDto
 */
export interface UpdateProductDealTypeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDealTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductDealTypeDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateProductDto
 */
export interface UpdateProductDto {
    /**
     * Whether the product template is active. Set false to hide the product from buyers.
     * @type {boolean}
     * @memberof UpdateProductDto
     */
    'active'?: boolean;
    /**
     * New product name
     * @type {string}
     * @memberof UpdateProductDto
     */
    'name'?: string;
    /**
     * New sale description
     * @type {string}
     * @memberof UpdateProductDto
     */
    'description'?: string;
    /**
     * Country of origin (Odoo res.country ID)
     * @type {number}
     * @memberof UpdateProductDto
     */
    'countryOfOriginId'?: number;
    /**
     * Product category (Odoo product.category ID)
     * @type {number}
     * @memberof UpdateProductDto
     */
    'categoryId'?: number;
    /**
     * New main image (template image_1920). GCS object key or base64. Omit to leave the existing main image unchanged.
     * @type {string}
     * @memberof UpdateProductDto
     */
    'image'?: string;
    /**
     * Reconcile the gallery. Existing rows whose id is not in keepIds are removed; each entry in add is created as a new product.image row. Omit the whole field to leave the gallery unchanged.
     * @type {UpdateProductGalleryDto}
     * @memberof UpdateProductDto
     */
    'gallery'?: UpdateProductGalleryDto;
    /**
     * Per-variant updates. Each entry must include product.product.id; only the fields that should change need to be set.
     * @type {Array<UpdateProductVariantDto>}
     * @memberof UpdateProductDto
     */
    'variants'?: Array<UpdateProductVariantDto>;
    /**
     * product.product IDs to archive (set active=false). Variants are not hard-deleted because Odoo regenerates them from attribute lines; archiving hides them from buyers while preserving order history.
     * @type {Array<number>}
     * @memberof UpdateProductDto
     */
    'archiveVariantIds'?: Array<number>;
    /**
     * Brand-new variants to add. Each entry must specify one value per attribute line on the product (either an existing valueId or a newValueName to create). Odoo auto-generates the variant after the attribute lines are updated; we then write SKU / supplier_stock / image / supplier_info / discount onto the new product.product row.
     * @type {Array<NewVariantDto>}
     * @memberof UpdateProductDto
     */
    'newVariants'?: Array<NewVariantDto>;
    /**
     * Reconcile the warranty SKUs offered for this product (product.template.compatible_warranty_ids). Pass the full list of warranty template ids to keep — anything not in the list is detached. Pass an empty array to detach all.
     * @type {Array<number>}
     * @memberof UpdateProductDto
     */
    'compatibleWarrantyIds'?: Array<number>;
    /**
     * Optional lifecycle marker for inactive products. Use \"discontinued\" to persist the stronger seller action; omit or set \"inactive\" for a plain inactive state.
     * @type {string}
     * @memberof UpdateProductDto
     */
    'lifecycleStatus'?: UpdateProductDtoLifecycleStatusEnum;
    /**
     * Per-variant discount changes. Each entry sets x_discount_percentage and recalculates pricelist prices. Set discountPercentage=0 to clear.
     * @type {Array<UpdateVariantDiscountInputDto>}
     * @memberof UpdateProductDto
     */
    'discounts'?: Array<UpdateVariantDiscountInputDto>;
}

export const UpdateProductDtoLifecycleStatusEnum = {
    Inactive: 'inactive',
    Discontinued: 'discontinued'
} as const;

export type UpdateProductDtoLifecycleStatusEnum = typeof UpdateProductDtoLifecycleStatusEnum[keyof typeof UpdateProductDtoLifecycleStatusEnum];

/**
 * 
 * @export
 * @interface UpdateProductGalleryDto
 */
export interface UpdateProductGalleryDto {
    /**
     * IDs of existing product.image rows to keep. Any gallery row not listed here is unlinked from the template and deleted.
     * @type {Array<number>}
     * @memberof UpdateProductGalleryDto
     */
    'keepIds'?: Array<number>;
    /**
     * New gallery images to add. Each entry is a GCS object key (\"product-images/...\") or a base64-encoded image. One product.image row is created per entry.
     * @type {Array<string>}
     * @memberof UpdateProductGalleryDto
     */
    'add'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateProductRequestDto
 */
export interface UpdateProductRequestDto {
    /**
     * Product template name
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'name'?: string;
    /**
     * Brand ID from Odoo
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'brandId'?: number;
    /**
     * Category ID from Odoo
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'categoryId'?: number;
    /**
     * Product description
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'description'?: string;
    /**
     * Product type
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'productType'?: UpdateProductRequestDtoProductTypeEnum;
    /**
     * Warranty record ID from Odoo. Optional — required for non-draft submissions in product UX, but the API accepts drafts without it.
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'warrantyId'?: number;
    /**
     * Warranty type ID from Odoo (optional)
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'warrantyTypeId'?: number;
    /**
     * Warranty provider ID from Odoo (product.warranty.provider). Optional.
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'warrantyProviderId'?: number;
    /**
     * Country of origin ID from Odoo (optional)
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'countryOfOriginId'?: number;
    /**
     * Screen size ID (product.screen.size). Template-level — same for every variant.
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'screenSizeId'?: number;
    /**
     * Resolution ID (product.resolution). Template-level — same for every variant.
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'resolutionId'?: number;
    /**
     * Template-level \"main\" image. Accepts a GCS object key (prefix \"product-images/\"), a public URL (https://), or a base64-encoded image. When the request is non-draft, the server requires `image` or a non-empty `images[]` — every submitted product needs at least one image.
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'image'?: string;
    /**
     * Additional template-level gallery images. Each entry is a GCS object key (prefix \"product-images/\") or a base64-encoded image. On approval each image becomes a product.image row linked via product_tmpl_id.
     * @type {Array<string>}
     * @memberof UpdateProductRequestDto
     */
    'images'?: Array<string>;
    /**
     * External datasheet URL (legacy / bulk-import). When provided alongside a PDF that ends in .pdf, the backend will fetch+rehost it as a real PDF attachment. For the single-product UI, prefer uploading via /product-datasheets/upload-url and sending datasheetObjectKey instead.
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'datasheetUrl'?: string;
    /**
     * GCS object key for an uploaded datasheet PDF (prefix \"product-datasheets/\"). Obtained via POST /product-datasheets/upload-url. Backend copies the bytes into an ir.attachment on the new product template and runs AI extraction.
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'datasheetObjectKey'?: string;
    /**
     * Original filename of the uploaded datasheet PDF, used for the ir.attachment name and download attribution.
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'datasheetFileName'?: string;
    /**
     * AiExtraction row id returned by POST /product-datasheets/extract on the FE. When present, the backend loads that row, mirrors its outputJson + outputText onto the new product template in Odoo, and links the extraction to the template — all without re-running Gemini. The bulk-import path leaves this undefined and the backend extracts in the background instead.
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'datasheetExtractionId'?: string;
    /**
     * Internal notes (optional)
     * @type {string}
     * @memberof UpdateProductRequestDto
     */
    'notes'?: string;
    /**
     * Deal type ID from Odoo (optional)
     * @type {number}
     * @memberof UpdateProductRequestDto
     */
    'dealTypeId'?: number;
    /**
     * Product variants with storage, color, SKUs, images, and quantities
     * @type {Array<CreateProductVariantDto>}
     * @memberof UpdateProductRequestDto
     */
    'variants'?: Array<CreateProductVariantDto>;
    /**
     * Warranty product template ids (product.template where is_warranty=true) the buyer can pick from at checkout. Maps to product.template.compatible_warranty_ids on the created template.
     * @type {Array<number>}
     * @memberof UpdateProductRequestDto
     */
    'compatibleWarrantyIds'?: Array<number>;
    /**
     * When true, the request is saved as a seller-only draft and does not enter the admin review queue.
     * @type {boolean}
     * @memberof UpdateProductRequestDto
     */
    'isDraft'?: boolean;
}

export const UpdateProductRequestDtoProductTypeEnum = {
    Consu: 'consu'
} as const;

export type UpdateProductRequestDtoProductTypeEnum = typeof UpdateProductRequestDtoProductTypeEnum[keyof typeof UpdateProductRequestDtoProductTypeEnum];

/**
 * 
 * @export
 * @interface UpdateProductResolutionDto
 */
export interface UpdateProductResolutionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductResolutionDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductResolutionDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateProductScreenSizeDto
 */
export interface UpdateProductScreenSizeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductScreenSizeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductScreenSizeDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateProductVariantDto
 */
export interface UpdateProductVariantDto {
    /**
     * product.product ID
     * @type {number}
     * @memberof UpdateProductVariantDto
     */
    'id'?: number;
    /**
     * New SKU (default_code)
     * @type {string}
     * @memberof UpdateProductVariantDto
     */
    'sku'?: string;
    /**
     * New stock (supplier_stock)
     * @type {number}
     * @memberof UpdateProductVariantDto
     */
    'quantity'?: number;
    /**
     * Variant price delta vs the template list_price (price_extra). Example: template list_price=1000 and the variant should sell for 1200 → priceExtra=200. Not used for the seller edit flow — sellers should send `sellerPrice` instead.
     * @type {number}
     * @memberof UpdateProductVariantDto
     */
    'priceExtra'?: number;
    /**
     * Seller\'s own list price for this variant. Writes the `price` field on the seller\'s product.supplierinfo row at the lowest min_qty tier (the unit price). Use this on the seller edit flow instead of `priceExtra`, which is buyer-facing.
     * @type {number}
     * @memberof UpdateProductVariantDto
     */
    'sellerPrice'?: number;
    /**
     * New variant image (product.product.image_1920). GCS object key or base64.
     * @type {string}
     * @memberof UpdateProductVariantDto
     */
    'image'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductWarrantyDto
 */
export interface UpdateProductWarrantyDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductWarrantyDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductWarrantyDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateProductWarrantyProviderDto
 */
export interface UpdateProductWarrantyProviderDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductWarrantyProviderDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductWarrantyProviderDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateProductWarrantyTypeDto
 */
export interface UpdateProductWarrantyTypeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductWarrantyTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductWarrantyTypeDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateProfileDto
 */
export interface UpdateProfileDto {
    /**
     * User full name
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'name'?: string;
    /**
     * URL of the user profile image
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'profileImage'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSaleBillingAddressDto
 */
export interface UpdateSaleBillingAddressDto {
    /**
     * Buyer-owned res.partner id (invoice / other address). `null` bills the company partner.
     * @type {number}
     * @memberof UpdateSaleBillingAddressDto
     */
    'billingAddressId': number | null;
}
/**
 * 
 * @export
 * @interface UpdateSaleShippingAddressDto
 */
export interface UpdateSaleShippingAddressDto {
    /**
     * Buyer-owned res.partner id (delivery address).
     * @type {number}
     * @memberof UpdateSaleShippingAddressDto
     */
    'shippingAddressId': number;
}
/**
 * 
 * @export
 * @interface UpdateVariantDiscountDto
 */
export interface UpdateVariantDiscountDto {
    /**
     * Discount percentage to apply (0 = remove discount)
     * @type {number}
     * @memberof UpdateVariantDiscountDto
     */
    'discountPercentage': number;
}
/**
 * 
 * @export
 * @interface UpdateVariantDiscountInputDto
 */
export interface UpdateVariantDiscountInputDto {
    /**
     * product.product ID
     * @type {number}
     * @memberof UpdateVariantDiscountInputDto
     */
    'variantId'?: number;
    /**
     * Seller discount percentage on this variant. 0 removes the discount.
     * @type {number}
     * @memberof UpdateVariantDiscountInputDto
     */
    'discountPercentage'?: number;
}
/**
 * 
 * @export
 * @interface UpdateVariantPricingDto
 */
export interface UpdateVariantPricingDto {
    /**
     * Odoo product.product variant ID
     * @type {number}
     * @memberof UpdateVariantPricingDto
     */
    'variantId': number;
    /**
     * Buyer-facing pricing tiers for this variant
     * @type {Array<PricingTierDto>}
     * @memberof UpdateVariantPricingDto
     */
    'pricingTiers': Array<PricingTierDto>;
}
/**
 * 
 * @export
 * @interface UpdateVariantStockDto
 */
export interface UpdateVariantStockDto {
    /**
     * Supplier stock quantity
     * @type {number}
     * @memberof UpdateVariantStockDto
     */
    'supplierStock': number;
}
/**
 * 
 * @export
 * @interface UpdateWarrantyProductDto
 */
export interface UpdateWarrantyProductDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateWarrantyProductDto
     */
    'name'?: string;
    /**
     * Price per unit in the platform currency (QAR).
     * @type {number}
     * @memberof UpdateWarrantyProductDto
     */
    'price'?: number;
    /**
     * product.warranty (period) row id.
     * @type {number}
     * @memberof UpdateWarrantyProductDto
     */
    'warrantyId'?: number;
    /**
     * product.warranty.type row id.
     * @type {number}
     * @memberof UpdateWarrantyProductDto
     */
    'warrantyTypeId'?: number;
    /**
     * product.warranty.provider row id.
     * @type {number}
     * @memberof UpdateWarrantyProductDto
     */
    'warrantyProviderId'?: number;
    /**
     * Buyer-facing description / terms summary.
     * @type {string}
     * @memberof UpdateWarrantyProductDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWarrantyProductDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UploadUrlRequestDto
 */
export interface UploadUrlRequestDto {
    /**
     * MIME type of the file to upload
     * @type {string}
     * @memberof UploadUrlRequestDto
     */
    'contentType': string;
}
/**
 * 
 * @export
 * @interface UploadUrlResponseDto
 */
export interface UploadUrlResponseDto {
    /**
     * Signed upload URL
     * @type {string}
     * @memberof UploadUrlResponseDto
     */
    'uploadUrl': string;
    /**
     * Expiration timestamp (ISO)
     * @type {string}
     * @memberof UploadUrlResponseDto
     */
    'expiresAt': string;
    /**
     * HTTP headers for upload
     * @type {object}
     * @memberof UploadUrlResponseDto
     */
    'headers': object;
    /**
     * Object key in storage
     * @type {string}
     * @memberof UploadUrlResponseDto
     */
    'objectKey': string;
}
/**
 * 
 * @export
 * @interface UpsertInternalDeliveryCostDto
 */
export interface UpsertInternalDeliveryCostDto {
    /**
     * Order type for the shipment record
     * @type {string}
     * @memberof UpsertInternalDeliveryCostDto
     */
    'orderType': string;
    /**
     * Order ID for the shipment record
     * @type {number}
     * @memberof UpsertInternalDeliveryCostDto
     */
    'orderId': number;
    /**
     * Actual internal delivery cost
     * @type {number}
     * @memberof UpsertInternalDeliveryCostDto
     */
    'actualCost': number;
    /**
     * Currency used for the actual cost
     * @type {string}
     * @memberof UpsertInternalDeliveryCostDto
     */
    'currency': string;
    /**
     * Source of the recorded cost
     * @type {string}
     * @memberof UpsertInternalDeliveryCostDto
     */
    'costSource': string;
    /**
     * Optional admin note
     * @type {string}
     * @memberof UpsertInternalDeliveryCostDto
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface UserChangeRequestsDto
 */
export interface UserChangeRequestsDto {
    /**
     * 
     * @type {string}
     * @memberof UserChangeRequestsDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserChangeRequestsDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof UserChangeRequestsDto
     */
    'userEmail'?: string | null;
    /**
     * All change requests for this user.
     * @type {Array<ChangeRequestDto>}
     * @memberof UserChangeRequestsDto
     */
    'changeRequests': Array<ChangeRequestDto>;
}
/**
 * 
 * @export
 * @interface UserDocumentsDto
 */
export interface UserDocumentsDto {
    /**
     * User ID
     * @type {string}
     * @memberof UserDocumentsDto
     */
    'userId': string;
    /**
     * User name
     * @type {string}
     * @memberof UserDocumentsDto
     */
    'userName': string;
    /**
     * User email
     * @type {string}
     * @memberof UserDocumentsDto
     */
    'userEmail'?: string | null;
    /**
     * Partner type
     * @type {string}
     * @memberof UserDocumentsDto
     */
    'partnerType'?: UserDocumentsDtoPartnerTypeEnum | null;
    /**
     * User documents
     * @type {Array<DocumentDto>}
     * @memberof UserDocumentsDto
     */
    'documents': Array<DocumentDto>;
    /**
     * Submitted BANK_ACCOUNT_CREATE change requests
     * @type {Array<BankingChangeRequestSummaryDto>}
     * @memberof UserDocumentsDto
     */
    'bankingChangeRequests': Array<BankingChangeRequestSummaryDto>;
}

export const UserDocumentsDtoPartnerTypeEnum = {
    Buyer: 'buyer',
    Seller: 'seller'
} as const;

export type UserDocumentsDtoPartnerTypeEnum = typeof UserDocumentsDtoPartnerTypeEnum[keyof typeof UserDocumentsDtoPartnerTypeEnum];

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * User ID
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * User email address
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string | null;
    /**
     * User phone number
     * @type {string}
     * @memberof UserDto
     */
    'phoneNumber'?: string | null;
    /**
     * User full name
     * @type {string}
     * @memberof UserDto
     */
    'name': string;
    /**
     * User role
     * @type {string}
     * @memberof UserDto
     */
    'role': string;
    /**
     * Company name
     * @type {string}
     * @memberof UserDto
     */
    'companyName'?: string | null;
    /**
     * Commercial Registration number
     * @type {string}
     * @memberof UserDto
     */
    'crNumber'?: string | null;
    /**
     * Tax number (VAT)
     * @type {string}
     * @memberof UserDto
     */
    'taxNumber'?: string | null;
    /**
     * Contact name
     * @type {string}
     * @memberof UserDto
     */
    'contactName'?: string | null;
    /**
     * Street
     * @type {string}
     * @memberof UserDto
     */
    'street'?: string | null;
    /**
     * Street line 2
     * @type {string}
     * @memberof UserDto
     */
    'street2'?: string | null;
    /**
     * City
     * @type {string}
     * @memberof UserDto
     */
    'city'?: string | null;
    /**
     * ZIP / postal code
     * @type {string}
     * @memberof UserDto
     */
    'zip'?: string | null;
    /**
     * State / province
     * @type {OdooObjectDto}
     * @memberof UserDto
     */
    'state'?: OdooObjectDto | null;
    /**
     * Country
     * @type {OdooObjectDto}
     * @memberof UserDto
     */
    'country'?: OdooObjectDto | null;
    /**
     * User profile image URL
     * @type {string}
     * @memberof UserDto
     */
    'profileImage'?: string | null;
    /**
     * Whether the account is active
     * @type {boolean}
     * @memberof UserDto
     */
    'isActive': boolean;
    /**
     * Email verification status
     * @type {boolean}
     * @memberof UserDto
     */
    'emailVerified': boolean;
    /**
     * Phone verification status
     * @type {boolean}
     * @memberof UserDto
     */
    'phoneVerified': boolean;
    /**
     * Account creation date
     * @type {string}
     * @memberof UserDto
     */
    'createdAt': string;
    /**
     * Last update date
     * @type {string}
     * @memberof UserDto
     */
    'updatedAt': string;
    /**
     * Document upload status for onboarding flow
     * @type {Array<UserDtoDocumentsInner>}
     * @memberof UserDto
     */
    'documents'?: Array<UserDtoDocumentsInner>;
    /**
     * Odoo user ID
     * @type {number}
     * @memberof UserDto
     */
    'partnerId'?: number | null;
    /**
     * Loyalty points balance
     * @type {number}
     * @memberof UserDto
     */
    'loyaltyPoints': number;
    /**
     * Whether two-factor auth is enabled
     * @type {boolean}
     * @memberof UserDto
     */
    'twoFactorEnabled': boolean;
    /**
     * Last password change timestamp
     * @type {string}
     * @memberof UserDto
     */
    'passwordChangedAt'?: string | null;
    /**
     * Current user\'s bank accounts (sellers).
     * @type {Array<BankAccountDto>}
     * @memberof UserDto
     */
    'bankAccounts'?: Array<BankAccountDto>;
    /**
     * Open change requests submitted by this user. Frontend uses this to render \"Submitted for review\" badges per section.
     * @type {Array<PendingChangeRequestSummaryDto>}
     * @memberof UserDto
     */
    'pendingChangeRequests'?: Array<PendingChangeRequestSummaryDto>;
}
/**
 * 
 * @export
 * @interface UserDtoDocumentsInner
 */
export interface UserDtoDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof UserDtoDocumentsInner
     */
    'type'?: UserDtoDocumentsInnerTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserDtoDocumentsInner
     */
    'uploaded'?: boolean;
}

export const UserDtoDocumentsInnerTypeEnum = {
    Cr: 'CR',
    TaxCard: 'TAX_CARD'
} as const;

export type UserDtoDocumentsInnerTypeEnum = typeof UserDtoDocumentsInnerTypeEnum[keyof typeof UserDtoDocumentsInnerTypeEnum];

/**
 * 
 * @export
 * @interface UserProductRequestsDto
 */
export interface UserProductRequestsDto {
    /**
     * User ID
     * @type {string}
     * @memberof UserProductRequestsDto
     */
    'userId': string;
    /**
     * User name
     * @type {string}
     * @memberof UserProductRequestsDto
     */
    'userName': string;
    /**
     * User email
     * @type {string}
     * @memberof UserProductRequestsDto
     */
    'userEmail'?: string | null;
    /**
     * User product requests
     * @type {Array<ProductRequestDto>}
     * @memberof UserProductRequestsDto
     */
    'productRequests': Array<ProductRequestDto>;
}
/**
 * 
 * @export
 * @interface UsersChangeRequestsResponseDto
 */
export interface UsersChangeRequestsResponseDto {
    /**
     * List of users with their change requests
     * @type {Array<UserChangeRequestsDto>}
     * @memberof UsersChangeRequestsResponseDto
     */
    'data': Array<UserChangeRequestsDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof UsersChangeRequestsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface UsersDocumentsResponseDto
 */
export interface UsersDocumentsResponseDto {
    /**
     * List of users with their documents
     * @type {Array<UserDocumentsDto>}
     * @memberof UsersDocumentsResponseDto
     */
    'data': Array<UserDocumentsDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof UsersDocumentsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface UsersProductRequestsResponseDto
 */
export interface UsersProductRequestsResponseDto {
    /**
     * List of users with their product requests
     * @type {Array<UserProductRequestsDto>}
     * @memberof UsersProductRequestsResponseDto
     */
    'data': Array<UserProductRequestsDto>;
    /**
     * Pagination metadata
     * @type {PaginationMeta}
     * @memberof UsersProductRequestsResponseDto
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface VariantCategoryWinnerDto
 */
export interface VariantCategoryWinnerDto {
    /**
     * Winning variant ID for this category
     * @type {number}
     * @memberof VariantCategoryWinnerDto
     */
    'variantId': number;
    /**
     * One-sentence reason why this variant wins the category
     * @type {string}
     * @memberof VariantCategoryWinnerDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface VariantComparisonDto
 */
export interface VariantComparisonDto {
    /**
     * Short overview of the comparison
     * @type {string}
     * @memberof VariantComparisonDto
     */
    'summary': string;
    /**
     * Per-variant pros, cons and ideal use case
     * @type {Array<VariantPerProductComparisonDto>}
     * @memberof VariantComparisonDto
     */
    'perProduct': Array<VariantPerProductComparisonDto>;
    /**
     * Category-level winners. Fields are omitted when not meaningful for the inputs.
     * @type {VariantWinnerByCategoryDto}
     * @memberof VariantComparisonDto
     */
    'winnerByCategory': VariantWinnerByCategoryDto;
    /**
     * Overall recommendation
     * @type {VariantRecommendationDto}
     * @memberof VariantComparisonDto
     */
    'recommendation': VariantRecommendationDto;
}
/**
 * 
 * @export
 * @interface VariantComparisonResponseDto
 */
export interface VariantComparisonResponseDto {
    /**
     * Full details of the variants that were compared, in request order
     * @type {Array<ProductVariantDto>}
     * @memberof VariantComparisonResponseDto
     */
    'variants': Array<ProductVariantDto>;
    /**
     * Structured AI-generated comparison of the variants
     * @type {VariantComparisonDto}
     * @memberof VariantComparisonResponseDto
     */
    'comparison': VariantComparisonDto;
}
/**
 * 
 * @export
 * @interface VariantPerProductComparisonDto
 */
export interface VariantPerProductComparisonDto {
    /**
     * Variant ID this entry refers to
     * @type {number}
     * @memberof VariantPerProductComparisonDto
     */
    'variantId': number;
    /**
     * Notable strengths of this variant based on the provided specs
     * @type {Array<string>}
     * @memberof VariantPerProductComparisonDto
     */
    'pros': Array<string>;
    /**
     * Notable weaknesses of this variant based on the provided specs
     * @type {Array<string>}
     * @memberof VariantPerProductComparisonDto
     */
    'cons': Array<string>;
    /**
     * Short phrase describing the ideal use case for this variant
     * @type {string}
     * @memberof VariantPerProductComparisonDto
     */
    'bestFor': string;
}
/**
 * 
 * @export
 * @interface VariantPricingTiersDto
 */
export interface VariantPricingTiersDto {
    /**
     * Variant ID (ProductRequestVariant.id)
     * @type {string}
     * @memberof VariantPricingTiersDto
     */
    'variantId': string;
    /**
     * Admin pricing tiers for this variant (buyer-facing prices)
     * @type {Array<PricingTierDto>}
     * @memberof VariantPricingTiersDto
     */
    'pricingTiers': Array<PricingTierDto>;
}
/**
 * 
 * @export
 * @interface VariantRecommendationDto
 */
export interface VariantRecommendationDto {
    /**
     * Recommended variant ID
     * @type {number}
     * @memberof VariantRecommendationDto
     */
    'variantId': number;
    /**
     * Reasoning behind the overall recommendation
     * @type {string}
     * @memberof VariantRecommendationDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface VariantWinnerByCategoryDto
 */
export interface VariantWinnerByCategoryDto {
    /**
     * Best pick by price
     * @type {VariantCategoryWinnerDto}
     * @memberof VariantWinnerByCategoryDto
     */
    'price'?: VariantCategoryWinnerDto;
    /**
     * Best pick by raw performance
     * @type {VariantCategoryWinnerDto}
     * @memberof VariantWinnerByCategoryDto
     */
    'performance'?: VariantCategoryWinnerDto;
    /**
     * Best pick by overall value for money
     * @type {VariantCategoryWinnerDto}
     * @memberof VariantWinnerByCategoryDto
     */
    'value'?: VariantCategoryWinnerDto;
    /**
     * Best pick by build quality / warranty
     * @type {VariantCategoryWinnerDto}
     * @memberof VariantWinnerByCategoryDto
     */
    'build'?: VariantCategoryWinnerDto;
}
/**
 * 
 * @export
 * @interface VendorBillDto
 */
export interface VendorBillDto {
    /**
     * 
     * @type {number}
     * @memberof VendorBillDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof VendorBillDto
     */
    'supplierId': number | null;
    /**
     * 
     * @type {string}
     * @memberof VendorBillDto
     */
    'supplierName': string | null;
    /**
     * 
     * @type {string}
     * @memberof VendorBillDto
     */
    'reference': string | null;
    /**
     * 
     * @type {string}
     * @memberof VendorBillDto
     */
    'invoiceDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof VendorBillDto
     */
    'dueDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof VendorBillDto
     */
    'amountTotal': number;
    /**
     * Outstanding balance still to be paid
     * @type {number}
     * @memberof VendorBillDto
     */
    'amountResidual': number;
    /**
     * 
     * @type {string}
     * @memberof VendorBillDto
     */
    'currency': string | null;
    /**
     * 
     * @type {string}
     * @memberof VendorBillDto
     */
    'paymentState': VendorBillDtoPaymentStateEnum;
    /**
     * 
     * @type {string}
     * @memberof VendorBillDto
     */
    'state': string | null;
    /**
     * Source document reference (e.g. the PO that produced this bill). Null when no source ref is set on the move.
     * @type {string}
     * @memberof VendorBillDto
     */
    'originRef': string | null;
}

export const VendorBillDtoPaymentStateEnum = {
    NotPaid: 'NOT_PAID',
    InPayment: 'IN_PAYMENT',
    Partial: 'PARTIAL',
    Paid: 'PAID',
    Reversed: 'REVERSED',
    InvoicingLegacy: 'INVOICING_LEGACY',
    Unknown: 'UNKNOWN'
} as const;

export type VendorBillDtoPaymentStateEnum = typeof VendorBillDtoPaymentStateEnum[keyof typeof VendorBillDtoPaymentStateEnum];

/**
 * 
 * @export
 * @interface Verify2faLoginDto
 */
export interface Verify2faLoginDto {
    /**
     * Token returned by /auth/password/login when 2FA is enabled.
     * @type {string}
     * @memberof Verify2faLoginDto
     */
    'mfaToken': string;
    /**
     * 
     * @type {string}
     * @memberof Verify2faLoginDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface VerifyContactChangeDto
 */
export interface VerifyContactChangeDto {
    /**
     * New email address
     * @type {string}
     * @memberof VerifyContactChangeDto
     */
    'email'?: string;
    /**
     * New phone number in E.164 format
     * @type {string}
     * @memberof VerifyContactChangeDto
     */
    'phoneNumber'?: string;
    /**
     * 6-digit code sent to the new email address or phone number
     * @type {string}
     * @memberof VerifyContactChangeDto
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface VerifyOtpCodeDto
 */
export interface VerifyOtpCodeDto {
    /**
     * 
     * @type {string}
     * @memberof VerifyOtpCodeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface VerifyOtpDto
 */
export interface VerifyOtpDto {
    /**
     * Email address
     * @type {string}
     * @memberof VerifyOtpDto
     */
    'email'?: string;
    /**
     * Phone number in E.164 format
     * @type {string}
     * @memberof VerifyOtpDto
     */
    'phoneNumber'?: string;
    /**
     * 6-digit OTP code
     * @type {string}
     * @memberof VerifyOtpDto
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface VerifyPasswordResetOtpDto
 */
export interface VerifyPasswordResetOtpDto {
    /**
     * Email address associated with the password reset request
     * @type {string}
     * @memberof VerifyPasswordResetOtpDto
     */
    'email': string;
    /**
     * 6-digit OTP code sent to user email for password reset
     * @type {string}
     * @memberof VerifyPasswordResetOtpDto
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface VerifyPasswordResetOtpResponseDto
 */
export interface VerifyPasswordResetOtpResponseDto {
    /**
     * Success message
     * @type {string}
     * @memberof VerifyPasswordResetOtpResponseDto
     */
    'message': string;
    /**
     * Temporary token for password reset (use this token in reset-password endpoint)
     * @type {string}
     * @memberof VerifyPasswordResetOtpResponseDto
     */
    'tempToken': string;
    /**
     * Token expiration time in seconds
     * @type {number}
     * @memberof VerifyPasswordResetOtpResponseDto
     */
    'expiresIn': number;
}
/**
 * 
 * @export
 * @interface WarrantyClaimDto
 */
export interface WarrantyClaimDto {
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof WarrantyClaimDto
     */
    'saleOrderId': number;
    /**
     * 
     * @type {number}
     * @memberof WarrantyClaimDto
     */
    'saleOrderLineId': number;
    /**
     * 
     * @type {number}
     * @memberof WarrantyClaimDto
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'buyerId': string;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'claimType': WarrantyClaimDtoClaimTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'status': WarrantyClaimDtoStatusEnum;
    /**
     * Attachment metadata array
     * @type {Array<ClaimAttachmentDto>}
     * @memberof WarrantyClaimDto
     */
    'attachments': Array<ClaimAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'resolutionAction'?: WarrantyClaimDtoResolutionActionEnum | null;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'resolutionNote'?: string | null;
    /**
     * 
     * @type {Array<WarrantyClaimMessageDto>}
     * @memberof WarrantyClaimDto
     */
    'messages'?: Array<WarrantyClaimMessageDto>;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimDto
     */
    'updatedAt': string;
}

export const WarrantyClaimDtoClaimTypeEnum = {
    Damage: 'DAMAGE',
    Defect: 'DEFECT',
    MissingPart: 'MISSING_PART',
    DoesNotMatchDescription: 'DOES_NOT_MATCH_DESCRIPTION',
    Other: 'OTHER'
} as const;

export type WarrantyClaimDtoClaimTypeEnum = typeof WarrantyClaimDtoClaimTypeEnum[keyof typeof WarrantyClaimDtoClaimTypeEnum];
export const WarrantyClaimDtoStatusEnum = {
    New: 'NEW',
    Acknowledged: 'ACKNOWLEDGED',
    Investigating: 'INVESTIGATING',
    Resolved: 'RESOLVED',
    Rejected: 'REJECTED',
    Mediating: 'MEDIATING',
    Escalated: 'ESCALATED'
} as const;

export type WarrantyClaimDtoStatusEnum = typeof WarrantyClaimDtoStatusEnum[keyof typeof WarrantyClaimDtoStatusEnum];
export const WarrantyClaimDtoResolutionActionEnum = {
    Refund: 'REFUND',
    Replacement: 'REPLACEMENT',
    StoreCredit: 'STORE_CREDIT',
    None: 'NONE'
} as const;

export type WarrantyClaimDtoResolutionActionEnum = typeof WarrantyClaimDtoResolutionActionEnum[keyof typeof WarrantyClaimDtoResolutionActionEnum];

/**
 * 
 * @export
 * @interface WarrantyClaimMessageDto
 */
export interface WarrantyClaimMessageDto {
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimMessageDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimMessageDto
     */
    'claimId': string;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimMessageDto
     */
    'authorId': string;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimMessageDto
     */
    'authorRole': string;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimMessageDto
     */
    'content': string;
    /**
     * Attachment metadata array
     * @type {Array<ClaimAttachmentDto>}
     * @memberof WarrantyClaimMessageDto
     */
    'attachments': Array<ClaimAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimMessageDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface WarrantyClaimQueryDto
 */
export interface WarrantyClaimQueryDto {
    /**
     * 
     * @type {string}
     * @memberof WarrantyClaimQueryDto
     */
    'status'?: WarrantyClaimQueryDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof WarrantyClaimQueryDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof WarrantyClaimQueryDto
     */
    'pageSize'?: number;
}

export const WarrantyClaimQueryDtoStatusEnum = {
    New: 'NEW',
    Acknowledged: 'ACKNOWLEDGED',
    Investigating: 'INVESTIGATING',
    Resolved: 'RESOLVED',
    Rejected: 'REJECTED',
    Mediating: 'MEDIATING',
    Escalated: 'ESCALATED'
} as const;

export type WarrantyClaimQueryDtoStatusEnum = typeof WarrantyClaimQueryDtoStatusEnum[keyof typeof WarrantyClaimQueryDtoStatusEnum];

/**
 * 
 * @export
 * @interface WarrantyClaimStatsDto
 */
export interface WarrantyClaimStatsDto {
    /**
     * 
     * @type {number}
     * @memberof WarrantyClaimStatsDto
     */
    'total': number;
    /**
     * Count per ClaimStatus value
     * @type {object}
     * @memberof WarrantyClaimStatsDto
     */
    'byStatus': object;
    /**
     * Count per ClaimType value
     * @type {object}
     * @memberof WarrantyClaimStatsDto
     */
    'byClaimType': object;
    /**
     * Average days from NEW to RESOLVED/REJECTED/ESCALATED
     * @type {number}
     * @memberof WarrantyClaimStatsDto
     */
    'avgResolutionDays': number | null;
    /**
     * Top 20 suppliers by claim volume
     * @type {Array<SupplierWarrantyStatDto>}
     * @memberof WarrantyClaimStatsDto
     */
    'supplierStats': Array<SupplierWarrantyStatDto>;
}
/**
 * 
 * @export
 * @interface WarrantyProductDto
 */
export interface WarrantyProductDto {
    /**
     * product.template id.
     * @type {number}
     * @memberof WarrantyProductDto
     */
    'id': number;
    /**
     * First product.product (variant) id. Use this when creating sale order lines — Odoo expects a variant id, not a template id.
     * @type {number}
     * @memberof WarrantyProductDto
     */
    'variantId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarrantyProductDto
     */
    'name': string;
    /**
     * Price per unit in QAR.
     * @type {number}
     * @memberof WarrantyProductDto
     */
    'price'?: number | null;
    /**
     * Linked product.warranty (period) row id.
     * @type {number}
     * @memberof WarrantyProductDto
     */
    'warrantyId'?: number | null;
    /**
     * Linked product.warranty.type row id.
     * @type {number}
     * @memberof WarrantyProductDto
     */
    'warrantyTypeId'?: number | null;
    /**
     * Linked product.warranty.provider row id.
     * @type {number}
     * @memberof WarrantyProductDto
     */
    'warrantyProviderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarrantyProductDto
     */
    'description'?: string | null;
    /**
     * product.supplierinfo row ids backing this template. Used by admin moderation views to identify the owning seller. Buyers do not consume this.
     * @type {Array<number>}
     * @memberof WarrantyProductDto
     */
    'sellerIds'?: Array<number>;
    /**
     * How many products currently list this warranty in compatible_warranty_ids.
     * @type {number}
     * @memberof WarrantyProductDto
     */
    'productUsageCount'?: number;
    /**
     * Confirmed sale-order lines (state in sale|done) that reference this warranty. Past sales — informational only; editing/archiving the warranty never touches these.
     * @type {number}
     * @memberof WarrantyProductDto
     */
    'orderUsageCount'?: number;
}

/**
 * AdminAIChatApi - axios parameter creator
 * @export
 */
export const AdminAIChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the conversation metadata plus all messages (user + assistant) in chronological order.
         * @summary Get full conversation with all messages (admin only)
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAiChatConversation: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('adminGetAiChatConversation', 'chatId', chatId)
            const localVarPath = `/api/v1/admin/ai-chat/conversations/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves the Odoo partner ID to a Prisma user and returns aggregated AI chat cost.
         * @summary Get AI chat cost for a specific partner (admin only)
         * @param {number} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAiChatPartnerCost: async (partnerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminGetAiChatPartnerCost', 'partnerId', partnerId)
            const localVarPath = `/api/v1/admin/ai-chat/user-cost/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns spend / call totals over rolling 7-day, 30-day, and all-time windows, top users by 30-day spend, and a 12-week cost histogram.
         * @summary Aggregated AI chat usage + cost (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAiChatStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/ai-chat/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of assistant chat messages with token/cost fields. Filters: userId, dateFrom, dateTo, search (matches message text or user email/name).
         * @summary List AI chat messages with cost data (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiChatSortOrderEnum} [sortOrder] Sort order
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on createdAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on createdAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAiChat: async (page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiChatSortOrderEnum, userId?: string, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/ai-chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of conversations with total cost, token, and message counts. Filters: userId, dateFrom, dateTo, search.
         * @summary List AI chat conversations with aggregated cost (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiChatConversationsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on lastMessageAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on lastMessageAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAiChatConversations: async (page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiChatConversationsSortOrderEnum, userId?: string, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/ai-chat/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAIChatApi - functional programming interface
 * @export
 */
export const AdminAIChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAIChatApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the conversation metadata plus all messages (user + assistant) in chronological order.
         * @summary Get full conversation with all messages (admin only)
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAiChatConversation(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAiChatConversationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAiChatConversation(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAIChatApi.adminGetAiChatConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolves the Odoo partner ID to a Prisma user and returns aggregated AI chat cost.
         * @summary Get AI chat cost for a specific partner (admin only)
         * @param {number} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAiChatPartnerCost(partnerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAiChatPartnerCostDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAiChatPartnerCost(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAIChatApi.adminGetAiChatPartnerCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns spend / call totals over rolling 7-day, 30-day, and all-time windows, top users by 30-day spend, and a 12-week cost histogram.
         * @summary Aggregated AI chat usage + cost (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAiChatStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAiChatStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAiChatStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAIChatApi.adminGetAiChatStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of assistant chat messages with token/cost fields. Filters: userId, dateFrom, dateTo, search (matches message text or user email/name).
         * @summary List AI chat messages with cost data (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiChatSortOrderEnum} [sortOrder] Sort order
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on createdAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on createdAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListAiChat(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiChatSortOrderEnum, userId?: string, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminAiChatListItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListAiChat(page, pageSize, search, sortBy, sortOrder, userId, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAIChatApi.adminListAiChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of conversations with total cost, token, and message counts. Filters: userId, dateFrom, dateTo, search.
         * @summary List AI chat conversations with aggregated cost (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiChatConversationsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on lastMessageAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on lastMessageAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListAiChatConversations(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiChatConversationsSortOrderEnum, userId?: string, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminAiChatConversationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListAiChatConversations(page, pageSize, search, sortBy, sortOrder, userId, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAIChatApi.adminListAiChatConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAIChatApi - factory interface
 * @export
 */
export const AdminAIChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAIChatApiFp(configuration)
    return {
        /**
         * Returns the conversation metadata plus all messages (user + assistant) in chronological order.
         * @summary Get full conversation with all messages (admin only)
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAiChatConversation(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminAiChatConversationDetailDto> {
            return localVarFp.adminGetAiChatConversation(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolves the Odoo partner ID to a Prisma user and returns aggregated AI chat cost.
         * @summary Get AI chat cost for a specific partner (admin only)
         * @param {number} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAiChatPartnerCost(partnerId: number, options?: RawAxiosRequestConfig): AxiosPromise<AdminAiChatPartnerCostDto> {
            return localVarFp.adminGetAiChatPartnerCost(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns spend / call totals over rolling 7-day, 30-day, and all-time windows, top users by 30-day spend, and a 12-week cost histogram.
         * @summary Aggregated AI chat usage + cost (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAiChatStats(options?: RawAxiosRequestConfig): AxiosPromise<AdminAiChatStatsDto> {
            return localVarFp.adminGetAiChatStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of assistant chat messages with token/cost fields. Filters: userId, dateFrom, dateTo, search (matches message text or user email/name).
         * @summary List AI chat messages with cost data (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiChatSortOrderEnum} [sortOrder] Sort order
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on createdAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on createdAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAiChat(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiChatSortOrderEnum, userId?: string, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAiChatListItemDto>> {
            return localVarFp.adminListAiChat(page, pageSize, search, sortBy, sortOrder, userId, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of conversations with total cost, token, and message counts. Filters: userId, dateFrom, dateTo, search.
         * @summary List AI chat conversations with aggregated cost (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiChatConversationsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on lastMessageAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on lastMessageAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAiChatConversations(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiChatConversationsSortOrderEnum, userId?: string, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAiChatConversationDto>> {
            return localVarFp.adminListAiChatConversations(page, pageSize, search, sortBy, sortOrder, userId, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAIChatApi - object-oriented interface
 * @export
 * @class AdminAIChatApi
 * @extends {BaseAPI}
 */
export class AdminAIChatApi extends BaseAPI {
    /**
     * Returns the conversation metadata plus all messages (user + assistant) in chronological order.
     * @summary Get full conversation with all messages (admin only)
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAIChatApi
     */
    public adminGetAiChatConversation(chatId: string, options?: RawAxiosRequestConfig) {
        return AdminAIChatApiFp(this.configuration).adminGetAiChatConversation(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolves the Odoo partner ID to a Prisma user and returns aggregated AI chat cost.
     * @summary Get AI chat cost for a specific partner (admin only)
     * @param {number} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAIChatApi
     */
    public adminGetAiChatPartnerCost(partnerId: number, options?: RawAxiosRequestConfig) {
        return AdminAIChatApiFp(this.configuration).adminGetAiChatPartnerCost(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns spend / call totals over rolling 7-day, 30-day, and all-time windows, top users by 30-day spend, and a 12-week cost histogram.
     * @summary Aggregated AI chat usage + cost (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAIChatApi
     */
    public adminGetAiChatStats(options?: RawAxiosRequestConfig) {
        return AdminAIChatApiFp(this.configuration).adminGetAiChatStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of assistant chat messages with token/cost fields. Filters: userId, dateFrom, dateTo, search (matches message text or user email/name).
     * @summary List AI chat messages with cost data (admin only)
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Page size
     * @param {string} [search] Search term for text search
     * @param {string} [sortBy] Field to sort by
     * @param {AdminListAiChatSortOrderEnum} [sortOrder] Sort order
     * @param {string} [userId] Filter to a single user (uuid).
     * @param {string} [dateFrom] ISO 8601, inclusive lower bound on createdAt.
     * @param {string} [dateTo] ISO 8601, exclusive upper bound on createdAt.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAIChatApi
     */
    public adminListAiChat(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiChatSortOrderEnum, userId?: string, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig) {
        return AdminAIChatApiFp(this.configuration).adminListAiChat(page, pageSize, search, sortBy, sortOrder, userId, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of conversations with total cost, token, and message counts. Filters: userId, dateFrom, dateTo, search.
     * @summary List AI chat conversations with aggregated cost (admin only)
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Page size
     * @param {string} [search] Search term for text search
     * @param {string} [sortBy] Field to sort by
     * @param {AdminListAiChatConversationsSortOrderEnum} [sortOrder] Sort order
     * @param {string} [userId] Filter to a single user (uuid).
     * @param {string} [dateFrom] ISO 8601, inclusive lower bound on lastMessageAt.
     * @param {string} [dateTo] ISO 8601, exclusive upper bound on lastMessageAt.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAIChatApi
     */
    public adminListAiChatConversations(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiChatConversationsSortOrderEnum, userId?: string, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig) {
        return AdminAIChatApiFp(this.configuration).adminListAiChatConversations(page, pageSize, search, sortBy, sortOrder, userId, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminListAiChatSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminListAiChatSortOrderEnum = typeof AdminListAiChatSortOrderEnum[keyof typeof AdminListAiChatSortOrderEnum];
/**
 * @export
 */
export const AdminListAiChatConversationsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminListAiChatConversationsSortOrderEnum = typeof AdminListAiChatConversationsSortOrderEnum[keyof typeof AdminListAiChatConversationsSortOrderEnum];


/**
 * AdminAIExtractionsApi - axios parameter creator
 * @export
 */
export const AdminAIExtractionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns spend / call / success-rate totals over rolling 7-day, 30-day, and all-time windows, plus breakdowns by kind, top users by 30-day spend, and a 12-week cost-and-call histogram.
         * @summary Aggregated AI extraction usage + cost (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAiExtractionStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/ai-extractions/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated, filterable list of every AI extraction call. Filters: kind, userId, status, dateFrom, dateTo, search (matches sourceFileName / errorMessage / resourceId). Click a row in the FE to open the existing AdminDatasheetExtractionDto detail view.
         * @summary List AI extractions (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiExtractionsSortOrderEnum} [sortOrder] Sort order
         * @param {AdminListAiExtractionsKindEnum} [kind] Filter by extraction kind. Today only \&quot;datasheet\&quot; exists.
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {AdminListAiExtractionsStatusEnum} [status] 
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on createdAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on createdAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAiExtractions: async (page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiExtractionsSortOrderEnum, kind?: AdminListAiExtractionsKindEnum, userId?: string, status?: AdminListAiExtractionsStatusEnum, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/ai-extractions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAIExtractionsApi - functional programming interface
 * @export
 */
export const AdminAIExtractionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAIExtractionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns spend / call / success-rate totals over rolling 7-day, 30-day, and all-time windows, plus breakdowns by kind, top users by 30-day spend, and a 12-week cost-and-call histogram.
         * @summary Aggregated AI extraction usage + cost (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAiExtractionStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAiExtractionStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAiExtractionStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAIExtractionsApi.adminGetAiExtractionStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated, filterable list of every AI extraction call. Filters: kind, userId, status, dateFrom, dateTo, search (matches sourceFileName / errorMessage / resourceId). Click a row in the FE to open the existing AdminDatasheetExtractionDto detail view.
         * @summary List AI extractions (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiExtractionsSortOrderEnum} [sortOrder] Sort order
         * @param {AdminListAiExtractionsKindEnum} [kind] Filter by extraction kind. Today only \&quot;datasheet\&quot; exists.
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {AdminListAiExtractionsStatusEnum} [status] 
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on createdAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on createdAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListAiExtractions(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiExtractionsSortOrderEnum, kind?: AdminListAiExtractionsKindEnum, userId?: string, status?: AdminListAiExtractionsStatusEnum, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminAiExtractionListItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListAiExtractions(page, pageSize, search, sortBy, sortOrder, kind, userId, status, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAIExtractionsApi.adminListAiExtractions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAIExtractionsApi - factory interface
 * @export
 */
export const AdminAIExtractionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAIExtractionsApiFp(configuration)
    return {
        /**
         * Returns spend / call / success-rate totals over rolling 7-day, 30-day, and all-time windows, plus breakdowns by kind, top users by 30-day spend, and a 12-week cost-and-call histogram.
         * @summary Aggregated AI extraction usage + cost (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAiExtractionStats(options?: RawAxiosRequestConfig): AxiosPromise<AdminAiExtractionStatsDto> {
            return localVarFp.adminGetAiExtractionStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated, filterable list of every AI extraction call. Filters: kind, userId, status, dateFrom, dateTo, search (matches sourceFileName / errorMessage / resourceId). Click a row in the FE to open the existing AdminDatasheetExtractionDto detail view.
         * @summary List AI extractions (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListAiExtractionsSortOrderEnum} [sortOrder] Sort order
         * @param {AdminListAiExtractionsKindEnum} [kind] Filter by extraction kind. Today only \&quot;datasheet\&quot; exists.
         * @param {string} [userId] Filter to a single user (uuid).
         * @param {AdminListAiExtractionsStatusEnum} [status] 
         * @param {string} [dateFrom] ISO 8601, inclusive lower bound on createdAt.
         * @param {string} [dateTo] ISO 8601, exclusive upper bound on createdAt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAiExtractions(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiExtractionsSortOrderEnum, kind?: AdminListAiExtractionsKindEnum, userId?: string, status?: AdminListAiExtractionsStatusEnum, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAiExtractionListItemDto>> {
            return localVarFp.adminListAiExtractions(page, pageSize, search, sortBy, sortOrder, kind, userId, status, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAIExtractionsApi - object-oriented interface
 * @export
 * @class AdminAIExtractionsApi
 * @extends {BaseAPI}
 */
export class AdminAIExtractionsApi extends BaseAPI {
    /**
     * Returns spend / call / success-rate totals over rolling 7-day, 30-day, and all-time windows, plus breakdowns by kind, top users by 30-day spend, and a 12-week cost-and-call histogram.
     * @summary Aggregated AI extraction usage + cost (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAIExtractionsApi
     */
    public adminGetAiExtractionStats(options?: RawAxiosRequestConfig) {
        return AdminAIExtractionsApiFp(this.configuration).adminGetAiExtractionStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated, filterable list of every AI extraction call. Filters: kind, userId, status, dateFrom, dateTo, search (matches sourceFileName / errorMessage / resourceId). Click a row in the FE to open the existing AdminDatasheetExtractionDto detail view.
     * @summary List AI extractions (admin only)
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Page size
     * @param {string} [search] Search term for text search
     * @param {string} [sortBy] Field to sort by
     * @param {AdminListAiExtractionsSortOrderEnum} [sortOrder] Sort order
     * @param {AdminListAiExtractionsKindEnum} [kind] Filter by extraction kind. Today only \&quot;datasheet\&quot; exists.
     * @param {string} [userId] Filter to a single user (uuid).
     * @param {AdminListAiExtractionsStatusEnum} [status] 
     * @param {string} [dateFrom] ISO 8601, inclusive lower bound on createdAt.
     * @param {string} [dateTo] ISO 8601, exclusive upper bound on createdAt.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAIExtractionsApi
     */
    public adminListAiExtractions(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListAiExtractionsSortOrderEnum, kind?: AdminListAiExtractionsKindEnum, userId?: string, status?: AdminListAiExtractionsStatusEnum, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig) {
        return AdminAIExtractionsApiFp(this.configuration).adminListAiExtractions(page, pageSize, search, sortBy, sortOrder, kind, userId, status, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminListAiExtractionsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminListAiExtractionsSortOrderEnum = typeof AdminListAiExtractionsSortOrderEnum[keyof typeof AdminListAiExtractionsSortOrderEnum];
/**
 * @export
 */
export const AdminListAiExtractionsKindEnum = {
    Datasheet: 'datasheet'
} as const;
export type AdminListAiExtractionsKindEnum = typeof AdminListAiExtractionsKindEnum[keyof typeof AdminListAiExtractionsKindEnum];
/**
 * @export
 */
export const AdminListAiExtractionsStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Failed: 'failed'
} as const;
export type AdminListAiExtractionsStatusEnum = typeof AdminListAiExtractionsStatusEnum[keyof typeof AdminListAiExtractionsStatusEnum];


/**
 * AdminAuditLogApi - axios parameter creator
 * @export
 */
export const AdminAuditLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List audit log entries (US-A-025)
         * @param {AuditLogQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAuditLogs: async (query?: AuditLogQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAuditLogApi - functional programming interface
 * @export
 */
export const AdminAuditLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAuditLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List audit log entries (US-A-025)
         * @param {AuditLogQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListAuditLogs(query?: AuditLogQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListAuditLogs(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuditLogApi.adminListAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAuditLogApi - factory interface
 * @export
 */
export const AdminAuditLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAuditLogApiFp(configuration)
    return {
        /**
         * 
         * @summary List audit log entries (US-A-025)
         * @param {AuditLogQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAuditLogs(query?: AuditLogQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminListAuditLogs(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAuditLogApi - object-oriented interface
 * @export
 * @class AdminAuditLogApi
 * @extends {BaseAPI}
 */
export class AdminAuditLogApi extends BaseAPI {
    /**
     * 
     * @summary List audit log entries (US-A-025)
     * @param {AuditLogQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuditLogApi
     */
    public adminListAuditLogs(query?: AuditLogQueryDto, options?: RawAxiosRequestConfig) {
        return AdminAuditLogApiFp(this.configuration).adminListAuditLogs(query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminBrandsApi - axios parameter creator
 * @export
 */
export const AdminBrandsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a brand
         * @param {CreateBrandDto} createBrandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateBrand: async (createBrandDto: CreateBrandDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBrandDto' is not null or undefined
            assertParamExists('adminCreateBrand', 'createBrandDto', createBrandDto)
            const localVarPath = `/api/v1/admin/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBrandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a brand
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteBrand: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteBrand', 'id', id)
            const localVarPath = `/api/v1/admin/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a brand
         * @param {number} id 
         * @param {UpdateBrandDto} updateBrandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateBrand: async (id: number, updateBrandDto: UpdateBrandDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateBrand', 'id', id)
            // verify required parameter 'updateBrandDto' is not null or undefined
            assertParamExists('adminUpdateBrand', 'updateBrandDto', updateBrandDto)
            const localVarPath = `/api/v1/admin/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBrandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminBrandsApi - functional programming interface
 * @export
 */
export const AdminBrandsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminBrandsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a brand
         * @param {CreateBrandDto} createBrandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateBrand(createBrandDto: CreateBrandDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateBrand(createBrandDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBrandsApi.adminCreateBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a brand
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteBrand(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBrandsApi.adminDeleteBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a brand
         * @param {number} id 
         * @param {UpdateBrandDto} updateBrandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateBrand(id: number, updateBrandDto: UpdateBrandDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateBrand(id, updateBrandDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBrandsApi.adminUpdateBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminBrandsApi - factory interface
 * @export
 */
export const AdminBrandsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminBrandsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a brand
         * @param {CreateBrandDto} createBrandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateBrand(createBrandDto: CreateBrandDto, options?: RawAxiosRequestConfig): AxiosPromise<BrandDto> {
            return localVarFp.adminCreateBrand(createBrandDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a brand
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteBrand(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a brand
         * @param {number} id 
         * @param {UpdateBrandDto} updateBrandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateBrand(id: number, updateBrandDto: UpdateBrandDto, options?: RawAxiosRequestConfig): AxiosPromise<BrandDto> {
            return localVarFp.adminUpdateBrand(id, updateBrandDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminBrandsApi - object-oriented interface
 * @export
 * @class AdminBrandsApi
 * @extends {BaseAPI}
 */
export class AdminBrandsApi extends BaseAPI {
    /**
     * 
     * @summary Create a brand
     * @param {CreateBrandDto} createBrandDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBrandsApi
     */
    public adminCreateBrand(createBrandDto: CreateBrandDto, options?: RawAxiosRequestConfig) {
        return AdminBrandsApiFp(this.configuration).adminCreateBrand(createBrandDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a brand
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBrandsApi
     */
    public adminDeleteBrand(id: number, options?: RawAxiosRequestConfig) {
        return AdminBrandsApiFp(this.configuration).adminDeleteBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a brand
     * @param {number} id 
     * @param {UpdateBrandDto} updateBrandDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBrandsApi
     */
    public adminUpdateBrand(id: number, updateBrandDto: UpdateBrandDto, options?: RawAxiosRequestConfig) {
        return AdminBrandsApiFp(this.configuration).adminUpdateBrand(id, updateBrandDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCategoriesApi - axios parameter creator
 * @export
 */
export const AdminCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a category
         * @param {CreateCategoryDto} createCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCategory: async (createCategoryDto: CreateCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCategoryDto' is not null or undefined
            assertParamExists('adminCreateCategory', 'createCategoryDto', createCategoryDto)
            const localVarPath = `/api/v1/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a category
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCategory: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteCategory', 'id', id)
            const localVarPath = `/api/v1/admin/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get per-category field policy (own + effective + provenance)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCategoryFieldConfig: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetCategoryFieldConfig', 'id', id)
            const localVarPath = `/api/v1/admin/categories/{id}/field-config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a category
         * @param {number} id 
         * @param {UpdateCategoryDto} updateCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCategory: async (id: number, updateCategoryDto: UpdateCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateCategory', 'id', id)
            // verify required parameter 'updateCategoryDto' is not null or undefined
            assertParamExists('adminUpdateCategory', 'updateCategoryDto', updateCategoryDto)
            const localVarPath = `/api/v1/admin/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCategoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update per-category field policy overrides
         * @param {number} id 
         * @param {UpdateCategoryFieldConfigDto} updateCategoryFieldConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCategoryFieldConfig: async (id: number, updateCategoryFieldConfigDto: UpdateCategoryFieldConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateCategoryFieldConfig', 'id', id)
            // verify required parameter 'updateCategoryFieldConfigDto' is not null or undefined
            assertParamExists('adminUpdateCategoryFieldConfig', 'updateCategoryFieldConfigDto', updateCategoryFieldConfigDto)
            const localVarPath = `/api/v1/admin/categories/{id}/field-config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCategoryFieldConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCategoriesApi - functional programming interface
 * @export
 */
export const AdminCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a category
         * @param {CreateCategoryDto} createCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateCategory(createCategoryDto: CreateCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateCategory(createCategoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminCreateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a category
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteCategory(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteCategory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminDeleteCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get per-category field policy (own + effective + provenance)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetCategoryFieldConfig(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryFieldConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetCategoryFieldConfig(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminGetCategoryFieldConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a category
         * @param {number} id 
         * @param {UpdateCategoryDto} updateCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateCategory(id: number, updateCategoryDto: UpdateCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateCategory(id, updateCategoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminUpdateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update per-category field policy overrides
         * @param {number} id 
         * @param {UpdateCategoryFieldConfigDto} updateCategoryFieldConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateCategoryFieldConfig(id: number, updateCategoryFieldConfigDto: UpdateCategoryFieldConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateCategoryFieldConfig(id, updateCategoryFieldConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminUpdateCategoryFieldConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCategoriesApi - factory interface
 * @export
 */
export const AdminCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a category
         * @param {CreateCategoryDto} createCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCategory(createCategoryDto: CreateCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDto> {
            return localVarFp.adminCreateCategory(createCategoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a category
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCategory(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteCategory(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get per-category field policy (own + effective + provenance)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCategoryFieldConfig(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CategoryFieldConfigDto> {
            return localVarFp.adminGetCategoryFieldConfig(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a category
         * @param {number} id 
         * @param {UpdateCategoryDto} updateCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCategory(id: number, updateCategoryDto: UpdateCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDto> {
            return localVarFp.adminUpdateCategory(id, updateCategoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update per-category field policy overrides
         * @param {number} id 
         * @param {UpdateCategoryFieldConfigDto} updateCategoryFieldConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCategoryFieldConfig(id: number, updateCategoryFieldConfigDto: UpdateCategoryFieldConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminUpdateCategoryFieldConfig(id, updateCategoryFieldConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCategoriesApi - object-oriented interface
 * @export
 * @class AdminCategoriesApi
 * @extends {BaseAPI}
 */
export class AdminCategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Create a category
     * @param {CreateCategoryDto} createCategoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoriesApi
     */
    public adminCreateCategory(createCategoryDto: CreateCategoryDto, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminCreateCategory(createCategoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a category
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoriesApi
     */
    public adminDeleteCategory(id: number, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminDeleteCategory(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get per-category field policy (own + effective + provenance)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoriesApi
     */
    public adminGetCategoryFieldConfig(id: number, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminGetCategoryFieldConfig(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a category
     * @param {number} id 
     * @param {UpdateCategoryDto} updateCategoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoriesApi
     */
    public adminUpdateCategory(id: number, updateCategoryDto: UpdateCategoryDto, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminUpdateCategory(id, updateCategoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update per-category field policy overrides
     * @param {number} id 
     * @param {UpdateCategoryFieldConfigDto} updateCategoryFieldConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoriesApi
     */
    public adminUpdateCategoryFieldConfig(id: number, updateCategoryFieldConfigDto: UpdateCategoryFieldConfigDto, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminUpdateCategoryFieldConfig(id, updateCategoryFieldConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminChangeRequestsApi - axios parameter creator
 * @export
 */
export const AdminChangeRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a change request by ID (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetChangeRequest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetChangeRequest', 'id', id)
            const localVarPath = `/api/v1/admin/change-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all change requests (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListChangeRequests: async (query?: DocumentsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/change-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated users together with all their change requests, sorted by pending count descending — matches the admin triage pattern used for documents and product requests.
         * @summary List change requests grouped by submitter (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllGroupedByUser: async (query?: DocumentsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/change-requests/grouped-by-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Review (approve / reject / request changes) a pending change request
         * @param {string} id 
         * @param {ReviewChangeRequestDto} reviewChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        review: async (id: string, reviewChangeRequestDto: ReviewChangeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('review', 'id', id)
            // verify required parameter 'reviewChangeRequestDto' is not null or undefined
            assertParamExists('review', 'reviewChangeRequestDto', reviewChangeRequestDto)
            const localVarPath = `/api/v1/admin/change-requests/{id}/review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewChangeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminChangeRequestsApi - functional programming interface
 * @export
 */
export const AdminChangeRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminChangeRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a change request by ID (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetChangeRequest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetChangeRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminChangeRequestsApi.adminGetChangeRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all change requests (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListChangeRequests(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListChangeRequests(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminChangeRequestsApi.adminListChangeRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated users together with all their change requests, sorted by pending count descending — matches the admin triage pattern used for documents and product requests.
         * @summary List change requests grouped by submitter (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersChangeRequestsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllGroupedByUser(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminChangeRequestsApi.findAllGroupedByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Review (approve / reject / request changes) a pending change request
         * @param {string} id 
         * @param {ReviewChangeRequestDto} reviewChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async review(id: string, reviewChangeRequestDto: ReviewChangeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.review(id, reviewChangeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminChangeRequestsApi.review']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminChangeRequestsApi - factory interface
 * @export
 */
export const AdminChangeRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminChangeRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a change request by ID (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetChangeRequest(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestDto> {
            return localVarFp.adminGetChangeRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all change requests (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListChangeRequests(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestsResponseDto> {
            return localVarFp.adminListChangeRequests(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated users together with all their change requests, sorted by pending count descending — matches the admin triage pattern used for documents and product requests.
         * @summary List change requests grouped by submitter (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<UsersChangeRequestsResponseDto> {
            return localVarFp.findAllGroupedByUser(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Review (approve / reject / request changes) a pending change request
         * @param {string} id 
         * @param {ReviewChangeRequestDto} reviewChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        review(id: string, reviewChangeRequestDto: ReviewChangeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestDto> {
            return localVarFp.review(id, reviewChangeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminChangeRequestsApi - object-oriented interface
 * @export
 * @class AdminChangeRequestsApi
 * @extends {BaseAPI}
 */
export class AdminChangeRequestsApi extends BaseAPI {
    /**
     * 
     * @summary Get a change request by ID (admin only)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminChangeRequestsApi
     */
    public adminGetChangeRequest(id: string, options?: RawAxiosRequestConfig) {
        return AdminChangeRequestsApiFp(this.configuration).adminGetChangeRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all change requests (admin only)
     * @param {DocumentsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminChangeRequestsApi
     */
    public adminListChangeRequests(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig) {
        return AdminChangeRequestsApiFp(this.configuration).adminListChangeRequests(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated users together with all their change requests, sorted by pending count descending — matches the admin triage pattern used for documents and product requests.
     * @summary List change requests grouped by submitter (admin only)
     * @param {DocumentsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminChangeRequestsApi
     */
    public findAllGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig) {
        return AdminChangeRequestsApiFp(this.configuration).findAllGroupedByUser(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Review (approve / reject / request changes) a pending change request
     * @param {string} id 
     * @param {ReviewChangeRequestDto} reviewChangeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminChangeRequestsApi
     */
    public review(id: string, reviewChangeRequestDto: ReviewChangeRequestDto, options?: RawAxiosRequestConfig) {
        return AdminChangeRequestsApiFp(this.configuration).review(id, reviewChangeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDeliveryAlertsApi - axios parameter creator
 * @export
 */
export const AdminDeliveryAlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get delivery alert counts by type (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDeliveryAlertStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/delivery-alerts/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List at-risk and breached deliveries (admin)
         * @param {DeliveryAlertQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListDeliveryAlerts: async (query?: DeliveryAlertQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/delivery-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDeliveryAlertsApi - functional programming interface
 * @export
 */
export const AdminDeliveryAlertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDeliveryAlertsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get delivery alert counts by type (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetDeliveryAlertStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryAlertStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetDeliveryAlertStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryAlertsApi.adminGetDeliveryAlertStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List at-risk and breached deliveries (admin)
         * @param {DeliveryAlertQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListDeliveryAlerts(query?: DeliveryAlertQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListDeliveryAlerts(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryAlertsApi.adminListDeliveryAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDeliveryAlertsApi - factory interface
 * @export
 */
export const AdminDeliveryAlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDeliveryAlertsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get delivery alert counts by type (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDeliveryAlertStats(options?: RawAxiosRequestConfig): AxiosPromise<DeliveryAlertStatsDto> {
            return localVarFp.adminGetDeliveryAlertStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List at-risk and breached deliveries (admin)
         * @param {DeliveryAlertQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListDeliveryAlerts(query?: DeliveryAlertQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminListDeliveryAlerts(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDeliveryAlertsApi - object-oriented interface
 * @export
 * @class AdminDeliveryAlertsApi
 * @extends {BaseAPI}
 */
export class AdminDeliveryAlertsApi extends BaseAPI {
    /**
     * 
     * @summary Get delivery alert counts by type (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryAlertsApi
     */
    public adminGetDeliveryAlertStats(options?: RawAxiosRequestConfig) {
        return AdminDeliveryAlertsApiFp(this.configuration).adminGetDeliveryAlertStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List at-risk and breached deliveries (admin)
     * @param {DeliveryAlertQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryAlertsApi
     */
    public adminListDeliveryAlerts(query?: DeliveryAlertQueryDto, options?: RawAxiosRequestConfig) {
        return AdminDeliveryAlertsApiFp(this.configuration).adminListDeliveryAlerts(query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFeaturedDealsApi - axios parameter creator
 * @export
 */
export const AdminFeaturedDealsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a product to the Deal of the Week list
         * @param {CreateFeaturedDealDto} createFeaturedDealDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddFeaturedDeal: async (createFeaturedDealDto: CreateFeaturedDealDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFeaturedDealDto' is not null or undefined
            assertParamExists('adminAddFeaturedDeal', 'createFeaturedDealDto', createFeaturedDealDto)
            const localVarPath = `/api/v1/admin/featured-deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeaturedDealDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all featured deals (admin view)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListFeaturedDeals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/featured-deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a product from the Deal of the Week list
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveFeaturedDeal: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminRemoveFeaturedDeal', 'id', id)
            const localVarPath = `/api/v1/admin/featured-deals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder the Deal of the Week list
         * @param {ReorderFeaturedDealsDto} reorderFeaturedDealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReorderFeaturedDeals: async (reorderFeaturedDealsDto: ReorderFeaturedDealsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reorderFeaturedDealsDto' is not null or undefined
            assertParamExists('adminReorderFeaturedDeals', 'reorderFeaturedDealsDto', reorderFeaturedDealsDto)
            const localVarPath = `/api/v1/admin/featured-deals/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderFeaturedDealsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFeaturedDealsApi - functional programming interface
 * @export
 */
export const AdminFeaturedDealsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFeaturedDealsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a product to the Deal of the Week list
         * @param {CreateFeaturedDealDto} createFeaturedDealDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAddFeaturedDeal(createFeaturedDealDto: CreateFeaturedDealDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeaturedDealDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAddFeaturedDeal(createFeaturedDealDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeaturedDealsApi.adminAddFeaturedDeal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all featured deals (admin view)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListFeaturedDeals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeaturedDealDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListFeaturedDeals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeaturedDealsApi.adminListFeaturedDeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a product from the Deal of the Week list
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRemoveFeaturedDeal(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRemoveFeaturedDeal(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeaturedDealsApi.adminRemoveFeaturedDeal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reorder the Deal of the Week list
         * @param {ReorderFeaturedDealsDto} reorderFeaturedDealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminReorderFeaturedDeals(reorderFeaturedDealsDto: ReorderFeaturedDealsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeaturedDealDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminReorderFeaturedDeals(reorderFeaturedDealsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeaturedDealsApi.adminReorderFeaturedDeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFeaturedDealsApi - factory interface
 * @export
 */
export const AdminFeaturedDealsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFeaturedDealsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a product to the Deal of the Week list
         * @param {CreateFeaturedDealDto} createFeaturedDealDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddFeaturedDeal(createFeaturedDealDto: CreateFeaturedDealDto, options?: RawAxiosRequestConfig): AxiosPromise<FeaturedDealDto> {
            return localVarFp.adminAddFeaturedDeal(createFeaturedDealDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all featured deals (admin view)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListFeaturedDeals(options?: RawAxiosRequestConfig): AxiosPromise<Array<FeaturedDealDto>> {
            return localVarFp.adminListFeaturedDeals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a product from the Deal of the Week list
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveFeaturedDeal(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRemoveFeaturedDeal(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder the Deal of the Week list
         * @param {ReorderFeaturedDealsDto} reorderFeaturedDealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReorderFeaturedDeals(reorderFeaturedDealsDto: ReorderFeaturedDealsDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeaturedDealDto>> {
            return localVarFp.adminReorderFeaturedDeals(reorderFeaturedDealsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFeaturedDealsApi - object-oriented interface
 * @export
 * @class AdminFeaturedDealsApi
 * @extends {BaseAPI}
 */
export class AdminFeaturedDealsApi extends BaseAPI {
    /**
     * 
     * @summary Add a product to the Deal of the Week list
     * @param {CreateFeaturedDealDto} createFeaturedDealDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeaturedDealsApi
     */
    public adminAddFeaturedDeal(createFeaturedDealDto: CreateFeaturedDealDto, options?: RawAxiosRequestConfig) {
        return AdminFeaturedDealsApiFp(this.configuration).adminAddFeaturedDeal(createFeaturedDealDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all featured deals (admin view)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeaturedDealsApi
     */
    public adminListFeaturedDeals(options?: RawAxiosRequestConfig) {
        return AdminFeaturedDealsApiFp(this.configuration).adminListFeaturedDeals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a product from the Deal of the Week list
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeaturedDealsApi
     */
    public adminRemoveFeaturedDeal(id: number, options?: RawAxiosRequestConfig) {
        return AdminFeaturedDealsApiFp(this.configuration).adminRemoveFeaturedDeal(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder the Deal of the Week list
     * @param {ReorderFeaturedDealsDto} reorderFeaturedDealsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeaturedDealsApi
     */
    public adminReorderFeaturedDeals(reorderFeaturedDealsDto: ReorderFeaturedDealsDto, options?: RawAxiosRequestConfig) {
        return AdminFeaturedDealsApiFp(this.configuration).adminReorderFeaturedDeals(reorderFeaturedDealsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminInternalDeliveryRateCardApi - axios parameter creator
 * @export
 */
export const AdminInternalDeliveryRateCardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get internal delivery rate card (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalDeliveryRateCardConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/internal-delivery-rate-card/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Procurtal-owned delivery cost rate card. Buyer-facing checkout stays delivery-included.
         * @summary Update internal delivery rate card (admin only)
         * @param {UpdateInternalDeliveryRateCardDto} updateInternalDeliveryRateCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInternalDeliveryRateCardConfig: async (updateInternalDeliveryRateCardDto: UpdateInternalDeliveryRateCardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateInternalDeliveryRateCardDto' is not null or undefined
            assertParamExists('updateInternalDeliveryRateCardConfig', 'updateInternalDeliveryRateCardDto', updateInternalDeliveryRateCardDto)
            const localVarPath = `/api/v1/admin/internal-delivery-rate-card/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInternalDeliveryRateCardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used after reconciliation. Shipment confirmation does not set cost.
         * @summary Record internal delivery cost for a shipment (admin only)
         * @param {number} pickingId Odoo stock.picking ID
         * @param {UpsertInternalDeliveryCostDto} upsertInternalDeliveryCostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertInternalDeliveryCost: async (pickingId: number, upsertInternalDeliveryCostDto: UpsertInternalDeliveryCostDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pickingId' is not null or undefined
            assertParamExists('upsertInternalDeliveryCost', 'pickingId', pickingId)
            // verify required parameter 'upsertInternalDeliveryCostDto' is not null or undefined
            assertParamExists('upsertInternalDeliveryCost', 'upsertInternalDeliveryCostDto', upsertInternalDeliveryCostDto)
            const localVarPath = `/api/v1/admin/internal-delivery-rate-card/costs/{pickingId}`
                .replace(`{${"pickingId"}}`, encodeURIComponent(String(pickingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertInternalDeliveryCostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminInternalDeliveryRateCardApi - functional programming interface
 * @export
 */
export const AdminInternalDeliveryRateCardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminInternalDeliveryRateCardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get internal delivery rate card (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInternalDeliveryRateCardConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalDeliveryRateCardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInternalDeliveryRateCardConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminInternalDeliveryRateCardApi.getInternalDeliveryRateCardConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Procurtal-owned delivery cost rate card. Buyer-facing checkout stays delivery-included.
         * @summary Update internal delivery rate card (admin only)
         * @param {UpdateInternalDeliveryRateCardDto} updateInternalDeliveryRateCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInternalDeliveryRateCardConfig(updateInternalDeliveryRateCardDto: UpdateInternalDeliveryRateCardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalDeliveryRateCardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInternalDeliveryRateCardConfig(updateInternalDeliveryRateCardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminInternalDeliveryRateCardApi.updateInternalDeliveryRateCardConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used after reconciliation. Shipment confirmation does not set cost.
         * @summary Record internal delivery cost for a shipment (admin only)
         * @param {number} pickingId Odoo stock.picking ID
         * @param {UpsertInternalDeliveryCostDto} upsertInternalDeliveryCostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertInternalDeliveryCost(pickingId: number, upsertInternalDeliveryCostDto: UpsertInternalDeliveryCostDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalDeliveryCostRecordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertInternalDeliveryCost(pickingId, upsertInternalDeliveryCostDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminInternalDeliveryRateCardApi.upsertInternalDeliveryCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminInternalDeliveryRateCardApi - factory interface
 * @export
 */
export const AdminInternalDeliveryRateCardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminInternalDeliveryRateCardApiFp(configuration)
    return {
        /**
         * 
         * @summary Get internal delivery rate card (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalDeliveryRateCardConfig(options?: RawAxiosRequestConfig): AxiosPromise<InternalDeliveryRateCardDto> {
            return localVarFp.getInternalDeliveryRateCardConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * Procurtal-owned delivery cost rate card. Buyer-facing checkout stays delivery-included.
         * @summary Update internal delivery rate card (admin only)
         * @param {UpdateInternalDeliveryRateCardDto} updateInternalDeliveryRateCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInternalDeliveryRateCardConfig(updateInternalDeliveryRateCardDto: UpdateInternalDeliveryRateCardDto, options?: RawAxiosRequestConfig): AxiosPromise<InternalDeliveryRateCardDto> {
            return localVarFp.updateInternalDeliveryRateCardConfig(updateInternalDeliveryRateCardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Used after reconciliation. Shipment confirmation does not set cost.
         * @summary Record internal delivery cost for a shipment (admin only)
         * @param {number} pickingId Odoo stock.picking ID
         * @param {UpsertInternalDeliveryCostDto} upsertInternalDeliveryCostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertInternalDeliveryCost(pickingId: number, upsertInternalDeliveryCostDto: UpsertInternalDeliveryCostDto, options?: RawAxiosRequestConfig): AxiosPromise<InternalDeliveryCostRecordDto> {
            return localVarFp.upsertInternalDeliveryCost(pickingId, upsertInternalDeliveryCostDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminInternalDeliveryRateCardApi - object-oriented interface
 * @export
 * @class AdminInternalDeliveryRateCardApi
 * @extends {BaseAPI}
 */
export class AdminInternalDeliveryRateCardApi extends BaseAPI {
    /**
     * 
     * @summary Get internal delivery rate card (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInternalDeliveryRateCardApi
     */
    public getInternalDeliveryRateCardConfig(options?: RawAxiosRequestConfig) {
        return AdminInternalDeliveryRateCardApiFp(this.configuration).getInternalDeliveryRateCardConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Procurtal-owned delivery cost rate card. Buyer-facing checkout stays delivery-included.
     * @summary Update internal delivery rate card (admin only)
     * @param {UpdateInternalDeliveryRateCardDto} updateInternalDeliveryRateCardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInternalDeliveryRateCardApi
     */
    public updateInternalDeliveryRateCardConfig(updateInternalDeliveryRateCardDto: UpdateInternalDeliveryRateCardDto, options?: RawAxiosRequestConfig) {
        return AdminInternalDeliveryRateCardApiFp(this.configuration).updateInternalDeliveryRateCardConfig(updateInternalDeliveryRateCardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used after reconciliation. Shipment confirmation does not set cost.
     * @summary Record internal delivery cost for a shipment (admin only)
     * @param {number} pickingId Odoo stock.picking ID
     * @param {UpsertInternalDeliveryCostDto} upsertInternalDeliveryCostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInternalDeliveryRateCardApi
     */
    public upsertInternalDeliveryCost(pickingId: number, upsertInternalDeliveryCostDto: UpsertInternalDeliveryCostDto, options?: RawAxiosRequestConfig) {
        return AdminInternalDeliveryRateCardApiFp(this.configuration).upsertInternalDeliveryCost(pickingId, upsertInternalDeliveryCostDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminLoyaltyApi - axios parameter creator
 * @export
 */
export const AdminLoyaltyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a loyalty promotion (admin only)
         * @param {CreateLoyaltyPromotionDto} createLoyaltyPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateLoyaltyPromotion: async (createLoyaltyPromotionDto: CreateLoyaltyPromotionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLoyaltyPromotionDto' is not null or undefined
            assertParamExists('adminCreateLoyaltyPromotion', 'createLoyaltyPromotionDto', createLoyaltyPromotionDto)
            const localVarPath = `/api/v1/admin/loyalty/promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLoyaltyPromotionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a loyalty promotion (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteLoyaltyPromotion: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteLoyaltyPromotion', 'id', id)
            const localVarPath = `/api/v1/admin/loyalty/promotions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get loyalty configuration (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLoyaltyConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/loyalty/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all loyalty promotions (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLoyaltyPromotions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/loyalty/promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a loyalty promotion (admin only)
         * @param {string} id 
         * @param {UpdateLoyaltyPromotionDto} updateLoyaltyPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateLoyaltyPromotion: async (id: string, updateLoyaltyPromotionDto: UpdateLoyaltyPromotionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateLoyaltyPromotion', 'id', id)
            // verify required parameter 'updateLoyaltyPromotionDto' is not null or undefined
            assertParamExists('adminUpdateLoyaltyPromotion', 'updateLoyaltyPromotionDto', updateLoyaltyPromotionDto)
            const localVarPath = `/api/v1/admin/loyalty/promotions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoyaltyPromotionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of redemptions across all users, including the linked Odoo sale.order id when the redemption was made at checkout.
         * @summary List all loyalty redemptions (admin only)
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRedemptions: async (query?: LoyaltyPointsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/loyalty/redemptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of loyalty point transactions across all users, including user details
         * @summary List all loyalty point transactions (admin only)
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTransactions: async (query?: LoyaltyPointsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/loyalty/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns time-series and summary analytics for loyalty program performance within a date range
         * @summary Get loyalty analytics (admin only)
         * @param {string} [startDate] Start date (ISO YYYY-MM-DD)
         * @param {string} [endDate] End date (ISO YYYY-MM-DD)
         * @param {GetAnalyticsGranularityEnum} [granularity] Time-series granularity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalytics: async (startDate?: string, endDate?: string, granularity?: GetAnalyticsGranularityEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/loyalty/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns aggregate loyalty stats: total points issued, active members, points redeemed
         * @summary Get loyalty stats (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/loyalty/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update points per 100 units of currency and validity days for loyalty points
         * @summary Update loyalty configuration (admin only)
         * @param {UpdateLoyaltyConfigDto} updateLoyaltyConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfig: async (updateLoyaltyConfigDto: UpdateLoyaltyConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateLoyaltyConfigDto' is not null or undefined
            assertParamExists('updateConfig', 'updateLoyaltyConfigDto', updateLoyaltyConfigDto)
            const localVarPath = `/api/v1/admin/loyalty/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoyaltyConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminLoyaltyApi - functional programming interface
 * @export
 */
export const AdminLoyaltyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminLoyaltyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a loyalty promotion (admin only)
         * @param {CreateLoyaltyPromotionDto} createLoyaltyPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateLoyaltyPromotion(createLoyaltyPromotionDto: CreateLoyaltyPromotionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyPromotionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateLoyaltyPromotion(createLoyaltyPromotionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.adminCreateLoyaltyPromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a loyalty promotion (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteLoyaltyPromotion(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteLoyaltyPromotion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.adminDeleteLoyaltyPromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get loyalty configuration (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetLoyaltyConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetLoyaltyConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.adminGetLoyaltyConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all loyalty promotions (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetLoyaltyPromotions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoyaltyPromotionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetLoyaltyPromotions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.adminGetLoyaltyPromotions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a loyalty promotion (admin only)
         * @param {string} id 
         * @param {UpdateLoyaltyPromotionDto} updateLoyaltyPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateLoyaltyPromotion(id: string, updateLoyaltyPromotionDto: UpdateLoyaltyPromotionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyPromotionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateLoyaltyPromotion(id, updateLoyaltyPromotionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.adminUpdateLoyaltyPromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of redemptions across all users, including the linked Odoo sale.order id when the redemption was made at checkout.
         * @summary List all loyalty redemptions (admin only)
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRedemptions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRedemptions(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.getAllRedemptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of loyalty point transactions across all users, including user details
         * @summary List all loyalty point transactions (admin only)
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTransactions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLoyaltyTransactionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTransactions(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.getAllTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns time-series and summary analytics for loyalty program performance within a date range
         * @summary Get loyalty analytics (admin only)
         * @param {string} [startDate] Start date (ISO YYYY-MM-DD)
         * @param {string} [endDate] End date (ISO YYYY-MM-DD)
         * @param {GetAnalyticsGranularityEnum} [granularity] Time-series granularity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalytics(startDate?: string, endDate?: string, granularity?: GetAnalyticsGranularityEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyAnalyticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalytics(startDate, endDate, granularity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.getAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns aggregate loyalty stats: total points issued, active members, points redeemed
         * @summary Get loyalty stats (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.getStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update points per 100 units of currency and validity days for loyalty points
         * @summary Update loyalty configuration (admin only)
         * @param {UpdateLoyaltyConfigDto} updateLoyaltyConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfig(updateLoyaltyConfigDto: UpdateLoyaltyConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfig(updateLoyaltyConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoyaltyApi.updateConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminLoyaltyApi - factory interface
 * @export
 */
export const AdminLoyaltyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminLoyaltyApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a loyalty promotion (admin only)
         * @param {CreateLoyaltyPromotionDto} createLoyaltyPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateLoyaltyPromotion(createLoyaltyPromotionDto: CreateLoyaltyPromotionDto, options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyPromotionDto> {
            return localVarFp.adminCreateLoyaltyPromotion(createLoyaltyPromotionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a loyalty promotion (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteLoyaltyPromotion(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteLoyaltyPromotion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get loyalty configuration (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLoyaltyConfig(options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyConfigDto> {
            return localVarFp.adminGetLoyaltyConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all loyalty promotions (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLoyaltyPromotions(options?: RawAxiosRequestConfig): AxiosPromise<Array<LoyaltyPromotionDto>> {
            return localVarFp.adminGetLoyaltyPromotions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a loyalty promotion (admin only)
         * @param {string} id 
         * @param {UpdateLoyaltyPromotionDto} updateLoyaltyPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateLoyaltyPromotion(id: string, updateLoyaltyPromotionDto: UpdateLoyaltyPromotionDto, options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyPromotionDto> {
            return localVarFp.adminUpdateLoyaltyPromotion(id, updateLoyaltyPromotionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of redemptions across all users, including the linked Odoo sale.order id when the redemption was made at checkout.
         * @summary List all loyalty redemptions (admin only)
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRedemptions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAllRedemptions(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of loyalty point transactions across all users, including user details
         * @summary List all loyalty point transactions (admin only)
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTransactions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<AdminLoyaltyTransactionsResponseDto> {
            return localVarFp.getAllTransactions(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns time-series and summary analytics for loyalty program performance within a date range
         * @summary Get loyalty analytics (admin only)
         * @param {string} [startDate] Start date (ISO YYYY-MM-DD)
         * @param {string} [endDate] End date (ISO YYYY-MM-DD)
         * @param {GetAnalyticsGranularityEnum} [granularity] Time-series granularity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalytics(startDate?: string, endDate?: string, granularity?: GetAnalyticsGranularityEnum, options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyAnalyticsDto> {
            return localVarFp.getAnalytics(startDate, endDate, granularity, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns aggregate loyalty stats: total points issued, active members, points redeemed
         * @summary Get loyalty stats (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats(options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyStatsDto> {
            return localVarFp.getStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Update points per 100 units of currency and validity days for loyalty points
         * @summary Update loyalty configuration (admin only)
         * @param {UpdateLoyaltyConfigDto} updateLoyaltyConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfig(updateLoyaltyConfigDto: UpdateLoyaltyConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyConfigDto> {
            return localVarFp.updateConfig(updateLoyaltyConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminLoyaltyApi - object-oriented interface
 * @export
 * @class AdminLoyaltyApi
 * @extends {BaseAPI}
 */
export class AdminLoyaltyApi extends BaseAPI {
    /**
     * 
     * @summary Create a loyalty promotion (admin only)
     * @param {CreateLoyaltyPromotionDto} createLoyaltyPromotionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public adminCreateLoyaltyPromotion(createLoyaltyPromotionDto: CreateLoyaltyPromotionDto, options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).adminCreateLoyaltyPromotion(createLoyaltyPromotionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a loyalty promotion (admin only)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public adminDeleteLoyaltyPromotion(id: string, options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).adminDeleteLoyaltyPromotion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get loyalty configuration (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public adminGetLoyaltyConfig(options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).adminGetLoyaltyConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all loyalty promotions (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public adminGetLoyaltyPromotions(options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).adminGetLoyaltyPromotions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a loyalty promotion (admin only)
     * @param {string} id 
     * @param {UpdateLoyaltyPromotionDto} updateLoyaltyPromotionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public adminUpdateLoyaltyPromotion(id: string, updateLoyaltyPromotionDto: UpdateLoyaltyPromotionDto, options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).adminUpdateLoyaltyPromotion(id, updateLoyaltyPromotionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of redemptions across all users, including the linked Odoo sale.order id when the redemption was made at checkout.
     * @summary List all loyalty redemptions (admin only)
     * @param {LoyaltyPointsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public getAllRedemptions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).getAllRedemptions(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of loyalty point transactions across all users, including user details
     * @summary List all loyalty point transactions (admin only)
     * @param {LoyaltyPointsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public getAllTransactions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).getAllTransactions(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns time-series and summary analytics for loyalty program performance within a date range
     * @summary Get loyalty analytics (admin only)
     * @param {string} [startDate] Start date (ISO YYYY-MM-DD)
     * @param {string} [endDate] End date (ISO YYYY-MM-DD)
     * @param {GetAnalyticsGranularityEnum} [granularity] Time-series granularity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public getAnalytics(startDate?: string, endDate?: string, granularity?: GetAnalyticsGranularityEnum, options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).getAnalytics(startDate, endDate, granularity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns aggregate loyalty stats: total points issued, active members, points redeemed
     * @summary Get loyalty stats (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public getStats(options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).getStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update points per 100 units of currency and validity days for loyalty points
     * @summary Update loyalty configuration (admin only)
     * @param {UpdateLoyaltyConfigDto} updateLoyaltyConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoyaltyApi
     */
    public updateConfig(updateLoyaltyConfigDto: UpdateLoyaltyConfigDto, options?: RawAxiosRequestConfig) {
        return AdminLoyaltyApiFp(this.configuration).updateConfig(updateLoyaltyConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAnalyticsGranularityEnum = {
    Week: 'week',
    Month: 'month'
} as const;
export type GetAnalyticsGranularityEnum = typeof GetAnalyticsGranularityEnum[keyof typeof GetAnalyticsGranularityEnum];


/**
 * AdminOrderDisputesApi - axios parameter creator
 * @export
 */
export const AdminOrderDisputesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Reply to an order dispute (admin)
         * @param {string} id 
         * @param {AddDisputeMessageDto} addDisputeMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddOrderDisputeMessage: async (id: string, addDisputeMessageDto: AddDisputeMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminAddOrderDisputeMessage', 'id', id)
            // verify required parameter 'addDisputeMessageDto' is not null or undefined
            assertParamExists('adminAddOrderDisputeMessage', 'addDisputeMessageDto', addDisputeMessageDto)
            const localVarPath = `/api/v1/admin/order-disputes/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDisputeMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get any order dispute detail (admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrderDisputeDetail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetOrderDisputeDetail', 'id', id)
            const localVarPath = `/api/v1/admin/order-disputes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get platform-wide order dispute statistics (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrderDisputeStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/order-disputes/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all order disputes (admin)
         * @param {OrderDisputeQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListOrderDisputes: async (query?: OrderDisputeQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/order-disputes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an order dispute status / resolution (admin)
         * @param {string} id 
         * @param {ResolveDisputeDto} resolveDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResolveOrderDispute: async (id: string, resolveDisputeDto: ResolveDisputeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminResolveOrderDispute', 'id', id)
            // verify required parameter 'resolveDisputeDto' is not null or undefined
            assertParamExists('adminResolveOrderDispute', 'resolveDisputeDto', resolveDisputeDto)
            const localVarPath = `/api/v1/admin/order-disputes/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveDisputeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrderDisputesApi - functional programming interface
 * @export
 */
export const AdminOrderDisputesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrderDisputesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Reply to an order dispute (admin)
         * @param {string} id 
         * @param {AddDisputeMessageDto} addDisputeMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAddOrderDisputeMessage(id: string, addDisputeMessageDto: AddDisputeMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDisputeMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAddOrderDisputeMessage(id, addDisputeMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDisputesApi.adminAddOrderDisputeMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get any order dispute detail (admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetOrderDisputeDetail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDisputeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetOrderDisputeDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDisputesApi.adminGetOrderDisputeDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get platform-wide order dispute statistics (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetOrderDisputeStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDisputeStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetOrderDisputeStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDisputesApi.adminGetOrderDisputeStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all order disputes (admin)
         * @param {OrderDisputeQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListOrderDisputes(query?: OrderDisputeQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListOrderDisputes(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDisputesApi.adminListOrderDisputes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an order dispute status / resolution (admin)
         * @param {string} id 
         * @param {ResolveDisputeDto} resolveDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminResolveOrderDispute(id: string, resolveDisputeDto: ResolveDisputeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDisputeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminResolveOrderDispute(id, resolveDisputeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDisputesApi.adminResolveOrderDispute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrderDisputesApi - factory interface
 * @export
 */
export const AdminOrderDisputesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrderDisputesApiFp(configuration)
    return {
        /**
         * 
         * @summary Reply to an order dispute (admin)
         * @param {string} id 
         * @param {AddDisputeMessageDto} addDisputeMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddOrderDisputeMessage(id: string, addDisputeMessageDto: AddDisputeMessageDto, options?: RawAxiosRequestConfig): AxiosPromise<OrderDisputeMessageDto> {
            return localVarFp.adminAddOrderDisputeMessage(id, addDisputeMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get any order dispute detail (admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrderDisputeDetail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderDisputeDto> {
            return localVarFp.adminGetOrderDisputeDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get platform-wide order dispute statistics (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrderDisputeStats(options?: RawAxiosRequestConfig): AxiosPromise<OrderDisputeStatsDto> {
            return localVarFp.adminGetOrderDisputeStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all order disputes (admin)
         * @param {OrderDisputeQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListOrderDisputes(query?: OrderDisputeQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminListOrderDisputes(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an order dispute status / resolution (admin)
         * @param {string} id 
         * @param {ResolveDisputeDto} resolveDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResolveOrderDispute(id: string, resolveDisputeDto: ResolveDisputeDto, options?: RawAxiosRequestConfig): AxiosPromise<OrderDisputeDto> {
            return localVarFp.adminResolveOrderDispute(id, resolveDisputeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOrderDisputesApi - object-oriented interface
 * @export
 * @class AdminOrderDisputesApi
 * @extends {BaseAPI}
 */
export class AdminOrderDisputesApi extends BaseAPI {
    /**
     * 
     * @summary Reply to an order dispute (admin)
     * @param {string} id 
     * @param {AddDisputeMessageDto} addDisputeMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDisputesApi
     */
    public adminAddOrderDisputeMessage(id: string, addDisputeMessageDto: AddDisputeMessageDto, options?: RawAxiosRequestConfig) {
        return AdminOrderDisputesApiFp(this.configuration).adminAddOrderDisputeMessage(id, addDisputeMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get any order dispute detail (admin)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDisputesApi
     */
    public adminGetOrderDisputeDetail(id: string, options?: RawAxiosRequestConfig) {
        return AdminOrderDisputesApiFp(this.configuration).adminGetOrderDisputeDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get platform-wide order dispute statistics (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDisputesApi
     */
    public adminGetOrderDisputeStats(options?: RawAxiosRequestConfig) {
        return AdminOrderDisputesApiFp(this.configuration).adminGetOrderDisputeStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all order disputes (admin)
     * @param {OrderDisputeQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDisputesApi
     */
    public adminListOrderDisputes(query?: OrderDisputeQueryDto, options?: RawAxiosRequestConfig) {
        return AdminOrderDisputesApiFp(this.configuration).adminListOrderDisputes(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an order dispute status / resolution (admin)
     * @param {string} id 
     * @param {ResolveDisputeDto} resolveDisputeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDisputesApi
     */
    public adminResolveOrderDispute(id: string, resolveDisputeDto: ResolveDisputeDto, options?: RawAxiosRequestConfig) {
        return AdminOrderDisputesApiFp(this.configuration).adminResolveOrderDispute(id, resolveDisputeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPaymentsApi - axios parameter creator
 * @export
 */
export const AdminPaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a single payment by ID (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPayment: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetPayment', 'id', id)
            const localVarPath = `/api/v1/admin/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns totalRevenue (inbound PAID), payoutsOutstanding (outbound DRAFT/POSTED), procurtalMargin (revenue minus released payouts), and profit. Optionally scoped by date range.
         * @summary Get admin dashboard stats (admin only)
         * @param {string} [startDate] Filter payments from this date (YYYY-MM-DD inclusive)
         * @param {string} [endDate] Filter payments up to this date (YYYY-MM-DD inclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetStats: async (startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/payments/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all payments recorded in the accounting system (Odoo account.payment). Supports filtering by direction (incoming/outgoing), partner type (customer/supplier), and partner ID.
         * @summary List all payments (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListPaymentsSortOrderEnum} [sortOrder] Sort order
         * @param {AdminListPaymentsDirectionEnum} [direction] 
         * @param {AdminListPaymentsPartnerTypeEnum} [partnerType] 
         * @param {number} [partnerId] Filter by Odoo res.partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListPayments: async (page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListPaymentsSortOrderEnum, direction?: AdminListPaymentsDirectionEnum, partnerType?: AdminListPaymentsPartnerTypeEnum, partnerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns posted vendor bills (account.move where move_type=in_invoice) for the given supplier that have not been fully paid.
         * @summary List unpaid vendor bills for a supplier (admin only)
         * @param {number} supplierId 
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListSupplierUnpaidBills: async (supplierId: number, query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('adminListSupplierUnpaidBills', 'supplierId', supplierId)
            const localVarPath = `/api/v1/admin/payments/suppliers/{supplierId}/unpaid-bills`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uses the accounting system to register a payment for a posted vendor bill. Defaults to the full outstanding balance if amount is omitted.
         * @summary Register a payment against a vendor bill (admin only)
         * @param {PayVendorBillDto} payVendorBillDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPayVendorBill: async (payVendorBillDto: PayVendorBillDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payVendorBillDto' is not null or undefined
            assertParamExists('adminPayVendorBill', 'payVendorBillDto', payVendorBillDto)
            const localVarPath = `/api/v1/admin/payments/vendor-bills/pay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payVendorBillDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPaymentsApi - functional programming interface
 * @export
 */
export const AdminPaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a single payment by ID (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetPayment(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetPayment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPaymentsApi.adminGetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns totalRevenue (inbound PAID), payoutsOutstanding (outbound DRAFT/POSTED), procurtalMargin (revenue minus released payouts), and profit. Optionally scoped by date range.
         * @summary Get admin dashboard stats (admin only)
         * @param {string} [startDate] Filter payments from this date (YYYY-MM-DD inclusive)
         * @param {string} [endDate] Filter payments up to this date (YYYY-MM-DD inclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetStats(startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetStats(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPaymentsApi.adminGetStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all payments recorded in the accounting system (Odoo account.payment). Supports filtering by direction (incoming/outgoing), partner type (customer/supplier), and partner ID.
         * @summary List all payments (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListPaymentsSortOrderEnum} [sortOrder] Sort order
         * @param {AdminListPaymentsDirectionEnum} [direction] 
         * @param {AdminListPaymentsPartnerTypeEnum} [partnerType] 
         * @param {number} [partnerId] Filter by Odoo res.partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListPayments(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListPaymentsSortOrderEnum, direction?: AdminListPaymentsDirectionEnum, partnerType?: AdminListPaymentsPartnerTypeEnum, partnerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListPayments(page, pageSize, search, sortBy, sortOrder, direction, partnerType, partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPaymentsApi.adminListPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns posted vendor bills (account.move where move_type=in_invoice) for the given supplier that have not been fully paid.
         * @summary List unpaid vendor bills for a supplier (admin only)
         * @param {number} supplierId 
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListSupplierUnpaidBills(supplierId: number, query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListSupplierUnpaidBills(supplierId, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPaymentsApi.adminListSupplierUnpaidBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uses the accounting system to register a payment for a posted vendor bill. Defaults to the full outstanding balance if amount is omitted.
         * @summary Register a payment against a vendor bill (admin only)
         * @param {PayVendorBillDto} payVendorBillDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPayVendorBill(payVendorBillDto: PayVendorBillDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPayVendorBill(payVendorBillDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPaymentsApi.adminPayVendorBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPaymentsApi - factory interface
 * @export
 */
export const AdminPaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a single payment by ID (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPayment(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PaymentDto> {
            return localVarFp.adminGetPayment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns totalRevenue (inbound PAID), payoutsOutstanding (outbound DRAFT/POSTED), procurtalMargin (revenue minus released payouts), and profit. Optionally scoped by date range.
         * @summary Get admin dashboard stats (admin only)
         * @param {string} [startDate] Filter payments from this date (YYYY-MM-DD inclusive)
         * @param {string} [endDate] Filter payments up to this date (YYYY-MM-DD inclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetStats(startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminStatsDto> {
            return localVarFp.adminGetStats(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all payments recorded in the accounting system (Odoo account.payment). Supports filtering by direction (incoming/outgoing), partner type (customer/supplier), and partner ID.
         * @summary List all payments (admin only)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {AdminListPaymentsSortOrderEnum} [sortOrder] Sort order
         * @param {AdminListPaymentsDirectionEnum} [direction] 
         * @param {AdminListPaymentsPartnerTypeEnum} [partnerType] 
         * @param {number} [partnerId] Filter by Odoo res.partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListPayments(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListPaymentsSortOrderEnum, direction?: AdminListPaymentsDirectionEnum, partnerType?: AdminListPaymentsPartnerTypeEnum, partnerId?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminListPayments(page, pageSize, search, sortBy, sortOrder, direction, partnerType, partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns posted vendor bills (account.move where move_type=in_invoice) for the given supplier that have not been fully paid.
         * @summary List unpaid vendor bills for a supplier (admin only)
         * @param {number} supplierId 
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListSupplierUnpaidBills(supplierId: number, query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminListSupplierUnpaidBills(supplierId, query, options).then((request) => request(axios, basePath));
        },
        /**
         * Uses the accounting system to register a payment for a posted vendor bill. Defaults to the full outstanding balance if amount is omitted.
         * @summary Register a payment against a vendor bill (admin only)
         * @param {PayVendorBillDto} payVendorBillDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPayVendorBill(payVendorBillDto: PayVendorBillDto, options?: RawAxiosRequestConfig): AxiosPromise<PaymentDto> {
            return localVarFp.adminPayVendorBill(payVendorBillDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPaymentsApi - object-oriented interface
 * @export
 * @class AdminPaymentsApi
 * @extends {BaseAPI}
 */
export class AdminPaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Get a single payment by ID (admin only)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPaymentsApi
     */
    public adminGetPayment(id: number, options?: RawAxiosRequestConfig) {
        return AdminPaymentsApiFp(this.configuration).adminGetPayment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns totalRevenue (inbound PAID), payoutsOutstanding (outbound DRAFT/POSTED), procurtalMargin (revenue minus released payouts), and profit. Optionally scoped by date range.
     * @summary Get admin dashboard stats (admin only)
     * @param {string} [startDate] Filter payments from this date (YYYY-MM-DD inclusive)
     * @param {string} [endDate] Filter payments up to this date (YYYY-MM-DD inclusive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPaymentsApi
     */
    public adminGetStats(startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return AdminPaymentsApiFp(this.configuration).adminGetStats(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all payments recorded in the accounting system (Odoo account.payment). Supports filtering by direction (incoming/outgoing), partner type (customer/supplier), and partner ID.
     * @summary List all payments (admin only)
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Page size
     * @param {string} [search] Search term for text search
     * @param {string} [sortBy] Field to sort by
     * @param {AdminListPaymentsSortOrderEnum} [sortOrder] Sort order
     * @param {AdminListPaymentsDirectionEnum} [direction] 
     * @param {AdminListPaymentsPartnerTypeEnum} [partnerType] 
     * @param {number} [partnerId] Filter by Odoo res.partner ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPaymentsApi
     */
    public adminListPayments(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: AdminListPaymentsSortOrderEnum, direction?: AdminListPaymentsDirectionEnum, partnerType?: AdminListPaymentsPartnerTypeEnum, partnerId?: number, options?: RawAxiosRequestConfig) {
        return AdminPaymentsApiFp(this.configuration).adminListPayments(page, pageSize, search, sortBy, sortOrder, direction, partnerType, partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns posted vendor bills (account.move where move_type=in_invoice) for the given supplier that have not been fully paid.
     * @summary List unpaid vendor bills for a supplier (admin only)
     * @param {number} supplierId 
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPaymentsApi
     */
    public adminListSupplierUnpaidBills(supplierId: number, query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return AdminPaymentsApiFp(this.configuration).adminListSupplierUnpaidBills(supplierId, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uses the accounting system to register a payment for a posted vendor bill. Defaults to the full outstanding balance if amount is omitted.
     * @summary Register a payment against a vendor bill (admin only)
     * @param {PayVendorBillDto} payVendorBillDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPaymentsApi
     */
    public adminPayVendorBill(payVendorBillDto: PayVendorBillDto, options?: RawAxiosRequestConfig) {
        return AdminPaymentsApiFp(this.configuration).adminPayVendorBill(payVendorBillDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminListPaymentsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminListPaymentsSortOrderEnum = typeof AdminListPaymentsSortOrderEnum[keyof typeof AdminListPaymentsSortOrderEnum];
/**
 * @export
 */
export const AdminListPaymentsDirectionEnum = {
    Incoming: 'INCOMING',
    Outgoing: 'OUTGOING'
} as const;
export type AdminListPaymentsDirectionEnum = typeof AdminListPaymentsDirectionEnum[keyof typeof AdminListPaymentsDirectionEnum];
/**
 * @export
 */
export const AdminListPaymentsPartnerTypeEnum = {
    Customer: 'CUSTOMER',
    Supplier: 'SUPPLIER',
    Other: 'OTHER'
} as const;
export type AdminListPaymentsPartnerTypeEnum = typeof AdminListPaymentsPartnerTypeEnum[keyof typeof AdminListPaymentsPartnerTypeEnum];


/**
 * AdminPlatformSettingsApi - axios parameter creator
 * @export
 */
export const AdminPlatformSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get platform settings (US-A-026)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPlatformSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/platform-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update platform settings (US-A-026)
         * @param {UpdatePlatformSettingsDto} updatePlatformSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdatePlatformSettings: async (updatePlatformSettingsDto: UpdatePlatformSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePlatformSettingsDto' is not null or undefined
            assertParamExists('adminUpdatePlatformSettings', 'updatePlatformSettingsDto', updatePlatformSettingsDto)
            const localVarPath = `/api/v1/admin/platform-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlatformSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPlatformSettingsApi - functional programming interface
 * @export
 */
export const AdminPlatformSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPlatformSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get platform settings (US-A-026)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetPlatformSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetPlatformSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPlatformSettingsApi.adminGetPlatformSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update platform settings (US-A-026)
         * @param {UpdatePlatformSettingsDto} updatePlatformSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdatePlatformSettings(updatePlatformSettingsDto: UpdatePlatformSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdatePlatformSettings(updatePlatformSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPlatformSettingsApi.adminUpdatePlatformSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPlatformSettingsApi - factory interface
 * @export
 */
export const AdminPlatformSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPlatformSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get platform settings (US-A-026)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPlatformSettings(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.adminGetPlatformSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update platform settings (US-A-026)
         * @param {UpdatePlatformSettingsDto} updatePlatformSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdatePlatformSettings(updatePlatformSettingsDto: UpdatePlatformSettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.adminUpdatePlatformSettings(updatePlatformSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPlatformSettingsApi - object-oriented interface
 * @export
 * @class AdminPlatformSettingsApi
 * @extends {BaseAPI}
 */
export class AdminPlatformSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Get platform settings (US-A-026)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlatformSettingsApi
     */
    public adminGetPlatformSettings(options?: RawAxiosRequestConfig) {
        return AdminPlatformSettingsApiFp(this.configuration).adminGetPlatformSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update platform settings (US-A-026)
     * @param {UpdatePlatformSettingsDto} updatePlatformSettingsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlatformSettingsApi
     */
    public adminUpdatePlatformSettings(updatePlatformSettingsDto: UpdatePlatformSettingsDto, options?: RawAxiosRequestConfig) {
        return AdminPlatformSettingsApiFp(this.configuration).adminUpdatePlatformSettings(updatePlatformSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductAttributesApi - axios parameter creator
 * @export
 */
export const AdminProductAttributesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create an attribute
         * @param {CreateProductAttributeDto} createProductAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAttribute: async (createProductAttributeDto: CreateProductAttributeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductAttributeDto' is not null or undefined
            assertParamExists('adminCreateAttribute', 'createProductAttributeDto', createProductAttributeDto)
            const localVarPath = `/api/v1/admin/product-attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductAttributeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an attribute value
         * @param {CreateProductAttributeValueDto} createProductAttributeValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAttributeValue: async (createProductAttributeValueDto: CreateProductAttributeValueDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductAttributeValueDto' is not null or undefined
            assertParamExists('adminCreateAttributeValue', 'createProductAttributeValueDto', createProductAttributeValueDto)
            const localVarPath = `/api/v1/admin/product-attributes/values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductAttributeValueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an attribute
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAttribute: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteAttribute', 'id', id)
            const localVarPath = `/api/v1/admin/product-attributes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an attribute value
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAttributeValue: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteAttributeValue', 'id', id)
            const localVarPath = `/api/v1/admin/product-attributes/values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an attribute
         * @param {number} id 
         * @param {UpdateProductAttributeDto} updateProductAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAttribute: async (id: number, updateProductAttributeDto: UpdateProductAttributeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateAttribute', 'id', id)
            // verify required parameter 'updateProductAttributeDto' is not null or undefined
            assertParamExists('adminUpdateAttribute', 'updateProductAttributeDto', updateProductAttributeDto)
            const localVarPath = `/api/v1/admin/product-attributes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductAttributeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an attribute value
         * @param {number} id 
         * @param {UpdateProductAttributeValueDto} updateProductAttributeValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAttributeValue: async (id: number, updateProductAttributeValueDto: UpdateProductAttributeValueDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateAttributeValue', 'id', id)
            // verify required parameter 'updateProductAttributeValueDto' is not null or undefined
            assertParamExists('adminUpdateAttributeValue', 'updateProductAttributeValueDto', updateProductAttributeValueDto)
            const localVarPath = `/api/v1/admin/product-attributes/values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductAttributeValueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductAttributesApi - functional programming interface
 * @export
 */
export const AdminProductAttributesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductAttributesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create an attribute
         * @param {CreateProductAttributeDto} createProductAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateAttribute(createProductAttributeDto: CreateProductAttributeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateAttribute(createProductAttributeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductAttributesApi.adminCreateAttribute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an attribute value
         * @param {CreateProductAttributeValueDto} createProductAttributeValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateAttributeValue(createProductAttributeValueDto: CreateProductAttributeValueDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateAttributeValue(createProductAttributeValueDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductAttributesApi.adminCreateAttributeValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an attribute
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteAttribute(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteAttribute(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductAttributesApi.adminDeleteAttribute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an attribute value
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteAttributeValue(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteAttributeValue(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductAttributesApi.adminDeleteAttributeValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an attribute
         * @param {number} id 
         * @param {UpdateProductAttributeDto} updateProductAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateAttribute(id: number, updateProductAttributeDto: UpdateProductAttributeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateAttribute(id, updateProductAttributeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductAttributesApi.adminUpdateAttribute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an attribute value
         * @param {number} id 
         * @param {UpdateProductAttributeValueDto} updateProductAttributeValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateAttributeValue(id: number, updateProductAttributeValueDto: UpdateProductAttributeValueDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateAttributeValue(id, updateProductAttributeValueDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductAttributesApi.adminUpdateAttributeValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductAttributesApi - factory interface
 * @export
 */
export const AdminProductAttributesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductAttributesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create an attribute
         * @param {CreateProductAttributeDto} createProductAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAttribute(createProductAttributeDto: CreateProductAttributeDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeDto> {
            return localVarFp.adminCreateAttribute(createProductAttributeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an attribute value
         * @param {CreateProductAttributeValueDto} createProductAttributeValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAttributeValue(createProductAttributeValueDto: CreateProductAttributeValueDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeValueDto> {
            return localVarFp.adminCreateAttributeValue(createProductAttributeValueDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an attribute
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAttribute(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteAttribute(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an attribute value
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteAttributeValue(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteAttributeValue(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an attribute
         * @param {number} id 
         * @param {UpdateProductAttributeDto} updateProductAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAttribute(id: number, updateProductAttributeDto: UpdateProductAttributeDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeDto> {
            return localVarFp.adminUpdateAttribute(id, updateProductAttributeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an attribute value
         * @param {number} id 
         * @param {UpdateProductAttributeValueDto} updateProductAttributeValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAttributeValue(id: number, updateProductAttributeValueDto: UpdateProductAttributeValueDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeValueDto> {
            return localVarFp.adminUpdateAttributeValue(id, updateProductAttributeValueDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductAttributesApi - object-oriented interface
 * @export
 * @class AdminProductAttributesApi
 * @extends {BaseAPI}
 */
export class AdminProductAttributesApi extends BaseAPI {
    /**
     * 
     * @summary Create an attribute
     * @param {CreateProductAttributeDto} createProductAttributeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductAttributesApi
     */
    public adminCreateAttribute(createProductAttributeDto: CreateProductAttributeDto, options?: RawAxiosRequestConfig) {
        return AdminProductAttributesApiFp(this.configuration).adminCreateAttribute(createProductAttributeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an attribute value
     * @param {CreateProductAttributeValueDto} createProductAttributeValueDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductAttributesApi
     */
    public adminCreateAttributeValue(createProductAttributeValueDto: CreateProductAttributeValueDto, options?: RawAxiosRequestConfig) {
        return AdminProductAttributesApiFp(this.configuration).adminCreateAttributeValue(createProductAttributeValueDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an attribute
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductAttributesApi
     */
    public adminDeleteAttribute(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductAttributesApiFp(this.configuration).adminDeleteAttribute(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an attribute value
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductAttributesApi
     */
    public adminDeleteAttributeValue(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductAttributesApiFp(this.configuration).adminDeleteAttributeValue(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an attribute
     * @param {number} id 
     * @param {UpdateProductAttributeDto} updateProductAttributeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductAttributesApi
     */
    public adminUpdateAttribute(id: number, updateProductAttributeDto: UpdateProductAttributeDto, options?: RawAxiosRequestConfig) {
        return AdminProductAttributesApiFp(this.configuration).adminUpdateAttribute(id, updateProductAttributeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an attribute value
     * @param {number} id 
     * @param {UpdateProductAttributeValueDto} updateProductAttributeValueDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductAttributesApi
     */
    public adminUpdateAttributeValue(id: number, updateProductAttributeValueDto: UpdateProductAttributeValueDto, options?: RawAxiosRequestConfig) {
        return AdminProductAttributesApiFp(this.configuration).adminUpdateAttributeValue(id, updateProductAttributeValueDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductConditionsApi - axios parameter creator
 * @export
 */
export const AdminProductConditionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a condition
         * @param {CreateProductConditionDto} createProductConditionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCondition: async (createProductConditionDto: CreateProductConditionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductConditionDto' is not null or undefined
            assertParamExists('adminCreateCondition', 'createProductConditionDto', createProductConditionDto)
            const localVarPath = `/api/v1/admin/product-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductConditionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a condition
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCondition: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteCondition', 'id', id)
            const localVarPath = `/api/v1/admin/product-conditions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a condition
         * @param {number} id 
         * @param {UpdateProductConditionDto} updateProductConditionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCondition: async (id: number, updateProductConditionDto: UpdateProductConditionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateCondition', 'id', id)
            // verify required parameter 'updateProductConditionDto' is not null or undefined
            assertParamExists('adminUpdateCondition', 'updateProductConditionDto', updateProductConditionDto)
            const localVarPath = `/api/v1/admin/product-conditions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductConditionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductConditionsApi - functional programming interface
 * @export
 */
export const AdminProductConditionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductConditionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a condition
         * @param {CreateProductConditionDto} createProductConditionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateCondition(createProductConditionDto: CreateProductConditionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductConditionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateCondition(createProductConditionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductConditionsApi.adminCreateCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a condition
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteCondition(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteCondition(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductConditionsApi.adminDeleteCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a condition
         * @param {number} id 
         * @param {UpdateProductConditionDto} updateProductConditionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateCondition(id: number, updateProductConditionDto: UpdateProductConditionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductConditionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateCondition(id, updateProductConditionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductConditionsApi.adminUpdateCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductConditionsApi - factory interface
 * @export
 */
export const AdminProductConditionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductConditionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a condition
         * @param {CreateProductConditionDto} createProductConditionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCondition(createProductConditionDto: CreateProductConditionDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductConditionDto> {
            return localVarFp.adminCreateCondition(createProductConditionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a condition
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCondition(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteCondition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a condition
         * @param {number} id 
         * @param {UpdateProductConditionDto} updateProductConditionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCondition(id: number, updateProductConditionDto: UpdateProductConditionDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductConditionDto> {
            return localVarFp.adminUpdateCondition(id, updateProductConditionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductConditionsApi - object-oriented interface
 * @export
 * @class AdminProductConditionsApi
 * @extends {BaseAPI}
 */
export class AdminProductConditionsApi extends BaseAPI {
    /**
     * 
     * @summary Create a condition
     * @param {CreateProductConditionDto} createProductConditionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductConditionsApi
     */
    public adminCreateCondition(createProductConditionDto: CreateProductConditionDto, options?: RawAxiosRequestConfig) {
        return AdminProductConditionsApiFp(this.configuration).adminCreateCondition(createProductConditionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a condition
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductConditionsApi
     */
    public adminDeleteCondition(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductConditionsApiFp(this.configuration).adminDeleteCondition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a condition
     * @param {number} id 
     * @param {UpdateProductConditionDto} updateProductConditionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductConditionsApi
     */
    public adminUpdateCondition(id: number, updateProductConditionDto: UpdateProductConditionDto, options?: RawAxiosRequestConfig) {
        return AdminProductConditionsApiFp(this.configuration).adminUpdateCondition(id, updateProductConditionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductDealTypesApi - axios parameter creator
 * @export
 */
export const AdminProductDealTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a deal type
         * @param {CreateProductDealTypeDto} createProductDealTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateDealType: async (createProductDealTypeDto: CreateProductDealTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductDealTypeDto' is not null or undefined
            assertParamExists('adminCreateDealType', 'createProductDealTypeDto', createProductDealTypeDto)
            const localVarPath = `/api/v1/admin/product-deal-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductDealTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a deal type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDealType: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteDealType', 'id', id)
            const localVarPath = `/api/v1/admin/product-deal-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a deal type
         * @param {number} id 
         * @param {UpdateProductDealTypeDto} updateProductDealTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateDealType: async (id: number, updateProductDealTypeDto: UpdateProductDealTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateDealType', 'id', id)
            // verify required parameter 'updateProductDealTypeDto' is not null or undefined
            assertParamExists('adminUpdateDealType', 'updateProductDealTypeDto', updateProductDealTypeDto)
            const localVarPath = `/api/v1/admin/product-deal-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductDealTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductDealTypesApi - functional programming interface
 * @export
 */
export const AdminProductDealTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductDealTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a deal type
         * @param {CreateProductDealTypeDto} createProductDealTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateDealType(createProductDealTypeDto: CreateProductDealTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDealTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateDealType(createProductDealTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDealTypesApi.adminCreateDealType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a deal type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteDealType(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteDealType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDealTypesApi.adminDeleteDealType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a deal type
         * @param {number} id 
         * @param {UpdateProductDealTypeDto} updateProductDealTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateDealType(id: number, updateProductDealTypeDto: UpdateProductDealTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDealTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateDealType(id, updateProductDealTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDealTypesApi.adminUpdateDealType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductDealTypesApi - factory interface
 * @export
 */
export const AdminProductDealTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductDealTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a deal type
         * @param {CreateProductDealTypeDto} createProductDealTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateDealType(createProductDealTypeDto: CreateProductDealTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductDealTypeDto> {
            return localVarFp.adminCreateDealType(createProductDealTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a deal type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDealType(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteDealType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a deal type
         * @param {number} id 
         * @param {UpdateProductDealTypeDto} updateProductDealTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateDealType(id: number, updateProductDealTypeDto: UpdateProductDealTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductDealTypeDto> {
            return localVarFp.adminUpdateDealType(id, updateProductDealTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductDealTypesApi - object-oriented interface
 * @export
 * @class AdminProductDealTypesApi
 * @extends {BaseAPI}
 */
export class AdminProductDealTypesApi extends BaseAPI {
    /**
     * 
     * @summary Create a deal type
     * @param {CreateProductDealTypeDto} createProductDealTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDealTypesApi
     */
    public adminCreateDealType(createProductDealTypeDto: CreateProductDealTypeDto, options?: RawAxiosRequestConfig) {
        return AdminProductDealTypesApiFp(this.configuration).adminCreateDealType(createProductDealTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a deal type
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDealTypesApi
     */
    public adminDeleteDealType(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductDealTypesApiFp(this.configuration).adminDeleteDealType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a deal type
     * @param {number} id 
     * @param {UpdateProductDealTypeDto} updateProductDealTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDealTypesApi
     */
    public adminUpdateDealType(id: number, updateProductDealTypeDto: UpdateProductDealTypeDto, options?: RawAxiosRequestConfig) {
        return AdminProductDealTypesApiFp(this.configuration).adminUpdateDealType(id, updateProductDealTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductRequestsApi - axios parameter creator
 * @export
 */
export const AdminProductRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns paginated list of all product requests. Can be filtered by status.
         * @summary Get all product requests (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllProductRequests: async (query?: DocumentsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/product-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a product request by ID (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductRequestById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetProductRequestById', 'id', id)
            const localVarPath = `/api/v1/admin/product-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the parsed AI summary, raw extracted text, signed download URL for the PDF, and audit fields (cost, provider, model, status). Returns status=\"none\" when the request has no datasheet at all.
         * @summary Get the latest AI datasheet extraction for a product request (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductRequestDatasheetExtraction: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetProductRequestDatasheetExtraction', 'id', id)
            const localVarPath = `/api/v1/admin/product-requests/{id}/datasheet-extraction`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve or reject a product request. If approved, the product will be created in Odoo.
         * @summary Review (approve/reject) a product request (admin only)
         * @param {string} id 
         * @param {ReviewProductRequestDto} reviewProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReviewProductRequest: async (id: string, reviewProductRequestDto: ReviewProductRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminReviewProductRequest', 'id', id)
            // verify required parameter 'reviewProductRequestDto' is not null or undefined
            assertParamExists('adminReviewProductRequest', 'reviewProductRequestDto', reviewProductRequestDto)
            const localVarPath = `/api/v1/admin/product-requests/{id}/review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewProductRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approves all pending product requests and applies a margin percentage to seller pricing to calculate admin pricing. Each request will be processed individually, and results will show which requests succeeded or failed.
         * @summary Bulk approve all pending product requests (admin only)
         * @param {BulkApproveProductRequestsDto} bulkApproveProductRequestsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkApproveProductRequests: async (bulkApproveProductRequestsDto: BulkApproveProductRequestsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkApproveProductRequestsDto' is not null or undefined
            assertParamExists('bulkApproveProductRequests', 'bulkApproveProductRequestsDto', bulkApproveProductRequestsDto)
            const localVarPath = `/api/v1/admin/product-requests/bulk-approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkApproveProductRequestsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of users with their product requests. Only admins can access this endpoint.
         * @summary Get all product requests grouped by user (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRequestsGroupedByUser: async (query?: DocumentsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/product-requests/grouped-by-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductRequestsApi - functional programming interface
 * @export
 */
export const AdminProductRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns paginated list of all product requests. Can be filtered by status.
         * @summary Get all product requests (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAllProductRequests(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAllProductRequests(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductRequestsApi.adminGetAllProductRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a product request by ID (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetProductRequestById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetProductRequestById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductRequestsApi.adminGetProductRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the parsed AI summary, raw extracted text, signed download URL for the PDF, and audit fields (cost, provider, model, status). Returns status=\"none\" when the request has no datasheet at all.
         * @summary Get the latest AI datasheet extraction for a product request (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetProductRequestDatasheetExtraction(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDatasheetExtractionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetProductRequestDatasheetExtraction(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductRequestsApi.adminGetProductRequestDatasheetExtraction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approve or reject a product request. If approved, the product will be created in Odoo.
         * @summary Review (approve/reject) a product request (admin only)
         * @param {string} id 
         * @param {ReviewProductRequestDto} reviewProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminReviewProductRequest(id: string, reviewProductRequestDto: ReviewProductRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminReviewProductRequest(id, reviewProductRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductRequestsApi.adminReviewProductRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approves all pending product requests and applies a margin percentage to seller pricing to calculate admin pricing. Each request will be processed individually, and results will show which requests succeeded or failed.
         * @summary Bulk approve all pending product requests (admin only)
         * @param {BulkApproveProductRequestsDto} bulkApproveProductRequestsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkApproveProductRequests(bulkApproveProductRequestsDto: BulkApproveProductRequestsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkApproveResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkApproveProductRequests(bulkApproveProductRequestsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductRequestsApi.bulkApproveProductRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of users with their product requests. Only admins can access this endpoint.
         * @summary Get all product requests grouped by user (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductRequestsGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersProductRequestsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductRequestsGroupedByUser(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductRequestsApi.getProductRequestsGroupedByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductRequestsApi - factory interface
 * @export
 */
export const AdminProductRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductRequestsApiFp(configuration)
    return {
        /**
         * Returns paginated list of all product requests. Can be filtered by status.
         * @summary Get all product requests (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllProductRequests(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductRequestResponseDto> {
            return localVarFp.adminGetAllProductRequests(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a product request by ID (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductRequestById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductRequestDto> {
            return localVarFp.adminGetProductRequestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the parsed AI summary, raw extracted text, signed download URL for the PDF, and audit fields (cost, provider, model, status). Returns status=\"none\" when the request has no datasheet at all.
         * @summary Get the latest AI datasheet extraction for a product request (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductRequestDatasheetExtraction(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminDatasheetExtractionDto> {
            return localVarFp.adminGetProductRequestDatasheetExtraction(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve or reject a product request. If approved, the product will be created in Odoo.
         * @summary Review (approve/reject) a product request (admin only)
         * @param {string} id 
         * @param {ReviewProductRequestDto} reviewProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReviewProductRequest(id: string, reviewProductRequestDto: ReviewProductRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductRequestDto> {
            return localVarFp.adminReviewProductRequest(id, reviewProductRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Approves all pending product requests and applies a margin percentage to seller pricing to calculate admin pricing. Each request will be processed individually, and results will show which requests succeeded or failed.
         * @summary Bulk approve all pending product requests (admin only)
         * @param {BulkApproveProductRequestsDto} bulkApproveProductRequestsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkApproveProductRequests(bulkApproveProductRequestsDto: BulkApproveProductRequestsDto, options?: RawAxiosRequestConfig): AxiosPromise<BulkApproveResponseDto> {
            return localVarFp.bulkApproveProductRequests(bulkApproveProductRequestsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of users with their product requests. Only admins can access this endpoint.
         * @summary Get all product requests grouped by user (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRequestsGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<UsersProductRequestsResponseDto> {
            return localVarFp.getProductRequestsGroupedByUser(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductRequestsApi - object-oriented interface
 * @export
 * @class AdminProductRequestsApi
 * @extends {BaseAPI}
 */
export class AdminProductRequestsApi extends BaseAPI {
    /**
     * Returns paginated list of all product requests. Can be filtered by status.
     * @summary Get all product requests (admin only)
     * @param {DocumentsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductRequestsApi
     */
    public adminGetAllProductRequests(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig) {
        return AdminProductRequestsApiFp(this.configuration).adminGetAllProductRequests(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a product request by ID (admin only)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductRequestsApi
     */
    public adminGetProductRequestById(id: string, options?: RawAxiosRequestConfig) {
        return AdminProductRequestsApiFp(this.configuration).adminGetProductRequestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the parsed AI summary, raw extracted text, signed download URL for the PDF, and audit fields (cost, provider, model, status). Returns status=\"none\" when the request has no datasheet at all.
     * @summary Get the latest AI datasheet extraction for a product request (admin only)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductRequestsApi
     */
    public adminGetProductRequestDatasheetExtraction(id: string, options?: RawAxiosRequestConfig) {
        return AdminProductRequestsApiFp(this.configuration).adminGetProductRequestDatasheetExtraction(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve or reject a product request. If approved, the product will be created in Odoo.
     * @summary Review (approve/reject) a product request (admin only)
     * @param {string} id 
     * @param {ReviewProductRequestDto} reviewProductRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductRequestsApi
     */
    public adminReviewProductRequest(id: string, reviewProductRequestDto: ReviewProductRequestDto, options?: RawAxiosRequestConfig) {
        return AdminProductRequestsApiFp(this.configuration).adminReviewProductRequest(id, reviewProductRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approves all pending product requests and applies a margin percentage to seller pricing to calculate admin pricing. Each request will be processed individually, and results will show which requests succeeded or failed.
     * @summary Bulk approve all pending product requests (admin only)
     * @param {BulkApproveProductRequestsDto} bulkApproveProductRequestsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductRequestsApi
     */
    public bulkApproveProductRequests(bulkApproveProductRequestsDto: BulkApproveProductRequestsDto, options?: RawAxiosRequestConfig) {
        return AdminProductRequestsApiFp(this.configuration).bulkApproveProductRequests(bulkApproveProductRequestsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of users with their product requests. Only admins can access this endpoint.
     * @summary Get all product requests grouped by user (admin only)
     * @param {DocumentsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductRequestsApi
     */
    public getProductRequestsGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig) {
        return AdminProductRequestsApiFp(this.configuration).getProductRequestsGroupedByUser(query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductResolutionsApi - axios parameter creator
 * @export
 */
export const AdminProductResolutionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a resolution
         * @param {CreateProductResolutionDto} createProductResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateResolution: async (createProductResolutionDto: CreateProductResolutionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductResolutionDto' is not null or undefined
            assertParamExists('adminCreateResolution', 'createProductResolutionDto', createProductResolutionDto)
            const localVarPath = `/api/v1/admin/product-resolutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductResolutionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a resolution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteResolution: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteResolution', 'id', id)
            const localVarPath = `/api/v1/admin/product-resolutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a resolution
         * @param {number} id 
         * @param {UpdateProductResolutionDto} updateProductResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateResolution: async (id: number, updateProductResolutionDto: UpdateProductResolutionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateResolution', 'id', id)
            // verify required parameter 'updateProductResolutionDto' is not null or undefined
            assertParamExists('adminUpdateResolution', 'updateProductResolutionDto', updateProductResolutionDto)
            const localVarPath = `/api/v1/admin/product-resolutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductResolutionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductResolutionsApi - functional programming interface
 * @export
 */
export const AdminProductResolutionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductResolutionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a resolution
         * @param {CreateProductResolutionDto} createProductResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateResolution(createProductResolutionDto: CreateProductResolutionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResolutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateResolution(createProductResolutionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductResolutionsApi.adminCreateResolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a resolution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteResolution(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteResolution(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductResolutionsApi.adminDeleteResolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a resolution
         * @param {number} id 
         * @param {UpdateProductResolutionDto} updateProductResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateResolution(id: number, updateProductResolutionDto: UpdateProductResolutionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResolutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateResolution(id, updateProductResolutionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductResolutionsApi.adminUpdateResolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductResolutionsApi - factory interface
 * @export
 */
export const AdminProductResolutionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductResolutionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a resolution
         * @param {CreateProductResolutionDto} createProductResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateResolution(createProductResolutionDto: CreateProductResolutionDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductResolutionDto> {
            return localVarFp.adminCreateResolution(createProductResolutionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a resolution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteResolution(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteResolution(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a resolution
         * @param {number} id 
         * @param {UpdateProductResolutionDto} updateProductResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateResolution(id: number, updateProductResolutionDto: UpdateProductResolutionDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductResolutionDto> {
            return localVarFp.adminUpdateResolution(id, updateProductResolutionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductResolutionsApi - object-oriented interface
 * @export
 * @class AdminProductResolutionsApi
 * @extends {BaseAPI}
 */
export class AdminProductResolutionsApi extends BaseAPI {
    /**
     * 
     * @summary Create a resolution
     * @param {CreateProductResolutionDto} createProductResolutionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductResolutionsApi
     */
    public adminCreateResolution(createProductResolutionDto: CreateProductResolutionDto, options?: RawAxiosRequestConfig) {
        return AdminProductResolutionsApiFp(this.configuration).adminCreateResolution(createProductResolutionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a resolution
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductResolutionsApi
     */
    public adminDeleteResolution(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductResolutionsApiFp(this.configuration).adminDeleteResolution(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a resolution
     * @param {number} id 
     * @param {UpdateProductResolutionDto} updateProductResolutionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductResolutionsApi
     */
    public adminUpdateResolution(id: number, updateProductResolutionDto: UpdateProductResolutionDto, options?: RawAxiosRequestConfig) {
        return AdminProductResolutionsApiFp(this.configuration).adminUpdateResolution(id, updateProductResolutionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductScreenSizesApi - axios parameter creator
 * @export
 */
export const AdminProductScreenSizesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a screen size
         * @param {CreateProductScreenSizeDto} createProductScreenSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateScreenSize: async (createProductScreenSizeDto: CreateProductScreenSizeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductScreenSizeDto' is not null or undefined
            assertParamExists('adminCreateScreenSize', 'createProductScreenSizeDto', createProductScreenSizeDto)
            const localVarPath = `/api/v1/admin/product-screen-sizes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductScreenSizeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a screen size
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteScreenSize: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteScreenSize', 'id', id)
            const localVarPath = `/api/v1/admin/product-screen-sizes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a screen size
         * @param {number} id 
         * @param {UpdateProductScreenSizeDto} updateProductScreenSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateScreenSize: async (id: number, updateProductScreenSizeDto: UpdateProductScreenSizeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateScreenSize', 'id', id)
            // verify required parameter 'updateProductScreenSizeDto' is not null or undefined
            assertParamExists('adminUpdateScreenSize', 'updateProductScreenSizeDto', updateProductScreenSizeDto)
            const localVarPath = `/api/v1/admin/product-screen-sizes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductScreenSizeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductScreenSizesApi - functional programming interface
 * @export
 */
export const AdminProductScreenSizesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductScreenSizesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a screen size
         * @param {CreateProductScreenSizeDto} createProductScreenSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateScreenSize(createProductScreenSizeDto: CreateProductScreenSizeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductScreenSizeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateScreenSize(createProductScreenSizeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductScreenSizesApi.adminCreateScreenSize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a screen size
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteScreenSize(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteScreenSize(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductScreenSizesApi.adminDeleteScreenSize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a screen size
         * @param {number} id 
         * @param {UpdateProductScreenSizeDto} updateProductScreenSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateScreenSize(id: number, updateProductScreenSizeDto: UpdateProductScreenSizeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductScreenSizeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateScreenSize(id, updateProductScreenSizeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductScreenSizesApi.adminUpdateScreenSize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductScreenSizesApi - factory interface
 * @export
 */
export const AdminProductScreenSizesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductScreenSizesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a screen size
         * @param {CreateProductScreenSizeDto} createProductScreenSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateScreenSize(createProductScreenSizeDto: CreateProductScreenSizeDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductScreenSizeDto> {
            return localVarFp.adminCreateScreenSize(createProductScreenSizeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a screen size
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteScreenSize(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteScreenSize(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a screen size
         * @param {number} id 
         * @param {UpdateProductScreenSizeDto} updateProductScreenSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateScreenSize(id: number, updateProductScreenSizeDto: UpdateProductScreenSizeDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductScreenSizeDto> {
            return localVarFp.adminUpdateScreenSize(id, updateProductScreenSizeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductScreenSizesApi - object-oriented interface
 * @export
 * @class AdminProductScreenSizesApi
 * @extends {BaseAPI}
 */
export class AdminProductScreenSizesApi extends BaseAPI {
    /**
     * 
     * @summary Create a screen size
     * @param {CreateProductScreenSizeDto} createProductScreenSizeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductScreenSizesApi
     */
    public adminCreateScreenSize(createProductScreenSizeDto: CreateProductScreenSizeDto, options?: RawAxiosRequestConfig) {
        return AdminProductScreenSizesApiFp(this.configuration).adminCreateScreenSize(createProductScreenSizeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a screen size
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductScreenSizesApi
     */
    public adminDeleteScreenSize(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductScreenSizesApiFp(this.configuration).adminDeleteScreenSize(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a screen size
     * @param {number} id 
     * @param {UpdateProductScreenSizeDto} updateProductScreenSizeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductScreenSizesApi
     */
    public adminUpdateScreenSize(id: number, updateProductScreenSizeDto: UpdateProductScreenSizeDto, options?: RawAxiosRequestConfig) {
        return AdminProductScreenSizesApiFp(this.configuration).adminUpdateScreenSize(id, updateProductScreenSizeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductVariantsApi - axios parameter creator
 * @export
 */
export const AdminProductVariantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Admin can update the supplier_stock field for any product variant without seller authorization check.
         * @summary Update supplier stock for a product variant (admin only)
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductVariantStock: async (productId: number, updateVariantStockDto: UpdateVariantStockDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminUpdateProductVariantStock', 'productId', productId)
            // verify required parameter 'updateVariantStockDto' is not null or undefined
            assertParamExists('adminUpdateProductVariantStock', 'updateVariantStockDto', updateVariantStockDto)
            const localVarPath = `/api/v1/admin/product-variants/{productId}/stock`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVariantStockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin can update the supplier_stock field for any product variant without seller authorization check. Alternative to /:productId/stock.
         * @summary Update supplier stock for a product variant (admin only) - alternative route
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductVariantStockDirect: async (productId: number, updateVariantStockDto: UpdateVariantStockDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminUpdateProductVariantStockDirect', 'productId', productId)
            // verify required parameter 'updateVariantStockDto' is not null or undefined
            assertParamExists('adminUpdateProductVariantStockDirect', 'updateVariantStockDto', updateVariantStockDto)
            const localVarPath = `/api/v1/admin/product-variants/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVariantStockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductVariantsApi - functional programming interface
 * @export
 */
export const AdminProductVariantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductVariantsApiAxiosParamCreator(configuration)
    return {
        /**
         * Admin can update the supplier_stock field for any product variant without seller authorization check.
         * @summary Update supplier stock for a product variant (admin only)
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateProductVariantStock(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateProductVariantStock(productId, updateVariantStockDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductVariantsApi.adminUpdateProductVariantStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin can update the supplier_stock field for any product variant without seller authorization check. Alternative to /:productId/stock.
         * @summary Update supplier stock for a product variant (admin only) - alternative route
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateProductVariantStockDirect(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateProductVariantStockDirect(productId, updateVariantStockDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductVariantsApi.adminUpdateProductVariantStockDirect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductVariantsApi - factory interface
 * @export
 */
export const AdminProductVariantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductVariantsApiFp(configuration)
    return {
        /**
         * Admin can update the supplier_stock field for any product variant without seller authorization check.
         * @summary Update supplier stock for a product variant (admin only)
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductVariantStock(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminUpdateProductVariantStock(productId, updateVariantStockDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin can update the supplier_stock field for any product variant without seller authorization check. Alternative to /:productId/stock.
         * @summary Update supplier stock for a product variant (admin only) - alternative route
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductVariantStockDirect(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminUpdateProductVariantStockDirect(productId, updateVariantStockDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductVariantsApi - object-oriented interface
 * @export
 * @class AdminProductVariantsApi
 * @extends {BaseAPI}
 */
export class AdminProductVariantsApi extends BaseAPI {
    /**
     * Admin can update the supplier_stock field for any product variant without seller authorization check.
     * @summary Update supplier stock for a product variant (admin only)
     * @param {number} productId 
     * @param {UpdateVariantStockDto} updateVariantStockDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductVariantsApi
     */
    public adminUpdateProductVariantStock(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig) {
        return AdminProductVariantsApiFp(this.configuration).adminUpdateProductVariantStock(productId, updateVariantStockDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin can update the supplier_stock field for any product variant without seller authorization check. Alternative to /:productId/stock.
     * @summary Update supplier stock for a product variant (admin only) - alternative route
     * @param {number} productId 
     * @param {UpdateVariantStockDto} updateVariantStockDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductVariantsApi
     */
    public adminUpdateProductVariantStockDirect(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig) {
        return AdminProductVariantsApiFp(this.configuration).adminUpdateProductVariantStockDirect(productId, updateVariantStockDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductWarrantiesApi - axios parameter creator
 * @export
 */
export const AdminProductWarrantiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a warranty
         * @param {CreateProductWarrantyDto} createProductWarrantyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateWarranty: async (createProductWarrantyDto: CreateProductWarrantyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductWarrantyDto' is not null or undefined
            assertParamExists('adminCreateWarranty', 'createProductWarrantyDto', createProductWarrantyDto)
            const localVarPath = `/api/v1/admin/product-warranties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductWarrantyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a warranty
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWarranty: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteWarranty', 'id', id)
            const localVarPath = `/api/v1/admin/product-warranties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a warranty
         * @param {number} id 
         * @param {UpdateProductWarrantyDto} updateProductWarrantyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWarranty: async (id: number, updateProductWarrantyDto: UpdateProductWarrantyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateWarranty', 'id', id)
            // verify required parameter 'updateProductWarrantyDto' is not null or undefined
            assertParamExists('adminUpdateWarranty', 'updateProductWarrantyDto', updateProductWarrantyDto)
            const localVarPath = `/api/v1/admin/product-warranties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductWarrantyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductWarrantiesApi - functional programming interface
 * @export
 */
export const AdminProductWarrantiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductWarrantiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a warranty
         * @param {CreateProductWarrantyDto} createProductWarrantyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateWarranty(createProductWarrantyDto: CreateProductWarrantyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateWarranty(createProductWarrantyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantiesApi.adminCreateWarranty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a warranty
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteWarranty(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteWarranty(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantiesApi.adminDeleteWarranty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a warranty
         * @param {number} id 
         * @param {UpdateProductWarrantyDto} updateProductWarrantyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateWarranty(id: number, updateProductWarrantyDto: UpdateProductWarrantyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateWarranty(id, updateProductWarrantyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantiesApi.adminUpdateWarranty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductWarrantiesApi - factory interface
 * @export
 */
export const AdminProductWarrantiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductWarrantiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a warranty
         * @param {CreateProductWarrantyDto} createProductWarrantyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateWarranty(createProductWarrantyDto: CreateProductWarrantyDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyDto> {
            return localVarFp.adminCreateWarranty(createProductWarrantyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a warranty
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWarranty(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteWarranty(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a warranty
         * @param {number} id 
         * @param {UpdateProductWarrantyDto} updateProductWarrantyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWarranty(id: number, updateProductWarrantyDto: UpdateProductWarrantyDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyDto> {
            return localVarFp.adminUpdateWarranty(id, updateProductWarrantyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductWarrantiesApi - object-oriented interface
 * @export
 * @class AdminProductWarrantiesApi
 * @extends {BaseAPI}
 */
export class AdminProductWarrantiesApi extends BaseAPI {
    /**
     * 
     * @summary Create a warranty
     * @param {CreateProductWarrantyDto} createProductWarrantyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantiesApi
     */
    public adminCreateWarranty(createProductWarrantyDto: CreateProductWarrantyDto, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantiesApiFp(this.configuration).adminCreateWarranty(createProductWarrantyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a warranty
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantiesApi
     */
    public adminDeleteWarranty(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantiesApiFp(this.configuration).adminDeleteWarranty(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a warranty
     * @param {number} id 
     * @param {UpdateProductWarrantyDto} updateProductWarrantyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantiesApi
     */
    public adminUpdateWarranty(id: number, updateProductWarrantyDto: UpdateProductWarrantyDto, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantiesApiFp(this.configuration).adminUpdateWarranty(id, updateProductWarrantyDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductWarrantyProvidersApi - axios parameter creator
 * @export
 */
export const AdminProductWarrantyProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a warranty provider
         * @param {CreateProductWarrantyProviderDto} createProductWarrantyProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateWarrantyProvider: async (createProductWarrantyProviderDto: CreateProductWarrantyProviderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductWarrantyProviderDto' is not null or undefined
            assertParamExists('adminCreateWarrantyProvider', 'createProductWarrantyProviderDto', createProductWarrantyProviderDto)
            const localVarPath = `/api/v1/admin/product-warranty-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductWarrantyProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a warranty provider
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWarrantyProvider: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteWarrantyProvider', 'id', id)
            const localVarPath = `/api/v1/admin/product-warranty-providers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a warranty provider
         * @param {number} id 
         * @param {UpdateProductWarrantyProviderDto} updateProductWarrantyProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWarrantyProvider: async (id: number, updateProductWarrantyProviderDto: UpdateProductWarrantyProviderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateWarrantyProvider', 'id', id)
            // verify required parameter 'updateProductWarrantyProviderDto' is not null or undefined
            assertParamExists('adminUpdateWarrantyProvider', 'updateProductWarrantyProviderDto', updateProductWarrantyProviderDto)
            const localVarPath = `/api/v1/admin/product-warranty-providers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductWarrantyProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductWarrantyProvidersApi - functional programming interface
 * @export
 */
export const AdminProductWarrantyProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductWarrantyProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a warranty provider
         * @param {CreateProductWarrantyProviderDto} createProductWarrantyProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateWarrantyProvider(createProductWarrantyProviderDto: CreateProductWarrantyProviderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateWarrantyProvider(createProductWarrantyProviderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantyProvidersApi.adminCreateWarrantyProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a warranty provider
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteWarrantyProvider(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteWarrantyProvider(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantyProvidersApi.adminDeleteWarrantyProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a warranty provider
         * @param {number} id 
         * @param {UpdateProductWarrantyProviderDto} updateProductWarrantyProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateWarrantyProvider(id: number, updateProductWarrantyProviderDto: UpdateProductWarrantyProviderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateWarrantyProvider(id, updateProductWarrantyProviderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantyProvidersApi.adminUpdateWarrantyProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductWarrantyProvidersApi - factory interface
 * @export
 */
export const AdminProductWarrantyProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductWarrantyProvidersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a warranty provider
         * @param {CreateProductWarrantyProviderDto} createProductWarrantyProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateWarrantyProvider(createProductWarrantyProviderDto: CreateProductWarrantyProviderDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyProviderDto> {
            return localVarFp.adminCreateWarrantyProvider(createProductWarrantyProviderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a warranty provider
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWarrantyProvider(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteWarrantyProvider(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a warranty provider
         * @param {number} id 
         * @param {UpdateProductWarrantyProviderDto} updateProductWarrantyProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWarrantyProvider(id: number, updateProductWarrantyProviderDto: UpdateProductWarrantyProviderDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyProviderDto> {
            return localVarFp.adminUpdateWarrantyProvider(id, updateProductWarrantyProviderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductWarrantyProvidersApi - object-oriented interface
 * @export
 * @class AdminProductWarrantyProvidersApi
 * @extends {BaseAPI}
 */
export class AdminProductWarrantyProvidersApi extends BaseAPI {
    /**
     * 
     * @summary Create a warranty provider
     * @param {CreateProductWarrantyProviderDto} createProductWarrantyProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantyProvidersApi
     */
    public adminCreateWarrantyProvider(createProductWarrantyProviderDto: CreateProductWarrantyProviderDto, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantyProvidersApiFp(this.configuration).adminCreateWarrantyProvider(createProductWarrantyProviderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a warranty provider
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantyProvidersApi
     */
    public adminDeleteWarrantyProvider(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantyProvidersApiFp(this.configuration).adminDeleteWarrantyProvider(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a warranty provider
     * @param {number} id 
     * @param {UpdateProductWarrantyProviderDto} updateProductWarrantyProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantyProvidersApi
     */
    public adminUpdateWarrantyProvider(id: number, updateProductWarrantyProviderDto: UpdateProductWarrantyProviderDto, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantyProvidersApiFp(this.configuration).adminUpdateWarrantyProvider(id, updateProductWarrantyProviderDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductWarrantyTypesApi - axios parameter creator
 * @export
 */
export const AdminProductWarrantyTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a warranty type
         * @param {CreateProductWarrantyTypeDto} createProductWarrantyTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateWarrantyType: async (createProductWarrantyTypeDto: CreateProductWarrantyTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductWarrantyTypeDto' is not null or undefined
            assertParamExists('adminCreateWarrantyType', 'createProductWarrantyTypeDto', createProductWarrantyTypeDto)
            const localVarPath = `/api/v1/admin/product-warranty-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductWarrantyTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a warranty type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWarrantyType: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteWarrantyType', 'id', id)
            const localVarPath = `/api/v1/admin/product-warranty-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a warranty type
         * @param {number} id 
         * @param {UpdateProductWarrantyTypeDto} updateProductWarrantyTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWarrantyType: async (id: number, updateProductWarrantyTypeDto: UpdateProductWarrantyTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateWarrantyType', 'id', id)
            // verify required parameter 'updateProductWarrantyTypeDto' is not null or undefined
            assertParamExists('adminUpdateWarrantyType', 'updateProductWarrantyTypeDto', updateProductWarrantyTypeDto)
            const localVarPath = `/api/v1/admin/product-warranty-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductWarrantyTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductWarrantyTypesApi - functional programming interface
 * @export
 */
export const AdminProductWarrantyTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductWarrantyTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a warranty type
         * @param {CreateProductWarrantyTypeDto} createProductWarrantyTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateWarrantyType(createProductWarrantyTypeDto: CreateProductWarrantyTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateWarrantyType(createProductWarrantyTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantyTypesApi.adminCreateWarrantyType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a warranty type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteWarrantyType(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteWarrantyType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantyTypesApi.adminDeleteWarrantyType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a warranty type
         * @param {number} id 
         * @param {UpdateProductWarrantyTypeDto} updateProductWarrantyTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateWarrantyType(id: number, updateProductWarrantyTypeDto: UpdateProductWarrantyTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateWarrantyType(id, updateProductWarrantyTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductWarrantyTypesApi.adminUpdateWarrantyType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductWarrantyTypesApi - factory interface
 * @export
 */
export const AdminProductWarrantyTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductWarrantyTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a warranty type
         * @param {CreateProductWarrantyTypeDto} createProductWarrantyTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateWarrantyType(createProductWarrantyTypeDto: CreateProductWarrantyTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyTypeDto> {
            return localVarFp.adminCreateWarrantyType(createProductWarrantyTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a warranty type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWarrantyType(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteWarrantyType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a warranty type
         * @param {number} id 
         * @param {UpdateProductWarrantyTypeDto} updateProductWarrantyTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWarrantyType(id: number, updateProductWarrantyTypeDto: UpdateProductWarrantyTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyTypeDto> {
            return localVarFp.adminUpdateWarrantyType(id, updateProductWarrantyTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductWarrantyTypesApi - object-oriented interface
 * @export
 * @class AdminProductWarrantyTypesApi
 * @extends {BaseAPI}
 */
export class AdminProductWarrantyTypesApi extends BaseAPI {
    /**
     * 
     * @summary Create a warranty type
     * @param {CreateProductWarrantyTypeDto} createProductWarrantyTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantyTypesApi
     */
    public adminCreateWarrantyType(createProductWarrantyTypeDto: CreateProductWarrantyTypeDto, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantyTypesApiFp(this.configuration).adminCreateWarrantyType(createProductWarrantyTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a warranty type
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantyTypesApi
     */
    public adminDeleteWarrantyType(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantyTypesApiFp(this.configuration).adminDeleteWarrantyType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a warranty type
     * @param {number} id 
     * @param {UpdateProductWarrantyTypeDto} updateProductWarrantyTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductWarrantyTypesApi
     */
    public adminUpdateWarrantyType(id: number, updateProductWarrantyTypeDto: UpdateProductWarrantyTypeDto, options?: RawAxiosRequestConfig) {
        return AdminProductWarrantyTypesApiFp(this.configuration).adminUpdateWarrantyType(id, updateProductWarrantyTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductsApi - axios parameter creator
 * @export
 */
export const AdminProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns product template with all variants, pricing tiers, and supplier cost information.
         * @summary Get product details with variants (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductDetails: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetProductDetails', 'id', id)
            const localVarPath = `/api/v1/admin/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated product list. Pass sellerPartnerId to filter products by seller — equivalent to the seller\'s /products/my view but accessible to admins for any partner.
         * @summary List products (admin only)
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProducts: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets or updates pricelist items (buyer-facing prices) for each variant. Reconciles existing tiers: matched tiers are updated, new tiers are created, removed tiers are deleted.
         * @summary Update buyer-facing pricing tiers (admin only)
         * @param {number} id 
         * @param {UpdateBuyerPricingDto} updateBuyerPricingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductPricing: async (id: number, updateBuyerPricingDto: UpdateBuyerPricingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateProductPricing', 'id', id)
            // verify required parameter 'updateBuyerPricingDto' is not null or undefined
            assertParamExists('adminUpdateProductPricing', 'updateBuyerPricingDto', updateBuyerPricingDto)
            const localVarPath = `/api/v1/admin/products/{id}/pricing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBuyerPricingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductsApi - functional programming interface
 * @export
 */
export const AdminProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns product template with all variants, pricing tiers, and supplier cost information.
         * @summary Get product details with variants (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetProductDetails(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetProductDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminGetProductDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated product list. Pass sellerPartnerId to filter products by seller — equivalent to the seller\'s /products/my view but accessible to admins for any partner.
         * @summary List products (admin only)
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetProducts(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminGetProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets or updates pricelist items (buyer-facing prices) for each variant. Reconciles existing tiers: matched tiers are updated, new tiers are created, removed tiers are deleted.
         * @summary Update buyer-facing pricing tiers (admin only)
         * @param {number} id 
         * @param {UpdateBuyerPricingDto} updateBuyerPricingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateProductPricing(id: number, updateBuyerPricingDto: UpdateBuyerPricingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateProductPricing(id, updateBuyerPricingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminUpdateProductPricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductsApi - factory interface
 * @export
 */
export const AdminProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductsApiFp(configuration)
    return {
        /**
         * Returns product template with all variants, pricing tiers, and supplier cost information.
         * @summary Get product details with variants (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductDetails(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductDetailsDto> {
            return localVarFp.adminGetProductDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated product list. Pass sellerPartnerId to filter products by seller — equivalent to the seller\'s /products/my view but accessible to admins for any partner.
         * @summary List products (admin only)
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductsResponseDto> {
            return localVarFp.adminGetProducts(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets or updates pricelist items (buyer-facing prices) for each variant. Reconciles existing tiers: matched tiers are updated, new tiers are created, removed tiers are deleted.
         * @summary Update buyer-facing pricing tiers (admin only)
         * @param {number} id 
         * @param {UpdateBuyerPricingDto} updateBuyerPricingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateProductPricing(id: number, updateBuyerPricingDto: UpdateBuyerPricingDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminUpdateProductPricing(id, updateBuyerPricingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductsApi - object-oriented interface
 * @export
 * @class AdminProductsApi
 * @extends {BaseAPI}
 */
export class AdminProductsApi extends BaseAPI {
    /**
     * Returns product template with all variants, pricing tiers, and supplier cost information.
     * @summary Get product details with variants (admin only)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductsApi
     */
    public adminGetProductDetails(id: number, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminGetProductDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated product list. Pass sellerPartnerId to filter products by seller — equivalent to the seller\'s /products/my view but accessible to admins for any partner.
     * @summary List products (admin only)
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductsApi
     */
    public adminGetProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminGetProducts(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets or updates pricelist items (buyer-facing prices) for each variant. Reconciles existing tiers: matched tiers are updated, new tiers are created, removed tiers are deleted.
     * @summary Update buyer-facing pricing tiers (admin only)
     * @param {number} id 
     * @param {UpdateBuyerPricingDto} updateBuyerPricingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductsApi
     */
    public adminUpdateProductPricing(id: number, updateBuyerPricingDto: UpdateBuyerPricingDto, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminUpdateProductPricing(id, updateBuyerPricingDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminReportsApi - axios parameter creator
 * @export
 */
export const AdminReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export buyer engagement report as CSV (US-A-023)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExportBuyerReport: async (query?: ReportQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reports/buyers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export sales report as CSV (US-A-021)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExportSalesReport: async (query?: SalesQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reports/sales/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export supplier performance report as CSV (US-A-022)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExportSupplierReport: async (query?: ReportQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reports/suppliers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Buyer engagement report (US-A-023)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetBuyerReport: async (query?: ReportQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reports/buyers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sales and margin report (US-A-021)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSalesReport: async (query?: SalesQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reports/sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Supplier performance report (US-A-022)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSupplierReport: async (query?: ReportQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reports/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminReportsApi - functional programming interface
 * @export
 */
export const AdminReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export buyer engagement report as CSV (US-A-023)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminExportBuyerReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminExportBuyerReport(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.adminExportBuyerReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export sales report as CSV (US-A-021)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminExportSalesReport(query?: SalesQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminExportSalesReport(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.adminExportSalesReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export supplier performance report as CSV (US-A-022)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminExportSupplierReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminExportSupplierReport(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.adminExportSupplierReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Buyer engagement report (US-A-023)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetBuyerReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetBuyerReport(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.adminGetBuyerReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sales and margin report (US-A-021)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetSalesReport(query?: SalesQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetSalesReport(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.adminGetSalesReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Supplier performance report (US-A-022)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetSupplierReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetSupplierReport(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.adminGetSupplierReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminReportsApi - factory interface
 * @export
 */
export const AdminReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Export buyer engagement report as CSV (US-A-023)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExportBuyerReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminExportBuyerReport(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export sales report as CSV (US-A-021)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExportSalesReport(query?: SalesQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminExportSalesReport(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export supplier performance report as CSV (US-A-022)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExportSupplierReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminExportSupplierReport(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Buyer engagement report (US-A-023)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetBuyerReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminGetBuyerReport(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sales and margin report (US-A-021)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSalesReport(query?: SalesQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<SalesReportDto> {
            return localVarFp.adminGetSalesReport(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Supplier performance report (US-A-022)
         * @param {ReportQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSupplierReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminGetSupplierReport(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminReportsApi - object-oriented interface
 * @export
 * @class AdminReportsApi
 * @extends {BaseAPI}
 */
export class AdminReportsApi extends BaseAPI {
    /**
     * 
     * @summary Export buyer engagement report as CSV (US-A-023)
     * @param {ReportQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminExportBuyerReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminExportBuyerReport(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export sales report as CSV (US-A-021)
     * @param {SalesQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminExportSalesReport(query?: SalesQueryDto, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminExportSalesReport(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export supplier performance report as CSV (US-A-022)
     * @param {ReportQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminExportSupplierReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminExportSupplierReport(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Buyer engagement report (US-A-023)
     * @param {ReportQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminGetBuyerReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminGetBuyerReport(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sales and margin report (US-A-021)
     * @param {SalesQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminGetSalesReport(query?: SalesQueryDto, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminGetSalesReport(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Supplier performance report (US-A-022)
     * @param {ReportQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminGetSupplierReport(query?: ReportQueryDto, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminGetSupplierReport(query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminUsersApi - axios parameter creator
 * @export
 */
export const AdminUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Soft-delete (deactivate) user (US-A-024)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteUser', 'id', id)
            const localVarPath = `/api/v1/admin/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user by ID (US-A-024)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetUser', 'id', id)
            const localVarPath = `/api/v1/admin/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all users (US-A-024)
         * @param {AdminUserQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListUsers: async (query?: AdminUserQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user role or active status (US-A-024)
         * @param {string} id 
         * @param {AdminUpdateUserDto} adminUpdateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateUser: async (id: string, adminUpdateUserDto: AdminUpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateUser', 'id', id)
            // verify required parameter 'adminUpdateUserDto' is not null or undefined
            assertParamExists('adminUpdateUser', 'adminUpdateUserDto', adminUpdateUserDto)
            const localVarPath = `/api/v1/admin/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin-assisted user creation for corporate accounts. Creates user with verified email/phone, optionally sets password, and can include documents (which will be auto-approved).
         * @summary Create a new user account (admin only)
         * @param {AdminCreateUserDto} adminCreateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (adminCreateUserDto: AdminCreateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreateUserDto' is not null or undefined
            assertParamExists('createUser', 'adminCreateUserDto', adminCreateUserDto)
            const localVarPath = `/api/v1/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUsersApi - functional programming interface
 * @export
 */
export const AdminUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Soft-delete (deactivate) user (US-A-024)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminDeleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user by ID (US-A-024)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminGetUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all users (US-A-024)
         * @param {AdminUserQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListUsers(query?: AdminUserQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListUsers(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminListUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user role or active status (US-A-024)
         * @param {string} id 
         * @param {AdminUpdateUserDto} adminUpdateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateUser(id: string, adminUpdateUserDto: AdminUpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateUser(id, adminUpdateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUpdateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin-assisted user creation for corporate accounts. Creates user with verified email/phone, optionally sets password, and can include documents (which will be auto-approved).
         * @summary Create a new user account (admin only)
         * @param {AdminCreateUserDto} adminCreateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(adminCreateUserDto: AdminCreateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(adminCreateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUsersApi - factory interface
 * @export
 */
export const AdminUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Soft-delete (deactivate) user (US-A-024)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user by ID (US-A-024)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.adminGetUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all users (US-A-024)
         * @param {AdminUserQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListUsers(query?: AdminUserQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminListUsers(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user role or active status (US-A-024)
         * @param {string} id 
         * @param {AdminUpdateUserDto} adminUpdateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateUser(id: string, adminUpdateUserDto: AdminUpdateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.adminUpdateUser(id, adminUpdateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin-assisted user creation for corporate accounts. Creates user with verified email/phone, optionally sets password, and can include documents (which will be auto-approved).
         * @summary Create a new user account (admin only)
         * @param {AdminCreateUserDto} adminCreateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(adminCreateUserDto: AdminCreateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.createUser(adminCreateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUsersApi - object-oriented interface
 * @export
 * @class AdminUsersApi
 * @extends {BaseAPI}
 */
export class AdminUsersApi extends BaseAPI {
    /**
     * 
     * @summary Soft-delete (deactivate) user (US-A-024)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminDeleteUser(id: string, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminDeleteUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user by ID (US-A-024)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminGetUser(id: string, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminGetUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all users (US-A-024)
     * @param {AdminUserQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminListUsers(query?: AdminUserQueryDto, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminListUsers(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user role or active status (US-A-024)
     * @param {string} id 
     * @param {AdminUpdateUserDto} adminUpdateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUpdateUser(id: string, adminUpdateUserDto: AdminUpdateUserDto, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUpdateUser(id, adminUpdateUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin-assisted user creation for corporate accounts. Creates user with verified email/phone, optionally sets password, and can include documents (which will be auto-approved).
     * @summary Create a new user account (admin only)
     * @param {AdminCreateUserDto} adminCreateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public createUser(adminCreateUserDto: AdminCreateUserDto, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).createUser(adminCreateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminWarrantyClaimsApi - axios parameter creator
 * @export
 */
export const AdminWarrantyClaimsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin adds a message to a warranty claim thread
         * @param {string} id 
         * @param {AddClaimMessageDto} addClaimMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddWarrantyClaimMessage: async (id: string, addClaimMessageDto: AddClaimMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminAddWarrantyClaimMessage', 'id', id)
            // verify required parameter 'addClaimMessageDto' is not null or undefined
            assertParamExists('adminAddWarrantyClaimMessage', 'addClaimMessageDto', addClaimMessageDto)
            const localVarPath = `/api/v1/admin/warranty-claims/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addClaimMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get any warranty claim detail (admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWarrantyClaimDetail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminGetWarrantyClaimDetail', 'id', id)
            const localVarPath = `/api/v1/admin/warranty-claims/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get platform-wide warranty claim statistics (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWarrantyClaimStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/warranty-claims/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all warranty claims (admin)
         * @param {AdminWarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListWarrantyClaims: async (query?: AdminWarrantyClaimQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/warranty-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin mediation: transition claim status (MEDIATING → RESOLVED/REJECTED/ESCALATED)
         * @param {string} id 
         * @param {AdminResolveClaimDto} adminResolveClaimDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResolveWarrantyClaim: async (id: string, adminResolveClaimDto: AdminResolveClaimDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminResolveWarrantyClaim', 'id', id)
            // verify required parameter 'adminResolveClaimDto' is not null or undefined
            assertParamExists('adminResolveWarrantyClaim', 'adminResolveClaimDto', adminResolveClaimDto)
            const localVarPath = `/api/v1/admin/warranty-claims/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminResolveClaimDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminWarrantyClaimsApi - functional programming interface
 * @export
 */
export const AdminWarrantyClaimsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminWarrantyClaimsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin adds a message to a warranty claim thread
         * @param {string} id 
         * @param {AddClaimMessageDto} addClaimMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAddWarrantyClaimMessage(id: string, addClaimMessageDto: AddClaimMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAddWarrantyClaimMessage(id, addClaimMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWarrantyClaimsApi.adminAddWarrantyClaimMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get any warranty claim detail (admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetWarrantyClaimDetail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetWarrantyClaimDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWarrantyClaimsApi.adminGetWarrantyClaimDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get platform-wide warranty claim statistics (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetWarrantyClaimStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetWarrantyClaimStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWarrantyClaimsApi.adminGetWarrantyClaimStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all warranty claims (admin)
         * @param {AdminWarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListWarrantyClaims(query?: AdminWarrantyClaimQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListWarrantyClaims(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWarrantyClaimsApi.adminListWarrantyClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin mediation: transition claim status (MEDIATING → RESOLVED/REJECTED/ESCALATED)
         * @param {string} id 
         * @param {AdminResolveClaimDto} adminResolveClaimDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminResolveWarrantyClaim(id: string, adminResolveClaimDto: AdminResolveClaimDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminResolveWarrantyClaim(id, adminResolveClaimDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWarrantyClaimsApi.adminResolveWarrantyClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminWarrantyClaimsApi - factory interface
 * @export
 */
export const AdminWarrantyClaimsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminWarrantyClaimsApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin adds a message to a warranty claim thread
         * @param {string} id 
         * @param {AddClaimMessageDto} addClaimMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddWarrantyClaimMessage(id: string, addClaimMessageDto: AddClaimMessageDto, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimMessageDto> {
            return localVarFp.adminAddWarrantyClaimMessage(id, addClaimMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get any warranty claim detail (admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWarrantyClaimDetail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimDto> {
            return localVarFp.adminGetWarrantyClaimDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get platform-wide warranty claim statistics (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWarrantyClaimStats(options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimStatsDto> {
            return localVarFp.adminGetWarrantyClaimStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all warranty claims (admin)
         * @param {AdminWarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListWarrantyClaims(query?: AdminWarrantyClaimQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminListWarrantyClaims(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin mediation: transition claim status (MEDIATING → RESOLVED/REJECTED/ESCALATED)
         * @param {string} id 
         * @param {AdminResolveClaimDto} adminResolveClaimDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResolveWarrantyClaim(id: string, adminResolveClaimDto: AdminResolveClaimDto, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimDto> {
            return localVarFp.adminResolveWarrantyClaim(id, adminResolveClaimDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminWarrantyClaimsApi - object-oriented interface
 * @export
 * @class AdminWarrantyClaimsApi
 * @extends {BaseAPI}
 */
export class AdminWarrantyClaimsApi extends BaseAPI {
    /**
     * 
     * @summary Admin adds a message to a warranty claim thread
     * @param {string} id 
     * @param {AddClaimMessageDto} addClaimMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWarrantyClaimsApi
     */
    public adminAddWarrantyClaimMessage(id: string, addClaimMessageDto: AddClaimMessageDto, options?: RawAxiosRequestConfig) {
        return AdminWarrantyClaimsApiFp(this.configuration).adminAddWarrantyClaimMessage(id, addClaimMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get any warranty claim detail (admin)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWarrantyClaimsApi
     */
    public adminGetWarrantyClaimDetail(id: string, options?: RawAxiosRequestConfig) {
        return AdminWarrantyClaimsApiFp(this.configuration).adminGetWarrantyClaimDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get platform-wide warranty claim statistics (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWarrantyClaimsApi
     */
    public adminGetWarrantyClaimStats(options?: RawAxiosRequestConfig) {
        return AdminWarrantyClaimsApiFp(this.configuration).adminGetWarrantyClaimStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all warranty claims (admin)
     * @param {AdminWarrantyClaimQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWarrantyClaimsApi
     */
    public adminListWarrantyClaims(query?: AdminWarrantyClaimQueryDto, options?: RawAxiosRequestConfig) {
        return AdminWarrantyClaimsApiFp(this.configuration).adminListWarrantyClaims(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin mediation: transition claim status (MEDIATING → RESOLVED/REJECTED/ESCALATED)
     * @param {string} id 
     * @param {AdminResolveClaimDto} adminResolveClaimDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWarrantyClaimsApi
     */
    public adminResolveWarrantyClaim(id: string, adminResolveClaimDto: AdminResolveClaimDto, options?: RawAxiosRequestConfig) {
        return AdminWarrantyClaimsApiFp(this.configuration).adminResolveWarrantyClaim(id, adminResolveClaimDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminWarrantyProductsApi - axios parameter creator
 * @export
 */
export const AdminWarrantyProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Archive a warranty product (moderation takedown)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWarrantyProduct: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDeleteWarrantyProduct', 'id', id)
            const localVarPath = `/api/v1/admin/warranty-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all warranty products (cross-seller)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListWarrantyProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/warranty-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Moderate a warranty product (override seller fields)
         * @param {number} id 
         * @param {UpdateWarrantyProductDto} updateWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWarrantyProduct: async (id: number, updateWarrantyProductDto: UpdateWarrantyProductDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUpdateWarrantyProduct', 'id', id)
            // verify required parameter 'updateWarrantyProductDto' is not null or undefined
            assertParamExists('adminUpdateWarrantyProduct', 'updateWarrantyProductDto', updateWarrantyProductDto)
            const localVarPath = `/api/v1/admin/warranty-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWarrantyProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminWarrantyProductsApi - functional programming interface
 * @export
 */
export const AdminWarrantyProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminWarrantyProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Archive a warranty product (moderation takedown)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteWarrantyProduct(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteWarrantyProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWarrantyProductsApi.adminDeleteWarrantyProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all warranty products (cross-seller)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListWarrantyProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarrantyProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListWarrantyProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWarrantyProductsApi.adminListWarrantyProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Moderate a warranty product (override seller fields)
         * @param {number} id 
         * @param {UpdateWarrantyProductDto} updateWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateWarrantyProduct(id: number, updateWarrantyProductDto: UpdateWarrantyProductDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateWarrantyProduct(id, updateWarrantyProductDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminWarrantyProductsApi.adminUpdateWarrantyProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminWarrantyProductsApi - factory interface
 * @export
 */
export const AdminWarrantyProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminWarrantyProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Archive a warranty product (moderation takedown)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWarrantyProduct(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeleteWarrantyProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all warranty products (cross-seller)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListWarrantyProducts(options?: RawAxiosRequestConfig): AxiosPromise<Array<WarrantyProductDto>> {
            return localVarFp.adminListWarrantyProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Moderate a warranty product (override seller fields)
         * @param {number} id 
         * @param {UpdateWarrantyProductDto} updateWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWarrantyProduct(id: number, updateWarrantyProductDto: UpdateWarrantyProductDto, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyProductDto> {
            return localVarFp.adminUpdateWarrantyProduct(id, updateWarrantyProductDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminWarrantyProductsApi - object-oriented interface
 * @export
 * @class AdminWarrantyProductsApi
 * @extends {BaseAPI}
 */
export class AdminWarrantyProductsApi extends BaseAPI {
    /**
     * 
     * @summary Archive a warranty product (moderation takedown)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWarrantyProductsApi
     */
    public adminDeleteWarrantyProduct(id: number, options?: RawAxiosRequestConfig) {
        return AdminWarrantyProductsApiFp(this.configuration).adminDeleteWarrantyProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all warranty products (cross-seller)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWarrantyProductsApi
     */
    public adminListWarrantyProducts(options?: RawAxiosRequestConfig) {
        return AdminWarrantyProductsApiFp(this.configuration).adminListWarrantyProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Moderate a warranty product (override seller fields)
     * @param {number} id 
     * @param {UpdateWarrantyProductDto} updateWarrantyProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminWarrantyProductsApi
     */
    public adminUpdateWarrantyProduct(id: number, updateWarrantyProductDto: UpdateWarrantyProductDto, options?: RawAxiosRequestConfig) {
        return AdminWarrantyProductsApiFp(this.configuration).adminUpdateWarrantyProduct(id, updateWarrantyProductDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppApi - axios parameter creator
 * @export
 */
export const AppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHello: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppApi - functional programming interface
 * @export
 */
export const AppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHello(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHello(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppApi.getHello']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppApi - factory interface
 * @export
 */
export const AppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHello(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getHello(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
export class AppApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public getHello(options?: RawAxiosRequestConfig) {
        return AppApiFp(this.configuration).getHello(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationOTPApi - axios parameter creator
 * @export
 */
export const AuthenticationOTPApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lightweight precheck used by the multi-step signup wizard so the user is told an email is taken at the credentials step instead of failing the final submit. Returns one boolean per field supplied; fields omitted in the request are omitted from the response.
         * @summary Check whether an email and/or phone are free to register
         * @param {CheckAvailabilityDto} checkAvailabilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpCheckAvailability: async (checkAvailabilityDto: CheckAvailabilityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkAvailabilityDto' is not null or undefined
            assertParamExists('otpCheckAvailability', 'checkAvailabilityDto', checkAvailabilityDto)
            const localVarPath = `/api/v1/auth/otp/check-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkAvailabilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initiate OTP login
         * @param {LoginOtpRequestDto} loginOtpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpLoginRequest: async (loginOtpRequestDto: LoginOtpRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginOtpRequestDto' is not null or undefined
            assertParamExists('otpLoginRequest', 'loginOtpRequestDto', loginOtpRequestDto)
            const localVarPath = `/api/v1/auth/otp/login/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginOtpRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify OTP and login
         * @param {VerifyOtpDto} verifyOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpLoginVerify: async (verifyOtpDto: VerifyOtpDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyOtpDto' is not null or undefined
            assertParamExists('otpLoginVerify', 'verifyOtpDto', verifyOtpDto)
            const localVarPath = `/api/v1/auth/otp/login/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register (email+otp or phone+otp)
         * @param {RegisterOtpDto} registerOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpRegister: async (registerOtpDto: RegisterOtpDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerOtpDto' is not null or undefined
            assertParamExists('otpRegister', 'registerOtpDto', registerOtpDto)
            const localVarPath = `/api/v1/auth/otp/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerOtpDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend verification OTP
         * @param {ResendVerificationDto} resendVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpResendVerification: async (resendVerificationDto: ResendVerificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendVerificationDto' is not null or undefined
            assertParamExists('otpResendVerification', 'resendVerificationDto', resendVerificationDto)
            const localVarPath = `/api/v1/auth/otp/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify registration OTP and create session
         * @param {VerifyOtpDto} verifyOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpVerifyComplete: async (verifyOtpDto: VerifyOtpDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyOtpDto' is not null or undefined
            assertParamExists('otpVerifyComplete', 'verifyOtpDto', verifyOtpDto)
            const localVarPath = `/api/v1/auth/otp/register/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationOTPApi - functional programming interface
 * @export
 */
export const AuthenticationOTPApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationOTPApiAxiosParamCreator(configuration)
    return {
        /**
         * Lightweight precheck used by the multi-step signup wizard so the user is told an email is taken at the credentials step instead of failing the final submit. Returns one boolean per field supplied; fields omitted in the request are omitted from the response.
         * @summary Check whether an email and/or phone are free to register
         * @param {CheckAvailabilityDto} checkAvailabilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpCheckAvailability(checkAvailabilityDto: CheckAvailabilityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAvailabilityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpCheckAvailability(checkAvailabilityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationOTPApi.otpCheckAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initiate OTP login
         * @param {LoginOtpRequestDto} loginOtpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpLoginRequest(loginOtpRequestDto: LoginOtpRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpLoginRequest(loginOtpRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationOTPApi.otpLoginRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify OTP and login
         * @param {VerifyOtpDto} verifyOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpLoginVerify(verifyOtpDto: VerifyOtpDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpLoginVerify(verifyOtpDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationOTPApi.otpLoginVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register (email+otp or phone+otp)
         * @param {RegisterOtpDto} registerOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpRegister(registerOtpDto: RegisterOtpDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpRegister(registerOtpDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationOTPApi.otpRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend verification OTP
         * @param {ResendVerificationDto} resendVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpResendVerification(resendVerificationDto: ResendVerificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpResendVerification(resendVerificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationOTPApi.otpResendVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify registration OTP and create session
         * @param {VerifyOtpDto} verifyOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpVerifyComplete(verifyOtpDto: VerifyOtpDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpVerifyComplete(verifyOtpDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationOTPApi.otpVerifyComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationOTPApi - factory interface
 * @export
 */
export const AuthenticationOTPApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationOTPApiFp(configuration)
    return {
        /**
         * Lightweight precheck used by the multi-step signup wizard so the user is told an email is taken at the credentials step instead of failing the final submit. Returns one boolean per field supplied; fields omitted in the request are omitted from the response.
         * @summary Check whether an email and/or phone are free to register
         * @param {CheckAvailabilityDto} checkAvailabilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpCheckAvailability(checkAvailabilityDto: CheckAvailabilityDto, options?: RawAxiosRequestConfig): AxiosPromise<CheckAvailabilityResponseDto> {
            return localVarFp.otpCheckAvailability(checkAvailabilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initiate OTP login
         * @param {LoginOtpRequestDto} loginOtpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpLoginRequest(loginOtpRequestDto: LoginOtpRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.otpLoginRequest(loginOtpRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify OTP and login
         * @param {VerifyOtpDto} verifyOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpLoginVerify(verifyOtpDto: VerifyOtpDto, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseDto> {
            return localVarFp.otpLoginVerify(verifyOtpDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register (email+otp or phone+otp)
         * @param {RegisterOtpDto} registerOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpRegister(registerOtpDto: RegisterOtpDto, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResponseDto> {
            return localVarFp.otpRegister(registerOtpDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend verification OTP
         * @param {ResendVerificationDto} resendVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpResendVerification(resendVerificationDto: ResendVerificationDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.otpResendVerification(resendVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify registration OTP and create session
         * @param {VerifyOtpDto} verifyOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpVerifyComplete(verifyOtpDto: VerifyOtpDto, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseDto> {
            return localVarFp.otpVerifyComplete(verifyOtpDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationOTPApi - object-oriented interface
 * @export
 * @class AuthenticationOTPApi
 * @extends {BaseAPI}
 */
export class AuthenticationOTPApi extends BaseAPI {
    /**
     * Lightweight precheck used by the multi-step signup wizard so the user is told an email is taken at the credentials step instead of failing the final submit. Returns one boolean per field supplied; fields omitted in the request are omitted from the response.
     * @summary Check whether an email and/or phone are free to register
     * @param {CheckAvailabilityDto} checkAvailabilityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationOTPApi
     */
    public otpCheckAvailability(checkAvailabilityDto: CheckAvailabilityDto, options?: RawAxiosRequestConfig) {
        return AuthenticationOTPApiFp(this.configuration).otpCheckAvailability(checkAvailabilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initiate OTP login
     * @param {LoginOtpRequestDto} loginOtpRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationOTPApi
     */
    public otpLoginRequest(loginOtpRequestDto: LoginOtpRequestDto, options?: RawAxiosRequestConfig) {
        return AuthenticationOTPApiFp(this.configuration).otpLoginRequest(loginOtpRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify OTP and login
     * @param {VerifyOtpDto} verifyOtpDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationOTPApi
     */
    public otpLoginVerify(verifyOtpDto: VerifyOtpDto, options?: RawAxiosRequestConfig) {
        return AuthenticationOTPApiFp(this.configuration).otpLoginVerify(verifyOtpDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register (email+otp or phone+otp)
     * @param {RegisterOtpDto} registerOtpDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationOTPApi
     */
    public otpRegister(registerOtpDto: RegisterOtpDto, options?: RawAxiosRequestConfig) {
        return AuthenticationOTPApiFp(this.configuration).otpRegister(registerOtpDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend verification OTP
     * @param {ResendVerificationDto} resendVerificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationOTPApi
     */
    public otpResendVerification(resendVerificationDto: ResendVerificationDto, options?: RawAxiosRequestConfig) {
        return AuthenticationOTPApiFp(this.configuration).otpResendVerification(resendVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify registration OTP and create session
     * @param {VerifyOtpDto} verifyOtpDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationOTPApi
     */
    public otpVerifyComplete(verifyOtpDto: VerifyOtpDto, options?: RawAxiosRequestConfig) {
        return AuthenticationOTPApiFp(this.configuration).otpVerifyComplete(verifyOtpDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationPasswordApi - axios parameter creator
 * @export
 */
export const AuthenticationPasswordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Initiate password reset via email OTP
         * @param {ForgotPasswordDto} forgotPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordForgot: async (forgotPasswordDto: ForgotPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordDto' is not null or undefined
            assertParamExists('passwordForgot', 'forgotPasswordDto', forgotPasswordDto)
            const localVarPath = `/api/v1/auth/password/forgot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with email and password
         * @param {LoginPasswordDto} loginPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordLogin: async (loginPasswordDto: LoginPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginPasswordDto' is not null or undefined
            assertParamExists('passwordLogin', 'loginPasswordDto', loginPasswordDto)
            const localVarPath = `/api/v1/auth/password/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register with email and password
         * @param {RegisterPasswordDto} registerPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordRegister: async (registerPasswordDto: RegisterPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerPasswordDto' is not null or undefined
            assertParamExists('passwordRegister', 'registerPasswordDto', registerPasswordDto)
            const localVarPath = `/api/v1/auth/password/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset password with temp token
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReset: async (resetPasswordDto: ResetPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('passwordReset', 'resetPasswordDto', resetPasswordDto)
            const localVarPath = `/api/v1/auth/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify password reset OTP
         * @param {VerifyPasswordResetOtpDto} verifyPasswordResetOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordVerifyResetOtp: async (verifyPasswordResetOtpDto: VerifyPasswordResetOtpDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPasswordResetOtpDto' is not null or undefined
            assertParamExists('passwordVerifyResetOtp', 'verifyPasswordResetOtpDto', verifyPasswordResetOtpDto)
            const localVarPath = `/api/v1/auth/password/verify-reset-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPasswordResetOtpDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify 2FA code from login challenge and issue session
         * @param {Verify2faLoginDto} verify2faLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorVerifyLogin: async (verify2faLoginDto: Verify2faLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verify2faLoginDto' is not null or undefined
            assertParamExists('twoFactorVerifyLogin', 'verify2faLoginDto', verify2faLoginDto)
            const localVarPath = `/api/v1/auth/password/2fa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verify2faLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationPasswordApi - functional programming interface
 * @export
 */
export const AuthenticationPasswordApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationPasswordApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Initiate password reset via email OTP
         * @param {ForgotPasswordDto} forgotPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordForgot(forgotPasswordDto: ForgotPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordForgot(forgotPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationPasswordApi.passwordForgot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with email and password
         * @param {LoginPasswordDto} loginPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordLogin(loginPasswordDto: LoginPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordLogin(loginPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationPasswordApi.passwordLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register with email and password
         * @param {RegisterPasswordDto} registerPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordRegister(registerPasswordDto: RegisterPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordRegister(registerPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationPasswordApi.passwordRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset password with temp token
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReset(resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReset(resetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationPasswordApi.passwordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify password reset OTP
         * @param {VerifyPasswordResetOtpDto} verifyPasswordResetOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordVerifyResetOtp(verifyPasswordResetOtpDto: VerifyPasswordResetOtpDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyPasswordResetOtpResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordVerifyResetOtp(verifyPasswordResetOtpDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationPasswordApi.passwordVerifyResetOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify 2FA code from login challenge and issue session
         * @param {Verify2faLoginDto} verify2faLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorVerifyLogin(verify2faLoginDto: Verify2faLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorVerifyLogin(verify2faLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationPasswordApi.twoFactorVerifyLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationPasswordApi - factory interface
 * @export
 */
export const AuthenticationPasswordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationPasswordApiFp(configuration)
    return {
        /**
         * 
         * @summary Initiate password reset via email OTP
         * @param {ForgotPasswordDto} forgotPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordForgot(forgotPasswordDto: ForgotPasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.passwordForgot(forgotPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with email and password
         * @param {LoginPasswordDto} loginPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordLogin(loginPasswordDto: LoginPasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseDto> {
            return localVarFp.passwordLogin(loginPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register with email and password
         * @param {RegisterPasswordDto} registerPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordRegister(registerPasswordDto: RegisterPasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResponseDto> {
            return localVarFp.passwordRegister(registerPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset password with temp token
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReset(resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.passwordReset(resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify password reset OTP
         * @param {VerifyPasswordResetOtpDto} verifyPasswordResetOtpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordVerifyResetOtp(verifyPasswordResetOtpDto: VerifyPasswordResetOtpDto, options?: RawAxiosRequestConfig): AxiosPromise<VerifyPasswordResetOtpResponseDto> {
            return localVarFp.passwordVerifyResetOtp(verifyPasswordResetOtpDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify 2FA code from login challenge and issue session
         * @param {Verify2faLoginDto} verify2faLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorVerifyLogin(verify2faLoginDto: Verify2faLoginDto, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseDto> {
            return localVarFp.twoFactorVerifyLogin(verify2faLoginDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationPasswordApi - object-oriented interface
 * @export
 * @class AuthenticationPasswordApi
 * @extends {BaseAPI}
 */
export class AuthenticationPasswordApi extends BaseAPI {
    /**
     * 
     * @summary Initiate password reset via email OTP
     * @param {ForgotPasswordDto} forgotPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationPasswordApi
     */
    public passwordForgot(forgotPasswordDto: ForgotPasswordDto, options?: RawAxiosRequestConfig) {
        return AuthenticationPasswordApiFp(this.configuration).passwordForgot(forgotPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with email and password
     * @param {LoginPasswordDto} loginPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationPasswordApi
     */
    public passwordLogin(loginPasswordDto: LoginPasswordDto, options?: RawAxiosRequestConfig) {
        return AuthenticationPasswordApiFp(this.configuration).passwordLogin(loginPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register with email and password
     * @param {RegisterPasswordDto} registerPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationPasswordApi
     */
    public passwordRegister(registerPasswordDto: RegisterPasswordDto, options?: RawAxiosRequestConfig) {
        return AuthenticationPasswordApiFp(this.configuration).passwordRegister(registerPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset password with temp token
     * @param {ResetPasswordDto} resetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationPasswordApi
     */
    public passwordReset(resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig) {
        return AuthenticationPasswordApiFp(this.configuration).passwordReset(resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify password reset OTP
     * @param {VerifyPasswordResetOtpDto} verifyPasswordResetOtpDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationPasswordApi
     */
    public passwordVerifyResetOtp(verifyPasswordResetOtpDto: VerifyPasswordResetOtpDto, options?: RawAxiosRequestConfig) {
        return AuthenticationPasswordApiFp(this.configuration).passwordVerifyResetOtp(verifyPasswordResetOtpDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify 2FA code from login challenge and issue session
     * @param {Verify2faLoginDto} verify2faLoginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationPasswordApi
     */
    public twoFactorVerifyLogin(verify2faLoginDto: Verify2faLoginDto, options?: RawAxiosRequestConfig) {
        return AuthenticationPasswordApiFp(this.configuration).twoFactorVerifyLogin(verify2faLoginDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationSessionApi - axios parameter creator
 * @export
 */
export const AuthenticationSessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Logout a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh a user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationSessionApi - functional programming interface
 * @export
 */
export const AuthenticationSessionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationSessionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Logout a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationSessionApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh a user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationSessionApi.refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationSessionApi - factory interface
 * @export
 */
export const AuthenticationSessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationSessionApiFp(configuration)
    return {
        /**
         * 
         * @summary Logout a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh a user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseDto> {
            return localVarFp.refresh(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationSessionApi - object-oriented interface
 * @export
 * @class AuthenticationSessionApi
 * @extends {BaseAPI}
 */
export class AuthenticationSessionApi extends BaseAPI {
    /**
     * 
     * @summary Logout a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationSessionApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return AuthenticationSessionApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh a user session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationSessionApi
     */
    public refresh(options?: RawAxiosRequestConfig) {
        return AuthenticationSessionApiFp(this.configuration).refresh(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BankAccountsApi - axios parameter creator
 * @export
 */
export const BankAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List the current user\'s bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyBankAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/bank-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankAccountsApi - functional programming interface
 * @export
 */
export const BankAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List the current user\'s bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyBankAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankAccountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyBankAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountsApi.listMyBankAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BankAccountsApi - factory interface
 * @export
 */
export const BankAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankAccountsApiFp(configuration)
    return {
        /**
         * 
         * @summary List the current user\'s bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyBankAccounts(options?: RawAxiosRequestConfig): AxiosPromise<Array<BankAccountDto>> {
            return localVarFp.listMyBankAccounts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BankAccountsApi - object-oriented interface
 * @export
 * @class BankAccountsApi
 * @extends {BaseAPI}
 */
export class BankAccountsApi extends BaseAPI {
    /**
     * 
     * @summary List the current user\'s bank accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    public listMyBankAccounts(options?: RawAxiosRequestConfig) {
        return BankAccountsApiFp(this.configuration).listMyBankAccounts(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BrandsApi - axios parameter creator
 * @export
 */
export const BrandsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a brand by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBrandById', 'id', id)
            const localVarPath = `/api/v1/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all product brands from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandsApi - functional programming interface
 * @export
 */
export const BrandsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a brand by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getBrandById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all product brands from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandsApi - factory interface
 * @export
 */
export const BrandsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a brand by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<BrandDto> {
            return localVarFp.getBrandById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all product brands from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands(options?: RawAxiosRequestConfig): AxiosPromise<Array<BrandDto>> {
            return localVarFp.getBrands(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandsApi - object-oriented interface
 * @export
 * @class BrandsApi
 * @extends {BaseAPI}
 */
export class BrandsApi extends BaseAPI {
    /**
     * 
     * @summary Get a brand by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getBrandById(id: number, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getBrandById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all product brands from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getBrands(options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getBrands(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BuyerAddressesApi - axios parameter creator
 * @export
 */
export const BuyerAddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Archive a saved delivery address (soft delete)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveMyAddress: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveMyAddress', 'id', id)
            const localVarPath = `/api/v1/me/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save a new delivery address for the current buyer
         * @param {CreateBuyerAddressDto} createBuyerAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMyAddress: async (createBuyerAddressDto: CreateBuyerAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBuyerAddressDto' is not null or undefined
            assertParamExists('createMyAddress', 'createBuyerAddressDto', createBuyerAddressDto)
            const localVarPath = `/api/v1/me/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBuyerAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns delivery, invoice, and other address-book entries owned by the current buyer. Use the optional `type` query param to narrow.
         * @summary List the current buyer\'s saved address book entries
         * @param {PartnersQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyAddresses: async (query?: PartnersQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only `delivery` entries can be the default. The default is flagged with `isDefault` and listed first, so checkout pre-selects it.
         * @summary Make a saved delivery address the current buyer\'s default
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMyDefaultAddress: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setMyDefaultAddress', 'id', id)
            const localVarPath = `/api/v1/me/addresses/{id}/default`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyerAddressesApi - functional programming interface
 * @export
 */
export const BuyerAddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyerAddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Archive a saved delivery address (soft delete)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveMyAddress(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveMyAddress(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyerAddressesApi.archiveMyAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save a new delivery address for the current buyer
         * @param {CreateBuyerAddressDto} createBuyerAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMyAddress(createBuyerAddressDto: CreateBuyerAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerAddressDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMyAddress(createBuyerAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyerAddressesApi.createMyAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns delivery, invoice, and other address-book entries owned by the current buyer. Use the optional `type` query param to narrow.
         * @summary List the current buyer\'s saved address book entries
         * @param {PartnersQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyAddresses(query?: PartnersQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuyerAddressDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyAddresses(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyerAddressesApi.listMyAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only `delivery` entries can be the default. The default is flagged with `isDefault` and listed first, so checkout pre-selects it.
         * @summary Make a saved delivery address the current buyer\'s default
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMyDefaultAddress(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerAddressDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setMyDefaultAddress(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyerAddressesApi.setMyDefaultAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BuyerAddressesApi - factory interface
 * @export
 */
export const BuyerAddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyerAddressesApiFp(configuration)
    return {
        /**
         * 
         * @summary Archive a saved delivery address (soft delete)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveMyAddress(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveMyAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save a new delivery address for the current buyer
         * @param {CreateBuyerAddressDto} createBuyerAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMyAddress(createBuyerAddressDto: CreateBuyerAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<BuyerAddressDto> {
            return localVarFp.createMyAddress(createBuyerAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns delivery, invoice, and other address-book entries owned by the current buyer. Use the optional `type` query param to narrow.
         * @summary List the current buyer\'s saved address book entries
         * @param {PartnersQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyAddresses(query?: PartnersQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<BuyerAddressDto>> {
            return localVarFp.listMyAddresses(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Only `delivery` entries can be the default. The default is flagged with `isDefault` and listed first, so checkout pre-selects it.
         * @summary Make a saved delivery address the current buyer\'s default
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMyDefaultAddress(id: number, options?: RawAxiosRequestConfig): AxiosPromise<BuyerAddressDto> {
            return localVarFp.setMyDefaultAddress(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyerAddressesApi - object-oriented interface
 * @export
 * @class BuyerAddressesApi
 * @extends {BaseAPI}
 */
export class BuyerAddressesApi extends BaseAPI {
    /**
     * 
     * @summary Archive a saved delivery address (soft delete)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerAddressesApi
     */
    public archiveMyAddress(id: number, options?: RawAxiosRequestConfig) {
        return BuyerAddressesApiFp(this.configuration).archiveMyAddress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save a new delivery address for the current buyer
     * @param {CreateBuyerAddressDto} createBuyerAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerAddressesApi
     */
    public createMyAddress(createBuyerAddressDto: CreateBuyerAddressDto, options?: RawAxiosRequestConfig) {
        return BuyerAddressesApiFp(this.configuration).createMyAddress(createBuyerAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns delivery, invoice, and other address-book entries owned by the current buyer. Use the optional `type` query param to narrow.
     * @summary List the current buyer\'s saved address book entries
     * @param {PartnersQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerAddressesApi
     */
    public listMyAddresses(query?: PartnersQueryDto, options?: RawAxiosRequestConfig) {
        return BuyerAddressesApiFp(this.configuration).listMyAddresses(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only `delivery` entries can be the default. The default is flagged with `isDefault` and listed first, so checkout pre-selects it.
     * @summary Make a saved delivery address the current buyer\'s default
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerAddressesApi
     */
    public setMyDefaultAddress(id: number, options?: RawAxiosRequestConfig) {
        return BuyerAddressesApiFp(this.configuration).setMyDefaultAddress(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatalogAssistantApi - axios parameter creator
 * @export
 */
export const CatalogAssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List the current user\'s catalog chats, newest first (paginated).
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChats: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List messages for a catalog chat, oldest first.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listMessages', 'id', id)
            const localVarPath = `/api/v1/chats/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stream a catalog-only assistant reply. Response is a chunked concatenation of JSON events: {chatId} → {text}* → {done,insights}.
         * @param {SendMessageDto} sendMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stream: async (sendMessageDto: SendMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendMessageDto' is not null or undefined
            assertParamExists('stream', 'sendMessageDto', sendMessageDto)
            const localVarPath = `/api/v1/chat/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogAssistantApi - functional programming interface
 * @export
 */
export const CatalogAssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogAssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List the current user\'s catalog chats, newest first (paginated).
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listChats(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listChats(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogAssistantApi.listChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List messages for a catalog chat, oldest first.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessages(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessages(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogAssistantApi.listMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stream a catalog-only assistant reply. Response is a chunked concatenation of JSON events: {chatId} → {text}* → {done,insights}.
         * @param {SendMessageDto} sendMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stream(sendMessageDto: SendMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stream(sendMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogAssistantApi.stream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogAssistantApi - factory interface
 * @export
 */
export const CatalogAssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogAssistantApiFp(configuration)
    return {
        /**
         * 
         * @summary List the current user\'s catalog chats, newest first (paginated).
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChats(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.listChats(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List messages for a catalog chat, oldest first.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.listMessages(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stream a catalog-only assistant reply. Response is a chunked concatenation of JSON events: {chatId} → {text}* → {done,insights}.
         * @param {SendMessageDto} sendMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stream(sendMessageDto: SendMessageDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stream(sendMessageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogAssistantApi - object-oriented interface
 * @export
 * @class CatalogAssistantApi
 * @extends {BaseAPI}
 */
export class CatalogAssistantApi extends BaseAPI {
    /**
     * 
     * @summary List the current user\'s catalog chats, newest first (paginated).
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogAssistantApi
     */
    public listChats(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return CatalogAssistantApiFp(this.configuration).listChats(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List messages for a catalog chat, oldest first.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogAssistantApi
     */
    public listMessages(id: string, options?: RawAxiosRequestConfig) {
        return CatalogAssistantApiFp(this.configuration).listMessages(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stream a catalog-only assistant reply. Response is a chunked concatenation of JSON events: {chatId} → {text}* → {done,insights}.
     * @param {SendMessageDto} sendMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogAssistantApi
     */
    public stream(sendMessageDto: SendMessageDto, options?: RawAxiosRequestConfig) {
        return CatalogAssistantApiFp(this.configuration).stream(sendMessageDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all product categories from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a product category by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryById', 'id', id)
            const localVarPath = `/api/v1/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the effective per-category field policy (after inheritance)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryFieldConfig: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryFieldConfig', 'id', id)
            const localVarPath = `/api/v1/categories/{id}/field-config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all product categories from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.getCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a product category by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.getCategoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the effective per-category field policy (after inheritance)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryFieldConfig(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectiveFieldConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryFieldConfig(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.getCategoryFieldConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all product categories from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryDto>> {
            return localVarFp.getCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a product category by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDto> {
            return localVarFp.getCategoryById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the effective per-category field policy (after inheritance)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryFieldConfig(id: number, options?: RawAxiosRequestConfig): AxiosPromise<EffectiveFieldConfigDto> {
            return localVarFp.getCategoryFieldConfig(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Get all product categories from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getCategories(options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).getCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a product category by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getCategoryById(id: number, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).getCategoryById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the effective per-category field policy (after inheritance)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getCategoryFieldConfig(id: number, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).getCategoryFieldConfig(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChangeRequestsApi - axios parameter creator
 * @export
 */
export const ChangeRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel an open change request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancel', 'id', id)
            const localVarPath = `/api/v1/change-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a DRAFT change request
         * @param {CreateChangeRequestDto} createChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createChangeRequestDto: CreateChangeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createChangeRequestDto' is not null or undefined
            assertParamExists('create', 'createChangeRequestDto', createChangeRequestDto)
            const localVarPath = `/api/v1/change-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChangeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the current user\'s change requests
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMine: async (query?: DocumentsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/change-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a change request by ID (owner or admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChangeRequest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getChangeRequest', 'id', id)
            const localVarPath = `/api/v1/change-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit a change request for admin review
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submit', 'id', id)
            const localVarPath = `/api/v1/change-requests/{id}/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit a DRAFT or CHANGES_REQUESTED change request
         * @param {string} id 
         * @param {UpdateChangeRequestDto} updateChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateChangeRequestDto: UpdateChangeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateChangeRequestDto' is not null or undefined
            assertParamExists('update', 'updateChangeRequestDto', updateChangeRequestDto)
            const localVarPath = `/api/v1/change-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChangeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChangeRequestsApi - functional programming interface
 * @export
 */
export const ChangeRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChangeRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel an open change request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRequestsApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a DRAFT change request
         * @param {CreateChangeRequestDto} createChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createChangeRequestDto: CreateChangeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createChangeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRequestsApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the current user\'s change requests
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMine(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMine(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRequestsApi.findMine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a change request by ID (owner or admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChangeRequest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChangeRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRequestsApi.getChangeRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit a change request for admin review
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submit(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submit(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRequestsApi.submit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit a DRAFT or CHANGES_REQUESTED change request
         * @param {string} id 
         * @param {UpdateChangeRequestDto} updateChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateChangeRequestDto: UpdateChangeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateChangeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRequestsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChangeRequestsApi - factory interface
 * @export
 */
export const ChangeRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChangeRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel an open change request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestDto> {
            return localVarFp.cancel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a DRAFT change request
         * @param {CreateChangeRequestDto} createChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createChangeRequestDto: CreateChangeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestDto> {
            return localVarFp.create(createChangeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the current user\'s change requests
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMine(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestsResponseDto> {
            return localVarFp.findMine(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a change request by ID (owner or admin)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChangeRequest(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestDto> {
            return localVarFp.getChangeRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit a change request for admin review
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestDto> {
            return localVarFp.submit(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit a DRAFT or CHANGES_REQUESTED change request
         * @param {string} id 
         * @param {UpdateChangeRequestDto} updateChangeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateChangeRequestDto: UpdateChangeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRequestDto> {
            return localVarFp.update(id, updateChangeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChangeRequestsApi - object-oriented interface
 * @export
 * @class ChangeRequestsApi
 * @extends {BaseAPI}
 */
export class ChangeRequestsApi extends BaseAPI {
    /**
     * 
     * @summary Cancel an open change request
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRequestsApi
     */
    public cancel(id: string, options?: RawAxiosRequestConfig) {
        return ChangeRequestsApiFp(this.configuration).cancel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a DRAFT change request
     * @param {CreateChangeRequestDto} createChangeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRequestsApi
     */
    public create(createChangeRequestDto: CreateChangeRequestDto, options?: RawAxiosRequestConfig) {
        return ChangeRequestsApiFp(this.configuration).create(createChangeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the current user\'s change requests
     * @param {DocumentsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRequestsApi
     */
    public findMine(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig) {
        return ChangeRequestsApiFp(this.configuration).findMine(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a change request by ID (owner or admin)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRequestsApi
     */
    public getChangeRequest(id: string, options?: RawAxiosRequestConfig) {
        return ChangeRequestsApiFp(this.configuration).getChangeRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit a change request for admin review
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRequestsApi
     */
    public submit(id: string, options?: RawAxiosRequestConfig) {
        return ChangeRequestsApiFp(this.configuration).submit(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit a DRAFT or CHANGES_REQUESTED change request
     * @param {string} id 
     * @param {UpdateChangeRequestDto} updateChangeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRequestsApi
     */
    public update(id: string, updateChangeRequestDto: UpdateChangeRequestDto, options?: RawAxiosRequestConfig) {
        return ChangeRequestsApiFp(this.configuration).update(id, updateChangeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyLogoApi - axios parameter creator
 * @export
 */
export const CompanyLogoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the current user\'s company logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompanyLogo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/company-logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove the current user\'s company logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMyCompanyLogo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/company-logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stored on the Odoo company partner, so quotation and order PDFs show it.
         * @summary Upload (or replace) the current user\'s company logo
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyCompanyLogo: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadMyCompanyLogo', 'file', file)
            const localVarPath = `/api/v1/me/company-logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyLogoApi - functional programming interface
 * @export
 */
export const CompanyLogoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyLogoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the current user\'s company logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyCompanyLogo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyCompanyLogo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyLogoApi.getMyCompanyLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove the current user\'s company logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMyCompanyLogo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMyCompanyLogo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyLogoApi.removeMyCompanyLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stored on the Odoo company partner, so quotation and order PDFs show it.
         * @summary Upload (or replace) the current user\'s company logo
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMyCompanyLogo(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMyCompanyLogo(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyLogoApi.uploadMyCompanyLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyLogoApi - factory interface
 * @export
 */
export const CompanyLogoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyLogoApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the current user\'s company logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompanyLogo(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMyCompanyLogo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove the current user\'s company logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMyCompanyLogo(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeMyCompanyLogo(options).then((request) => request(axios, basePath));
        },
        /**
         * Stored on the Odoo company partner, so quotation and order PDFs show it.
         * @summary Upload (or replace) the current user\'s company logo
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyCompanyLogo(file: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadMyCompanyLogo(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyLogoApi - object-oriented interface
 * @export
 * @class CompanyLogoApi
 * @extends {BaseAPI}
 */
export class CompanyLogoApi extends BaseAPI {
    /**
     * 
     * @summary Get the current user\'s company logo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyLogoApi
     */
    public getMyCompanyLogo(options?: RawAxiosRequestConfig) {
        return CompanyLogoApiFp(this.configuration).getMyCompanyLogo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove the current user\'s company logo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyLogoApi
     */
    public removeMyCompanyLogo(options?: RawAxiosRequestConfig) {
        return CompanyLogoApiFp(this.configuration).removeMyCompanyLogo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stored on the Odoo company partner, so quotation and order PDFs show it.
     * @summary Upload (or replace) the current user\'s company logo
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyLogoApi
     */
    public uploadMyCompanyLogo(file: File, options?: RawAxiosRequestConfig) {
        return CompanyLogoApiFp(this.configuration).uploadMyCompanyLogo(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComparisonsApi - axios parameter creator
 * @export
 */
export const ComparisonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Save a comparison for the current user
         * @param {CreateComparisonDto} createComparisonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparison: async (createComparisonDto: CreateComparisonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createComparisonDto' is not null or undefined
            assertParamExists('createComparison', 'createComparisonDto', createComparisonDto)
            const localVarPath = `/api/v1/comparisons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createComparisonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a saved comparison
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComparison: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteComparison', 'id', id)
            const localVarPath = `/api/v1/comparisons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a saved comparison by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparison: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getComparison', 'id', id)
            const localVarPath = `/api/v1/comparisons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the current user\'s saved comparisons
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyComparisons: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/comparisons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns `{ saved: null }` when the user has not saved this set. The compare page uses it to restore the \"Saved\" state after a refresh, where no client state survives.
         * @summary Find the current user\'s saved comparison for an exact variant set
         * @param {Array<number>} variantIds Odoo product.product IDs of the comparison to look for. Order does not matter — the match is on the exact set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupComparison: async (variantIds: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantIds' is not null or undefined
            assertParamExists('lookupComparison', 'variantIds', variantIds)
            const localVarPath = `/api/v1/comparisons/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (variantIds) {
                localVarQueryParameter['variantIds'] = variantIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparisonsApi - functional programming interface
 * @export
 */
export const ComparisonsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComparisonsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Save a comparison for the current user
         * @param {CreateComparisonDto} createComparisonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComparison(createComparisonDto: CreateComparisonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComparison(createComparisonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonsApi.createComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a saved comparison
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComparison(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComparison(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonsApi.deleteComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a saved comparison by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComparison(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComparison(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonsApi.getComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the current user\'s saved comparisons
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyComparisons(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyComparisons(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonsApi.listMyComparisons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns `{ saved: null }` when the user has not saved this set. The compare page uses it to restore the \"Saved\" state after a refresh, where no client state survives.
         * @summary Find the current user\'s saved comparison for an exact variant set
         * @param {Array<number>} variantIds Odoo product.product IDs of the comparison to look for. Order does not matter — the match is on the exact set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookupComparison(variantIds: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonLookupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookupComparison(variantIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonsApi.lookupComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComparisonsApi - factory interface
 * @export
 */
export const ComparisonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComparisonsApiFp(configuration)
    return {
        /**
         * 
         * @summary Save a comparison for the current user
         * @param {CreateComparisonDto} createComparisonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparison(createComparisonDto: CreateComparisonDto, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonDto> {
            return localVarFp.createComparison(createComparisonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a saved comparison
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComparison(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteComparison(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a saved comparison by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparison(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonDto> {
            return localVarFp.getComparison(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the current user\'s saved comparisons
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyComparisons(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonsResponseDto> {
            return localVarFp.listMyComparisons(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns `{ saved: null }` when the user has not saved this set. The compare page uses it to restore the \"Saved\" state after a refresh, where no client state survives.
         * @summary Find the current user\'s saved comparison for an exact variant set
         * @param {Array<number>} variantIds Odoo product.product IDs of the comparison to look for. Order does not matter — the match is on the exact set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupComparison(variantIds: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonLookupDto> {
            return localVarFp.lookupComparison(variantIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComparisonsApi - object-oriented interface
 * @export
 * @class ComparisonsApi
 * @extends {BaseAPI}
 */
export class ComparisonsApi extends BaseAPI {
    /**
     * 
     * @summary Save a comparison for the current user
     * @param {CreateComparisonDto} createComparisonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public createComparison(createComparisonDto: CreateComparisonDto, options?: RawAxiosRequestConfig) {
        return ComparisonsApiFp(this.configuration).createComparison(createComparisonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a saved comparison
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public deleteComparison(id: string, options?: RawAxiosRequestConfig) {
        return ComparisonsApiFp(this.configuration).deleteComparison(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a saved comparison by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public getComparison(id: string, options?: RawAxiosRequestConfig) {
        return ComparisonsApiFp(this.configuration).getComparison(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the current user\'s saved comparisons
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public listMyComparisons(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return ComparisonsApiFp(this.configuration).listMyComparisons(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns `{ saved: null }` when the user has not saved this set. The compare page uses it to restore the \"Saved\" state after a refresh, where no client state survives.
     * @summary Find the current user\'s saved comparison for an exact variant set
     * @param {Array<number>} variantIds Odoo product.product IDs of the comparison to look for. Order does not matter — the match is on the exact set.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public lookupComparison(variantIds: Array<number>, options?: RawAxiosRequestConfig) {
        return ComparisonsApiFp(this.configuration).lookupComparison(variantIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all countries from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a country by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCountryById', 'id', id)
            const localVarPath = `/api/v1/countries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all countries from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountriesApi.getCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a country by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountryById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountryById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountriesApi.getCountryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all countries from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryDto>> {
            return localVarFp.getCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a country by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CountryDto> {
            return localVarFp.getCountryById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI {
    /**
     * 
     * @summary Get all countries from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getCountries(options?: RawAxiosRequestConfig) {
        return CountriesApiFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a country by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getCountryById(id: number, options?: RawAxiosRequestConfig) {
        return CountriesApiFp(this.configuration).getCountryById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CurrenciesApi - axios parameter creator
 * @export
 */
export const CurrenciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all currencies from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a currency by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCurrencyById', 'id', id)
            const localVarPath = `/api/v1/currencies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrenciesApi - functional programming interface
 * @export
 */
export const CurrenciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrenciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all currencies from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrencyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrenciesApi.getCurrencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a currency by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencyById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencyById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrenciesApi.getCurrencyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CurrenciesApi - factory interface
 * @export
 */
export const CurrenciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrenciesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all currencies from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies(options?: RawAxiosRequestConfig): AxiosPromise<Array<CurrencyDto>> {
            return localVarFp.getCurrencies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a currency by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CurrencyDto> {
            return localVarFp.getCurrencyById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CurrenciesApi - object-oriented interface
 * @export
 * @class CurrenciesApi
 * @extends {BaseAPI}
 */
export class CurrenciesApi extends BaseAPI {
    /**
     * 
     * @summary Get all currencies from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    public getCurrencies(options?: RawAxiosRequestConfig) {
        return CurrenciesApiFp(this.configuration).getCurrencies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a currency by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    public getCurrencyById(id: number, options?: RawAxiosRequestConfig) {
        return CurrenciesApiFp(this.configuration).getCurrencyById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Approve a pending document. Only admins can perform this action.
         * @summary Approve a document (admin only)
         * @param {string} id 
         * @param {ApproveDocumentDto} approveDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveDocument: async (id: string, approveDocumentDto: ApproveDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveDocument', 'id', id)
            // verify required parameter 'approveDocumentDto' is not null or undefined
            assertParamExists('approveDocument', 'approveDocumentDto', approveDocumentDto)
            const localVarPath = `/api/v1/documents/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a document record in the database after the file has been uploaded to storage. Admins can specify a userId to create documents for other users.
         * @summary Create a document record after file upload
         * @param {CreateDocumentDto} createDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument: async (createDocumentDto: CreateDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDocumentDto' is not null or undefined
            assertParamExists('createDocument', 'createDocumentDto', createDocumentDto)
            const localVarPath = `/api/v1/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates signed upload URLs for document files. Each URL is valid for a specific content type and expires after a set time.
         * @summary Create signed upload URLs for document files
         * @param {CreateUploadUrlDto} createUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentUploadUrl: async (createUploadUrlDto: CreateUploadUrlDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUploadUrlDto' is not null or undefined
            assertParamExists('createDocumentUploadUrl', 'createUploadUrlDto', createUploadUrlDto)
            const localVarPath = `/api/v1/documents/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUploadUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the model\'s best guess at the document\'s expiration date and key fields. Today this is a placeholder that returns deterministic defaults with low confidence; the response shape is stable so the admin UI can pre-fill the approval form regardless.
         * @summary Extract document metadata via AI (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractDocumentMetadata: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('extractDocumentMetadata', 'id', id)
            const localVarPath = `/api/v1/documents/{id}/extract-metadata`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single document by ID. Users can only access their own documents.
         * @summary Get a document by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocument', 'id', id)
            const localVarPath = `/api/v1/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a temporary signed URL to download a document file. Users can only access their own documents.
         * @summary Get a signed download URL for a document
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrl: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentDownloadUrl', 'id', id)
            const localVarPath = `/api/v1/documents/{id}/download-url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of documents. Users see only their own documents, admins see all documents.
         * @summary Get all documents
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (query?: DocumentsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of users with their documents. Only admins can access this endpoint.
         * @summary Get all documents grouped by user (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsGroupedByUser: async (query?: DocumentsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/documents/admin/grouped-by-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reject a pending document with a reason. Only admins can perform this action.
         * @summary Reject a document (admin only)
         * @param {string} id 
         * @param {RejectDocumentDto} rejectDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDocument: async (id: string, rejectDocumentDto: RejectDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectDocument', 'id', id)
            // verify required parameter 'rejectDocumentDto' is not null or undefined
            assertParamExists('rejectDocument', 'rejectDocumentDto', rejectDocumentDto)
            const localVarPath = `/api/v1/documents/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Approve a pending document. Only admins can perform this action.
         * @summary Approve a document (admin only)
         * @param {string} id 
         * @param {ApproveDocumentDto} approveDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveDocument(id: string, approveDocumentDto: ApproveDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveDocument(id, approveDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.approveDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a document record in the database after the file has been uploaded to storage. Admins can specify a userId to create documents for other users.
         * @summary Create a document record after file upload
         * @param {CreateDocumentDto} createDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocument(createDocumentDto: CreateDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocument(createDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.createDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates signed upload URLs for document files. Each URL is valid for a specific content type and expires after a set time.
         * @summary Create signed upload URLs for document files
         * @param {CreateUploadUrlDto} createUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentUploadUrl(createUploadUrlDto: CreateUploadUrlDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UploadUrlResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentUploadUrl(createUploadUrlDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.createDocumentUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the model\'s best guess at the document\'s expiration date and key fields. Today this is a placeholder that returns deterministic defaults with low confidence; the response shape is stable so the admin UI can pre-fill the approval form regardless.
         * @summary Extract document metadata via AI (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractDocumentMetadata(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractedDocumentMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractDocumentMetadata(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.extractDocumentMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single document by ID. Users can only access their own documents.
         * @summary Get a document by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocument(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a temporary signed URL to download a document file. Users can only access their own documents.
         * @summary Get a signed download URL for a document
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentDownloadUrl(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDocumentDownloadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentDownloadUrl(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of documents. Users see only their own documents, admins see all documents.
         * @summary Get all documents
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of users with their documents. Only admins can access this endpoint.
         * @summary Get all documents grouped by user (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentsGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersDocumentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentsGroupedByUser(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentsGroupedByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reject a pending document with a reason. Only admins can perform this action.
         * @summary Reject a document (admin only)
         * @param {string} id 
         * @param {RejectDocumentDto} rejectDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectDocument(id: string, rejectDocumentDto: RejectDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectDocument(id, rejectDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.rejectDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * Approve a pending document. Only admins can perform this action.
         * @summary Approve a document (admin only)
         * @param {string} id 
         * @param {ApproveDocumentDto} approveDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveDocument(id: string, approveDocumentDto: ApproveDocumentDto, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.approveDocument(id, approveDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a document record in the database after the file has been uploaded to storage. Admins can specify a userId to create documents for other users.
         * @summary Create a document record after file upload
         * @param {CreateDocumentDto} createDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument(createDocumentDto: CreateDocumentDto, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.createDocument(createDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates signed upload URLs for document files. Each URL is valid for a specific content type and expires after a set time.
         * @summary Create signed upload URLs for document files
         * @param {CreateUploadUrlDto} createUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentUploadUrl(createUploadUrlDto: CreateUploadUrlDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<UploadUrlResponseDto>> {
            return localVarFp.createDocumentUploadUrl(createUploadUrlDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the model\'s best guess at the document\'s expiration date and key fields. Today this is a placeholder that returns deterministic defaults with low confidence; the response shape is stable so the admin UI can pre-fill the approval form regardless.
         * @summary Extract document metadata via AI (admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractDocumentMetadata(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDocumentMetadataDto> {
            return localVarFp.extractDocumentMetadata(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single document by ID. Users can only access their own documents.
         * @summary Get a document by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.getDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a temporary signed URL to download a document file. Users can only access their own documents.
         * @summary Get a signed download URL for a document
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrl(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDocumentDownloadUrl200Response> {
            return localVarFp.getDocumentDownloadUrl(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of documents. Users see only their own documents, admins see all documents.
         * @summary Get all documents
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<DocumentsResponseDto> {
            return localVarFp.getDocuments(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of users with their documents. Only admins can access this endpoint.
         * @summary Get all documents grouped by user (admin only)
         * @param {DocumentsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<UsersDocumentsResponseDto> {
            return localVarFp.getDocumentsGroupedByUser(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Reject a pending document with a reason. Only admins can perform this action.
         * @summary Reject a document (admin only)
         * @param {string} id 
         * @param {RejectDocumentDto} rejectDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDocument(id: string, rejectDocumentDto: RejectDocumentDto, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.rejectDocument(id, rejectDocumentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Approve a pending document. Only admins can perform this action.
     * @summary Approve a document (admin only)
     * @param {string} id 
     * @param {ApproveDocumentDto} approveDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public approveDocument(id: string, approveDocumentDto: ApproveDocumentDto, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).approveDocument(id, approveDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a document record in the database after the file has been uploaded to storage. Admins can specify a userId to create documents for other users.
     * @summary Create a document record after file upload
     * @param {CreateDocumentDto} createDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public createDocument(createDocumentDto: CreateDocumentDto, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).createDocument(createDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates signed upload URLs for document files. Each URL is valid for a specific content type and expires after a set time.
     * @summary Create signed upload URLs for document files
     * @param {CreateUploadUrlDto} createUploadUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public createDocumentUploadUrl(createUploadUrlDto: CreateUploadUrlDto, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).createDocumentUploadUrl(createUploadUrlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the model\'s best guess at the document\'s expiration date and key fields. Today this is a placeholder that returns deterministic defaults with low confidence; the response shape is stable so the admin UI can pre-fill the approval form regardless.
     * @summary Extract document metadata via AI (admin only)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public extractDocumentMetadata(id: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).extractDocumentMetadata(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single document by ID. Users can only access their own documents.
     * @summary Get a document by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocument(id: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocument(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a temporary signed URL to download a document file. Users can only access their own documents.
     * @summary Get a signed download URL for a document
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentDownloadUrl(id: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentDownloadUrl(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of documents. Users see only their own documents, admins see all documents.
     * @summary Get all documents
     * @param {DocumentsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocuments(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocuments(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of users with their documents. Only admins can access this endpoint.
     * @summary Get all documents grouped by user (admin only)
     * @param {DocumentsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentsGroupedByUser(query?: DocumentsQueryDto, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentsGroupedByUser(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reject a pending document with a reason. Only admins can perform this action.
     * @summary Reject a document (admin only)
     * @param {string} id 
     * @param {RejectDocumentDto} rejectDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public rejectDocument(id: string, rejectDocumentDto: RejectDocumentDto, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).rejectDocument(id, rejectDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DropshippingApi - axios parameter creator
 * @export
 */
export const DropshippingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a stock.picking record (dropshipping) by its ID.
         * @summary Get dropshipping by ID
         * @param {number} id Dropshipping ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/dropshipping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DropshippingApi - functional programming interface
 * @export
 */
export const DropshippingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DropshippingApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a stock.picking record (dropshipping) by its ID.
         * @summary Get dropshipping by ID
         * @param {number} id Dropshipping ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DropshippingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DropshippingApi.findOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DropshippingApi - factory interface
 * @export
 */
export const DropshippingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DropshippingApiFp(configuration)
    return {
        /**
         * Returns a stock.picking record (dropshipping) by its ID.
         * @summary Get dropshipping by ID
         * @param {number} id Dropshipping ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DropshippingDto> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DropshippingApi - object-oriented interface
 * @export
 * @class DropshippingApi
 * @extends {BaseAPI}
 */
export class DropshippingApi extends BaseAPI {
    /**
     * Returns a stock.picking record (dropshipping) by its ID.
     * @summary Get dropshipping by ID
     * @param {number} id Dropshipping ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropshippingApi
     */
    public findOne(id: number, options?: RawAxiosRequestConfig) {
        return DropshippingApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeaturedDealsApi - axios parameter creator
 * @export
 */
export const FeaturedDealsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the active Deal of the Week list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedDeals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/featured-deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturedDealsApi - functional programming interface
 * @export
 */
export const FeaturedDealsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturedDealsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the active Deal of the Week list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturedDeals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeaturedDealDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturedDeals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturedDealsApi.getFeaturedDeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeaturedDealsApi - factory interface
 * @export
 */
export const FeaturedDealsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturedDealsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the active Deal of the Week list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedDeals(options?: RawAxiosRequestConfig): AxiosPromise<Array<FeaturedDealDto>> {
            return localVarFp.getFeaturedDeals(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeaturedDealsApi - object-oriented interface
 * @export
 * @class FeaturedDealsApi
 * @extends {BaseAPI}
 */
export class FeaturedDealsApi extends BaseAPI {
    /**
     * 
     * @summary Get the active Deal of the Week list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturedDealsApi
     */
    public getFeaturedDeals(options?: RawAxiosRequestConfig) {
        return FeaturedDealsApiFp(this.configuration).getFeaturedDeals(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/healthz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthDb: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/health/db`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.health']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthDb(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthDb(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthDb']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthDb(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.healthDb(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public health(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthDb(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthDb(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InboxApi - axios parameter creator
 * @export
 */
export const InboxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List my notifications
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInbox: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/inbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count my unread notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInboxUnreadCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/inbox/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark every notification as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllInboxRead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/inbox/read-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a single notification as read
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInboxItemRead: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markInboxItemRead', 'id', id)
            const localVarPath = `/api/v1/me/inbox/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InboxApi - functional programming interface
 * @export
 */
export const InboxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InboxApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List my notifications
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyInbox(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyInbox(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InboxApi.getMyInbox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Count my unread notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyInboxUnreadCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnreadCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyInboxUnreadCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InboxApi.getMyInboxUnreadCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark every notification as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllInboxRead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnreadCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllInboxRead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InboxApi.markAllInboxRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a single notification as read
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markInboxItemRead(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markInboxItemRead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InboxApi.markInboxItemRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InboxApi - factory interface
 * @export
 */
export const InboxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InboxApiFp(configuration)
    return {
        /**
         * 
         * @summary List my notifications
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInbox(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<NotificationsResponseDto> {
            return localVarFp.getMyInbox(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count my unread notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInboxUnreadCount(options?: RawAxiosRequestConfig): AxiosPromise<UnreadCountDto> {
            return localVarFp.getMyInboxUnreadCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark every notification as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllInboxRead(options?: RawAxiosRequestConfig): AxiosPromise<UnreadCountDto> {
            return localVarFp.markAllInboxRead(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a single notification as read
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInboxItemRead(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markInboxItemRead(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InboxApi - object-oriented interface
 * @export
 * @class InboxApi
 * @extends {BaseAPI}
 */
export class InboxApi extends BaseAPI {
    /**
     * 
     * @summary List my notifications
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    public getMyInbox(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return InboxApiFp(this.configuration).getMyInbox(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count my unread notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    public getMyInboxUnreadCount(options?: RawAxiosRequestConfig) {
        return InboxApiFp(this.configuration).getMyInboxUnreadCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark every notification as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    public markAllInboxRead(options?: RawAxiosRequestConfig) {
        return InboxApiFp(this.configuration).markAllInboxRead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a single notification as read
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    public markInboxItemRead(id: string, options?: RawAxiosRequestConfig) {
        return InboxApiFp(this.configuration).markInboxItemRead(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicesApi - axios parameter creator
 * @export
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create invoice from sale order (admin only)
         * @param {CreateInvoiceDto} createInvoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice: async (createInvoiceDto: CreateInvoiceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvoiceDto' is not null or undefined
            assertParamExists('createInvoice', 'createInvoiceDto', createInvoiceDto)
            const localVarPath = `/api/v1/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesApi - functional programming interface
 * @export
 */
export const InvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create invoice from sale order (admin only)
         * @param {CreateInvoiceDto} createInvoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoice(createInvoiceDto: CreateInvoiceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoice(createInvoiceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.createInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicesApi - factory interface
 * @export
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create invoice from sale order (admin only)
         * @param {CreateInvoiceDto} createInvoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice(createInvoiceDto: CreateInvoiceDto, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceDto> {
            return localVarFp.createInvoice(createInvoiceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoicesApi - object-oriented interface
 * @export
 * @class InvoicesApi
 * @extends {BaseAPI}
 */
export class InvoicesApi extends BaseAPI {
    /**
     * 
     * @summary Create invoice from sale order (admin only)
     * @param {CreateInvoiceDto} createInvoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public createInvoice(createInvoiceDto: CreateInvoiceDto, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).createInvoice(createInvoiceDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LikesApi - axios parameter creator
 * @export
 */
export const LikesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the full set of liked Odoo variant ids. Lightweight — no pagination, no Odoo hydration. Intended for client-side caches that drive heart-icon state on product cards.
         * @summary Get the current user\'s liked product-variant ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLikedVariantIds: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me/liked-variant-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated, sorted by most-recently-liked first. Variants are hydrated from Odoo; entries whose Odoo variant no longer exists are filtered out.
         * @summary Get the current user\'s liked product variants
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLikes: async (page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me/likes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Idempotent: liking an already-liked variant is a no-op.
         * @summary Like a product variant
         * @param {number} odooVariantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeProductVariant: async (odooVariantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'odooVariantId' is not null or undefined
            assertParamExists('likeProductVariant', 'odooVariantId', odooVariantId)
            const localVarPath = `/api/v1/product-variants/{odooVariantId}/like`
                .replace(`{${"odooVariantId"}}`, encodeURIComponent(String(odooVariantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes ProductLike rows whose Odoo variant no longer exists.
         * @summary Manually run the likes cleanup job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runLikesCleanup: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/likes/cleanup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Idempotent: unliking a variant that is not liked is a no-op.
         * @summary Unlike a product variant
         * @param {number} odooVariantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlikeProductVariant: async (odooVariantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'odooVariantId' is not null or undefined
            assertParamExists('unlikeProductVariant', 'odooVariantId', odooVariantId)
            const localVarPath = `/api/v1/product-variants/{odooVariantId}/like`
                .replace(`{${"odooVariantId"}}`, encodeURIComponent(String(odooVariantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LikesApi - functional programming interface
 * @export
 */
export const LikesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LikesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the full set of liked Odoo variant ids. Lightweight — no pagination, no Odoo hydration. Intended for client-side caches that drive heart-icon state on product cards.
         * @summary Get the current user\'s liked product-variant ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyLikedVariantIds(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyLikedVariantIds(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LikesApi.getMyLikedVariantIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated, sorted by most-recently-liked first. Variants are hydrated from Odoo; entries whose Odoo variant no longer exists are filtered out.
         * @summary Get the current user\'s liked product variants
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyLikes(page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductVariantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyLikes(page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LikesApi.getMyLikes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Idempotent: liking an already-liked variant is a no-op.
         * @summary Like a product variant
         * @param {number} odooVariantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async likeProductVariant(odooVariantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.likeProductVariant(odooVariantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LikesApi.likeProductVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes ProductLike rows whose Odoo variant no longer exists.
         * @summary Manually run the likes cleanup job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runLikesCleanup(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runLikesCleanup(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LikesApi.runLikesCleanup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Idempotent: unliking a variant that is not liked is a no-op.
         * @summary Unlike a product variant
         * @param {number} odooVariantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlikeProductVariant(odooVariantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlikeProductVariant(odooVariantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LikesApi.unlikeProductVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LikesApi - factory interface
 * @export
 */
export const LikesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LikesApiFp(configuration)
    return {
        /**
         * Returns the full set of liked Odoo variant ids. Lightweight — no pagination, no Odoo hydration. Intended for client-side caches that drive heart-icon state on product cards.
         * @summary Get the current user\'s liked product-variant ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLikedVariantIds(options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getMyLikedVariantIds(options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated, sorted by most-recently-liked first. Variants are hydrated from Odoo; entries whose Odoo variant no longer exists are filtered out.
         * @summary Get the current user\'s liked product variants
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLikes(page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductVariantDto>> {
            return localVarFp.getMyLikes(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Idempotent: liking an already-liked variant is a no-op.
         * @summary Like a product variant
         * @param {number} odooVariantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeProductVariant(odooVariantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.likeProductVariant(odooVariantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes ProductLike rows whose Odoo variant no longer exists.
         * @summary Manually run the likes cleanup job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runLikesCleanup(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.runLikesCleanup(options).then((request) => request(axios, basePath));
        },
        /**
         * Idempotent: unliking a variant that is not liked is a no-op.
         * @summary Unlike a product variant
         * @param {number} odooVariantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlikeProductVariant(odooVariantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlikeProductVariant(odooVariantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LikesApi - object-oriented interface
 * @export
 * @class LikesApi
 * @extends {BaseAPI}
 */
export class LikesApi extends BaseAPI {
    /**
     * Returns the full set of liked Odoo variant ids. Lightweight — no pagination, no Odoo hydration. Intended for client-side caches that drive heart-icon state on product cards.
     * @summary Get the current user\'s liked product-variant ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LikesApi
     */
    public getMyLikedVariantIds(options?: RawAxiosRequestConfig) {
        return LikesApiFp(this.configuration).getMyLikedVariantIds(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated, sorted by most-recently-liked first. Variants are hydrated from Odoo; entries whose Odoo variant no longer exists are filtered out.
     * @summary Get the current user\'s liked product variants
     * @param {number} [page] Page number (1-based)
     * @param {number} [limit] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LikesApi
     */
    public getMyLikes(page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return LikesApiFp(this.configuration).getMyLikes(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Idempotent: liking an already-liked variant is a no-op.
     * @summary Like a product variant
     * @param {number} odooVariantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LikesApi
     */
    public likeProductVariant(odooVariantId: number, options?: RawAxiosRequestConfig) {
        return LikesApiFp(this.configuration).likeProductVariant(odooVariantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes ProductLike rows whose Odoo variant no longer exists.
     * @summary Manually run the likes cleanup job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LikesApi
     */
    public runLikesCleanup(options?: RawAxiosRequestConfig) {
        return LikesApiFp(this.configuration).runLikesCleanup(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Idempotent: unliking a variant that is not liked is a no-op.
     * @summary Unlike a product variant
     * @param {number} odooVariantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LikesApi
     */
    public unlikeProductVariant(odooVariantId: number, options?: RawAxiosRequestConfig) {
        return LikesApiFp(this.configuration).unlikeProductVariant(odooVariantId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoyaltyApi - axios parameter creator
 * @export
 */
export const LoyaltyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns promotions that are enabled and within their date window right now. Buyers use these to preview \"earn Nx points\" on product pages and at checkout.
         * @summary Get currently-active loyalty promotions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveLoyaltyPromotions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/promotions/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns earn rate (pointsPer100), redemption value (redemptionValuePer100Points), and validity. Buyers need this to preview the discount value of applying points at checkout.
         * @summary Get loyalty configuration (read-only for buyers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of loyalty point transactions with summary totals
         * @summary Get current user\'s loyalty points
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLoyaltyPoints: async (query?: LoyaltyPointsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of point redemptions made by the current user.
         * @summary Get current user\'s loyalty redemptions
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRedemptions: async (query?: LoyaltyPointsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/loyalty/redemptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deducts points from the current user balance using FIFO consumption of active earning transactions. Returns the redemption record.
         * @summary Redeem loyalty points
         * @param {RedeemPointsDto} redeemPointsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeem: async (redeemPointsDto: RedeemPointsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redeemPointsDto' is not null or undefined
            assertParamExists('redeem', 'redeemPointsDto', redeemPointsDto)
            const localVarPath = `/api/v1/loyalty/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemPointsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoyaltyApi - functional programming interface
 * @export
 */
export const LoyaltyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoyaltyApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns promotions that are enabled and within their date window right now. Buyers use these to preview \"earn Nx points\" on product pages and at checkout.
         * @summary Get currently-active loyalty promotions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveLoyaltyPromotions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoyaltyPromotionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveLoyaltyPromotions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoyaltyApi.getActiveLoyaltyPromotions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns earn rate (pointsPer100), redemption value (redemptionValuePer100Points), and validity. Buyers need this to preview the discount value of applying points at checkout.
         * @summary Get loyalty configuration (read-only for buyers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoyaltyApi.getConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of loyalty point transactions with summary totals
         * @summary Get current user\'s loyalty points
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyLoyaltyPoints(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyPointsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyLoyaltyPoints(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoyaltyApi.getMyLoyaltyPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of point redemptions made by the current user.
         * @summary Get current user\'s loyalty redemptions
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyRedemptions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyRedemptions(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoyaltyApi.getMyRedemptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deducts points from the current user balance using FIFO consumption of active earning transactions. Returns the redemption record.
         * @summary Redeem loyalty points
         * @param {RedeemPointsDto} redeemPointsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeem(redeemPointsDto: RedeemPointsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyRedemptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeem(redeemPointsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoyaltyApi.redeem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoyaltyApi - factory interface
 * @export
 */
export const LoyaltyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoyaltyApiFp(configuration)
    return {
        /**
         * Returns promotions that are enabled and within their date window right now. Buyers use these to preview \"earn Nx points\" on product pages and at checkout.
         * @summary Get currently-active loyalty promotions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveLoyaltyPromotions(options?: RawAxiosRequestConfig): AxiosPromise<Array<LoyaltyPromotionDto>> {
            return localVarFp.getActiveLoyaltyPromotions(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns earn rate (pointsPer100), redemption value (redemptionValuePer100Points), and validity. Buyers need this to preview the discount value of applying points at checkout.
         * @summary Get loyalty configuration (read-only for buyers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyConfigDto> {
            return localVarFp.getConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of loyalty point transactions with summary totals
         * @summary Get current user\'s loyalty points
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLoyaltyPoints(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyPointsResponseDto> {
            return localVarFp.getMyLoyaltyPoints(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of point redemptions made by the current user.
         * @summary Get current user\'s loyalty redemptions
         * @param {LoyaltyPointsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRedemptions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMyRedemptions(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Deducts points from the current user balance using FIFO consumption of active earning transactions. Returns the redemption record.
         * @summary Redeem loyalty points
         * @param {RedeemPointsDto} redeemPointsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeem(redeemPointsDto: RedeemPointsDto, options?: RawAxiosRequestConfig): AxiosPromise<LoyaltyRedemptionDto> {
            return localVarFp.redeem(redeemPointsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoyaltyApi - object-oriented interface
 * @export
 * @class LoyaltyApi
 * @extends {BaseAPI}
 */
export class LoyaltyApi extends BaseAPI {
    /**
     * Returns promotions that are enabled and within their date window right now. Buyers use these to preview \"earn Nx points\" on product pages and at checkout.
     * @summary Get currently-active loyalty promotions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public getActiveLoyaltyPromotions(options?: RawAxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).getActiveLoyaltyPromotions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns earn rate (pointsPer100), redemption value (redemptionValuePer100Points), and validity. Buyers need this to preview the discount value of applying points at checkout.
     * @summary Get loyalty configuration (read-only for buyers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public getConfig(options?: RawAxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).getConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of loyalty point transactions with summary totals
     * @summary Get current user\'s loyalty points
     * @param {LoyaltyPointsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public getMyLoyaltyPoints(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).getMyLoyaltyPoints(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of point redemptions made by the current user.
     * @summary Get current user\'s loyalty redemptions
     * @param {LoyaltyPointsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public getMyRedemptions(query?: LoyaltyPointsQueryDto, options?: RawAxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).getMyRedemptions(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deducts points from the current user balance using FIFO consumption of active earning transactions. Returns the redemption record.
     * @summary Redeem loyalty points
     * @param {RedeemPointsDto} redeemPointsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    public redeem(redeemPointsDto: RedeemPointsDto, options?: RawAxiosRequestConfig) {
        return LoyaltyApiFp(this.configuration).redeem(redeemPointsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNotificationPrefs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification preferences
         * @param {UpdateNotificationPrefsDto} updateNotificationPrefsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyNotificationPrefs: async (updateNotificationPrefsDto: UpdateNotificationPrefsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateNotificationPrefsDto' is not null or undefined
            assertParamExists('updateMyNotificationPrefs', 'updateNotificationPrefsDto', updateNotificationPrefsDto)
            const localVarPath = `/api/v1/me/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationPrefsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyNotificationPrefs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPrefsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyNotificationPrefs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getMyNotificationPrefs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update notification preferences
         * @param {UpdateNotificationPrefsDto} updateNotificationPrefsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyNotificationPrefs(updateNotificationPrefsDto: UpdateNotificationPrefsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPrefsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyNotificationPrefs(updateNotificationPrefsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateMyNotificationPrefs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNotificationPrefs(options?: RawAxiosRequestConfig): AxiosPromise<NotificationPrefsDto> {
            return localVarFp.getMyNotificationPrefs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update notification preferences
         * @param {UpdateNotificationPrefsDto} updateNotificationPrefsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyNotificationPrefs(updateNotificationPrefsDto: UpdateNotificationPrefsDto, options?: RawAxiosRequestConfig): AxiosPromise<NotificationPrefsDto> {
            return localVarFp.updateMyNotificationPrefs(updateNotificationPrefsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Get notification preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getMyNotificationPrefs(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getMyNotificationPrefs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update notification preferences
     * @param {UpdateNotificationPrefsDto} updateNotificationPrefsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateMyNotificationPrefs(updateNotificationPrefsDto: UpdateNotificationPrefsDto, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateMyNotificationPrefs(updateNotificationPrefsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderDisputesBuyerApi - axios parameter creator
 * @export
 */
export const OrderDisputesBuyerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Raise an order dispute
         * @param {CreateOrderDisputeDto} createOrderDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderDispute: async (createOrderDisputeDto: CreateOrderDisputeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderDisputeDto' is not null or undefined
            assertParamExists('createOrderDispute', 'createOrderDisputeDto', createOrderDisputeDto)
            const localVarPath = `/api/v1/order-disputes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderDisputeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a buyer\'s order dispute detail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerOrderDisputeDetail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBuyerOrderDisputeDetail', 'id', id)
            const localVarPath = `/api/v1/order-disputes/me/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get signed upload URL for dispute attachment
         * @param {UploadUrlRequestDto} uploadUrlRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDisputeUploadUrl: async (uploadUrlRequestDto: UploadUrlRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadUrlRequestDto' is not null or undefined
            assertParamExists('getOrderDisputeUploadUrl', 'uploadUrlRequestDto', uploadUrlRequestDto)
            const localVarPath = `/api/v1/order-disputes/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadUrlRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the buyer\'s own order disputes
         * @param {OrderDisputeQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyOrderDisputes: async (query?: OrderDisputeQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order-disputes/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderDisputesBuyerApi - functional programming interface
 * @export
 */
export const OrderDisputesBuyerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderDisputesBuyerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Raise an order dispute
         * @param {CreateOrderDisputeDto} createOrderDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderDispute(createOrderDisputeDto: CreateOrderDisputeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDisputeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderDispute(createOrderDisputeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderDisputesBuyerApi.createOrderDispute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a buyer\'s order dispute detail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuyerOrderDisputeDetail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDisputeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuyerOrderDisputeDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderDisputesBuyerApi.getBuyerOrderDisputeDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get signed upload URL for dispute attachment
         * @param {UploadUrlRequestDto} uploadUrlRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDisputeUploadUrl(uploadUrlRequestDto: UploadUrlRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDisputeUploadUrl(uploadUrlRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderDisputesBuyerApi.getOrderDisputeUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the buyer\'s own order disputes
         * @param {OrderDisputeQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyOrderDisputes(query?: OrderDisputeQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyOrderDisputes(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderDisputesBuyerApi.listMyOrderDisputes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderDisputesBuyerApi - factory interface
 * @export
 */
export const OrderDisputesBuyerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderDisputesBuyerApiFp(configuration)
    return {
        /**
         * 
         * @summary Raise an order dispute
         * @param {CreateOrderDisputeDto} createOrderDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderDispute(createOrderDisputeDto: CreateOrderDisputeDto, options?: RawAxiosRequestConfig): AxiosPromise<OrderDisputeDto> {
            return localVarFp.createOrderDispute(createOrderDisputeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a buyer\'s order dispute detail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerOrderDisputeDetail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderDisputeDto> {
            return localVarFp.getBuyerOrderDisputeDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get signed upload URL for dispute attachment
         * @param {UploadUrlRequestDto} uploadUrlRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDisputeUploadUrl(uploadUrlRequestDto: UploadUrlRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getOrderDisputeUploadUrl(uploadUrlRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the buyer\'s own order disputes
         * @param {OrderDisputeQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyOrderDisputes(query?: OrderDisputeQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.listMyOrderDisputes(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderDisputesBuyerApi - object-oriented interface
 * @export
 * @class OrderDisputesBuyerApi
 * @extends {BaseAPI}
 */
export class OrderDisputesBuyerApi extends BaseAPI {
    /**
     * 
     * @summary Raise an order dispute
     * @param {CreateOrderDisputeDto} createOrderDisputeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDisputesBuyerApi
     */
    public createOrderDispute(createOrderDisputeDto: CreateOrderDisputeDto, options?: RawAxiosRequestConfig) {
        return OrderDisputesBuyerApiFp(this.configuration).createOrderDispute(createOrderDisputeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a buyer\'s order dispute detail
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDisputesBuyerApi
     */
    public getBuyerOrderDisputeDetail(id: string, options?: RawAxiosRequestConfig) {
        return OrderDisputesBuyerApiFp(this.configuration).getBuyerOrderDisputeDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get signed upload URL for dispute attachment
     * @param {UploadUrlRequestDto} uploadUrlRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDisputesBuyerApi
     */
    public getOrderDisputeUploadUrl(uploadUrlRequestDto: UploadUrlRequestDto, options?: RawAxiosRequestConfig) {
        return OrderDisputesBuyerApiFp(this.configuration).getOrderDisputeUploadUrl(uploadUrlRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the buyer\'s own order disputes
     * @param {OrderDisputeQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDisputesBuyerApi
     */
    public listMyOrderDisputes(query?: OrderDisputeQueryDto, options?: RawAxiosRequestConfig) {
        return OrderDisputesBuyerApiFp(this.configuration).listMyOrderDisputes(query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartnersApi - axios parameter creator
 * @export
 */
export const PartnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Filter partners by type: buyer (customer_rank > 0), supplier (supplier_rank > 0), or user (all partners). Leave type empty to get all partners.
         * @summary Get partners from Odoo with pagination and search
         * @param {PartnersQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (query?: PartnersQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user\'s partner information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPartner: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns totalPartners, sellers (supplier_rank > 0), and buyers (customer_rank > 0) in a single call.
         * @summary Get partner overview counts (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a partner by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartner: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPartner', 'id', id)
            const localVarPath = `/api/v1/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns child res.partner rows for the given commercial entity. The `type` field discriminates contact people (`contact`) from address-book entries (`delivery`, `invoice`, `other`).
         * @summary List the partner\'s child rows (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerChildren: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPartnerChildren', 'id', id)
            const localVarPath = `/api/v1/partners/{id}/children`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns buyer stats (orderCount, lifetimeSpend, avgOrderValue, lastOrderAt) when customer_rank > 0, and seller stats (activeProductCount, totalSales, openPoCount, avgFulfillmentDays) when supplier_rank > 0. Both are populated for dual-role partners.
         * @summary Get role-aware stats for a partner (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerStats: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPartnerStats', 'id', id)
            const localVarPath = `/api/v1/partners/{id}/stats`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnersApi - functional programming interface
 * @export
 */
export const PartnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnersApiAxiosParamCreator(configuration)
    return {
        /**
         * Filter partners by type: buyer (customer_rank > 0), supplier (supplier_rank > 0), or user (all partners). Leave type empty to get all partners.
         * @summary Get partners from Odoo with pagination and search
         * @param {PartnersQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(query?: PartnersQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.findAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user\'s partner information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserPartner(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserPartner(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.getCurrentUserPartner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns totalPartners, sellers (supplier_rank > 0), and buyers (customer_rank > 0) in a single call.
         * @summary Get partner overview counts (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverviewStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerOverviewStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverviewStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.getOverviewStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a partner by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartner(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartner(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.getPartner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns child res.partner rows for the given commercial entity. The `type` field discriminates contact people (`contact`) from address-book entries (`delivery`, `invoice`, `other`).
         * @summary List the partner\'s child rows (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerChildren(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnerChildDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerChildren(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.getPartnerChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns buyer stats (orderCount, lifetimeSpend, avgOrderValue, lastOrderAt) when customer_rank > 0, and seller stats (activeProductCount, totalSales, openPoCount, avgFulfillmentDays) when supplier_rank > 0. Both are populated for dual-role partners.
         * @summary Get role-aware stats for a partner (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerStats(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerStats(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.getPartnerStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnersApi - factory interface
 * @export
 */
export const PartnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnersApiFp(configuration)
    return {
        /**
         * Filter partners by type: buyer (customer_rank > 0), supplier (supplier_rank > 0), or user (all partners). Leave type empty to get all partners.
         * @summary Get partners from Odoo with pagination and search
         * @param {PartnersQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(query?: PartnersQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<PartnersResponseDto> {
            return localVarFp.findAll(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user\'s partner information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPartner(options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.getCurrentUserPartner(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns totalPartners, sellers (supplier_rank > 0), and buyers (customer_rank > 0) in a single call.
         * @summary Get partner overview counts (admin only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewStats(options?: RawAxiosRequestConfig): AxiosPromise<PartnerOverviewStatsDto> {
            return localVarFp.getOverviewStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a partner by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartner(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.getPartner(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns child res.partner rows for the given commercial entity. The `type` field discriminates contact people (`contact`) from address-book entries (`delivery`, `invoice`, `other`).
         * @summary List the partner\'s child rows (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerChildren(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PartnerChildDto>> {
            return localVarFp.getPartnerChildren(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns buyer stats (orderCount, lifetimeSpend, avgOrderValue, lastOrderAt) when customer_rank > 0, and seller stats (activeProductCount, totalSales, openPoCount, avgFulfillmentDays) when supplier_rank > 0. Both are populated for dual-role partners.
         * @summary Get role-aware stats for a partner (admin only)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerStats(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PartnerStatsDto> {
            return localVarFp.getPartnerStats(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
export class PartnersApi extends BaseAPI {
    /**
     * Filter partners by type: buyer (customer_rank > 0), supplier (supplier_rank > 0), or user (all partners). Leave type empty to get all partners.
     * @summary Get partners from Odoo with pagination and search
     * @param {PartnersQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public findAll(query?: PartnersQueryDto, options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).findAll(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user\'s partner information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getCurrentUserPartner(options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getCurrentUserPartner(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns totalPartners, sellers (supplier_rank > 0), and buyers (customer_rank > 0) in a single call.
     * @summary Get partner overview counts (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getOverviewStats(options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getOverviewStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a partner by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getPartner(id: number, options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getPartner(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns child res.partner rows for the given commercial entity. The `type` field discriminates contact people (`contact`) from address-book entries (`delivery`, `invoice`, `other`).
     * @summary List the partner\'s child rows (admin only)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getPartnerChildren(id: number, options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getPartnerChildren(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns buyer stats (orderCount, lifetimeSpend, avgOrderValue, lastOrderAt) when customer_rank > 0, and seller stats (activeProductCount, totalSales, openPoCount, avgFulfillmentDays) when supplier_rank > 0. Both are populated for dual-role partners.
     * @summary Get role-aware stats for a partner (admin only)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getPartnerStats(id: number, options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getPartnerStats(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentMethodsApi - axios parameter creator
 * @export
 */
export const PaymentMethodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detach a payment method
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyPaymentMethod: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMyPaymentMethod', 'id', id)
            const localVarPath = `/api/v1/me/payment-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List saved payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyPaymentMethods: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/payment-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set a payment method as default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMyDefaultPaymentMethod: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setMyDefaultPaymentMethod', 'id', id)
            const localVarPath = `/api/v1/me/payment-methods/{id}/default`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentMethodsApi - functional programming interface
 * @export
 */
export const PaymentMethodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentMethodsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detach a payment method
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMyPaymentMethod(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMyPaymentMethod(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.deleteMyPaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List saved payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyPaymentMethods(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentMethodDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyPaymentMethods(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.listMyPaymentMethods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set a payment method as default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMyDefaultPaymentMethod(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setMyDefaultPaymentMethod(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.setMyDefaultPaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentMethodsApi - factory interface
 * @export
 */
export const PaymentMethodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentMethodsApiFp(configuration)
    return {
        /**
         * 
         * @summary Detach a payment method
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyPaymentMethod(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.deleteMyPaymentMethod(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List saved payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyPaymentMethods(options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentMethodDto>> {
            return localVarFp.listMyPaymentMethods(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set a payment method as default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMyDefaultPaymentMethod(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.setMyDefaultPaymentMethod(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentMethodsApi - object-oriented interface
 * @export
 * @class PaymentMethodsApi
 * @extends {BaseAPI}
 */
export class PaymentMethodsApi extends BaseAPI {
    /**
     * 
     * @summary Detach a payment method
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public deleteMyPaymentMethod(id: string, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).deleteMyPaymentMethod(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List saved payment methods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public listMyPaymentMethods(options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).listMyPaymentMethods(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set a payment method as default
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public setMyDefaultPaymentMethod(id: string, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).setMyDefaultPaymentMethod(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a Stripe customer (if needed), ephemeral key, and payment intent for mobile PaymentSheet
         * @summary Create customer payment sheet
         * @param {CreateIntentDto} createIntentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerSheet: async (createIntentDto: CreateIntentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIntentDto' is not null or undefined
            assertParamExists('createCustomerSheet', 'createIntentDto', createIntentDto)
            const localVarPath = `/api/v1/payments/customer-sheet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIntentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a payment intent. If user is authenticated, creates/uses Stripe customer. Works with native payment buttons (Apple Pay/Google Pay).
         * @summary Create payment intent
         * @param {CreateIntentDto} createIntentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentIntent: async (createIntentDto: CreateIntentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIntentDto' is not null or undefined
            assertParamExists('createPaymentIntent', 'createIntentDto', createIntentDto)
            const localVarPath = `/api/v1/payments/intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIntentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a Stripe customer (if needed), ephemeral key, and payment intent for mobile PaymentSheet
         * @summary Create customer payment sheet
         * @param {CreateIntentDto} createIntentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerSheet(createIntentDto: CreateIntentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeCustomerSheetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerSheet(createIntentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createCustomerSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a payment intent. If user is authenticated, creates/uses Stripe customer. Works with native payment buttons (Apple Pay/Google Pay).
         * @summary Create payment intent
         * @param {CreateIntentDto} createIntentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaymentIntent(createIntentDto: CreateIntentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeGuestIntentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPaymentIntent(createIntentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createPaymentIntent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * Creates a Stripe customer (if needed), ephemeral key, and payment intent for mobile PaymentSheet
         * @summary Create customer payment sheet
         * @param {CreateIntentDto} createIntentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerSheet(createIntentDto: CreateIntentDto, options?: RawAxiosRequestConfig): AxiosPromise<StripeCustomerSheetResponseDto> {
            return localVarFp.createCustomerSheet(createIntentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a payment intent. If user is authenticated, creates/uses Stripe customer. Works with native payment buttons (Apple Pay/Google Pay).
         * @summary Create payment intent
         * @param {CreateIntentDto} createIntentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentIntent(createIntentDto: CreateIntentDto, options?: RawAxiosRequestConfig): AxiosPromise<StripeGuestIntentResponseDto> {
            return localVarFp.createPaymentIntent(createIntentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * Creates a Stripe customer (if needed), ephemeral key, and payment intent for mobile PaymentSheet
     * @summary Create customer payment sheet
     * @param {CreateIntentDto} createIntentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createCustomerSheet(createIntentDto: CreateIntentDto, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createCustomerSheet(createIntentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a payment intent. If user is authenticated, creates/uses Stripe customer. Works with native payment buttons (Apple Pay/Google Pay).
     * @summary Create payment intent
     * @param {CreateIntentDto} createIntentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createPaymentIntent(createIntentDto: CreateIntentDto, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createPaymentIntent(createIntentDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsMeApi - axios parameter creator
 * @export
 */
export const PaymentsMeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns paginated outgoing payments (Procurtal → seller) where the seller is the supplier. Cash that has already been released for completed orders.
         * @summary List payments paid to the current seller
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {GetMyPaymentsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [originRef] Filter by source document ref (e.g. \&quot;PO00123\&quot;)
         * @param {UnpaidBillsQueryDto} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPayments: async (page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: GetMyPaymentsSortOrderEnum, originRef?: string, query?: UnpaidBillsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/me/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (originRef !== undefined) {
                localVarQueryParameter['originRef'] = originRef;
            }

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the count and total residual amount of unpaid vendor bills (posted, not fully paid) for the authenticated seller.
         * @summary Get the current seller\'s pending release summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPendingRelease: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/me/pending-release`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated posted vendor bills for the authenticated seller that have not been fully paid. Combine with `/pending-release` for summary stats.
         * @summary List unpaid vendor bills owed to the current seller
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {GetMyUnpaidBillsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [originRef] Filter by source document ref (e.g. \&quot;PO00123\&quot;)
         * @param {UnpaidBillsQueryDto} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUnpaidBills: async (page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: GetMyUnpaidBillsSortOrderEnum, originRef?: string, query?: UnpaidBillsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/me/unpaid-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (originRef !== undefined) {
                localVarQueryParameter['originRef'] = originRef;
            }

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsMeApi - functional programming interface
 * @export
 */
export const PaymentsMeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsMeApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns paginated outgoing payments (Procurtal → seller) where the seller is the supplier. Cash that has already been released for completed orders.
         * @summary List payments paid to the current seller
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {GetMyPaymentsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [originRef] Filter by source document ref (e.g. \&quot;PO00123\&quot;)
         * @param {UnpaidBillsQueryDto} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyPayments(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: GetMyPaymentsSortOrderEnum, originRef?: string, query?: UnpaidBillsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyPaymentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyPayments(page, pageSize, search, sortBy, sortOrder, originRef, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsMeApi.getMyPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the count and total residual amount of unpaid vendor bills (posted, not fully paid) for the authenticated seller.
         * @summary Get the current seller\'s pending release summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyPendingRelease(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingReleaseSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyPendingRelease(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsMeApi.getMyPendingRelease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated posted vendor bills for the authenticated seller that have not been fully paid. Combine with `/pending-release` for summary stats.
         * @summary List unpaid vendor bills owed to the current seller
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {GetMyUnpaidBillsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [originRef] Filter by source document ref (e.g. \&quot;PO00123\&quot;)
         * @param {UnpaidBillsQueryDto} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyUnpaidBills(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: GetMyUnpaidBillsSortOrderEnum, originRef?: string, query?: UnpaidBillsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyUnpaidBillsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyUnpaidBills(page, pageSize, search, sortBy, sortOrder, originRef, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsMeApi.getMyUnpaidBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsMeApi - factory interface
 * @export
 */
export const PaymentsMeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsMeApiFp(configuration)
    return {
        /**
         * Returns paginated outgoing payments (Procurtal → seller) where the seller is the supplier. Cash that has already been released for completed orders.
         * @summary List payments paid to the current seller
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {GetMyPaymentsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [originRef] Filter by source document ref (e.g. \&quot;PO00123\&quot;)
         * @param {UnpaidBillsQueryDto} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPayments(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: GetMyPaymentsSortOrderEnum, originRef?: string, query?: UnpaidBillsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<MyPaymentsResponseDto> {
            return localVarFp.getMyPayments(page, pageSize, search, sortBy, sortOrder, originRef, query, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the count and total residual amount of unpaid vendor bills (posted, not fully paid) for the authenticated seller.
         * @summary Get the current seller\'s pending release summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPendingRelease(options?: RawAxiosRequestConfig): AxiosPromise<PendingReleaseSummaryDto> {
            return localVarFp.getMyPendingRelease(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated posted vendor bills for the authenticated seller that have not been fully paid. Combine with `/pending-release` for summary stats.
         * @summary List unpaid vendor bills owed to the current seller
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {string} [search] Search term for text search
         * @param {string} [sortBy] Field to sort by
         * @param {GetMyUnpaidBillsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [originRef] Filter by source document ref (e.g. \&quot;PO00123\&quot;)
         * @param {UnpaidBillsQueryDto} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUnpaidBills(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: GetMyUnpaidBillsSortOrderEnum, originRef?: string, query?: UnpaidBillsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<MyUnpaidBillsResponseDto> {
            return localVarFp.getMyUnpaidBills(page, pageSize, search, sortBy, sortOrder, originRef, query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsMeApi - object-oriented interface
 * @export
 * @class PaymentsMeApi
 * @extends {BaseAPI}
 */
export class PaymentsMeApi extends BaseAPI {
    /**
     * Returns paginated outgoing payments (Procurtal → seller) where the seller is the supplier. Cash that has already been released for completed orders.
     * @summary List payments paid to the current seller
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Page size
     * @param {string} [search] Search term for text search
     * @param {string} [sortBy] Field to sort by
     * @param {GetMyPaymentsSortOrderEnum} [sortOrder] Sort order
     * @param {string} [originRef] Filter by source document ref (e.g. \&quot;PO00123\&quot;)
     * @param {UnpaidBillsQueryDto} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsMeApi
     */
    public getMyPayments(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: GetMyPaymentsSortOrderEnum, originRef?: string, query?: UnpaidBillsQueryDto, options?: RawAxiosRequestConfig) {
        return PaymentsMeApiFp(this.configuration).getMyPayments(page, pageSize, search, sortBy, sortOrder, originRef, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the count and total residual amount of unpaid vendor bills (posted, not fully paid) for the authenticated seller.
     * @summary Get the current seller\'s pending release summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsMeApi
     */
    public getMyPendingRelease(options?: RawAxiosRequestConfig) {
        return PaymentsMeApiFp(this.configuration).getMyPendingRelease(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated posted vendor bills for the authenticated seller that have not been fully paid. Combine with `/pending-release` for summary stats.
     * @summary List unpaid vendor bills owed to the current seller
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Page size
     * @param {string} [search] Search term for text search
     * @param {string} [sortBy] Field to sort by
     * @param {GetMyUnpaidBillsSortOrderEnum} [sortOrder] Sort order
     * @param {string} [originRef] Filter by source document ref (e.g. \&quot;PO00123\&quot;)
     * @param {UnpaidBillsQueryDto} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsMeApi
     */
    public getMyUnpaidBills(page?: number, pageSize?: number, search?: string, sortBy?: string, sortOrder?: GetMyUnpaidBillsSortOrderEnum, originRef?: string, query?: UnpaidBillsQueryDto, options?: RawAxiosRequestConfig) {
        return PaymentsMeApiFp(this.configuration).getMyUnpaidBills(page, pageSize, search, sortBy, sortOrder, originRef, query, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetMyPaymentsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetMyPaymentsSortOrderEnum = typeof GetMyPaymentsSortOrderEnum[keyof typeof GetMyPaymentsSortOrderEnum];
/**
 * @export
 */
export const GetMyUnpaidBillsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetMyUnpaidBillsSortOrderEnum = typeof GetMyUnpaidBillsSortOrderEnum[keyof typeof GetMyUnpaidBillsSortOrderEnum];


/**
 * PricelistsApi - axios parameter creator
 * @export
 */
export const PricelistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all pricelists from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricelists: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pricelists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PricelistsApi - functional programming interface
 * @export
 */
export const PricelistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PricelistsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all pricelists from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricelists(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PricelistDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricelists(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricelistsApi.getPricelists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PricelistsApi - factory interface
 * @export
 */
export const PricelistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PricelistsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all pricelists from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricelists(options?: RawAxiosRequestConfig): AxiosPromise<Array<PricelistDto>> {
            return localVarFp.getPricelists(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PricelistsApi - object-oriented interface
 * @export
 * @class PricelistsApi
 * @extends {BaseAPI}
 */
export class PricelistsApi extends BaseAPI {
    /**
     * 
     * @summary Get all pricelists from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricelistsApi
     */
    public getPricelists(options?: RawAxiosRequestConfig) {
        return PricelistsApiFp(this.configuration).getPricelists(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductAttributesApi - axios parameter creator
 * @export
 */
export const ProductAttributesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all product attribute values with their attribute IDs
         * @summary Get all product attribute values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductAttributeValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-attributes/values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all product attributes with their value IDs
         * @summary Get all product attributes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductAttributes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets an existing product attribute by name
         * @summary Get product attribute
         * @param {GetOrCreateAttributeDto} getOrCreateAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttribute: async (getOrCreateAttributeDto: GetOrCreateAttributeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getOrCreateAttributeDto' is not null or undefined
            assertParamExists('getAttribute', 'getOrCreateAttributeDto', getOrCreateAttributeDto)
            const localVarPath = `/api/v1/product-attributes/getAttribute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrCreateAttributeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific product attribute with its value IDs
         * @summary Get product attribute by ID
         * @param {number} id Product attribute ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAttributeById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductAttributeById', 'id', id)
            const localVarPath = `/api/v1/product-attributes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific product attribute value by its ID
         * @summary Get product attribute value by ID
         * @param {number} id Product attribute value ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAttributeValueById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductAttributeValueById', 'id', id)
            const localVarPath = `/api/v1/product-attributes/values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all values for a specific product attribute
         * @summary Get product attribute values by attribute ID
         * @param {number} id Product attribute ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAttributeValuesById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductAttributeValuesById', 'id', id)
            const localVarPath = `/api/v1/product-attributes/{id}/values`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductAttributesApi - functional programming interface
 * @export
 */
export const ProductAttributesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductAttributesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all product attribute values with their attribute IDs
         * @summary Get all product attribute values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProductAttributeValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductAttributeValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProductAttributeValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getAllProductAttributeValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all product attributes with their value IDs
         * @summary Get all product attributes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProductAttributes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductAttributeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProductAttributes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getAllProductAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets an existing product attribute by name
         * @summary Get product attribute
         * @param {GetOrCreateAttributeDto} getOrCreateAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttribute(getOrCreateAttributeDto: GetOrCreateAttributeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrCreateAttributeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttribute(getOrCreateAttributeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getAttribute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific product attribute with its value IDs
         * @summary Get product attribute by ID
         * @param {number} id Product attribute ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAttributeById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAttributeById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getProductAttributeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific product attribute value by its ID
         * @summary Get product attribute value by ID
         * @param {number} id Product attribute value ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAttributeValueById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAttributeValueById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getProductAttributeValueById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all values for a specific product attribute
         * @summary Get product attribute values by attribute ID
         * @param {number} id Product attribute ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAttributeValuesById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductAttributeValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAttributeValuesById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getProductAttributeValuesById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductAttributesApi - factory interface
 * @export
 */
export const ProductAttributesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductAttributesApiFp(configuration)
    return {
        /**
         * Returns all product attribute values with their attribute IDs
         * @summary Get all product attribute values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductAttributeValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductAttributeValueDto>> {
            return localVarFp.getAllProductAttributeValues(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all product attributes with their value IDs
         * @summary Get all product attributes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductAttributes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductAttributeDto>> {
            return localVarFp.getAllProductAttributes(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets an existing product attribute by name
         * @summary Get product attribute
         * @param {GetOrCreateAttributeDto} getOrCreateAttributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttribute(getOrCreateAttributeDto: GetOrCreateAttributeDto, options?: RawAxiosRequestConfig): AxiosPromise<GetOrCreateAttributeResponseDto> {
            return localVarFp.getAttribute(getOrCreateAttributeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific product attribute with its value IDs
         * @summary Get product attribute by ID
         * @param {number} id Product attribute ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAttributeById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeDto> {
            return localVarFp.getProductAttributeById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific product attribute value by its ID
         * @summary Get product attribute value by ID
         * @param {number} id Product attribute value ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAttributeValueById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeValueDto> {
            return localVarFp.getProductAttributeValueById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all values for a specific product attribute
         * @summary Get product attribute values by attribute ID
         * @param {number} id Product attribute ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAttributeValuesById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductAttributeValueDto>> {
            return localVarFp.getProductAttributeValuesById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductAttributesApi - object-oriented interface
 * @export
 * @class ProductAttributesApi
 * @extends {BaseAPI}
 */
export class ProductAttributesApi extends BaseAPI {
    /**
     * Returns all product attribute values with their attribute IDs
     * @summary Get all product attribute values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    public getAllProductAttributeValues(options?: RawAxiosRequestConfig) {
        return ProductAttributesApiFp(this.configuration).getAllProductAttributeValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all product attributes with their value IDs
     * @summary Get all product attributes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    public getAllProductAttributes(options?: RawAxiosRequestConfig) {
        return ProductAttributesApiFp(this.configuration).getAllProductAttributes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets an existing product attribute by name
     * @summary Get product attribute
     * @param {GetOrCreateAttributeDto} getOrCreateAttributeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    public getAttribute(getOrCreateAttributeDto: GetOrCreateAttributeDto, options?: RawAxiosRequestConfig) {
        return ProductAttributesApiFp(this.configuration).getAttribute(getOrCreateAttributeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific product attribute with its value IDs
     * @summary Get product attribute by ID
     * @param {number} id Product attribute ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    public getProductAttributeById(id: number, options?: RawAxiosRequestConfig) {
        return ProductAttributesApiFp(this.configuration).getProductAttributeById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific product attribute value by its ID
     * @summary Get product attribute value by ID
     * @param {number} id Product attribute value ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    public getProductAttributeValueById(id: number, options?: RawAxiosRequestConfig) {
        return ProductAttributesApiFp(this.configuration).getProductAttributeValueById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all values for a specific product attribute
     * @summary Get product attribute values by attribute ID
     * @param {number} id Product attribute ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    public getProductAttributeValuesById(id: number, options?: RawAxiosRequestConfig) {
        return ProductAttributesApiFp(this.configuration).getProductAttributeValuesById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductCPUsApi - axios parameter creator
 * @export
 */
export const ProductCPUsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a CPU attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCpuById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductCpuById', 'id', id)
            const localVarPath = `/api/v1/product-cpus/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all CPU attribute values (e.g. Intel i7, AMD Ryzen 7) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCpus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-cpus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductCPUsApi - functional programming interface
 * @export
 */
export const ProductCPUsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductCPUsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a CPU attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCpuById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCpuById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductCPUsApi.getProductCpuById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all CPU attribute values (e.g. Intel i7, AMD Ryzen 7) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCpus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductAttributeValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCpus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductCPUsApi.getProductCpus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductCPUsApi - factory interface
 * @export
 */
export const ProductCPUsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductCPUsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a CPU attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCpuById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeValueDto> {
            return localVarFp.getProductCpuById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all CPU attribute values (e.g. Intel i7, AMD Ryzen 7) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCpus(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductAttributeValueDto>> {
            return localVarFp.getProductCpus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductCPUsApi - object-oriented interface
 * @export
 * @class ProductCPUsApi
 * @extends {BaseAPI}
 */
export class ProductCPUsApi extends BaseAPI {
    /**
     * 
     * @summary Get a CPU attribute value by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCPUsApi
     */
    public getProductCpuById(id: number, options?: RawAxiosRequestConfig) {
        return ProductCPUsApiFp(this.configuration).getProductCpuById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all CPU attribute values (e.g. Intel i7, AMD Ryzen 7) from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCPUsApi
     */
    public getProductCpus(options?: RawAxiosRequestConfig) {
        return ProductCPUsApiFp(this.configuration).getProductCpus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductColorsApi - axios parameter creator
 * @export
 */
export const ProductColorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a color attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductColorById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductColorById', 'id', id)
            const localVarPath = `/api/v1/product-colors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all color attribute values (e.g. Black, Silver) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductColors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-colors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductColorsApi - functional programming interface
 * @export
 */
export const ProductColorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductColorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a color attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductColorById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductColorById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductColorsApi.getProductColorById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all color attribute values (e.g. Black, Silver) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductColors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductAttributeValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductColors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductColorsApi.getProductColors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductColorsApi - factory interface
 * @export
 */
export const ProductColorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductColorsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a color attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductColorById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeValueDto> {
            return localVarFp.getProductColorById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all color attribute values (e.g. Black, Silver) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductColors(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductAttributeValueDto>> {
            return localVarFp.getProductColors(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductColorsApi - object-oriented interface
 * @export
 * @class ProductColorsApi
 * @extends {BaseAPI}
 */
export class ProductColorsApi extends BaseAPI {
    /**
     * 
     * @summary Get a color attribute value by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductColorsApi
     */
    public getProductColorById(id: number, options?: RawAxiosRequestConfig) {
        return ProductColorsApiFp(this.configuration).getProductColorById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all color attribute values (e.g. Black, Silver) from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductColorsApi
     */
    public getProductColors(options?: RawAxiosRequestConfig) {
        return ProductColorsApiFp(this.configuration).getProductColors(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductConditionsApi - axios parameter creator
 * @export
 */
export const ProductConditionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a product condition by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductConditionById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductConditionById', 'id', id)
            const localVarPath = `/api/v1/product-conditions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all product conditions from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductConditions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductConditionsApi - functional programming interface
 * @export
 */
export const ProductConditionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductConditionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a product condition by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductConditionById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductConditionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductConditionById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductConditionsApi.getProductConditionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all product conditions from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductConditions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductConditionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductConditions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductConditionsApi.getProductConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductConditionsApi - factory interface
 * @export
 */
export const ProductConditionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductConditionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a product condition by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductConditionById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductConditionDto> {
            return localVarFp.getProductConditionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all product conditions from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductConditions(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductConditionDto>> {
            return localVarFp.getProductConditions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductConditionsApi - object-oriented interface
 * @export
 * @class ProductConditionsApi
 * @extends {BaseAPI}
 */
export class ProductConditionsApi extends BaseAPI {
    /**
     * 
     * @summary Get a product condition by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductConditionsApi
     */
    public getProductConditionById(id: number, options?: RawAxiosRequestConfig) {
        return ProductConditionsApiFp(this.configuration).getProductConditionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all product conditions from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductConditionsApi
     */
    public getProductConditions(options?: RawAxiosRequestConfig) {
        return ProductConditionsApiFp(this.configuration).getProductConditions(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductDatasheetsApi - axios parameter creator
 * @export
 */
export const ProductDatasheetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a GCS signed PUT URL. The client uploads the PDF directly, then passes the returned objectKey as CreateProductRequestDto.datasheetObjectKey when submitting the product request.
         * @summary Create a signed upload URL for a product datasheet PDF
         * @param {CreateProductDatasheetUploadUrlDto} createProductDatasheetUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadUrl: async (createProductDatasheetUploadUrlDto: CreateProductDatasheetUploadUrlDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductDatasheetUploadUrlDto' is not null or undefined
            assertParamExists('createUploadUrl', 'createProductDatasheetUploadUrlDto', createProductDatasheetUploadUrlDto)
            const localVarPath = `/api/v1/product-datasheets/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductDatasheetUploadUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by the product-request form after the seller uploads a PDF. Reads the PDF from GCS, asks Gemini for a structured JSON summary + raw text, persists an AiExtraction audit row with cost+token telemetry, and returns the row id + parsed content. The FE renders a confirm-to-autofill dialog with the content, then sends the extractionId back as CreateProductRequestDto.datasheetExtractionId on submit so the backend mirrors content to Odoo without re-running Gemini.
         * @summary Synchronously extract structured data from an uploaded datasheet PDF
         * @param {ExtractProductDatasheetDto} extractProductDatasheetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extract: async (extractProductDatasheetDto: ExtractProductDatasheetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extractProductDatasheetDto' is not null or undefined
            assertParamExists('extract', 'extractProductDatasheetDto', extractProductDatasheetDto)
            const localVarPath = `/api/v1/product-datasheets/extract`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extractProductDatasheetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a v4 signed GCS read URL. Use it as an <iframe> src for inline PDF preview or as an <a download> href.
         * @summary Get a short-lived signed download URL for a product template datasheet
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateDownloadUrl: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTemplateDownloadUrl', 'id', id)
            const localVarPath = `/api/v1/product-datasheets/template/{id}/download-url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductDatasheetsApi - functional programming interface
 * @export
 */
export const ProductDatasheetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductDatasheetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a GCS signed PUT URL. The client uploads the PDF directly, then passes the returned objectKey as CreateProductRequestDto.datasheetObjectKey when submitting the product request.
         * @summary Create a signed upload URL for a product datasheet PDF
         * @param {CreateProductDatasheetUploadUrlDto} createProductDatasheetUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUploadUrl(createProductDatasheetUploadUrlDto: CreateProductDatasheetUploadUrlDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDatasheetUploadUrlResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUploadUrl(createProductDatasheetUploadUrlDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDatasheetsApi.createUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used by the product-request form after the seller uploads a PDF. Reads the PDF from GCS, asks Gemini for a structured JSON summary + raw text, persists an AiExtraction audit row with cost+token telemetry, and returns the row id + parsed content. The FE renders a confirm-to-autofill dialog with the content, then sends the extractionId back as CreateProductRequestDto.datasheetExtractionId on submit so the backend mirrors content to Odoo without re-running Gemini.
         * @summary Synchronously extract structured data from an uploaded datasheet PDF
         * @param {ExtractProductDatasheetDto} extractProductDatasheetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extract(extractProductDatasheetDto: ExtractProductDatasheetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDatasheetExtractionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extract(extractProductDatasheetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDatasheetsApi.extract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a v4 signed GCS read URL. Use it as an <iframe> src for inline PDF preview or as an <a download> href.
         * @summary Get a short-lived signed download URL for a product template datasheet
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateDownloadUrl(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDatasheetDownloadUrlResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateDownloadUrl(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDatasheetsApi.getTemplateDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductDatasheetsApi - factory interface
 * @export
 */
export const ProductDatasheetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductDatasheetsApiFp(configuration)
    return {
        /**
         * Returns a GCS signed PUT URL. The client uploads the PDF directly, then passes the returned objectKey as CreateProductRequestDto.datasheetObjectKey when submitting the product request.
         * @summary Create a signed upload URL for a product datasheet PDF
         * @param {CreateProductDatasheetUploadUrlDto} createProductDatasheetUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadUrl(createProductDatasheetUploadUrlDto: CreateProductDatasheetUploadUrlDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductDatasheetUploadUrlResponseDto> {
            return localVarFp.createUploadUrl(createProductDatasheetUploadUrlDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by the product-request form after the seller uploads a PDF. Reads the PDF from GCS, asks Gemini for a structured JSON summary + raw text, persists an AiExtraction audit row with cost+token telemetry, and returns the row id + parsed content. The FE renders a confirm-to-autofill dialog with the content, then sends the extractionId back as CreateProductRequestDto.datasheetExtractionId on submit so the backend mirrors content to Odoo without re-running Gemini.
         * @summary Synchronously extract structured data from an uploaded datasheet PDF
         * @param {ExtractProductDatasheetDto} extractProductDatasheetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extract(extractProductDatasheetDto: ExtractProductDatasheetDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductDatasheetExtractionDto> {
            return localVarFp.extract(extractProductDatasheetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a v4 signed GCS read URL. Use it as an <iframe> src for inline PDF preview or as an <a download> href.
         * @summary Get a short-lived signed download URL for a product template datasheet
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateDownloadUrl(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductDatasheetDownloadUrlResponseDto> {
            return localVarFp.getTemplateDownloadUrl(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductDatasheetsApi - object-oriented interface
 * @export
 * @class ProductDatasheetsApi
 * @extends {BaseAPI}
 */
export class ProductDatasheetsApi extends BaseAPI {
    /**
     * Returns a GCS signed PUT URL. The client uploads the PDF directly, then passes the returned objectKey as CreateProductRequestDto.datasheetObjectKey when submitting the product request.
     * @summary Create a signed upload URL for a product datasheet PDF
     * @param {CreateProductDatasheetUploadUrlDto} createProductDatasheetUploadUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDatasheetsApi
     */
    public createUploadUrl(createProductDatasheetUploadUrlDto: CreateProductDatasheetUploadUrlDto, options?: RawAxiosRequestConfig) {
        return ProductDatasheetsApiFp(this.configuration).createUploadUrl(createProductDatasheetUploadUrlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by the product-request form after the seller uploads a PDF. Reads the PDF from GCS, asks Gemini for a structured JSON summary + raw text, persists an AiExtraction audit row with cost+token telemetry, and returns the row id + parsed content. The FE renders a confirm-to-autofill dialog with the content, then sends the extractionId back as CreateProductRequestDto.datasheetExtractionId on submit so the backend mirrors content to Odoo without re-running Gemini.
     * @summary Synchronously extract structured data from an uploaded datasheet PDF
     * @param {ExtractProductDatasheetDto} extractProductDatasheetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDatasheetsApi
     */
    public extract(extractProductDatasheetDto: ExtractProductDatasheetDto, options?: RawAxiosRequestConfig) {
        return ProductDatasheetsApiFp(this.configuration).extract(extractProductDatasheetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a v4 signed GCS read URL. Use it as an <iframe> src for inline PDF preview or as an <a download> href.
     * @summary Get a short-lived signed download URL for a product template datasheet
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDatasheetsApi
     */
    public getTemplateDownloadUrl(id: number, options?: RawAxiosRequestConfig) {
        return ProductDatasheetsApiFp(this.configuration).getTemplateDownloadUrl(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductDealTypesApi - axios parameter creator
 * @export
 */
export const ProductDealTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a product deal type by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDealTypeById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductDealTypeById', 'id', id)
            const localVarPath = `/api/v1/product-deal-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all product deal types from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDealTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-deal-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductDealTypesApi - functional programming interface
 * @export
 */
export const ProductDealTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductDealTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a product deal type by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDealTypeById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDealTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDealTypeById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDealTypesApi.getProductDealTypeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all product deal types from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDealTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDealTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDealTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDealTypesApi.getProductDealTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductDealTypesApi - factory interface
 * @export
 */
export const ProductDealTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductDealTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a product deal type by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDealTypeById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductDealTypeDto> {
            return localVarFp.getProductDealTypeById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all product deal types from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDealTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductDealTypeDto>> {
            return localVarFp.getProductDealTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductDealTypesApi - object-oriented interface
 * @export
 * @class ProductDealTypesApi
 * @extends {BaseAPI}
 */
export class ProductDealTypesApi extends BaseAPI {
    /**
     * 
     * @summary Get a product deal type by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDealTypesApi
     */
    public getProductDealTypeById(id: number, options?: RawAxiosRequestConfig) {
        return ProductDealTypesApiFp(this.configuration).getProductDealTypeById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all product deal types from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDealTypesApi
     */
    public getProductDealTypes(options?: RawAxiosRequestConfig) {
        return ProductDealTypesApiFp(this.configuration).getProductDealTypes(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductImagesApi - axios parameter creator
 * @export
 */
export const ProductImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a GCS signed PUT URL. The client uploads the file directly, then passes the returned objectKey as CreateProductVariantDto.image when submitting the product request.
         * @summary Create a signed upload URL for a product image
         * @param {CreateProductImageUploadUrlDto} createProductImageUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadUrl: async (createProductImageUploadUrlDto: CreateProductImageUploadUrlDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductImageUploadUrlDto' is not null or undefined
            assertParamExists('createUploadUrl', 'createProductImageUploadUrlDto', createProductImageUploadUrlDto)
            const localVarPath = `/api/v1/product-images/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductImageUploadUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a gallery image (product.image row) by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleryImage: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGalleryImage', 'id', id)
            const localVarPath = `/api/v1/product-images/gallery/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the main image for a product template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateImage: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTemplateImage', 'id', id)
            const localVarPath = `/api/v1/product-images/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the main image for a product variant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariantImage: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVariantImage', 'id', id)
            const localVarPath = `/api/v1/product-images/variant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductImagesApi - functional programming interface
 * @export
 */
export const ProductImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a GCS signed PUT URL. The client uploads the file directly, then passes the returned objectKey as CreateProductVariantDto.image when submitting the product request.
         * @summary Create a signed upload URL for a product image
         * @param {CreateProductImageUploadUrlDto} createProductImageUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUploadUrl(createProductImageUploadUrlDto: CreateProductImageUploadUrlDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductImageUploadUrlResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUploadUrl(createProductImageUploadUrlDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImagesApi.createUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a gallery image (product.image row) by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGalleryImage(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGalleryImage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImagesApi.getGalleryImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the main image for a product template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateImage(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateImage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImagesApi.getTemplateImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the main image for a product variant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariantImage(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariantImage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImagesApi.getVariantImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductImagesApi - factory interface
 * @export
 */
export const ProductImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductImagesApiFp(configuration)
    return {
        /**
         * Returns a GCS signed PUT URL. The client uploads the file directly, then passes the returned objectKey as CreateProductVariantDto.image when submitting the product request.
         * @summary Create a signed upload URL for a product image
         * @param {CreateProductImageUploadUrlDto} createProductImageUploadUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadUrl(createProductImageUploadUrlDto: CreateProductImageUploadUrlDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductImageUploadUrlResponseDto> {
            return localVarFp.createUploadUrl(createProductImageUploadUrlDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a gallery image (product.image row) by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleryImage(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getGalleryImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the main image for a product template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateImage(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getTemplateImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the main image for a product variant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariantImage(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getVariantImage(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductImagesApi - object-oriented interface
 * @export
 * @class ProductImagesApi
 * @extends {BaseAPI}
 */
export class ProductImagesApi extends BaseAPI {
    /**
     * Returns a GCS signed PUT URL. The client uploads the file directly, then passes the returned objectKey as CreateProductVariantDto.image when submitting the product request.
     * @summary Create a signed upload URL for a product image
     * @param {CreateProductImageUploadUrlDto} createProductImageUploadUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImagesApi
     */
    public createUploadUrl(createProductImageUploadUrlDto: CreateProductImageUploadUrlDto, options?: RawAxiosRequestConfig) {
        return ProductImagesApiFp(this.configuration).createUploadUrl(createProductImageUploadUrlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a gallery image (product.image row) by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImagesApi
     */
    public getGalleryImage(id: number, options?: RawAxiosRequestConfig) {
        return ProductImagesApiFp(this.configuration).getGalleryImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the main image for a product template
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImagesApi
     */
    public getTemplateImage(id: number, options?: RawAxiosRequestConfig) {
        return ProductImagesApiFp(this.configuration).getTemplateImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the main image for a product variant
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImagesApi
     */
    public getVariantImage(id: number, options?: RawAxiosRequestConfig) {
        return ProductImagesApiFp(this.configuration).getVariantImage(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductRAMsApi - axios parameter creator
 * @export
 */
export const ProductRAMsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a RAM attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRamById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductRamById', 'id', id)
            const localVarPath = `/api/v1/product-rams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all RAM attribute values (e.g. 8 GB, 16 GB) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRams: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-rams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductRAMsApi - functional programming interface
 * @export
 */
export const ProductRAMsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductRAMsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a RAM attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductRamById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductRamById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRAMsApi.getProductRamById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all RAM attribute values (e.g. 8 GB, 16 GB) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductRams(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductAttributeValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductRams(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRAMsApi.getProductRams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductRAMsApi - factory interface
 * @export
 */
export const ProductRAMsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductRAMsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a RAM attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRamById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeValueDto> {
            return localVarFp.getProductRamById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all RAM attribute values (e.g. 8 GB, 16 GB) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRams(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductAttributeValueDto>> {
            return localVarFp.getProductRams(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductRAMsApi - object-oriented interface
 * @export
 * @class ProductRAMsApi
 * @extends {BaseAPI}
 */
export class ProductRAMsApi extends BaseAPI {
    /**
     * 
     * @summary Get a RAM attribute value by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRAMsApi
     */
    public getProductRamById(id: number, options?: RawAxiosRequestConfig) {
        return ProductRAMsApiFp(this.configuration).getProductRamById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all RAM attribute values (e.g. 8 GB, 16 GB) from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRAMsApi
     */
    public getProductRams(options?: RawAxiosRequestConfig) {
        return ProductRAMsApiFp(this.configuration).getProductRams(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductRequestsApi - axios parameter creator
 * @export
 */
export const ProductRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create draft product requests from pre-normalized DTOs (returned by preview-import-excel).
         * @summary Confirm a previewed import and create drafts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmImport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-requests/confirm-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Users can create a product request with attributes, variants, and supplier information. The request will be pending admin review. The supplier ID is automatically taken from the authenticated user\'s partner ID.
         * @summary Create a new product request
         * @param {CreateProductRequestDto} createProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductRequest: async (createProductRequestDto: CreateProductRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductRequestDto' is not null or undefined
            assertParamExists('createProductRequest', 'createProductRequestDto', createProductRequestDto)
            const localVarPath = `/api/v1/product-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently delete a draft product request. Only the owner can delete their own drafts. Non-draft requests cannot be deleted.
         * @summary Delete a draft product request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductRequest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProductRequest', 'id', id)
            const localVarPath = `/api/v1/product-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an .xlsx file with the correct column headers and data-validation dropdowns populated from the Odoo catalog (brands, categories, warranties, etc.).
         * @summary Download Excel import template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportTemplate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-requests/import-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of product requests created by the authenticated user. Can be filtered by status.
         * @summary Get all product requests for the authenticated user
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductRequests: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a product request by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRequestById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductRequestById', 'id', id)
            const localVarPath = `/api/v1/product-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Parse an Excel file with one row per variant and create draft product requests. Returns both successfully created drafts and per-row errors for variants that could not be resolved.
         * @summary Import product requests from Excel (one-step)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductRequestFromExcel: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-requests/import-excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Parse and normalize an Excel file. Returns the normalized DTOs (ready to confirm) and per-row errors, but does NOT persist anything.
         * @summary Preview an Excel import without creating drafts
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewImportExcel: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-requests/preview-import-excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Convert a human-readable product request (brand, category, warranty, warranty type, country, deal type, storage, and color as names) into the internal ID-based CreateProductRequestDto. This does not persist anything.
         * @summary Preview normalized product request using names (brand, category, country, storage/color)
         * @param {CreateProductRequestByNameDto} createProductRequestByNameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewProductRequestByName: async (createProductRequestByNameDto: CreateProductRequestByNameDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductRequestByNameDto' is not null or undefined
            assertParamExists('previewProductRequestByName', 'createProductRequestByNameDto', createProductRequestByNameDto)
            const localVarPath = `/api/v1/product-requests/preview-by-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductRequestByNameDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a draft or pending product request. Sellers can only update their own requests. Setting isDraft from true to false submits the draft for admin review.
         * @summary Update a product request
         * @param {string} id 
         * @param {UpdateProductRequestDto} updateProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductRequest: async (id: string, updateProductRequestDto: UpdateProductRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductRequest', 'id', id)
            // verify required parameter 'updateProductRequestDto' is not null or undefined
            assertParamExists('updateProductRequest', 'updateProductRequestDto', updateProductRequestDto)
            const localVarPath = `/api/v1/product-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductRequestsApi - functional programming interface
 * @export
 */
export const ProductRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create draft product requests from pre-normalized DTOs (returned by preview-import-excel).
         * @summary Confirm a previewed import and create drafts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmImport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmImport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.confirmImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Users can create a product request with attributes, variants, and supplier information. The request will be pending admin review. The supplier ID is automatically taken from the authenticated user\'s partner ID.
         * @summary Create a new product request
         * @param {CreateProductRequestDto} createProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductRequest(createProductRequestDto: CreateProductRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductRequest(createProductRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.createProductRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently delete a draft product request. Only the owner can delete their own drafts. Non-draft requests cannot be deleted.
         * @summary Delete a draft product request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductRequest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.deleteProductRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an .xlsx file with the correct column headers and data-validation dropdowns populated from the Odoo catalog (brands, categories, warranties, etc.).
         * @summary Download Excel import template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadImportTemplate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadImportTemplate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.downloadImportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of product requests created by the authenticated user. Can be filtered by status.
         * @summary Get all product requests for the authenticated user
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProductRequests(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProductRequests(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.getAllProductRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a product request by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductRequestById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductRequestById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.getProductRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Parse an Excel file with one row per variant and create draft product requests. Returns both successfully created drafts and per-row errors for variants that could not be resolved.
         * @summary Import product requests from Excel (one-step)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProductRequestFromExcel(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProductRequestFromExcel(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.importProductRequestFromExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Parse and normalize an Excel file. Returns the normalized DTOs (ready to confirm) and per-row errors, but does NOT persist anything.
         * @summary Preview an Excel import without creating drafts
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewImportExcel(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewImportExcel(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.previewImportExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Convert a human-readable product request (brand, category, warranty, warranty type, country, deal type, storage, and color as names) into the internal ID-based CreateProductRequestDto. This does not persist anything.
         * @summary Preview normalized product request using names (brand, category, country, storage/color)
         * @param {CreateProductRequestByNameDto} createProductRequestByNameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewProductRequestByName(createProductRequestByNameDto: CreateProductRequestByNameDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProductRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewProductRequestByName(createProductRequestByNameDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.previewProductRequestByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a draft or pending product request. Sellers can only update their own requests. Setting isDraft from true to false submits the draft for admin review.
         * @summary Update a product request
         * @param {string} id 
         * @param {UpdateProductRequestDto} updateProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductRequest(id: string, updateProductRequestDto: UpdateProductRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductRequest(id, updateProductRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRequestsApi.updateProductRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductRequestsApi - factory interface
 * @export
 */
export const ProductRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductRequestsApiFp(configuration)
    return {
        /**
         * Create draft product requests from pre-normalized DTOs (returned by preview-import-excel).
         * @summary Confirm a previewed import and create drafts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmImport(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirmImport(options).then((request) => request(axios, basePath));
        },
        /**
         * Users can create a product request with attributes, variants, and supplier information. The request will be pending admin review. The supplier ID is automatically taken from the authenticated user\'s partner ID.
         * @summary Create a new product request
         * @param {CreateProductRequestDto} createProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductRequest(createProductRequestDto: CreateProductRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductRequestDto> {
            return localVarFp.createProductRequest(createProductRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently delete a draft product request. Only the owner can delete their own drafts. Non-draft requests cannot be deleted.
         * @summary Delete a draft product request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductRequest(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProductRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an .xlsx file with the correct column headers and data-validation dropdowns populated from the Odoo catalog (brands, categories, warranties, etc.).
         * @summary Download Excel import template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportTemplate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadImportTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of product requests created by the authenticated user. Can be filtered by status.
         * @summary Get all product requests for the authenticated user
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductRequests(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductRequestResponseDto> {
            return localVarFp.getAllProductRequests(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a product request by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRequestById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductRequestDto> {
            return localVarFp.getProductRequestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Parse an Excel file with one row per variant and create draft product requests. Returns both successfully created drafts and per-row errors for variants that could not be resolved.
         * @summary Import product requests from Excel (one-step)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductRequestFromExcel(file?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importProductRequestFromExcel(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Parse and normalize an Excel file. Returns the normalized DTOs (ready to confirm) and per-row errors, but does NOT persist anything.
         * @summary Preview an Excel import without creating drafts
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewImportExcel(file?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.previewImportExcel(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Convert a human-readable product request (brand, category, warranty, warranty type, country, deal type, storage, and color as names) into the internal ID-based CreateProductRequestDto. This does not persist anything.
         * @summary Preview normalized product request using names (brand, category, country, storage/color)
         * @param {CreateProductRequestByNameDto} createProductRequestByNameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewProductRequestByName(createProductRequestByNameDto: CreateProductRequestByNameDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateProductRequestDto> {
            return localVarFp.previewProductRequestByName(createProductRequestByNameDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a draft or pending product request. Sellers can only update their own requests. Setting isDraft from true to false submits the draft for admin review.
         * @summary Update a product request
         * @param {string} id 
         * @param {UpdateProductRequestDto} updateProductRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductRequest(id: string, updateProductRequestDto: UpdateProductRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductRequestDto> {
            return localVarFp.updateProductRequest(id, updateProductRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductRequestsApi - object-oriented interface
 * @export
 * @class ProductRequestsApi
 * @extends {BaseAPI}
 */
export class ProductRequestsApi extends BaseAPI {
    /**
     * Create draft product requests from pre-normalized DTOs (returned by preview-import-excel).
     * @summary Confirm a previewed import and create drafts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public confirmImport(options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).confirmImport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Users can create a product request with attributes, variants, and supplier information. The request will be pending admin review. The supplier ID is automatically taken from the authenticated user\'s partner ID.
     * @summary Create a new product request
     * @param {CreateProductRequestDto} createProductRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public createProductRequest(createProductRequestDto: CreateProductRequestDto, options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).createProductRequest(createProductRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently delete a draft product request. Only the owner can delete their own drafts. Non-draft requests cannot be deleted.
     * @summary Delete a draft product request
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public deleteProductRequest(id: string, options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).deleteProductRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an .xlsx file with the correct column headers and data-validation dropdowns populated from the Odoo catalog (brands, categories, warranties, etc.).
     * @summary Download Excel import template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public downloadImportTemplate(options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).downloadImportTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of product requests created by the authenticated user. Can be filtered by status.
     * @summary Get all product requests for the authenticated user
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public getAllProductRequests(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).getAllProductRequests(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a product request by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public getProductRequestById(id: string, options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).getProductRequestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Parse an Excel file with one row per variant and create draft product requests. Returns both successfully created drafts and per-row errors for variants that could not be resolved.
     * @summary Import product requests from Excel (one-step)
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public importProductRequestFromExcel(file?: File, options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).importProductRequestFromExcel(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Parse and normalize an Excel file. Returns the normalized DTOs (ready to confirm) and per-row errors, but does NOT persist anything.
     * @summary Preview an Excel import without creating drafts
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public previewImportExcel(file?: File, options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).previewImportExcel(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Convert a human-readable product request (brand, category, warranty, warranty type, country, deal type, storage, and color as names) into the internal ID-based CreateProductRequestDto. This does not persist anything.
     * @summary Preview normalized product request using names (brand, category, country, storage/color)
     * @param {CreateProductRequestByNameDto} createProductRequestByNameDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public previewProductRequestByName(createProductRequestByNameDto: CreateProductRequestByNameDto, options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).previewProductRequestByName(createProductRequestByNameDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a draft or pending product request. Sellers can only update their own requests. Setting isDraft from true to false submits the draft for admin review.
     * @summary Update a product request
     * @param {string} id 
     * @param {UpdateProductRequestDto} updateProductRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRequestsApi
     */
    public updateProductRequest(id: string, updateProductRequestDto: UpdateProductRequestDto, options?: RawAxiosRequestConfig) {
        return ProductRequestsApiFp(this.configuration).updateProductRequest(id, updateProductRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductResolutionsApi - axios parameter creator
 * @export
 */
export const ProductResolutionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a product resolution by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductResolutionById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductResolutionById', 'id', id)
            const localVarPath = `/api/v1/product-resolutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all product resolutions from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductResolutions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-resolutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductResolutionsApi - functional programming interface
 * @export
 */
export const ProductResolutionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductResolutionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a product resolution by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductResolutionById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResolutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductResolutionById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductResolutionsApi.getProductResolutionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all product resolutions from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductResolutions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductResolutionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductResolutions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductResolutionsApi.getProductResolutions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductResolutionsApi - factory interface
 * @export
 */
export const ProductResolutionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductResolutionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a product resolution by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductResolutionById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductResolutionDto> {
            return localVarFp.getProductResolutionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all product resolutions from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductResolutions(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductResolutionDto>> {
            return localVarFp.getProductResolutions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductResolutionsApi - object-oriented interface
 * @export
 * @class ProductResolutionsApi
 * @extends {BaseAPI}
 */
export class ProductResolutionsApi extends BaseAPI {
    /**
     * 
     * @summary Get a product resolution by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResolutionsApi
     */
    public getProductResolutionById(id: number, options?: RawAxiosRequestConfig) {
        return ProductResolutionsApiFp(this.configuration).getProductResolutionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all product resolutions from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResolutionsApi
     */
    public getProductResolutions(options?: RawAxiosRequestConfig) {
        return ProductResolutionsApiFp(this.configuration).getProductResolutions(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductScreenSizesApi - axios parameter creator
 * @export
 */
export const ProductScreenSizesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a product screen size by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductScreenSizeById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductScreenSizeById', 'id', id)
            const localVarPath = `/api/v1/product-screen-sizes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all product screen sizes from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductScreenSizes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-screen-sizes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductScreenSizesApi - functional programming interface
 * @export
 */
export const ProductScreenSizesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductScreenSizesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a product screen size by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductScreenSizeById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductScreenSizeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductScreenSizeById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductScreenSizesApi.getProductScreenSizeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all product screen sizes from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductScreenSizes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductScreenSizeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductScreenSizes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductScreenSizesApi.getProductScreenSizes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductScreenSizesApi - factory interface
 * @export
 */
export const ProductScreenSizesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductScreenSizesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a product screen size by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductScreenSizeById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductScreenSizeDto> {
            return localVarFp.getProductScreenSizeById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all product screen sizes from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductScreenSizes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductScreenSizeDto>> {
            return localVarFp.getProductScreenSizes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductScreenSizesApi - object-oriented interface
 * @export
 * @class ProductScreenSizesApi
 * @extends {BaseAPI}
 */
export class ProductScreenSizesApi extends BaseAPI {
    /**
     * 
     * @summary Get a product screen size by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductScreenSizesApi
     */
    public getProductScreenSizeById(id: number, options?: RawAxiosRequestConfig) {
        return ProductScreenSizesApiFp(this.configuration).getProductScreenSizeById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all product screen sizes from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductScreenSizesApi
     */
    public getProductScreenSizes(options?: RawAxiosRequestConfig) {
        return ProductScreenSizesApiFp(this.configuration).getProductScreenSizes(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductStorageApi - axios parameter creator
 * @export
 */
export const ProductStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a storage attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStorageValueById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductStorageValueById', 'id', id)
            const localVarPath = `/api/v1/product-storage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all storage attribute values (e.g. 256GB, 512GB) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStorageValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-storage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductStorageApi - functional programming interface
 * @export
 */
export const ProductStorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductStorageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a storage attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductStorageValueById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAttributeValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductStorageValueById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductStorageApi.getProductStorageValueById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all storage attribute values (e.g. 256GB, 512GB) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductStorageValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductAttributeValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductStorageValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductStorageApi.getProductStorageValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductStorageApi - factory interface
 * @export
 */
export const ProductStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductStorageApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a storage attribute value by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStorageValueById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductAttributeValueDto> {
            return localVarFp.getProductStorageValueById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all storage attribute values (e.g. 256GB, 512GB) from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStorageValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductAttributeValueDto>> {
            return localVarFp.getProductStorageValues(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductStorageApi - object-oriented interface
 * @export
 * @class ProductStorageApi
 * @extends {BaseAPI}
 */
export class ProductStorageApi extends BaseAPI {
    /**
     * 
     * @summary Get a storage attribute value by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductStorageApi
     */
    public getProductStorageValueById(id: number, options?: RawAxiosRequestConfig) {
        return ProductStorageApiFp(this.configuration).getProductStorageValueById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all storage attribute values (e.g. 256GB, 512GB) from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductStorageApi
     */
    public getProductStorageValues(options?: RawAxiosRequestConfig) {
        return ProductStorageApiFp(this.configuration).getProductStorageValues(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductVariantsApi - axios parameter creator
 * @export
 */
export const ProductVariantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accepts 2-3 product variant IDs and an optional \"focus\" hint, and returns structured pros/cons, category winners and an overall recommendation.
         * @summary Compare 2-3 product variants with AI
         * @param {CompareVariantsDto} compareVariantsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareProductVariants: async (compareVariantsDto: CompareVariantsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compareVariantsDto' is not null or undefined
            assertParamExists('compareProductVariants', 'compareVariantsDto', compareVariantsDto)
            const localVarPath = `/api/v1/product-variants/compare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(compareVariantsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns available RAM, storage, CPU options and brands derived from real product data.
         * @summary Get catalog facets for refine-search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogFacets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-variants/catalog-facets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a single product variant by its Odoo ID.
         * @summary Get product variant details by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVariantById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductVariantById', 'id', id)
            const localVarPath = `/api/v1/product-variants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supports text search across name, display_name, default_code, model, cpu, ram, screen_size, resolution and notes. Supports filtering by price, stock, condition, seller, RAM, screen size, MSRP, discount percentage, and exact matches for model, CPU, and resolution.
         * @summary Get paginated product variants from Odoo
         * @param {ProductVariantQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVariants: async (query?: ProductVariantQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-variants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts a natural language prompt (e.g. \"show me Dell laptops with at least 16GB RAM under 5000 QAR\") and converts it into structured filters using AI.
         * @summary Search product variants using natural language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductVariantsWithAi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-variants/search-with-ai`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Seller sets a discount % on their variant. Updates Odoo x_discount_percentage and recalculates pricelist item prices from standard_price. Set to 0 to remove the discount.
         * @summary Set discount percentage for a product variant
         * @param {number} variantId 
         * @param {UpdateVariantDiscountDto} updateVariantDiscountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductVariantDiscount: async (variantId: number, updateVariantDiscountDto: UpdateVariantDiscountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('updateProductVariantDiscount', 'variantId', variantId)
            // verify required parameter 'updateVariantDiscountDto' is not null or undefined
            assertParamExists('updateProductVariantDiscount', 'updateVariantDiscountDto', updateVariantDiscountDto)
            const localVarPath = `/api/v1/product-variants/{variantId}/discount`
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVariantDiscountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the supplier_stock field for a product variant. Only allowed if the authenticated user\'s partnerId matches one of the product\'s seller_ids.
         * @summary Update supplier stock for a product variant
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductVariantStock: async (productId: number, updateVariantStockDto: UpdateVariantStockDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateProductVariantStock', 'productId', productId)
            // verify required parameter 'updateVariantStockDto' is not null or undefined
            assertParamExists('updateProductVariantStock', 'updateVariantStockDto', updateVariantStockDto)
            const localVarPath = `/api/v1/product-variants/{productId}/stock`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVariantStockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductVariantsApi - functional programming interface
 * @export
 */
export const ProductVariantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductVariantsApiAxiosParamCreator(configuration)
    return {
        /**
         * Accepts 2-3 product variant IDs and an optional \"focus\" hint, and returns structured pros/cons, category winners and an overall recommendation.
         * @summary Compare 2-3 product variants with AI
         * @param {CompareVariantsDto} compareVariantsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async compareProductVariants(compareVariantsDto: CompareVariantsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VariantComparisonResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.compareProductVariants(compareVariantsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductVariantsApi.compareProductVariants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns available RAM, storage, CPU options and brands derived from real product data.
         * @summary Get catalog facets for refine-search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogFacets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogFacetsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogFacets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductVariantsApi.getCatalogFacets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a single product variant by its Odoo ID.
         * @summary Get product variant details by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductVariantById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductVariantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductVariantById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductVariantsApi.getProductVariantById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supports text search across name, display_name, default_code, model, cpu, ram, screen_size, resolution and notes. Supports filtering by price, stock, condition, seller, RAM, screen size, MSRP, discount percentage, and exact matches for model, CPU, and resolution.
         * @summary Get paginated product variants from Odoo
         * @param {ProductVariantQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductVariants(query?: ProductVariantQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductVariantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductVariants(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductVariantsApi.getProductVariants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts a natural language prompt (e.g. \"show me Dell laptops with at least 16GB RAM under 5000 QAR\") and converts it into structured filters using AI.
         * @summary Search product variants using natural language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProductVariantsWithAi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductVariantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProductVariantsWithAi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductVariantsApi.searchProductVariantsWithAi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Seller sets a discount % on their variant. Updates Odoo x_discount_percentage and recalculates pricelist item prices from standard_price. Set to 0 to remove the discount.
         * @summary Set discount percentage for a product variant
         * @param {number} variantId 
         * @param {UpdateVariantDiscountDto} updateVariantDiscountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductVariantDiscount(variantId: number, updateVariantDiscountDto: UpdateVariantDiscountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductVariantDiscount(variantId, updateVariantDiscountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductVariantsApi.updateProductVariantDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the supplier_stock field for a product variant. Only allowed if the authenticated user\'s partnerId matches one of the product\'s seller_ids.
         * @summary Update supplier stock for a product variant
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductVariantStock(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductVariantStock(productId, updateVariantStockDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductVariantsApi.updateProductVariantStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductVariantsApi - factory interface
 * @export
 */
export const ProductVariantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductVariantsApiFp(configuration)
    return {
        /**
         * Accepts 2-3 product variant IDs and an optional \"focus\" hint, and returns structured pros/cons, category winners and an overall recommendation.
         * @summary Compare 2-3 product variants with AI
         * @param {CompareVariantsDto} compareVariantsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareProductVariants(compareVariantsDto: CompareVariantsDto, options?: RawAxiosRequestConfig): AxiosPromise<VariantComparisonResponseDto> {
            return localVarFp.compareProductVariants(compareVariantsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns available RAM, storage, CPU options and brands derived from real product data.
         * @summary Get catalog facets for refine-search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogFacets(options?: RawAxiosRequestConfig): AxiosPromise<CatalogFacetsDto> {
            return localVarFp.getCatalogFacets(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a single product variant by its Odoo ID.
         * @summary Get product variant details by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVariantById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductVariantDto> {
            return localVarFp.getProductVariantById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Supports text search across name, display_name, default_code, model, cpu, ram, screen_size, resolution and notes. Supports filtering by price, stock, condition, seller, RAM, screen size, MSRP, discount percentage, and exact matches for model, CPU, and resolution.
         * @summary Get paginated product variants from Odoo
         * @param {ProductVariantQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductVariants(query?: ProductVariantQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductVariantDto>> {
            return localVarFp.getProductVariants(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts a natural language prompt (e.g. \"show me Dell laptops with at least 16GB RAM under 5000 QAR\") and converts it into structured filters using AI.
         * @summary Search product variants using natural language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductVariantsWithAi(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductVariantDto>> {
            return localVarFp.searchProductVariantsWithAi(options).then((request) => request(axios, basePath));
        },
        /**
         * Seller sets a discount % on their variant. Updates Odoo x_discount_percentage and recalculates pricelist item prices from standard_price. Set to 0 to remove the discount.
         * @summary Set discount percentage for a product variant
         * @param {number} variantId 
         * @param {UpdateVariantDiscountDto} updateVariantDiscountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductVariantDiscount(variantId: number, updateVariantDiscountDto: UpdateVariantDiscountDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProductVariantDiscount(variantId, updateVariantDiscountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the supplier_stock field for a product variant. Only allowed if the authenticated user\'s partnerId matches one of the product\'s seller_ids.
         * @summary Update supplier stock for a product variant
         * @param {number} productId 
         * @param {UpdateVariantStockDto} updateVariantStockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductVariantStock(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProductVariantStock(productId, updateVariantStockDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductVariantsApi - object-oriented interface
 * @export
 * @class ProductVariantsApi
 * @extends {BaseAPI}
 */
export class ProductVariantsApi extends BaseAPI {
    /**
     * Accepts 2-3 product variant IDs and an optional \"focus\" hint, and returns structured pros/cons, category winners and an overall recommendation.
     * @summary Compare 2-3 product variants with AI
     * @param {CompareVariantsDto} compareVariantsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVariantsApi
     */
    public compareProductVariants(compareVariantsDto: CompareVariantsDto, options?: RawAxiosRequestConfig) {
        return ProductVariantsApiFp(this.configuration).compareProductVariants(compareVariantsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns available RAM, storage, CPU options and brands derived from real product data.
     * @summary Get catalog facets for refine-search filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVariantsApi
     */
    public getCatalogFacets(options?: RawAxiosRequestConfig) {
        return ProductVariantsApiFp(this.configuration).getCatalogFacets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a single product variant by its Odoo ID.
     * @summary Get product variant details by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVariantsApi
     */
    public getProductVariantById(id: number, options?: RawAxiosRequestConfig) {
        return ProductVariantsApiFp(this.configuration).getProductVariantById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supports text search across name, display_name, default_code, model, cpu, ram, screen_size, resolution and notes. Supports filtering by price, stock, condition, seller, RAM, screen size, MSRP, discount percentage, and exact matches for model, CPU, and resolution.
     * @summary Get paginated product variants from Odoo
     * @param {ProductVariantQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVariantsApi
     */
    public getProductVariants(query?: ProductVariantQueryDto, options?: RawAxiosRequestConfig) {
        return ProductVariantsApiFp(this.configuration).getProductVariants(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts a natural language prompt (e.g. \"show me Dell laptops with at least 16GB RAM under 5000 QAR\") and converts it into structured filters using AI.
     * @summary Search product variants using natural language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVariantsApi
     */
    public searchProductVariantsWithAi(options?: RawAxiosRequestConfig) {
        return ProductVariantsApiFp(this.configuration).searchProductVariantsWithAi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Seller sets a discount % on their variant. Updates Odoo x_discount_percentage and recalculates pricelist item prices from standard_price. Set to 0 to remove the discount.
     * @summary Set discount percentage for a product variant
     * @param {number} variantId 
     * @param {UpdateVariantDiscountDto} updateVariantDiscountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVariantsApi
     */
    public updateProductVariantDiscount(variantId: number, updateVariantDiscountDto: UpdateVariantDiscountDto, options?: RawAxiosRequestConfig) {
        return ProductVariantsApiFp(this.configuration).updateProductVariantDiscount(variantId, updateVariantDiscountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the supplier_stock field for a product variant. Only allowed if the authenticated user\'s partnerId matches one of the product\'s seller_ids.
     * @summary Update supplier stock for a product variant
     * @param {number} productId 
     * @param {UpdateVariantStockDto} updateVariantStockDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVariantsApi
     */
    public updateProductVariantStock(productId: number, updateVariantStockDto: UpdateVariantStockDto, options?: RawAxiosRequestConfig) {
        return ProductVariantsApiFp(this.configuration).updateProductVariantStock(productId, updateVariantStockDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductWarrantiesApi - axios parameter creator
 * @export
 */
export const ProductWarrantiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all product warranties from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarranties: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-warranties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a product warranty by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductWarrantyById', 'id', id)
            const localVarPath = `/api/v1/product-warranties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductWarrantiesApi - functional programming interface
 * @export
 */
export const ProductWarrantiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductWarrantiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all product warranties from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductWarranties(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductWarrantyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductWarranties(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductWarrantiesApi.getProductWarranties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a product warranty by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductWarrantyById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductWarrantyById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductWarrantiesApi.getProductWarrantyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductWarrantiesApi - factory interface
 * @export
 */
export const ProductWarrantiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductWarrantiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all product warranties from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarranties(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductWarrantyDto>> {
            return localVarFp.getProductWarranties(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a product warranty by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyDto> {
            return localVarFp.getProductWarrantyById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductWarrantiesApi - object-oriented interface
 * @export
 * @class ProductWarrantiesApi
 * @extends {BaseAPI}
 */
export class ProductWarrantiesApi extends BaseAPI {
    /**
     * 
     * @summary Get all product warranties from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWarrantiesApi
     */
    public getProductWarranties(options?: RawAxiosRequestConfig) {
        return ProductWarrantiesApiFp(this.configuration).getProductWarranties(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a product warranty by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWarrantiesApi
     */
    public getProductWarrantyById(id: number, options?: RawAxiosRequestConfig) {
        return ProductWarrantiesApiFp(this.configuration).getProductWarrantyById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductWarrantyProvidersApi - axios parameter creator
 * @export
 */
export const ProductWarrantyProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a product warranty provider by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyProviderById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductWarrantyProviderById', 'id', id)
            const localVarPath = `/api/v1/product-warranty-providers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all product warranty providers from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyProviders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-warranty-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductWarrantyProvidersApi - functional programming interface
 * @export
 */
export const ProductWarrantyProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductWarrantyProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a product warranty provider by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductWarrantyProviderById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductWarrantyProviderById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductWarrantyProvidersApi.getProductWarrantyProviderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all product warranty providers from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductWarrantyProviders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductWarrantyProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductWarrantyProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductWarrantyProvidersApi.getProductWarrantyProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductWarrantyProvidersApi - factory interface
 * @export
 */
export const ProductWarrantyProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductWarrantyProvidersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a product warranty provider by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyProviderById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyProviderDto> {
            return localVarFp.getProductWarrantyProviderById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all product warranty providers from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyProviders(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductWarrantyProviderDto>> {
            return localVarFp.getProductWarrantyProviders(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductWarrantyProvidersApi - object-oriented interface
 * @export
 * @class ProductWarrantyProvidersApi
 * @extends {BaseAPI}
 */
export class ProductWarrantyProvidersApi extends BaseAPI {
    /**
     * 
     * @summary Get a product warranty provider by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWarrantyProvidersApi
     */
    public getProductWarrantyProviderById(id: number, options?: RawAxiosRequestConfig) {
        return ProductWarrantyProvidersApiFp(this.configuration).getProductWarrantyProviderById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all product warranty providers from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWarrantyProvidersApi
     */
    public getProductWarrantyProviders(options?: RawAxiosRequestConfig) {
        return ProductWarrantyProvidersApiFp(this.configuration).getProductWarrantyProviders(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductWarrantyTypesApi - axios parameter creator
 * @export
 */
export const ProductWarrantyTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a product warranty type by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyTypeById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductWarrantyTypeById', 'id', id)
            const localVarPath = `/api/v1/product-warranty-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all product warranty types from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/product-warranty-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductWarrantyTypesApi - functional programming interface
 * @export
 */
export const ProductWarrantyTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductWarrantyTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a product warranty type by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductWarrantyTypeById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWarrantyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductWarrantyTypeById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductWarrantyTypesApi.getProductWarrantyTypeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all product warranty types from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductWarrantyTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductWarrantyTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductWarrantyTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductWarrantyTypesApi.getProductWarrantyTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductWarrantyTypesApi - factory interface
 * @export
 */
export const ProductWarrantyTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductWarrantyTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a product warranty type by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyTypeById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductWarrantyTypeDto> {
            return localVarFp.getProductWarrantyTypeById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all product warranty types from Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductWarrantyTypeDto>> {
            return localVarFp.getProductWarrantyTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductWarrantyTypesApi - object-oriented interface
 * @export
 * @class ProductWarrantyTypesApi
 * @extends {BaseAPI}
 */
export class ProductWarrantyTypesApi extends BaseAPI {
    /**
     * 
     * @summary Get a product warranty type by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWarrantyTypesApi
     */
    public getProductWarrantyTypeById(id: number, options?: RawAxiosRequestConfig) {
        return ProductWarrantyTypesApiFp(this.configuration).getProductWarrantyTypeById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all product warranty types from Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWarrantyTypesApi
     */
    public getProductWarrantyTypes(options?: RawAxiosRequestConfig) {
        return ProductWarrantyTypesApiFp(this.configuration).getProductWarrantyTypes(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a small curated feed of verified, in-stock product variants ordered by discount and stock.
         * @summary Get best deals for the checkout basket
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestDeals: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/best-deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of products where the authenticated user is the supplier. Requires authentication and a linked partner ID.
         * @summary Get my products (supplier only)
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyProducts: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the Storage / Color / RAM / etc. axes configured on the template together with each axis’s existing values. The seller’s edit page uses this to populate Add-Variant pickers.
         * @summary Get attribute lines (variant axes) for a product template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAttributeLines: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductAttributeLines', 'id', id)
            const localVarPath = `/api/v1/products/{id}/attribute-lines`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get product with variants by template ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetails: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductDetails', 'id', id)
            const localVarPath = `/api/v1/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated products from Odoo
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get similar products for a product template
         * @param {SimilarProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimilarProducts: async (query?: SimilarProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/similar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts a natural language prompt (e.g. \"show me Dell laptops with at least 16GB RAM under 5000 QAR\") and converts it into structured filters using AI.
         * @summary Search products using natural language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductsWithAi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/search-with-ai`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets or updates pricelist items (buyer-facing prices) for each variant. Caller must be the seller that owns the product.
         * @summary Update buyer-facing pricing tiers (seller only)
         * @param {number} id 
         * @param {UpdateBuyerPricingDto} updateBuyerPricingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProductPricing: async (id: number, updateBuyerPricingDto: UpdateBuyerPricingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMyProductPricing', 'id', id)
            // verify required parameter 'updateBuyerPricingDto' is not null or undefined
            assertParamExists('updateMyProductPricing', 'updateBuyerPricingDto', updateBuyerPricingDto)
            const localVarPath = `/api/v1/products/{id}/pricing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBuyerPricingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates template-level fields the seller can edit: name, description, country of origin, active state, lifecycle status, main image, and gallery. Variant edits are out of scope. Caller must be the seller that owns the product.
         * @summary Update an existing product (seller only)
         * @param {number} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id: number, updateProductDto: UpdateProductDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProduct', 'id', id)
            // verify required parameter 'updateProductDto' is not null or undefined
            assertParamExists('updateProduct', 'updateProductDto', updateProductDto)
            const localVarPath = `/api/v1/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a small curated feed of verified, in-stock product variants ordered by discount and stock.
         * @summary Get best deals for the checkout basket
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBestDeals(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BestDealsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBestDeals(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getBestDeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of products where the authenticated user is the supplier. Requires authentication and a linked partner ID.
         * @summary Get my products (supplier only)
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyProducts(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getMyProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the Storage / Color / RAM / etc. axes configured on the template together with each axis’s existing values. The seller’s edit page uses this to populate Add-Variant pickers.
         * @summary Get attribute lines (variant axes) for a product template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAttributeLines(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductAttributeLineDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAttributeLines(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductAttributeLines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get product with variants by template ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDetails(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated products from Odoo
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get similar products for a product template
         * @param {SimilarProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimilarProducts(query?: SimilarProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimilarProducts(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getSimilarProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts a natural language prompt (e.g. \"show me Dell laptops with at least 16GB RAM under 5000 QAR\") and converts it into structured filters using AI.
         * @summary Search products using natural language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProductsWithAi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProductsWithAi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.searchProductsWithAi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets or updates pricelist items (buyer-facing prices) for each variant. Caller must be the seller that owns the product.
         * @summary Update buyer-facing pricing tiers (seller only)
         * @param {number} id 
         * @param {UpdateBuyerPricingDto} updateBuyerPricingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyProductPricing(id: number, updateBuyerPricingDto: UpdateBuyerPricingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyProductPricing(id, updateBuyerPricingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.updateMyProductPricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates template-level fields the seller can edit: name, description, country of origin, active state, lifecycle status, main image, and gallery. Variant edits are out of scope. Caller must be the seller that owns the product.
         * @summary Update an existing product (seller only)
         * @param {number} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id: number, updateProductDto: UpdateProductDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(id, updateProductDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.updateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * Returns a small curated feed of verified, in-stock product variants ordered by discount and stock.
         * @summary Get best deals for the checkout basket
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestDeals(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<BestDealsResponseDto> {
            return localVarFp.getBestDeals(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of products where the authenticated user is the supplier. Requires authentication and a linked partner ID.
         * @summary Get my products (supplier only)
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductsResponseDto> {
            return localVarFp.getMyProducts(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the Storage / Color / RAM / etc. axes configured on the template together with each axis’s existing values. The seller’s edit page uses this to populate Add-Variant pickers.
         * @summary Get attribute lines (variant axes) for a product template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAttributeLines(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductAttributeLineDto>> {
            return localVarFp.getProductAttributeLines(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get product with variants by template ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetails(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductDetailsDto> {
            return localVarFp.getProductDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated products from Odoo
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductsResponseDto> {
            return localVarFp.getProducts(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get similar products for a product template
         * @param {SimilarProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimilarProducts(query?: SimilarProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ProductsResponseDto> {
            return localVarFp.getSimilarProducts(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts a natural language prompt (e.g. \"show me Dell laptops with at least 16GB RAM under 5000 QAR\") and converts it into structured filters using AI.
         * @summary Search products using natural language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductsWithAi(options?: RawAxiosRequestConfig): AxiosPromise<ProductsResponseDto> {
            return localVarFp.searchProductsWithAi(options).then((request) => request(axios, basePath));
        },
        /**
         * Sets or updates pricelist items (buyer-facing prices) for each variant. Caller must be the seller that owns the product.
         * @summary Update buyer-facing pricing tiers (seller only)
         * @param {number} id 
         * @param {UpdateBuyerPricingDto} updateBuyerPricingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProductPricing(id: number, updateBuyerPricingDto: UpdateBuyerPricingDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMyProductPricing(id, updateBuyerPricingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates template-level fields the seller can edit: name, description, country of origin, active state, lifecycle status, main image, and gallery. Variant edits are out of scope. Caller must be the seller that owns the product.
         * @summary Update an existing product (seller only)
         * @param {number} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id: number, updateProductDto: UpdateProductDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProduct(id, updateProductDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * Returns a small curated feed of verified, in-stock product variants ordered by discount and stock.
     * @summary Get best deals for the checkout basket
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getBestDeals(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getBestDeals(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of products where the authenticated user is the supplier. Requires authentication and a linked partner ID.
     * @summary Get my products (supplier only)
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getMyProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getMyProducts(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the Storage / Color / RAM / etc. axes configured on the template together with each axis’s existing values. The seller’s edit page uses this to populate Add-Variant pickers.
     * @summary Get attribute lines (variant axes) for a product template
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductAttributeLines(id: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductAttributeLines(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get product with variants by template ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductDetails(id: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated products from Odoo
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProducts(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get similar products for a product template
     * @param {SimilarProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getSimilarProducts(query?: SimilarProductsQueryDto, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getSimilarProducts(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts a natural language prompt (e.g. \"show me Dell laptops with at least 16GB RAM under 5000 QAR\") and converts it into structured filters using AI.
     * @summary Search products using natural language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public searchProductsWithAi(options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).searchProductsWithAi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets or updates pricelist items (buyer-facing prices) for each variant. Caller must be the seller that owns the product.
     * @summary Update buyer-facing pricing tiers (seller only)
     * @param {number} id 
     * @param {UpdateBuyerPricingDto} updateBuyerPricingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateMyProductPricing(id: number, updateBuyerPricingDto: UpdateBuyerPricingDto, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).updateMyProductPricing(id, updateBuyerPricingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates template-level fields the seller can edit: name, description, country of origin, active state, lifecycle status, main image, and gallery. Variant edits are out of scope. Caller must be the seller that owns the product.
     * @summary Update an existing product (seller only)
     * @param {number} id 
     * @param {UpdateProductDto} updateProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateProduct(id: number, updateProductDto: UpdateProductDto, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).updateProduct(id, updateProductDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PurchaseOrdersApi - axios parameter creator
 * @export
 */
export const PurchaseOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns one entry per child purchase.order (one per seller in the cart) with: seller name, seller-uploaded tax invoice meta, and the auto-generated vendor bill meta. Use to render an \"Invoices per seller\" section on the admin sale-order page.
         * @summary Admin moderation: invoices for every PO under a sale order
         * @param {number} saleId Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSaleOrderInvoices: async (saleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saleId' is not null or undefined
            assertParamExists('adminGetSaleOrderInvoices', 'saleId', saleId)
            const localVarPath = `/api/v1/purchase-orders/admin/by-sale/{saleId}/invoices`
                .replace(`{${"saleId"}}`, encodeURIComponent(String(saleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirms a purchase order. Only the seller (partner) associated with the purchase order can confirm it. Optionally sets the planned date before confirming.
         * @summary Confirm a purchase order
         * @param {number} id Purchase order ID
         * @param {ConfirmPurchaseOrderDto} confirmPurchaseOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPurchaseOrder: async (id: number, confirmPurchaseOrderDto: ConfirmPurchaseOrderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('confirmPurchaseOrder', 'id', id)
            // verify required parameter 'confirmPurchaseOrderDto' is not null or undefined
            assertParamExists('confirmPurchaseOrder', 'confirmPurchaseOrderDto', confirmPurchaseOrderDto)
            const localVarPath = `/api/v1/purchase-orders/{id}/confirm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmPurchaseOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove the seller-uploaded invoice (seller-only)
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSellerInvoice: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSellerInvoice', 'id', id)
            const localVarPath = `/api/v1/purchase-orders/{id}/seller-invoice/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aggregates confirmed purchase order lines for the authenticated seller and returns the top N products by units. Default period is rolling 30 days, default limit is 4.
         * @summary Top products this seller shipped in the chosen period
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTopProducts: async (query?: ProductsQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/purchase-orders/my/top-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed information about a purchase order including all order lines and dropshipping records.
         * @summary Get purchase order details with order lines and dropshipping
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderDetails: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPurchaseOrderDetails', 'id', id)
            const localVarPath = `/api/v1/purchase-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the raw bytes of an ir.attachment that belongs to one of this purchase order\'s pickings. Used to display delivery proof images without exposing Odoo credentials to the client.
         * @summary Stream a picking attachment (e.g. delivery proof photo)
         * @param {number} id Purchase order ID
         * @param {number} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderPickingAttachment: async (id: number, attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPurchaseOrderPickingAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getPurchaseOrderPickingAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/purchase-orders/{id}/picking-attachments/{attachmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns exact counts for confirmed purchase orders, in-transit purchase orders, and delivered purchase orders.
         * @summary Get purchase order dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/purchase-orders/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Filter by state (draft, sent, purchase, done, cancel).
         * @summary Get paginated purchase orders from Odoo
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrders: async (query?: SalesQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/purchase-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allowed for the seller (PO owner), the buyer (PO destination address), and admins. Anyone else gets 404.
         * @summary Stream the seller-uploaded invoice file
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellerInvoice: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSellerInvoice', 'id', id)
            const localVarPath = `/api/v1/purchase-orders/{id}/seller-invoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the first associated dropshipping (picking) record for a purchase order. Only the seller (partner) associated with the purchase order can mark it as delivered. Optionally includes a delivery confirmation image.
         * @summary Mark purchase order as delivered
         * @param {number} id Purchase order ID
         * @param {File} [image] Delivery confirmation image file (multipart/form-data)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markPurchaseOrderDelivered: async (id: number, image?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markPurchaseOrderDelivered', 'id', id)
            const localVarPath = `/api/v1/purchase-orders/{id}/mark-delivered`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stores the seller\'s manually-prepared tax invoice as an ir.attachment on this purchase.order and pins it via purchase.order.seller_invoice_attachment_id. Replacing hard-deletes the previous file. Distinct from the auto-generated vendor bill (account.move). Seller-only; the PO\'s partner must match the caller\'s partnerId.
         * @summary Upload (or replace) the seller tax invoice for this PO
         * @param {number} id Purchase order ID
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSellerInvoice: async (id: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadSellerInvoice', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadSellerInvoice', 'file', file)
            const localVarPath = `/api/v1/purchase-orders/{id}/seller-invoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseOrdersApi - functional programming interface
 * @export
 */
export const PurchaseOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns one entry per child purchase.order (one per seller in the cart) with: seller name, seller-uploaded tax invoice meta, and the auto-generated vendor bill meta. Use to render an \"Invoices per seller\" section on the admin sale-order page.
         * @summary Admin moderation: invoices for every PO under a sale order
         * @param {number} saleId Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetSaleOrderInvoices(saleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetSaleOrderInvoices(saleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.adminGetSaleOrderInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirms a purchase order. Only the seller (partner) associated with the purchase order can confirm it. Optionally sets the planned date before confirming.
         * @summary Confirm a purchase order
         * @param {number} id Purchase order ID
         * @param {ConfirmPurchaseOrderDto} confirmPurchaseOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmPurchaseOrder(id: number, confirmPurchaseOrderDto: ConfirmPurchaseOrderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmPurchaseOrder(id, confirmPurchaseOrderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.confirmPurchaseOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove the seller-uploaded invoice (seller-only)
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSellerInvoice(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSellerInvoice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.deleteSellerInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aggregates confirmed purchase order lines for the authenticated seller and returns the top N products by units. Default period is rolling 30 days, default limit is 4.
         * @summary Top products this seller shipped in the chosen period
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTopProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TopProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTopProducts(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.getMyTopProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed information about a purchase order including all order lines and dropshipping records.
         * @summary Get purchase order details with order lines and dropshipping
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderDetails(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.getPurchaseOrderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the raw bytes of an ir.attachment that belongs to one of this purchase order\'s pickings. Used to display delivery proof images without exposing Odoo credentials to the client.
         * @summary Stream a picking attachment (e.g. delivery proof photo)
         * @param {number} id Purchase order ID
         * @param {number} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderPickingAttachment(id: number, attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderPickingAttachment(id, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.getPurchaseOrderPickingAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns exact counts for confirmed purchase orders, in-transit purchase orders, and delivered purchase orders.
         * @summary Get purchase order dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.getPurchaseOrderStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Filter by state (draft, sent, purchase, done, cancel).
         * @summary Get paginated purchase orders from Odoo
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrders(query?: SalesQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrdersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrders(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.getPurchaseOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allowed for the seller (PO owner), the buyer (PO destination address), and admins. Anyone else gets 404.
         * @summary Stream the seller-uploaded invoice file
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSellerInvoice(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSellerInvoice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.getSellerInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates the first associated dropshipping (picking) record for a purchase order. Only the seller (partner) associated with the purchase order can mark it as delivered. Optionally includes a delivery confirmation image.
         * @summary Mark purchase order as delivered
         * @param {number} id Purchase order ID
         * @param {File} [image] Delivery confirmation image file (multipart/form-data)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markPurchaseOrderDelivered(id: number, image?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markPurchaseOrderDelivered(id, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.markPurchaseOrderDelivered']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stores the seller\'s manually-prepared tax invoice as an ir.attachment on this purchase.order and pins it via purchase.order.seller_invoice_attachment_id. Replacing hard-deletes the previous file. Distinct from the auto-generated vendor bill (account.move). Seller-only; the PO\'s partner must match the caller\'s partnerId.
         * @summary Upload (or replace) the seller tax invoice for this PO
         * @param {number} id Purchase order ID
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSellerInvoice(id: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSellerInvoice(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOrdersApi.uploadSellerInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PurchaseOrdersApi - factory interface
 * @export
 */
export const PurchaseOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseOrdersApiFp(configuration)
    return {
        /**
         * Returns one entry per child purchase.order (one per seller in the cart) with: seller name, seller-uploaded tax invoice meta, and the auto-generated vendor bill meta. Use to render an \"Invoices per seller\" section on the admin sale-order page.
         * @summary Admin moderation: invoices for every PO under a sale order
         * @param {number} saleId Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSaleOrderInvoices(saleId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminGetSaleOrderInvoices(saleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirms a purchase order. Only the seller (partner) associated with the purchase order can confirm it. Optionally sets the planned date before confirming.
         * @summary Confirm a purchase order
         * @param {number} id Purchase order ID
         * @param {ConfirmPurchaseOrderDto} confirmPurchaseOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPurchaseOrder(id: number, confirmPurchaseOrderDto: ConfirmPurchaseOrderDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirmPurchaseOrder(id, confirmPurchaseOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove the seller-uploaded invoice (seller-only)
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSellerInvoice(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSellerInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Aggregates confirmed purchase order lines for the authenticated seller and returns the top N products by units. Default period is rolling 30 days, default limit is 4.
         * @summary Top products this seller shipped in the chosen period
         * @param {ProductsQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTopProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<TopProductDto>> {
            return localVarFp.getMyTopProducts(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed information about a purchase order including all order lines and dropshipping records.
         * @summary Get purchase order details with order lines and dropshipping
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderDetails(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseOrderDetailsDto> {
            return localVarFp.getPurchaseOrderDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the raw bytes of an ir.attachment that belongs to one of this purchase order\'s pickings. Used to display delivery proof images without exposing Odoo credentials to the client.
         * @summary Stream a picking attachment (e.g. delivery proof photo)
         * @param {number} id Purchase order ID
         * @param {number} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderPickingAttachment(id: number, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getPurchaseOrderPickingAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns exact counts for confirmed purchase orders, in-transit purchase orders, and delivered purchase orders.
         * @summary Get purchase order dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderStats(options?: RawAxiosRequestConfig): AxiosPromise<PurchaseOrderStatsDto> {
            return localVarFp.getPurchaseOrderStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Filter by state (draft, sent, purchase, done, cancel).
         * @summary Get paginated purchase orders from Odoo
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrders(query?: SalesQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseOrdersResponseDto> {
            return localVarFp.getPurchaseOrders(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Allowed for the seller (PO owner), the buyer (PO destination address), and admins. Anyone else gets 404.
         * @summary Stream the seller-uploaded invoice file
         * @param {number} id Purchase order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellerInvoice(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getSellerInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the first associated dropshipping (picking) record for a purchase order. Only the seller (partner) associated with the purchase order can mark it as delivered. Optionally includes a delivery confirmation image.
         * @summary Mark purchase order as delivered
         * @param {number} id Purchase order ID
         * @param {File} [image] Delivery confirmation image file (multipart/form-data)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markPurchaseOrderDelivered(id: number, image?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markPurchaseOrderDelivered(id, image, options).then((request) => request(axios, basePath));
        },
        /**
         * Stores the seller\'s manually-prepared tax invoice as an ir.attachment on this purchase.order and pins it via purchase.order.seller_invoice_attachment_id. Replacing hard-deletes the previous file. Distinct from the auto-generated vendor bill (account.move). Seller-only; the PO\'s partner must match the caller\'s partnerId.
         * @summary Upload (or replace) the seller tax invoice for this PO
         * @param {number} id Purchase order ID
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSellerInvoice(id: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadSellerInvoice(id, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseOrdersApi - object-oriented interface
 * @export
 * @class PurchaseOrdersApi
 * @extends {BaseAPI}
 */
export class PurchaseOrdersApi extends BaseAPI {
    /**
     * Returns one entry per child purchase.order (one per seller in the cart) with: seller name, seller-uploaded tax invoice meta, and the auto-generated vendor bill meta. Use to render an \"Invoices per seller\" section on the admin sale-order page.
     * @summary Admin moderation: invoices for every PO under a sale order
     * @param {number} saleId Sale order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public adminGetSaleOrderInvoices(saleId: number, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).adminGetSaleOrderInvoices(saleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirms a purchase order. Only the seller (partner) associated with the purchase order can confirm it. Optionally sets the planned date before confirming.
     * @summary Confirm a purchase order
     * @param {number} id Purchase order ID
     * @param {ConfirmPurchaseOrderDto} confirmPurchaseOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public confirmPurchaseOrder(id: number, confirmPurchaseOrderDto: ConfirmPurchaseOrderDto, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).confirmPurchaseOrder(id, confirmPurchaseOrderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove the seller-uploaded invoice (seller-only)
     * @param {number} id Purchase order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public deleteSellerInvoice(id: number, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).deleteSellerInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aggregates confirmed purchase order lines for the authenticated seller and returns the top N products by units. Default period is rolling 30 days, default limit is 4.
     * @summary Top products this seller shipped in the chosen period
     * @param {ProductsQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getMyTopProducts(query?: ProductsQueryDto, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getMyTopProducts(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed information about a purchase order including all order lines and dropshipping records.
     * @summary Get purchase order details with order lines and dropshipping
     * @param {number} id Purchase order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getPurchaseOrderDetails(id: number, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getPurchaseOrderDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the raw bytes of an ir.attachment that belongs to one of this purchase order\'s pickings. Used to display delivery proof images without exposing Odoo credentials to the client.
     * @summary Stream a picking attachment (e.g. delivery proof photo)
     * @param {number} id Purchase order ID
     * @param {number} attachmentId Attachment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getPurchaseOrderPickingAttachment(id: number, attachmentId: number, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getPurchaseOrderPickingAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns exact counts for confirmed purchase orders, in-transit purchase orders, and delivered purchase orders.
     * @summary Get purchase order dashboard stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getPurchaseOrderStats(options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getPurchaseOrderStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Filter by state (draft, sent, purchase, done, cancel).
     * @summary Get paginated purchase orders from Odoo
     * @param {SalesQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getPurchaseOrders(query?: SalesQueryDto, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getPurchaseOrders(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allowed for the seller (PO owner), the buyer (PO destination address), and admins. Anyone else gets 404.
     * @summary Stream the seller-uploaded invoice file
     * @param {number} id Purchase order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getSellerInvoice(id: number, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getSellerInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates the first associated dropshipping (picking) record for a purchase order. Only the seller (partner) associated with the purchase order can mark it as delivered. Optionally includes a delivery confirmation image.
     * @summary Mark purchase order as delivered
     * @param {number} id Purchase order ID
     * @param {File} [image] Delivery confirmation image file (multipart/form-data)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public markPurchaseOrderDelivered(id: number, image?: File, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).markPurchaseOrderDelivered(id, image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stores the seller\'s manually-prepared tax invoice as an ir.attachment on this purchase.order and pins it via purchase.order.seller_invoice_attachment_id. Replacing hard-deletes the previous file. Distinct from the auto-generated vendor bill (account.move). Seller-only; the PO\'s partner must match the caller\'s partnerId.
     * @summary Upload (or replace) the seller tax invoice for this PO
     * @param {number} id Purchase order ID
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public uploadSellerInvoice(id: number, file: File, options?: RawAxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).uploadSellerInvoice(id, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesApi - axios parameter creator
 * @export
 */
export const SalesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin: approve delivery and mark order as received
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApproveSaleDelivery: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminApproveSaleDelivery', 'id', id)
            const localVarPath = `/api/v1/sales/{id}/admin-approve-delivery`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancels a sale order. Users can only cancel their own orders, admins can cancel any order.
         * @summary Cancel a sale order
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSaleOrder: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelSaleOrder', 'id', id)
            const localVarPath = `/api/v1/sales/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new quotation (sale order)
         * @param {CreateQuotationDto} createQuotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuotation: async (createQuotationDto: CreateQuotationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createQuotationDto' is not null or undefined
            assertParamExists('createQuotation', 'createQuotationDto', createQuotationDto)
            const localVarPath = `/api/v1/sales/quotations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuotationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exports all sales orders matching the given filters as a CSV file. Mirrors the filters available on the admin orders list.
         * @summary Export sales orders as CSV (admin)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSalesCsv: async (query?: SalesQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sales/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed information about a sale order including all order lines. Users can only access their own sales, admins can access any sale.
         * @summary Get sale order details with order lines
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleDetails: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSaleDetails', 'id', id)
            const localVarPath = `/api/v1/sales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Streams the sale order PDF rendered by Odoo. Buyers whose prices are hidden (documents not yet approved) get a copy without unit prices, taxes or totals.
         * @summary Download the quotation / order PDF
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleOrderPdf: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSaleOrderPdf', 'id', id)
            const localVarPath = `/api/v1/sales/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the raw bytes of an ir.attachment that belongs to one of this sale order\'s pickings. Used to display delivery proof images without exposing Odoo credentials to the client.
         * @summary Stream a picking attachment (e.g. delivery proof photo)
         * @param {number} id Sale order ID
         * @param {number} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalePickingAttachment: async (id: number, attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalePickingAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getSalePickingAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/sales/{id}/picking-attachments/{attachmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Filter by state (draft, sent, sale, done, cancel). If no state is provided, defaults to quotations (draft and sent states).
         * @summary Get paginated sales orders from Odoo
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSales: async (query?: SalesQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns exact counts for confirmed orders, in-transit orders, delivered orders, and delivered orders awaiting buyer validation. Admins get platform-wide counts; buyers get counts for their own company\'s orders.
         * @summary Get sales order dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sales/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks the sale order as received by the buyer. The buyer must be associated with the same partner as the sale order.
         * @summary Mark sale order as received by buyer
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markReceived: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markReceived', 'id', id)
            const localVarPath = `/api/v1/sales/{id}/mark-received`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates product prices in order lines if they have changed, extends validity date by 1 day, and sets the quotation back to draft state. Users can only renew their own quotations, admins can renew any quotation.
         * @summary Renew a quotation
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewQuotation: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('renewQuotation', 'id', id)
            const localVarPath = `/api/v1/sales/{id}/renew`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-runs Odoo\'s procurement routing for a confirmed order, confirming any draft purchase orders Odoo already created. Returns the resulting routing status.
         * @summary Route a confirmed order to suppliers (admin)
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routeSaleOrderToSuppliers: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('routeSaleOrderToSuppliers', 'id', id)
            const localVarPath = `/api/v1/sales/{id}/route`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lets the buyer change `partner_invoice_id` on a draft / sent quotation. `null` bills the company partner. Rejected once the order is confirmed.
         * @summary Update the billing address on an unconfirmed quotation
         * @param {number} id Sale order ID
         * @param {UpdateSaleBillingAddressDto} updateSaleBillingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSaleBillingAddress: async (id: number, updateSaleBillingAddressDto: UpdateSaleBillingAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSaleBillingAddress', 'id', id)
            // verify required parameter 'updateSaleBillingAddressDto' is not null or undefined
            assertParamExists('updateSaleBillingAddress', 'updateSaleBillingAddressDto', updateSaleBillingAddressDto)
            const localVarPath = `/api/v1/sales/{id}/billing-address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSaleBillingAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lets the buyer change `partner_shipping_id` on a draft / sent quotation. Rejected once the order is confirmed because Odoo stock pickings already snapshot the address.
         * @summary Update the shipping address on an unconfirmed quotation
         * @param {number} id Sale order ID
         * @param {UpdateSaleShippingAddressDto} updateSaleShippingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSaleShippingAddress: async (id: number, updateSaleShippingAddressDto: UpdateSaleShippingAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSaleShippingAddress', 'id', id)
            // verify required parameter 'updateSaleShippingAddressDto' is not null or undefined
            assertParamExists('updateSaleShippingAddress', 'updateSaleShippingAddressDto', updateSaleShippingAddressDto)
            const localVarPath = `/api/v1/sales/{id}/shipping-address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSaleShippingAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesApi - functional programming interface
 * @export
 */
export const SalesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin: approve delivery and mark order as received
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminApproveSaleDelivery(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminApproveSaleDelivery(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.adminApproveSaleDelivery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancels a sale order. Users can only cancel their own orders, admins can cancel any order.
         * @summary Cancel a sale order
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSaleOrder(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSaleOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.cancelSaleOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new quotation (sale order)
         * @param {CreateQuotationDto} createQuotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuotation(createQuotationDto: CreateQuotationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuotationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuotation(createQuotationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.createQuotation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exports all sales orders matching the given filters as a CSV file. Mirrors the filters available on the admin orders list.
         * @summary Export sales orders as CSV (admin)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSalesCsv(query?: SalesQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSalesCsv(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.exportSalesCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed information about a sale order including all order lines. Users can only access their own sales, admins can access any sale.
         * @summary Get sale order details with order lines
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleDetails(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.getSaleDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Streams the sale order PDF rendered by Odoo. Buyers whose prices are hidden (documents not yet approved) get a copy without unit prices, taxes or totals.
         * @summary Download the quotation / order PDF
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaleOrderPdf(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaleOrderPdf(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.getSaleOrderPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the raw bytes of an ir.attachment that belongs to one of this sale order\'s pickings. Used to display delivery proof images without exposing Odoo credentials to the client.
         * @summary Stream a picking attachment (e.g. delivery proof photo)
         * @param {number} id Sale order ID
         * @param {number} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalePickingAttachment(id: number, attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalePickingAttachment(id, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.getSalePickingAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Filter by state (draft, sent, sale, done, cancel). If no state is provided, defaults to quotations (draft and sent states).
         * @summary Get paginated sales orders from Odoo
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSales(query?: SalesQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSales(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.getSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns exact counts for confirmed orders, in-transit orders, delivered orders, and delivered orders awaiting buyer validation. Admins get platform-wide counts; buyers get counts for their own company\'s orders.
         * @summary Get sales order dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.getSalesStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks the sale order as received by the buyer. The buyer must be associated with the same partner as the sale order.
         * @summary Mark sale order as received by buyer
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markReceived(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markReceived(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.markReceived']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates product prices in order lines if they have changed, extends validity date by 1 day, and sets the quotation back to draft state. Users can only renew their own quotations, admins can renew any quotation.
         * @summary Renew a quotation
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renewQuotation(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renewQuotation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.renewQuotation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Re-runs Odoo\'s procurement routing for a confirmed order, confirming any draft purchase orders Odoo already created. Returns the resulting routing status.
         * @summary Route a confirmed order to suppliers (admin)
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async routeSaleOrderToSuppliers(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.routeSaleOrderToSuppliers(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.routeSaleOrderToSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lets the buyer change `partner_invoice_id` on a draft / sent quotation. `null` bills the company partner. Rejected once the order is confirmed.
         * @summary Update the billing address on an unconfirmed quotation
         * @param {number} id Sale order ID
         * @param {UpdateSaleBillingAddressDto} updateSaleBillingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSaleBillingAddress(id: number, updateSaleBillingAddressDto: UpdateSaleBillingAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSaleBillingAddress(id, updateSaleBillingAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.updateSaleBillingAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lets the buyer change `partner_shipping_id` on a draft / sent quotation. Rejected once the order is confirmed because Odoo stock pickings already snapshot the address.
         * @summary Update the shipping address on an unconfirmed quotation
         * @param {number} id Sale order ID
         * @param {UpdateSaleShippingAddressDto} updateSaleShippingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSaleShippingAddress(id: number, updateSaleShippingAddressDto: UpdateSaleShippingAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSaleShippingAddress(id, updateSaleShippingAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApi.updateSaleShippingAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesApi - factory interface
 * @export
 */
export const SalesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin: approve delivery and mark order as received
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApproveSaleDelivery(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminApproveSaleDelivery(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancels a sale order. Users can only cancel their own orders, admins can cancel any order.
         * @summary Cancel a sale order
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSaleOrder(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelSaleOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new quotation (sale order)
         * @param {CreateQuotationDto} createQuotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuotation(createQuotationDto: CreateQuotationDto, options?: RawAxiosRequestConfig): AxiosPromise<QuotationDto> {
            return localVarFp.createQuotation(createQuotationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Exports all sales orders matching the given filters as a CSV file. Mirrors the filters available on the admin orders list.
         * @summary Export sales orders as CSV (admin)
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSalesCsv(query?: SalesQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportSalesCsv(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed information about a sale order including all order lines. Users can only access their own sales, admins can access any sale.
         * @summary Get sale order details with order lines
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleDetails(id: number, options?: RawAxiosRequestConfig): AxiosPromise<SaleDetailsDto> {
            return localVarFp.getSaleDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Streams the sale order PDF rendered by Odoo. Buyers whose prices are hidden (documents not yet approved) get a copy without unit prices, taxes or totals.
         * @summary Download the quotation / order PDF
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaleOrderPdf(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getSaleOrderPdf(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the raw bytes of an ir.attachment that belongs to one of this sale order\'s pickings. Used to display delivery proof images without exposing Odoo credentials to the client.
         * @summary Stream a picking attachment (e.g. delivery proof photo)
         * @param {number} id Sale order ID
         * @param {number} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalePickingAttachment(id: number, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getSalePickingAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Filter by state (draft, sent, sale, done, cancel). If no state is provided, defaults to quotations (draft and sent states).
         * @summary Get paginated sales orders from Odoo
         * @param {SalesQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSales(query?: SalesQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<SalesResponseDto> {
            return localVarFp.getSales(query, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns exact counts for confirmed orders, in-transit orders, delivered orders, and delivered orders awaiting buyer validation. Admins get platform-wide counts; buyers get counts for their own company\'s orders.
         * @summary Get sales order dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesStats(options?: RawAxiosRequestConfig): AxiosPromise<SaleStatsDto> {
            return localVarFp.getSalesStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Marks the sale order as received by the buyer. The buyer must be associated with the same partner as the sale order.
         * @summary Mark sale order as received by buyer
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markReceived(id: number, options?: RawAxiosRequestConfig): AxiosPromise<SaleDetailsDto> {
            return localVarFp.markReceived(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates product prices in order lines if they have changed, extends validity date by 1 day, and sets the quotation back to draft state. Users can only renew their own quotations, admins can renew any quotation.
         * @summary Renew a quotation
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewQuotation(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.renewQuotation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Re-runs Odoo\'s procurement routing for a confirmed order, confirming any draft purchase orders Odoo already created. Returns the resulting routing status.
         * @summary Route a confirmed order to suppliers (admin)
         * @param {number} id Sale order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routeSaleOrderToSuppliers(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.routeSaleOrderToSuppliers(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lets the buyer change `partner_invoice_id` on a draft / sent quotation. `null` bills the company partner. Rejected once the order is confirmed.
         * @summary Update the billing address on an unconfirmed quotation
         * @param {number} id Sale order ID
         * @param {UpdateSaleBillingAddressDto} updateSaleBillingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSaleBillingAddress(id: number, updateSaleBillingAddressDto: UpdateSaleBillingAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSaleBillingAddress(id, updateSaleBillingAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Lets the buyer change `partner_shipping_id` on a draft / sent quotation. Rejected once the order is confirmed because Odoo stock pickings already snapshot the address.
         * @summary Update the shipping address on an unconfirmed quotation
         * @param {number} id Sale order ID
         * @param {UpdateSaleShippingAddressDto} updateSaleShippingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSaleShippingAddress(id: number, updateSaleShippingAddressDto: UpdateSaleShippingAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSaleShippingAddress(id, updateSaleShippingAddressDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesApi - object-oriented interface
 * @export
 * @class SalesApi
 * @extends {BaseAPI}
 */
export class SalesApi extends BaseAPI {
    /**
     * 
     * @summary Admin: approve delivery and mark order as received
     * @param {number} id Sale order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public adminApproveSaleDelivery(id: number, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).adminApproveSaleDelivery(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancels a sale order. Users can only cancel their own orders, admins can cancel any order.
     * @summary Cancel a sale order
     * @param {number} id Sale order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public cancelSaleOrder(id: number, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).cancelSaleOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new quotation (sale order)
     * @param {CreateQuotationDto} createQuotationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public createQuotation(createQuotationDto: CreateQuotationDto, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).createQuotation(createQuotationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exports all sales orders matching the given filters as a CSV file. Mirrors the filters available on the admin orders list.
     * @summary Export sales orders as CSV (admin)
     * @param {SalesQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public exportSalesCsv(query?: SalesQueryDto, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).exportSalesCsv(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed information about a sale order including all order lines. Users can only access their own sales, admins can access any sale.
     * @summary Get sale order details with order lines
     * @param {number} id Sale order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getSaleDetails(id: number, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).getSaleDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Streams the sale order PDF rendered by Odoo. Buyers whose prices are hidden (documents not yet approved) get a copy without unit prices, taxes or totals.
     * @summary Download the quotation / order PDF
     * @param {number} id Sale order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getSaleOrderPdf(id: number, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).getSaleOrderPdf(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the raw bytes of an ir.attachment that belongs to one of this sale order\'s pickings. Used to display delivery proof images without exposing Odoo credentials to the client.
     * @summary Stream a picking attachment (e.g. delivery proof photo)
     * @param {number} id Sale order ID
     * @param {number} attachmentId Attachment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getSalePickingAttachment(id: number, attachmentId: number, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).getSalePickingAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Filter by state (draft, sent, sale, done, cancel). If no state is provided, defaults to quotations (draft and sent states).
     * @summary Get paginated sales orders from Odoo
     * @param {SalesQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getSales(query?: SalesQueryDto, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).getSales(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns exact counts for confirmed orders, in-transit orders, delivered orders, and delivered orders awaiting buyer validation. Admins get platform-wide counts; buyers get counts for their own company\'s orders.
     * @summary Get sales order dashboard stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public getSalesStats(options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).getSalesStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks the sale order as received by the buyer. The buyer must be associated with the same partner as the sale order.
     * @summary Mark sale order as received by buyer
     * @param {number} id Sale order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public markReceived(id: number, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).markReceived(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates product prices in order lines if they have changed, extends validity date by 1 day, and sets the quotation back to draft state. Users can only renew their own quotations, admins can renew any quotation.
     * @summary Renew a quotation
     * @param {number} id Sale order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public renewQuotation(id: number, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).renewQuotation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Re-runs Odoo\'s procurement routing for a confirmed order, confirming any draft purchase orders Odoo already created. Returns the resulting routing status.
     * @summary Route a confirmed order to suppliers (admin)
     * @param {number} id Sale order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public routeSaleOrderToSuppliers(id: number, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).routeSaleOrderToSuppliers(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lets the buyer change `partner_invoice_id` on a draft / sent quotation. `null` bills the company partner. Rejected once the order is confirmed.
     * @summary Update the billing address on an unconfirmed quotation
     * @param {number} id Sale order ID
     * @param {UpdateSaleBillingAddressDto} updateSaleBillingAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public updateSaleBillingAddress(id: number, updateSaleBillingAddressDto: UpdateSaleBillingAddressDto, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).updateSaleBillingAddress(id, updateSaleBillingAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lets the buyer change `partner_shipping_id` on a draft / sent quotation. Rejected once the order is confirmed because Odoo stock pickings already snapshot the address.
     * @summary Update the shipping address on an unconfirmed quotation
     * @param {number} id Sale order ID
     * @param {UpdateSaleShippingAddressDto} updateSaleShippingAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesApi
     */
    public updateSaleShippingAddress(id: number, updateSaleShippingAddressDto: UpdateSaleShippingAddressDto, options?: RawAxiosRequestConfig) {
        return SalesApiFp(this.configuration).updateSaleShippingAddress(id, updateSaleShippingAddressDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatesApi - axios parameter creator
 * @export
 */
export const StatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a state by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStateById', 'id', id)
            const localVarPath = `/api/v1/states/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all states from Odoo
         * @param {string} countryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStates: async (countryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryId' is not null or undefined
            assertParamExists('getStates', 'countryId', countryId)
            const localVarPath = `/api/v1/states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (countryId !== undefined) {
                localVarQueryParameter['countryId'] = countryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatesApi - functional programming interface
 * @export
 */
export const StatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a state by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStateById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStateById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatesApi.getStateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all states from Odoo
         * @param {string} countryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStates(countryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStates(countryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatesApi.getStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatesApi - factory interface
 * @export
 */
export const StatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a state by ID from Odoo
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<StateDto> {
            return localVarFp.getStateById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all states from Odoo
         * @param {string} countryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStates(countryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StateDto>> {
            return localVarFp.getStates(countryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatesApi - object-oriented interface
 * @export
 * @class StatesApi
 * @extends {BaseAPI}
 */
export class StatesApi extends BaseAPI {
    /**
     * 
     * @summary Get a state by ID from Odoo
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatesApi
     */
    public getStateById(id: number, options?: RawAxiosRequestConfig) {
        return StatesApiFp(this.configuration).getStateById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all states from Odoo
     * @param {string} countryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatesApi
     */
    public getStates(countryId: string, options?: RawAxiosRequestConfig) {
        return StatesApiFp(this.configuration).getStates(countryId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TwoFactorAuthenticationApi - axios parameter creator
 * @export
 */
export const TwoFactorAuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Send SMS OTP to disable 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorDisable: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/2fa/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm OTP and disable 2FA
         * @param {VerifyOtpCodeDto} verifyOtpCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorDisableConfirm: async (verifyOtpCodeDto: VerifyOtpCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyOtpCodeDto' is not null or undefined
            assertParamExists('twoFactorDisableConfirm', 'verifyOtpCodeDto', verifyOtpCodeDto)
            const localVarPath = `/api/v1/me/2fa/disable/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send SMS OTP to enable 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorEnable: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/2fa/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm OTP and enable 2FA
         * @param {VerifyOtpCodeDto} verifyOtpCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorEnableConfirm: async (verifyOtpCodeDto: VerifyOtpCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyOtpCodeDto' is not null or undefined
            assertParamExists('twoFactorEnableConfirm', 'verifyOtpCodeDto', verifyOtpCodeDto)
            const localVarPath = `/api/v1/me/2fa/enable/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TwoFactorAuthenticationApi - functional programming interface
 * @export
 */
export const TwoFactorAuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TwoFactorAuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Send SMS OTP to disable 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorDisable(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorDisable(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorAuthenticationApi.twoFactorDisable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm OTP and disable 2FA
         * @param {VerifyOtpCodeDto} verifyOtpCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorDisableConfirm(verifyOtpCodeDto: VerifyOtpCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwoFactorStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorDisableConfirm(verifyOtpCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorAuthenticationApi.twoFactorDisableConfirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send SMS OTP to enable 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorEnable(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorEnable(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorAuthenticationApi.twoFactorEnable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm OTP and enable 2FA
         * @param {VerifyOtpCodeDto} verifyOtpCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorEnableConfirm(verifyOtpCodeDto: VerifyOtpCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwoFactorStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorEnableConfirm(verifyOtpCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorAuthenticationApi.twoFactorEnableConfirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TwoFactorAuthenticationApi - factory interface
 * @export
 */
export const TwoFactorAuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TwoFactorAuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Send SMS OTP to disable 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorDisable(options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.twoFactorDisable(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm OTP and disable 2FA
         * @param {VerifyOtpCodeDto} verifyOtpCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorDisableConfirm(verifyOtpCodeDto: VerifyOtpCodeDto, options?: RawAxiosRequestConfig): AxiosPromise<TwoFactorStatusDto> {
            return localVarFp.twoFactorDisableConfirm(verifyOtpCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send SMS OTP to enable 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorEnable(options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.twoFactorEnable(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm OTP and enable 2FA
         * @param {VerifyOtpCodeDto} verifyOtpCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorEnableConfirm(verifyOtpCodeDto: VerifyOtpCodeDto, options?: RawAxiosRequestConfig): AxiosPromise<TwoFactorStatusDto> {
            return localVarFp.twoFactorEnableConfirm(verifyOtpCodeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TwoFactorAuthenticationApi - object-oriented interface
 * @export
 * @class TwoFactorAuthenticationApi
 * @extends {BaseAPI}
 */
export class TwoFactorAuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Send SMS OTP to disable 2FA
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApi
     */
    public twoFactorDisable(options?: RawAxiosRequestConfig) {
        return TwoFactorAuthenticationApiFp(this.configuration).twoFactorDisable(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm OTP and disable 2FA
     * @param {VerifyOtpCodeDto} verifyOtpCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApi
     */
    public twoFactorDisableConfirm(verifyOtpCodeDto: VerifyOtpCodeDto, options?: RawAxiosRequestConfig) {
        return TwoFactorAuthenticationApiFp(this.configuration).twoFactorDisableConfirm(verifyOtpCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send SMS OTP to enable 2FA
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApi
     */
    public twoFactorEnable(options?: RawAxiosRequestConfig) {
        return TwoFactorAuthenticationApiFp(this.configuration).twoFactorEnable(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm OTP and enable 2FA
     * @param {VerifyOtpCodeDto} verifyOtpCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApi
     */
    public twoFactorEnableConfirm(verifyOtpCodeDto: VerifyOtpCodeDto, options?: RawAxiosRequestConfig) {
        return TwoFactorAuthenticationApiFp(this.configuration).twoFactorEnableConfirm(verifyOtpCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change user password
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordDto: ChangePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordDto' is not null or undefined
            assertParamExists('changePassword', 'changePasswordDto', changePasswordDto)
            const localVarPath = `/api/v1/me/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List user sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a verification code to the NEW email address or phone number. The account is not changed yet.
         * @summary Start an email or phone number change
         * @param {RequestContactChangeDto} requestContactChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestContactChange: async (requestContactChangeDto: RequestContactChangeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestContactChangeDto' is not null or undefined
            assertParamExists('requestContactChange', 'requestContactChangeDto', requestContactChangeDto)
            const localVarPath = `/api/v1/me/contact/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestContactChangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke all other sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeOtherSessions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke specific session
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSession: async (tokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('revokeSession', 'tokenId', tokenId)
            const localVarPath = `/api/v1/me/sessions/{tokenId}`
                .replace(`{${"tokenId"}}`, encodeURIComponent(String(tokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user profile
         * @param {UpdateProfileDto} updateProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: async (updateProfileDto: UpdateProfileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProfileDto' is not null or undefined
            assertParamExists('updateProfile', 'updateProfileDto', updateProfileDto)
            const localVarPath = `/api/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves the new email address or phone number (marked verified) once the code sent to it is confirmed.
         * @summary Confirm an email or phone number change
         * @param {VerifyContactChangeDto} verifyContactChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyContactChange: async (verifyContactChangeDto: VerifyContactChangeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyContactChangeDto' is not null or undefined
            assertParamExists('verifyContactChange', 'verifyContactChangeDto', verifyContactChangeDto)
            const localVarPath = `/api/v1/me/contact/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyContactChangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change user password
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List user sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSessions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSessions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.listSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a verification code to the NEW email address or phone number. The account is not changed yet.
         * @summary Start an email or phone number change
         * @param {RequestContactChangeDto} requestContactChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestContactChange(requestContactChangeDto: RequestContactChangeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestContactChange(requestContactChangeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.requestContactChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke all other sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeOtherSessions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeOtherSessions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.revokeOtherSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke specific session
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeSession(tokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSession(tokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.revokeSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user profile
         * @param {UpdateProfileDto} updateProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfile(updateProfileDto: UpdateProfileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(updateProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves the new email address or phone number (marked verified) once the code sent to it is confirmed.
         * @summary Confirm an email or phone number change
         * @param {VerifyContactChangeDto} verifyContactChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyContactChange(verifyContactChangeDto: VerifyContactChangeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyContactChange(verifyContactChangeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.verifyContactChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Change user password
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.changePassword(changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List user sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessions(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.listSessions(options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a verification code to the NEW email address or phone number. The account is not changed yet.
         * @summary Start an email or phone number change
         * @param {RequestContactChangeDto} requestContactChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestContactChange(requestContactChangeDto: RequestContactChangeDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponseDto> {
            return localVarFp.requestContactChange(requestContactChangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke all other sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeOtherSessions(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeOtherSessions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke specific session
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSession(tokenId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeSession(tokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user profile
         * @param {UpdateProfileDto} updateProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(updateProfileDto: UpdateProfileDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.updateProfile(updateProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Saves the new email address or phone number (marked verified) once the code sent to it is confirmed.
         * @summary Confirm an email or phone number change
         * @param {VerifyContactChangeDto} verifyContactChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyContactChange(verifyContactChangeDto: VerifyContactChangeDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.verifyContactChange(verifyContactChangeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Change user password
     * @param {ChangePasswordDto} changePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public changePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).changePassword(changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getMe(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List user sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public listSessions(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).listSessions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a verification code to the NEW email address or phone number. The account is not changed yet.
     * @summary Start an email or phone number change
     * @param {RequestContactChangeDto} requestContactChangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public requestContactChange(requestContactChangeDto: RequestContactChangeDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).requestContactChange(requestContactChangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke all other sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public revokeOtherSessions(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).revokeOtherSessions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke specific session
     * @param {string} tokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public revokeSession(tokenId: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).revokeSession(tokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user profile
     * @param {UpdateProfileDto} updateProfileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateProfile(updateProfileDto: UpdateProfileDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateProfile(updateProfileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves the new email address or phone number (marked verified) once the code sent to it is confirmed.
     * @summary Confirm an email or phone number change
     * @param {VerifyContactChangeDto} verifyContactChangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public verifyContactChange(verifyContactChangeDto: VerifyContactChangeDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).verifyContactChange(verifyContactChangeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WarrantyClaimsBuyerApi - axios parameter creator
 * @export
 */
export const WarrantyClaimsBuyerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary File a warranty claim
         * @param {CreateWarrantyClaimDto} createWarrantyClaimDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWarrantyClaim: async (createWarrantyClaimDto: CreateWarrantyClaimDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarrantyClaimDto' is not null or undefined
            assertParamExists('createWarrantyClaim', 'createWarrantyClaimDto', createWarrantyClaimDto)
            const localVarPath = `/api/v1/warranty-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarrantyClaimDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a buyer\'s warranty claim detail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerClaimDetail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBuyerClaimDetail', 'id', id)
            const localVarPath = `/api/v1/warranty-claims/me/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get signed upload URL for claim attachment
         * @param {UploadUrlRequestDto} uploadUrlRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarrantyClaimUploadUrl: async (uploadUrlRequestDto: UploadUrlRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadUrlRequestDto' is not null or undefined
            assertParamExists('getWarrantyClaimUploadUrl', 'uploadUrlRequestDto', uploadUrlRequestDto)
            const localVarPath = `/api/v1/warranty-claims/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadUrlRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the buyer\'s own warranty claims
         * @param {WarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyClaims: async (query?: WarrantyClaimQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/warranty-claims/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a claim attachment directly (bypasses browser CORS for GCS)
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWarrantyClaimFile: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadWarrantyClaimFile', 'file', file)
            const localVarPath = `/api/v1/warranty-claims/upload-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarrantyClaimsBuyerApi - functional programming interface
 * @export
 */
export const WarrantyClaimsBuyerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarrantyClaimsBuyerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary File a warranty claim
         * @param {CreateWarrantyClaimDto} createWarrantyClaimDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWarrantyClaim(createWarrantyClaimDto: CreateWarrantyClaimDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWarrantyClaim(createWarrantyClaimDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsBuyerApi.createWarrantyClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a buyer\'s warranty claim detail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuyerClaimDetail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuyerClaimDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsBuyerApi.getBuyerClaimDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get signed upload URL for claim attachment
         * @param {UploadUrlRequestDto} uploadUrlRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarrantyClaimUploadUrl(uploadUrlRequestDto: UploadUrlRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWarrantyClaimUploadUrl(uploadUrlRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsBuyerApi.getWarrantyClaimUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the buyer\'s own warranty claims
         * @param {WarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyClaims(query?: WarrantyClaimQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyClaims(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsBuyerApi.listMyClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a claim attachment directly (bypasses browser CORS for GCS)
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadWarrantyClaimFile(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadWarrantyClaimFile(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsBuyerApi.uploadWarrantyClaimFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WarrantyClaimsBuyerApi - factory interface
 * @export
 */
export const WarrantyClaimsBuyerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarrantyClaimsBuyerApiFp(configuration)
    return {
        /**
         * 
         * @summary File a warranty claim
         * @param {CreateWarrantyClaimDto} createWarrantyClaimDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWarrantyClaim(createWarrantyClaimDto: CreateWarrantyClaimDto, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimDto> {
            return localVarFp.createWarrantyClaim(createWarrantyClaimDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a buyer\'s warranty claim detail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerClaimDetail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimDto> {
            return localVarFp.getBuyerClaimDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get signed upload URL for claim attachment
         * @param {UploadUrlRequestDto} uploadUrlRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarrantyClaimUploadUrl(uploadUrlRequestDto: UploadUrlRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getWarrantyClaimUploadUrl(uploadUrlRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the buyer\'s own warranty claims
         * @param {WarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyClaims(query?: WarrantyClaimQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.listMyClaims(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a claim attachment directly (bypasses browser CORS for GCS)
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWarrantyClaimFile(file: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadWarrantyClaimFile(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarrantyClaimsBuyerApi - object-oriented interface
 * @export
 * @class WarrantyClaimsBuyerApi
 * @extends {BaseAPI}
 */
export class WarrantyClaimsBuyerApi extends BaseAPI {
    /**
     * 
     * @summary File a warranty claim
     * @param {CreateWarrantyClaimDto} createWarrantyClaimDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsBuyerApi
     */
    public createWarrantyClaim(createWarrantyClaimDto: CreateWarrantyClaimDto, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsBuyerApiFp(this.configuration).createWarrantyClaim(createWarrantyClaimDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a buyer\'s warranty claim detail
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsBuyerApi
     */
    public getBuyerClaimDetail(id: string, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsBuyerApiFp(this.configuration).getBuyerClaimDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get signed upload URL for claim attachment
     * @param {UploadUrlRequestDto} uploadUrlRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsBuyerApi
     */
    public getWarrantyClaimUploadUrl(uploadUrlRequestDto: UploadUrlRequestDto, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsBuyerApiFp(this.configuration).getWarrantyClaimUploadUrl(uploadUrlRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the buyer\'s own warranty claims
     * @param {WarrantyClaimQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsBuyerApi
     */
    public listMyClaims(query?: WarrantyClaimQueryDto, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsBuyerApiFp(this.configuration).listMyClaims(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a claim attachment directly (bypasses browser CORS for GCS)
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsBuyerApi
     */
    public uploadWarrantyClaimFile(file: File, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsBuyerApiFp(this.configuration).uploadWarrantyClaimFile(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WarrantyClaimsSellerApi - axios parameter creator
 * @export
 */
export const WarrantyClaimsSellerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a response message to a warranty claim
         * @param {string} id 
         * @param {AddClaimMessageDto} addClaimMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupplierClaimMessage: async (id: string, addClaimMessageDto: AddClaimMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addSupplierClaimMessage', 'id', id)
            // verify required parameter 'addClaimMessageDto' is not null or undefined
            assertParamExists('addSupplierClaimMessage', 'addClaimMessageDto', addClaimMessageDto)
            const localVarPath = `/api/v1/warranty-claims/supplier/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addClaimMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a warranty claim detail (with message thread)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierClaimDetail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupplierClaimDetail', 'id', id)
            const localVarPath = `/api/v1/warranty-claims/supplier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the seller\'s warranty claim statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierClaimStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/warranty-claims/supplier/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List warranty claims received by the seller
         * @param {WarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplierClaims: async (query?: WarrantyClaimQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/warranty-claims/supplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a claim\'s status
         * @param {string} id 
         * @param {UpdateClaimStatusDto} updateClaimStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplierClaimStatus: async (id: string, updateClaimStatusDto: UpdateClaimStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSupplierClaimStatus', 'id', id)
            // verify required parameter 'updateClaimStatusDto' is not null or undefined
            assertParamExists('updateSupplierClaimStatus', 'updateClaimStatusDto', updateClaimStatusDto)
            const localVarPath = `/api/v1/warranty-claims/supplier/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClaimStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarrantyClaimsSellerApi - functional programming interface
 * @export
 */
export const WarrantyClaimsSellerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarrantyClaimsSellerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a response message to a warranty claim
         * @param {string} id 
         * @param {AddClaimMessageDto} addClaimMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSupplierClaimMessage(id: string, addClaimMessageDto: AddClaimMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSupplierClaimMessage(id, addClaimMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsSellerApi.addSupplierClaimMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a warranty claim detail (with message thread)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierClaimDetail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierClaimDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsSellerApi.getSupplierClaimDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the seller\'s warranty claim statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierClaimStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierClaimStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsSellerApi.getSupplierClaimStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List warranty claims received by the seller
         * @param {WarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupplierClaims(query?: WarrantyClaimQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupplierClaims(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsSellerApi.listSupplierClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a claim\'s status
         * @param {string} id 
         * @param {UpdateClaimStatusDto} updateClaimStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupplierClaimStatus(id: string, updateClaimStatusDto: UpdateClaimStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyClaimDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupplierClaimStatus(id, updateClaimStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyClaimsSellerApi.updateSupplierClaimStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WarrantyClaimsSellerApi - factory interface
 * @export
 */
export const WarrantyClaimsSellerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarrantyClaimsSellerApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a response message to a warranty claim
         * @param {string} id 
         * @param {AddClaimMessageDto} addClaimMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupplierClaimMessage(id: string, addClaimMessageDto: AddClaimMessageDto, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimMessageDto> {
            return localVarFp.addSupplierClaimMessage(id, addClaimMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a warranty claim detail (with message thread)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierClaimDetail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimDto> {
            return localVarFp.getSupplierClaimDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the seller\'s warranty claim statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierClaimStats(options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimStatsDto> {
            return localVarFp.getSupplierClaimStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List warranty claims received by the seller
         * @param {WarrantyClaimQueryDto} [query] Query parameters object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplierClaims(query?: WarrantyClaimQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.listSupplierClaims(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a claim\'s status
         * @param {string} id 
         * @param {UpdateClaimStatusDto} updateClaimStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplierClaimStatus(id: string, updateClaimStatusDto: UpdateClaimStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyClaimDto> {
            return localVarFp.updateSupplierClaimStatus(id, updateClaimStatusDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarrantyClaimsSellerApi - object-oriented interface
 * @export
 * @class WarrantyClaimsSellerApi
 * @extends {BaseAPI}
 */
export class WarrantyClaimsSellerApi extends BaseAPI {
    /**
     * 
     * @summary Add a response message to a warranty claim
     * @param {string} id 
     * @param {AddClaimMessageDto} addClaimMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsSellerApi
     */
    public addSupplierClaimMessage(id: string, addClaimMessageDto: AddClaimMessageDto, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsSellerApiFp(this.configuration).addSupplierClaimMessage(id, addClaimMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a warranty claim detail (with message thread)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsSellerApi
     */
    public getSupplierClaimDetail(id: string, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsSellerApiFp(this.configuration).getSupplierClaimDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the seller\'s warranty claim statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsSellerApi
     */
    public getSupplierClaimStats(options?: RawAxiosRequestConfig) {
        return WarrantyClaimsSellerApiFp(this.configuration).getSupplierClaimStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List warranty claims received by the seller
     * @param {WarrantyClaimQueryDto} [query] Query parameters object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsSellerApi
     */
    public listSupplierClaims(query?: WarrantyClaimQueryDto, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsSellerApiFp(this.configuration).listSupplierClaims(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a claim\'s status
     * @param {string} id 
     * @param {UpdateClaimStatusDto} updateClaimStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyClaimsSellerApi
     */
    public updateSupplierClaimStatus(id: string, updateClaimStatusDto: UpdateClaimStatusDto, options?: RawAxiosRequestConfig) {
        return WarrantyClaimsSellerApiFp(this.configuration).updateSupplierClaimStatus(id, updateClaimStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WarrantyProductsApi - axios parameter creator
 * @export
 */
export const WarrantyProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List warranty SKUs offered for a product (checkout selector)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyOptions: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductWarrantyOptions', 'id', id)
            const localVarPath = `/api/v1/products/{id}/warranty-options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarrantyProductsApi - functional programming interface
 * @export
 */
export const WarrantyProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarrantyProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List warranty SKUs offered for a product (checkout selector)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductWarrantyOptions(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarrantyProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductWarrantyOptions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyProductsApi.getProductWarrantyOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WarrantyProductsApi - factory interface
 * @export
 */
export const WarrantyProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarrantyProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary List warranty SKUs offered for a product (checkout selector)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductWarrantyOptions(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<WarrantyProductDto>> {
            return localVarFp.getProductWarrantyOptions(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarrantyProductsApi - object-oriented interface
 * @export
 * @class WarrantyProductsApi
 * @extends {BaseAPI}
 */
export class WarrantyProductsApi extends BaseAPI {
    /**
     * 
     * @summary List warranty SKUs offered for a product (checkout selector)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyProductsApi
     */
    public getProductWarrantyOptions(id: number, options?: RawAxiosRequestConfig) {
        return WarrantyProductsApiFp(this.configuration).getProductWarrantyOptions(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WarrantyProductsMySellerApi - axios parameter creator
 * @export
 */
export const WarrantyProductsMySellerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a warranty product owned by the current seller
         * @param {CreateWarrantyProductDto} createWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMyWarrantyProduct: async (createWarrantyProductDto: CreateWarrantyProductDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWarrantyProductDto' is not null or undefined
            assertParamExists('createMyWarrantyProduct', 'createWarrantyProductDto', createWarrantyProductDto)
            const localVarPath = `/api/v1/my-warranties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWarrantyProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive one of my warranty products
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyWarrantyProduct: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMyWarrantyProduct', 'id', id)
            const localVarPath = `/api/v1/my-warranties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List my warranty products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyWarrantyProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/my-warranties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update one of my warranty products
         * @param {number} id 
         * @param {UpdateWarrantyProductDto} updateWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyWarrantyProduct: async (id: number, updateWarrantyProductDto: UpdateWarrantyProductDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMyWarrantyProduct', 'id', id)
            // verify required parameter 'updateWarrantyProductDto' is not null or undefined
            assertParamExists('updateMyWarrantyProduct', 'updateWarrantyProductDto', updateWarrantyProductDto)
            const localVarPath = `/api/v1/my-warranties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWarrantyProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarrantyProductsMySellerApi - functional programming interface
 * @export
 */
export const WarrantyProductsMySellerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarrantyProductsMySellerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a warranty product owned by the current seller
         * @param {CreateWarrantyProductDto} createWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMyWarrantyProduct(createWarrantyProductDto: CreateWarrantyProductDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMyWarrantyProduct(createWarrantyProductDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyProductsMySellerApi.createMyWarrantyProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive one of my warranty products
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMyWarrantyProduct(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMyWarrantyProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyProductsMySellerApi.deleteMyWarrantyProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List my warranty products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyWarrantyProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarrantyProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyWarrantyProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyProductsMySellerApi.listMyWarrantyProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update one of my warranty products
         * @param {number} id 
         * @param {UpdateWarrantyProductDto} updateWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyWarrantyProduct(id: number, updateWarrantyProductDto: UpdateWarrantyProductDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarrantyProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyWarrantyProduct(id, updateWarrantyProductDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarrantyProductsMySellerApi.updateMyWarrantyProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WarrantyProductsMySellerApi - factory interface
 * @export
 */
export const WarrantyProductsMySellerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarrantyProductsMySellerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a warranty product owned by the current seller
         * @param {CreateWarrantyProductDto} createWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMyWarrantyProduct(createWarrantyProductDto: CreateWarrantyProductDto, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyProductDto> {
            return localVarFp.createMyWarrantyProduct(createWarrantyProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive one of my warranty products
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyWarrantyProduct(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMyWarrantyProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List my warranty products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyWarrantyProducts(options?: RawAxiosRequestConfig): AxiosPromise<Array<WarrantyProductDto>> {
            return localVarFp.listMyWarrantyProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update one of my warranty products
         * @param {number} id 
         * @param {UpdateWarrantyProductDto} updateWarrantyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyWarrantyProduct(id: number, updateWarrantyProductDto: UpdateWarrantyProductDto, options?: RawAxiosRequestConfig): AxiosPromise<WarrantyProductDto> {
            return localVarFp.updateMyWarrantyProduct(id, updateWarrantyProductDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarrantyProductsMySellerApi - object-oriented interface
 * @export
 * @class WarrantyProductsMySellerApi
 * @extends {BaseAPI}
 */
export class WarrantyProductsMySellerApi extends BaseAPI {
    /**
     * 
     * @summary Create a warranty product owned by the current seller
     * @param {CreateWarrantyProductDto} createWarrantyProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyProductsMySellerApi
     */
    public createMyWarrantyProduct(createWarrantyProductDto: CreateWarrantyProductDto, options?: RawAxiosRequestConfig) {
        return WarrantyProductsMySellerApiFp(this.configuration).createMyWarrantyProduct(createWarrantyProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive one of my warranty products
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyProductsMySellerApi
     */
    public deleteMyWarrantyProduct(id: number, options?: RawAxiosRequestConfig) {
        return WarrantyProductsMySellerApiFp(this.configuration).deleteMyWarrantyProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List my warranty products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyProductsMySellerApi
     */
    public listMyWarrantyProducts(options?: RawAxiosRequestConfig) {
        return WarrantyProductsMySellerApiFp(this.configuration).listMyWarrantyProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update one of my warranty products
     * @param {number} id 
     * @param {UpdateWarrantyProductDto} updateWarrantyProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarrantyProductsMySellerApi
     */
    public updateMyWarrantyProduct(id: number, updateWarrantyProductDto: UpdateWarrantyProductDto, options?: RawAxiosRequestConfig) {
        return WarrantyProductsMySellerApiFp(this.configuration).updateMyWarrantyProduct(id, updateWarrantyProductDto, options).then((request) => request(this.axios, this.basePath));
    }
}



